
/**
 * @class XLviewer
 */
function XLviewer(options) {
    return new XLviewer.Core(options);
}
(function( xlv ){

    /**
     * @class
     * Utility class
     */
    xlv.Utils = {};
    /**
     * Taken from jquery
     */
    var class2type = {
            '[object Boolean]':     'boolean',
            '[object Number]':      'number',
            '[object String]':      'string',
            '[object Function]':    'function',
            '[object Array]':       'array',
            '[object Date]':        'date',
            '[object RegExp]':      'regexp',
            '[object Object]':      'object'
        },
        // Save a reference to some core methods
        toString    = Object.prototype.toString,
        hasOwn      = Object.prototype.hasOwnProperty;

    /**
     * Say if argument is a function (boolean)
     */
    xlv.Utils.isFunction = function( obj ) {
        return xlv.Utils.type(obj) === "function";
    };


    /**
     * Say if argument is an array (boolean)
     */
    xlv.Utils.isArray = Array.isArray || function( obj ) {
        return xlv.Utils.type(obj) === "array";
    };


    /**
     * Determining if the argument passed is a window (hacky).
     */
    xlv.Utils.isWindow = function( obj ) {
        return obj && typeof obj === "object" && "setInterval" in obj;
    };


    /**
     * Determining the type of the argument passed
     */
    xlv.Utils.type = function( obj ) {
        return ( obj === null ) || ( obj === undefined ) ?
            String( obj ) :
            class2type[ toString.call(obj) ] || "object";
    };


    /**
     * Determining if the type of the argument passed id object
     */
    xlv.Utils.isPlainObject = function( obj ) {
        // Must be an Object.
        // Because of IE, we also have to check the presence of the constructor property.
        // Make sure that DOM nodes and window objects don't pass through, as well
        if ( !obj || xlv.Utils.type(obj) !== "object" || obj.nodeType || xlv.Utils.isWindow( obj ) ) {
            return false;
        }

        // Not own constructor property must be Object
        if ( obj.constructor &&
            !hasOwn.call(obj, "constructor") &&
            !hasOwn.call(obj.constructor.prototype, "isPrototypeOf") ) {
            return false;
        }

        // Own properties are enumerated firstly, so to speed up,
        // if last one is own, then all properties are own.

        var lastKey;
        for (var key in obj ) {
            lastKey = key;
        }

        return lastKey === undefined || hasOwn.call( obj, lastKey );
    };


    /**
     * Determining if the argument is an empty object
     */
    xlv.Utils.isEmptyObject = function( obj ) {
        for ( var name in obj ) {
            return false;
        }
        return true;
    };

    /**
     * Call Object.freeze. Does nothing if Object.freeze is not supported.
     */
    xlv.Utils.freezeObject = function(obj) {
        if (Object.freeze) {
            xlv.Utils.freezeObject = Object.freeze;
        } else {
            xlv.Utils.freezeObject = function(obj) {
                return obj;
            };
        }
        return xlv.Utils.freezeObject(obj);
    };

    /**
     * True if the browser supports the HTML5 canvas element
     */
    xlv.Utils.supportsCanvas = (function () {
        var canvasElement = document.createElement( 'canvas' );
        return !!( xlv.Utils.isFunction( canvasElement.getContext ) &&
            canvasElement.getContext( '2d' ) );
    }());

    /**
     * Test whether the submitted canvas is tainted or not.
     */
    xlv.Utils.isCanvasTainted = function(canvas) {
        var isTainted = false;
        try {
            // We test if the canvas is tainted by retrieving data from it.
            // An exception will be raised if the canvas is tainted.
            canvas.getContext('2d').getImageData(0, 0, 1, 1);
        } catch (e) {
            isTainted = true;
        }
        return isTainted;
    };

    /**
     * A ratio comparing the device screen's pixel density to the canvas's backing store pixel density. Defaults to 1 if canvas isn't supported by the browser.
     */
    xlv.Utils.pixelDensityRatio = (function () {
        if ( xlv.Utils.supportsCanvas ) {
            var context = document.createElement('canvas').getContext('2d');
            var devicePixelRatio = window.devicePixelRatio || 1;
            var backingStoreRatio = context.webkitBackingStorePixelRatio ||
                context.mozBackingStorePixelRatio ||
                context.msBackingStorePixelRatio ||
                context.oBackingStorePixelRatio ||
                context.backingStorePixelRatio || 1;
            return devicePixelRatio / backingStoreRatio;
        } else {
            return 1;
        }
    }());


    /**
     * Returns the current milliseconds, using Date.now() if available
     */
    xlv.Utils.now = function( ) {
        if (Date.now) {
            xlv.Utils.now = Date.now;
        } else {
            xlv.Utils.now = function() { return new Date().getTime(); };
        }
        return xlv.Utils.now();
    };

    /**
     * Returns a function which invokes the method as if it were a method belonging to the object.
     */
    xlv.Utils.delegate = function( object, method ) {
        return function(){
            var args = arguments;
            if ( args === undefined ){
                args = [];
            }
            return method.apply( object, args );
        };
    };
    /**
     * Capitalizes the first letter of a string
     */
    xlv.Utils.capitalizeFirstLetter = function(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    };
    /**
     * Clamp a number between a min and a max
     */
    xlv.Utils.clamp = function(value, min, max) {
        if (value < min) {
            return min;
        }
        if (value > max) {
            return max;
        }
        return value
    };

    /**
     * apply styles to a dom element
     * @param element {Element} - DOM element to be styled
     * @param styleMap {Object} - the properties of this object are applied to the ìgiven DOM element
     */
    xlv.Utils.applyStyle = function(element, styleMap) {
        for(var k in styleMap) {
            element.style[k] = styleMap[k];
        }
    };

    /**
     * Parses an XML string into a DOM Document.
     */
    xlv.Utils.parseXml = function( string ) {
        if ( window.DOMParser ) {

            xlv.Utils.parseXml = function( string ) {
                var parser = new DOMParser();
                return parser.parseFromString( string, "text/xml" );
            };

        } else if ( window.ActiveXObject ) {

            xlv.Utils.parseXml = function( string ) {
                var xmlDoc = new ActiveXObject( "Microsoft.XMLDOM" );
                xmlDoc.async = false;
                xmlDoc.loadXML( string );
                return xmlDoc;
            };

        } else {
            throw new Error( "Browser doesn't support XML DOM." );
        }

        return xlv.Utils.parseXml( string );
    };

    /* Copyright 2015 William Summers, MetaTribal LLC
     * adapted from https://developer.mozilla.org/en-US/docs/JXON
     *
     * Licensed under the MIT License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *     https://opensource.org/licenses/MIT
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    /**
     * @ignore
     * @author William Summers
     * @link https://github.com/metatribal/xmlToJSON
     */
    xlv.Utils.xmlToJSON = (function () {

        this.version = "1.3";

        var options = { // set up the default options
            mergeCDATA: true, // extract cdata and merge with text
            grokAttr: true, // convert truthy attributes to boolean, etc
            grokText: true, // convert truthy text/attr to boolean, etc
            normalize: true, // collapse multiple spaces to single space
            xmlns: true, // include namespaces as attribute in output
            namespaceKey: '_ns', // tag name for namespace objects
            textKey: '_text', // tag name for text nodes
            valueKey: '_value', // tag name for attribute values
            attrKey: '_attr', // tag for attr groups
            cdataKey: '_cdata', // tag for cdata nodes (ignored if mergeCDATA is true)
            attrsAsObject: true, // if false, key is used as prefix to name, set prefix to '' to merge children and attrs.
            stripAttrPrefix: true, // remove namespace prefixes from attributes
            stripElemPrefix: true, // for elements of same name in diff namespaces, you can enable namespaces and access the nskey property
            childrenAsArray: true // force children into arrays
        };

        var prefixMatch = new RegExp(/(?!xmlns)^.*:/);
        var trimMatch = new RegExp(/^\s+|\s+$/g);

        /**
         * @ignore
         */
        this.grokType = function (sValue) {
            if (/^\s*$/.test(sValue)) {
                return null;
            }
            if (/^(?:true|false)$/i.test(sValue)) {
                return sValue.toLowerCase() === "true";
            }
            if (isFinite(sValue)) {
                return parseFloat(sValue);
            }
            return sValue;
        };

        /**
         * @ignore
         */
        this.parseString = function (xmlString, opt) {
            return this.parseXML(this.stringToXML(xmlString), opt);
        };

        /**
         * @ignore
         */
        this.parseXML = function (oXMLParent, opt) {

            // initialize options
            for (var key in opt) {
                options[key] = opt[key];
            }

            var vResult = {},
                nLength = 0,
                sCollectedTxt = "";

            // parse namespace information
            if (options.xmlns && oXMLParent.namespaceURI) {
                vResult[options.namespaceKey] = oXMLParent.namespaceURI;
            }

            // parse attributes
            // using attributes property instead of hasAttributes method to support older browsers
            if (oXMLParent.attributes && oXMLParent.attributes.length > 0) {
                var vAttribs = {};

                for (nLength; nLength < oXMLParent.attributes.length; nLength++) {
                    var oAttrib = oXMLParent.attributes.item(nLength);
                    vContent = {};
                    var attribName = '';

                    if (options.stripAttrPrefix) {
                        attribName = oAttrib.name.replace(prefixMatch, '');

                    } else {
                        attribName = oAttrib.name;
                    }

                    if (options.grokAttr) {
                        vContent[options.valueKey] = this.grokType(oAttrib.value.replace(trimMatch, ''));
                    } else {
                        vContent[options.valueKey] = oAttrib.value.replace(trimMatch, '');
                    }

                    if (options.xmlns && oAttrib.namespaceURI) {
                        vContent[options.namespaceKey] = oAttrib.namespaceURI;
                    }

                    if (options.attrsAsObject) { // attributes with same local name must enable prefixes
                        vAttribs[attribName] = vContent;
                    } else {
                        vResult[options.attrKey + attribName] = vContent;
                    }
                }

                if (options.attrsAsObject) {
                    vResult[options.attrKey] = vAttribs;
                } else {}
            }

            // iterate over the children
            if (oXMLParent.hasChildNodes()) {
                for (var oNode, sProp, vContent, nItem = 0; nItem < oXMLParent.childNodes.length; nItem++) {
                    oNode = oXMLParent.childNodes.item(nItem);

                    if (oNode.nodeType === 4) {
                        if (options.mergeCDATA) {
                            sCollectedTxt += oNode.nodeValue;
                        } else {
                            if (vResult.hasOwnProperty(options.cdataKey)) {
                                if (vResult[options.cdataKey].constructor !== Array) {
                                    vResult[options.cdataKey] = [vResult[options.cdataKey]];
                                }
                                vResult[options.cdataKey].push(oNode.nodeValue);

                            } else {
                                if (options.childrenAsArray) {
                                    vResult[options.cdataKey] = [];
                                    vResult[options.cdataKey].push(oNode.nodeValue);
                                } else {
                                    vResult[options.cdataKey] = oNode.nodeValue;
                                }
                            }
                        }
                    } /* nodeType is "CDATASection" (4) */
                    else if (oNode.nodeType === 3) {
                        sCollectedTxt += oNode.nodeValue;
                    } /* nodeType is "Text" (3) */
                    else if (oNode.nodeType === 1) { /* nodeType is "Element" (1) */

                        if (nLength === 0) {
                            vResult = {};
                        }

                        // using nodeName to support browser (IE) implementation with no 'localName' property
                        if (options.stripElemPrefix) {
                            sProp = oNode.nodeName.replace(prefixMatch, '');
                        } else {
                            sProp = oNode.nodeName;
                        }

                        vContent = xlv.Utils.xmlToJSON.parseXML(oNode);

                        if (vResult.hasOwnProperty(sProp)) {
                            if (vResult[sProp].constructor !== Array) {
                                vResult[sProp] = [vResult[sProp]];
                            }
                            vResult[sProp].push(vContent);

                        } else {
                            if (options.childrenAsArray) {
                                vResult[sProp] = [];
                                vResult[sProp].push(vContent);
                            } else {
                                vResult[sProp] = vContent;
                            }
                            nLength++;
                        }
                    }
                }
            } else if (!sCollectedTxt) { // no children and no text, return null
                if (options.childrenAsArray) {
                    vResult[options.textKey] = [];
                    vResult[options.textKey].push(null);
                } else {
                    vResult[options.textKey] = null;
                }
            }

            if (sCollectedTxt) {
                if (options.grokText) {
                    var value = this.grokType(sCollectedTxt.replace(trimMatch, ''));
                    if (value !== null && value !== undefined) {
                        vResult[options.textKey] = value;
                    }
                } else if (options.normalize) {
                    vResult[options.textKey] = sCollectedTxt.replace(trimMatch, '').replace(/\s+/g, " ");
                } else {
                    vResult[options.textKey] = sCollectedTxt.replace(trimMatch, '');
                }
            }

            return vResult;
        };


        // Convert xmlDocument to a string
        // Returns null on failure
        this.xmlToString = function (xmlDoc) {
            try {
                return xmlDoc.xml ? xmlDoc.xml : (new XMLSerializer()).serializeToString(xmlDoc);
            } catch (err) {
                return null;
            }
        };

        // Convert a string to XML Node Structure
        // Returns null on failure
        this.stringToXML = function (xmlString) {
            try {
                var xmlDoc = null;

                if (window.DOMParser) {

                    var parser = new DOMParser();
                    xmlDoc = parser.parseFromString(xmlString, "text/xml");

                    return xmlDoc;
                } else {
                    xmlDoc = new ActiveXObject("Microsoft.XMLDOM");
                    xmlDoc.async = false;
                    xmlDoc.loadXML(xmlString);

                    return xmlDoc;
                }
            } catch (e) {
                return null;
            }
        };

        return this;
    }).call({});

}( XLviewer ));
(function (xlv) {
    /**
     * From jquery
     */
    xlv.extend = function() {
        var options,
            name,
            src,
            copy,
            copyIsArray,
            clone,
            target  = arguments[ 0 ] || {},
            length  = arguments.length,
            deep    = false,
            i       = 1;

        // Handle a deep copy situation
        if ( typeof target === "boolean" ) {
            deep    = target;
            target  = arguments[ 1 ] || {};
            // skip the boolean and the target
            i = 2;
        }

        // Handle case when target is a string or something (possible in deep copy)
        if ( typeof target !== "object" && !xlv.Utils.isFunction( target ) ) {
            target = {};
        }

        // extend jQuery itself if only one argument is passed
        if ( length === i ) {
            target = this;
            --i;
        }

        for ( ; i < length; i++ ) {
            // Only deal with non-null/undefined values
            options = arguments[ i ];
            if ( options !== null || options !== undefined ) {
                // Extend the base object
                for ( name in options ) {
                    src = target[ name ];
                    copy = options[ name ];

                    // Prevent never-ending loop
                    if ( target === copy ) {
                        continue;
                    }

                    // Recurse if we're merging plain objects or arrays
                    if ( deep && copy && ( xlv.Utils.isPlainObject( copy ) || ( copyIsArray = xlv.Utils.isArray( copy ) ) ) ) {
                        if ( copyIsArray ) {
                            copyIsArray = false;
                            clone = src && xlv.Utils.isArray( src ) ? src : [];

                        } else {
                            clone = src && xlv.Utils.isPlainObject( src ) ? src : {};
                        }

                        // Never move original objects, clone them
                        target[ name ] = XLviewer.extend( deep, clone, copy );

                        // Don't bring in undefined values
                    } else if ( copy !== undefined ) {
                        target[ name ] = copy;
                    }
                }
            }
        }
        // Return the modified object
        return target;
    };


    xlv.extend( xlv,{
        /**
         * Costanti della libreria
         */
        CONST: {
            BROWSER: {
                OTHER:    0,
                IE:         1,
                FIREFOX:    2,
                SAFARI:     3,
                CHROME:     4,
                OPERA:      5
            },
            LOG_LEVELS : {
                ERROR : 0,
                WARNING : 1,
                INFO : 2,
                LOG : 3,
                DEBUG : 4
            },
            BLENDING_TYPE : {

            }
        }

    });

    xlv.extend( xlv,{
        /**
         * Settings di default
         */
        DEFAULT_SETTINGS: {
            //DATA SOURCE DETAILS
            id: "xlviewer",
            source: 'http://localhost:7711/closer/',
            image : null,
            images : null,
            enableCORS : true,
            is3D: false,
            quality : 75,
            //PAN AND ZOOM SETTINGS AND CONSTRAINTS
            visibilityRatio: 1, //-> how much of the viewer can be negative space
            minPixelRatio: 0.8, //->closer to 0 draws tiles meant for a higher zoom at this zoom
            defaultZoomLevel: 0,
            minZoomLevel: null,
            maxZoomLevel: null,
            blockHorizontalPanning: false,
            blockVerticalPanning: false,
            //UI RESPONSIVENESS AND FEEL
            clickMaxDuration: 300,
            clickAreaRadius: 5,
            doubleClickMaxDuration: 300,
            doubleClickAreaRadius: 20,
            tweenSmoothness: 3.5,
            tweenDuration: 0.4,
            mouseBehavior: {
                trackScrollZoom: true,
                trackClickZoom: true,
                trackDoubleClickZoom: false,
                trackPinchZoom: false,
                afterDragTweenEnabled: true,
                afterDragTweenMinSpeed: 120,
                afterDragTweenAccel: 0.25,
                trackPinchRotate: false
            },
            touchBehavior: {
                trackScrollZoom: false,
                trackClickZoom: false,
                trackDoubleClickZoom: true,
                trackPinchZoom: true,
                afterDragTweenEnabled: true,
                afterDragTweenMinSpeed: 120,
                afterDragTweenAccel: 0.25,
                trackPinchRotate: true
            },
            clickZoomFactor: 2,
            scrollZoomFactor: 1.2,
            defaultZoomFactor: 1.0,
            blendDuration: 0.5,
            alwaysBlend: false,
            noWaitForRendering: false,
            underZoomRatio: 1, //-> closer to 0 allows zoom out to infinity
            overZoomRatio: 1, //-> higher allows 'over zoom' into pixels
            overZoomRatioForSmoothingTile: 1, //-> higher than overZoomRatio disables it
            mouseScrollFactor: 40,
            scrollTrackMinDuration: 50,
            //DEFAULT CONTROL SETTINGS
            autoResizeViewer: true,
            autoResizeImage: true, // requires autoResizeViewer=true
            mouseEnabled: true,  //GENERAL MOUSE INTERACTIVITY
            //VIEWPORT NAVIGATOR SETTINGS
            useNavigator: false,
            navigatorConfig : {
                id : null,
                position : null,
                sizeRatio: 0.2,
                maintainSizeRatio: false,
                top: null,
                left: null,
                height: null,
                width: null,
                autoResize: true,
                rotate: true
            },
            // INITIAL ROTATION
            rotation: 0,
            // APPEARANCE
            opacity: 1,
            // blendingType = canvas.context.globalCompositeOperation -> (default source-over)
            // http://www.w3schools.com/tags/canvas_globalcompositeoperation.asp
            // no sense to change this
            blendingType: null,
            placeholderFillStyle: null,
            //PERFORMANCE SETTINGS
            imageLoaderLimit: 16,
            maxImageCacheCount: 200,
            timeout: 30000,
            useCanvas: true,  // Use canvas element for drawing if available
            //DEVELOPER SETTINGS
            debug: false,
            logLevel : xlv.CONST.LOG_LEVELS.LOG,
            debugGridColor: '#ff0000'
        }
    });


}(XLviewer));(function (xlv) {
    xlv.Logger = function(level) {
        if(xlv.Utils.type(level) == "string") {
            level = parseInt(level, 10);
            if(isNaN(level)) {
                level = 0;
            }
        }
        if(xlv.Utils.type(level) != "number") {
            level = 0;
        }
        level = xlv.Utils.clamp(Math.round(level), xlv.CONST.LOG_LEVELS.ERROR, xlv.CONST.LOG_LEVELS.DEBUG)

        var muted = function(args){};
        var warning = level >= xlv.CONST.LOG_LEVELS.WARNING ? window.console.warn : muted;
        var info = level >= xlv.CONST.LOG_LEVELS.INFO ? window.console.info : muted;
        var log = level >= xlv.CONST.LOG_LEVELS.LOG ? window.console.log : muted;
        var debug = level >= xlv.CONST.LOG_LEVELS.DEBUG ? window.console.debug : muted;

        var logger = {};
        logger.e = logger.err = logger.error = window.console.error; // never muted
        logger.w = logger.warn = logger.warning = warning;
        logger.i = logger.info = info;
        logger.l = logger.log = log;
        logger.d = logger.dbg = logger.debug = debug;
        return logger;
    }
}(XLviewer));
(function (xlv) {
    xlv.extend(xlv, {
        /**
         * Returns a DOM Element for the given id or element.
         */
        getElement: function( element ) {
            if ( typeof ( element ) == "string" ) {
                element = document.getElementById( element );
            }
            return element;
        },
        /**
         * Determines the position of the upper-left corner of the element.
         */
        getElementPosition: function( element ) {
            var result = new xlv.Point(),
                isFixed,
                offsetParent;

            element      = xlv.getElement( element );
            offsetParent = this.getOffsetParent( element );

            while ( offsetParent ) {

                result.x += element.offsetLeft;
                result.y += element.offsetTop;

                if ( isFixed ) {
                    result = result.plus( xlv.getPageScroll() );
                }

                element = offsetParent;
                offsetParent = this.getOffsetParent( element );
            }

            return result;
        },
        getOffsetParent : function (element) {
            var positionStyle = element.style.position;
            var skipStatic = positionStyle == "fixed" || positionStyle == "absolute";
            for (var parent = element.parentNode;parent && parent != element;parent = parent.parentNode) {
                positionStyle = parent.style.position;
                skipStatic = skipStatic && positionStyle == "static" && parent != element;
                if (!skipStatic && (parent.scrollWidth > parent.clientWidth || parent.scrollHeight > parent.clientHeight || positionStyle == "fixed" || positionStyle == "absolute" || positionStyle == "relative")) {
                    return parent;
                }
            }
            return null;
        },
        /**
         * Determines the position of the upper-left corner of the element adjusted for current page and/or element scroll..
         */
        getElementOffset: function( element ) {
            element = xlv.getElement( element );

            var doc = element && element.ownerDocument,
                docElement,
                win,
                boundingRect = { top: 0, left: 0 };

            if ( !doc ) {
                return new xlv.Point();
            }

            docElement = doc.documentElement;

            if ( typeof element.getBoundingClientRect !== typeof undefined ) {
                boundingRect = element.getBoundingClientRect();
            }

            win = ( doc == doc.window ) ?
                doc :
                ( doc.nodeType === 9 ) ?
                    doc.defaultView || doc.parentWindow :
                    false;

            return new xlv.Point(
                boundingRect.left + ( win.pageXOffset || docElement.scrollLeft ) - ( docElement.clientLeft || 0 ),
                boundingRect.top + ( win.pageYOffset || docElement.scrollTop ) - ( docElement.clientTop || 0 )
            );
        },
        /**
         * Determines the height and width of the given element.
         */
        getElementSize: function( element ) {
            element = xlv.getElement( element );

            return new xlv.Point(
                element.clientWidth,
                element.clientHeight
            );
        },
        /**
         * Returns the CSSStyle object for the given element.
         * @function
         * @param {Element|String} element
         * @returns {CSSStyle}
         */
        getElementStyle:
            document.documentElement.currentStyle ?
                function( element ) {
                    element = xlv.getElement( element );
                    return element.currentStyle;
                } :
                function( element ) {
                    element = xlv.getElement( element );
                    return window.getComputedStyle( element, "" );
                },
        /**
         * Returns the property with the correct browser prefix appended.
         */
        getCssPropertyWithVendorPrefix: function(property) {
            var memo = {};

            xlv.getCssPropertyWithVendorPrefix = function(property) {
                if (memo[property] !== undefined) {
                    return memo[property];
                }
                var style = document.createElement('div').style;
                var result = null;
                if (style[property] !== undefined) {
                    result = property;
                } else {
                    var prefixes = ['Webkit', 'Moz', 'MS', 'O',
                        'webkit', 'moz', 'ms', 'o'];
                    var suffix = xlv.Utils.capitalizeFirstLetter(property);
                    for (var i = 0; i < prefixes.length; i++) {
                        var prop = prefixes[i] + suffix;
                        if (style[prop] !== undefined) {
                            result = prop;
                            break;
                        }
                    }
                }
                memo[property] = result;
                return result;
            };
            return xlv.getCssPropertyWithVendorPrefix(property);
        },
        /**
         * Determines if a point is within the bounding rectangle of the given element
         */
        hitTest: function( element, point ) {
            element = xlv.getElement( element );
            var offset = xlv.getElementOffset( element ),
                size = xlv.getElementSize( element );
            return point.x >= offset.x && point.x < offset.x + size.x && point.y < offset.y + size.y && point.y >= offset.y;
        },
        /**
         * Gets the position of the mouse on the screen for a given event.

         */
        getMousePosition: function( event ) {

            if ( typeof( event.pageX ) == "number" ) {
                xlv.getMousePosition = function( event ){
                    var result = new xlv.Point();

                    event = xlv.getEvent( event );
                    result.x = event.pageX;
                    result.y = event.pageY;

                    return result;
                };
            } else if ( typeof( event.clientX ) == "number" ) {
                xlv.getMousePosition = function( event ){
                    var result = new xlv.Point();

                    event = xlv.getEvent( event );
                    result.x =
                        event.clientX +
                        document.body.scrollLeft +
                        document.documentElement.scrollLeft;
                    result.y =
                        event.clientY +
                        document.body.scrollTop +
                        document.documentElement.scrollTop;

                    return result;
                };
            } else {
                throw new Error(
                    "Unknown event mouse position, no known technique."
                );
            }

            return xlv.getMousePosition( event );
        },
        /**
         * Determines the page's current scroll position.
         */
        getPageScroll: function() {
            var docElement  = document.documentElement || {},
                body        = document.body || {};

            if ( typeof( window.pageXOffset ) == "number" ) {
                xlv.getPageScroll = function(){
                    return new xlv.Point(
                        window.pageXOffset,
                        window.pageYOffset
                    );
                };
            } else if ( body.scrollLeft || body.scrollTop ) {
                xlv.getPageScroll = function(){
                    return new xlv.Point(
                        document.body.scrollLeft,
                        document.body.scrollTop
                    );
                };
            } else if ( docElement.scrollLeft || docElement.scrollTop ) {
                xlv.getPageScroll = function(){
                    return new xlv.Point(
                        document.documentElement.scrollLeft,
                        document.documentElement.scrollTop
                    );
                };
            } else {
                // We can't reassign the function yet, as there was no scroll.
                return new xlv.Point(0,0);
            }

            return xlv.getPageScroll();
        },
        /**
         * Set the page scroll position.
         * @function
         * @returns {XLviewer.Point}
         */
        setPageScroll: function( scroll ) {
            if ( typeof ( window.scrollTo ) !== "undefined" ) {
                xlv.setPageScroll = function( scroll ) {
                    window.scrollTo( scroll.x, scroll.y );
                };
            } else {
                var originalScroll = xlv.getPageScroll();
                if ( originalScroll.x === scroll.x &&
                    originalScroll.y === scroll.y ) {
                    // We are already correctly positioned and there
                    // is no way to detect the correct method.
                    return;
                }

                document.body.scrollLeft = scroll.x;
                document.body.scrollTop = scroll.y;
                var currentScroll = xlv.getPageScroll();
                if ( currentScroll.x !== originalScroll.x &&
                    currentScroll.y !== originalScroll.y ) {
                    xlv.setPageScroll = function( scroll ) {
                        document.body.scrollLeft = scroll.x;
                        document.body.scrollTop = scroll.y;
                    };
                    return;
                }

                document.documentElement.scrollLeft = scroll.x;
                document.documentElement.scrollTop = scroll.y;
                currentScroll = xlv.getPageScroll();
                if ( currentScroll.x !== originalScroll.x &&
                    currentScroll.y !== originalScroll.y ) {
                    xlv.setPageScroll = function( scroll ) {
                        document.documentElement.scrollLeft = scroll.x;
                        document.documentElement.scrollTop = scroll.y;
                    };
                    return;
                }

                // We can't find anything working, so we do nothing.
                xlv.setPageScroll = function( scroll ) {
                };
            }

            return xlv.setPageScroll( scroll );
        },

        /**
         * Determines the size of the browsers window.
         * @function
         * @returns {XLviewer.Point}
         */
        getWindowSize: function() {
            var docElement = document.documentElement || {},
                body    = document.body || {};

            if ( typeof( window.innerWidth ) == 'number' ) {
                xlv.getWindowSize = function(){
                    return new xlv.Point(
                        window.innerWidth,
                        window.innerHeight
                    );
                };
            } else if ( docElement.clientWidth || docElement.clientHeight ) {
                xlv.getWindowSize = function(){
                    return new xlv.Point(
                        document.documentElement.clientWidth,
                        document.documentElement.clientHeight
                    );
                };
            } else if ( body.clientWidth || body.clientHeight ) {
                xlv.getWindowSize = function(){
                    return new xlv.Point(
                        document.body.clientWidth,
                        document.body.clientHeight
                    );
                };
            } else {
                throw new Error("Unknown window size, no known technique.");
            }

            return xlv.getWindowSize();
        },


        /**
         * Wraps the given element in a nest of divs so that the element can
         * be easily centered using CSS tables
         * @function
         * @param {Element|String} element
         * @returns {Element} outermost wrapper element
         */
        makeCenteredNode: function( element ) {
            // Convert a possible ID to an actual HTMLElement
            element = xlv.getElement( element );

            /*
             CSS tables require you to have a display:table/row/cell hierarchy so we need to create
             three nested wrapper divs:
             */

            var wrappers = [
                xlv.makeNeutralElement( 'div' ),
                xlv.makeNeutralElement( 'div' ),
                xlv.makeNeutralElement( 'div' )
            ];

            // It feels like we should be able to pass style dicts to makeNeutralElement:
            xlv.extend(wrappers[0].style, {
                display: "table",
                height: "100%",
                width: "100%"
            });

            xlv.extend(wrappers[1].style, {
                display: "table-row"
            });

            xlv.extend(wrappers[2].style, {
                display: "table-cell",
                verticalAlign: "middle",
                textAlign: "center"
            });

            wrappers[0].appendChild(wrappers[1]);
            wrappers[1].appendChild(wrappers[2]);
            wrappers[2].appendChild(element);

            return wrappers[0];
        },


        /**
         * Creates an easily positionable element of the given type that therefor
         * serves as an excellent container element.
         * @function
         * @param {String} tagName
         * @returns {Element}
         */
        makeNeutralElement: function( tagName ) {
            var element = document.createElement( tagName ),
                style   = element.style;

            style.background = "transparent none";
            style.border     = "none";
            style.margin     = "0px";
            style.padding    = "0px";
            style.position   = "static";

            return element;
        },

        /**
         * Ensures an image is loaded correctly to support alpha transparency.
         * Generally only IE has issues doing this correctly for formats like
         * png.
         * @function
         * @param {String} src
         * @returns {Element}
         */
        makeTransparentImage: function( src ) {

            xlv.makeTransparentImage = function( src ){
                var img = xlv.makeNeutralElement( "img" );

                img.src = src;

                return img;
            };

            if ( xlv.Browser.vendor == xlv.CONST.BROWSER.IE && xlv.Browser.version < 7 ) {

                xlv.makeTransparentImage = function( src ){
                    var img     = xlv.makeNeutralElement( "img" ),
                        element = null;

                    element = xlv.makeNeutralElement("span");
                    element.style.display = "inline-block";

                    img.onload = function() {
                        element.style.width  = element.style.width || img.width + "px";
                        element.style.height = element.style.height || img.height + "px";

                        img.onload = null;
                        img = null;     // to prevent memory leaks in IE
                    };

                    img.src = src;
                    element.style.filter =
                        "progid:DXImageTransform.Microsoft.AlphaImageLoader(src='" +
                        src +
                        "', sizingMethod='scale')";

                    return element;
                };

            }

            return xlv.makeTransparentImage( src );
        },


        /**
         * Sets the opacity of the specified element.
         * @function
         * @param {Element|String} element
         * @param {Number} opacity
         * @param {Boolean} [usesAlpha]
         */
        setElementOpacity: function( element, opacity, usesAlpha ) {

            var ieOpacity,
                ieFilter;

            element = xlv.getElement( element );

            if ( usesAlpha && !xlv.Browser.alpha ) {
                opacity = Math.round( opacity );
            }

            if ( xlv.Browser.opacity ) {
                element.style.opacity = opacity < 1 ? opacity : "";
            } else {
                if ( opacity < 1 ) {
                    ieOpacity = Math.round( 100 * opacity );
                    ieFilter  = "alpha(opacity=" + ieOpacity + ")";
                    element.style.filter = ieFilter;
                } else {
                    element.style.filter = "";
                }
            }
        },
        /**
         * Sets visibility of the specified element.
         */
        setElementVisible: function( element, visible ) {
            element.style.visibility = visible ? 'visible' : 'hidden';
        },


        /**
         * Sets the specified element's touch-action style attribute to 'none'.
         */
        setElementTouchActionNone: function( element ) {
            element = xlv.getElement( element );
            if ( typeof element.style.touchAction !== 'undefined' ) {
                element.style.touchAction = 'none';
            } else if ( typeof element.style.msTouchAction !== 'undefined' ) {
                element.style.msTouchAction = 'none';
            }
        },


        /**
         * Add the specified CSS class to the element if not present.
         */
        addClass: function( element, className ) {
            element = xlv.getElement( element );

            if ( ! element.className ) {
                element.className = className;
            } else if ( ( ' ' + element.className + ' ' ).
            indexOf( ' ' + className + ' ' ) === -1 ) {
                element.className += ' ' + className;
            }
        },

        /**
         * Remove the specified CSS class from the element.
         */
        removeClass: function( element, className ) {
            var oldClasses,
                newClasses = [],
                i;

            element = xlv.getElement( element );
            oldClasses = element.className.split( /\s+/ );
            for ( i = 0; i < oldClasses.length; i++ ) {
                if ( oldClasses[ i ] && oldClasses[ i ] !== className ) {
                    newClasses.push( oldClasses[ i ] );
                }
            }
            element.className = newClasses.join(' ');
        },

        /**
         * Find the first index at which an element is found in an array or -1
         * if not present.
         */
        indexOf: function( array, searchElement, fromIndex ) {
            if ( Array.prototype.indexOf ) {
                this.indexOf = function( array, searchElement, fromIndex ) {
                    return array.indexOf( searchElement, fromIndex );
                };
            } else {
                this.indexOf = function( array, searchElement, fromIndex ) {
                    var i,
                        pivot = ( fromIndex ) ? fromIndex : 0,
                        length;
                    if ( !array ) {
                        throw new TypeError( );
                    }

                    length = array.length;
                    if ( length === 0 || pivot >= length ) {
                        return -1;
                    }

                    if ( pivot < 0 ) {
                        pivot = length - Math.abs( pivot );
                    }

                    for ( i = pivot; i < length; i++ ) {
                        if ( array[i] === searchElement ) {
                            return i;
                        }
                    }
                    return -1;
                };
            }
            return this.indexOf( array, searchElement, fromIndex );
        },
        setElementInteractive : function (element, value) {
            element = xlv.getElement( element );
            element.style.pointerEvents = value ? "all" : "none";
        }
    });



// Adding support for HTML5's requestAnimationFrame as suggested by acdha.
// Implementation taken from matt synder's post here:
// http://mattsnider.com/cross-browser-and-legacy-supported-requestframeanimation/
    (function( w ) {

        // most browsers have an implementation
        var requestAnimationFrame = w.requestAnimationFrame ||
            w.mozRequestAnimationFrame ||
            w.webkitRequestAnimationFrame ||
            w.msRequestAnimationFrame;

        var cancelAnimationFrame = w.cancelAnimationFrame ||
            w.mozCancelAnimationFrame ||
            w.webkitCancelAnimationFrame ||
            w.msCancelAnimationFrame;

        // polyfill, when necessary
        if ( requestAnimationFrame && cancelAnimationFrame ) {
            // We can't assign these window methods directly to $ because they
            // expect their "this" to be "window", so we call them in wrappers.
            xlv.requestAnimationFrame = function(){
                return requestAnimationFrame.apply( w, arguments );
            };
            xlv.cancelAnimationFrame = function(){
                return cancelAnimationFrame.apply( w, arguments );
            };
        } else {
            var aAnimQueue = [],
                processing = [],
                iRequestId = 0,
                iIntervalId;

            // create a mock requestAnimationFrame function
            xlv.requestAnimationFrame = function( callback ) {
                aAnimQueue.push( [ ++iRequestId, callback ] );

                if ( !iIntervalId ) {
                    iIntervalId = setInterval( function() {
                        if ( aAnimQueue.length ) {
                            var time = (new Date).getTime();
                            // Process all of the currently outstanding frame
                            // requests, but none that get added during the
                            // processing.
                            // Swap the arrays so we don't have to create a new
                            // array every frame.
                            var temp = processing;
                            processing = aAnimQueue;
                            aAnimQueue = temp;
                            while ( processing.length ) {
                                processing.shift()[ 1 ]( time );
                            }
                        } else {
                            // don't continue the interval, if unnecessary
                            clearInterval( iIntervalId );
                            iIntervalId = undefined;
                        }
                    }, 1000 / 50);  // estimating support for 50 frames per second
                }

                return iRequestId;
            };

            // create a mock cancelAnimationFrame function
            xlv.cancelAnimationFrame = function( requestId ) {
                // find the request ID and remove it
                var i, j;
                for ( i = 0, j = aAnimQueue.length; i < j; i += 1 ) {
                    if ( aAnimQueue[ i ][ 0 ] === requestId ) {
                        aAnimQueue.splice( i, 1 );
                        return;
                    }
                }

                // If it's not in the queue, it may be in the set we're currently
                // processing (if cancelAnimationFrame is called from within a
                // requestAnimationFrame callback).
                for ( i = 0, j = processing.length; i < j; i += 1 ) {
                    if ( processing[ i ][ 0 ] === requestId ) {
                        processing.splice( i, 1 );
                        return;
                    }
                }
            };
        }
    })( window );
}(XLviewer));(function (xlv) {
    xlv.Browser = {
        vendor:     xlv.CONST.BROWSER.OTHER,
        version:    0,
        alpha:      true
    };

    //A small auto-executing routine to determine the browser vendor,
    //version and supporting feature sets.
    var ver = navigator.appVersion,
        ua  = navigator.userAgent,
        regex;

    //console.error( 'appName: ' + navigator.appName );
    //console.error( 'appVersion: ' + navigator.appVersion );
    //console.error( 'userAgent: ' + navigator.userAgent );

    switch( navigator.appName ){
        case "Microsoft Internet Explorer":
            if( !!window.attachEvent &&
                !!window.ActiveXObject ) {

                xlv.Browser.vendor = xlv.CONST.BROWSER.IE;
                xlv.Browser.version = parseFloat(
                    ua.substring(
                        ua.indexOf( "MSIE" ) + 5,
                        ua.indexOf( ";", ua.indexOf( "MSIE" ) ) )
                );
            }
            break;
        case "Netscape":
            if( !!window.addEventListener ){
                if ( ua.indexOf( "Firefox" ) >= 0 ) {
                    xlv.Browser.vendor = xlv.CONST.BROWSER.FIREFOX;
                    xlv.Browser.version = parseFloat(
                        ua.substring( ua.indexOf( "Firefox" ) + 8 )
                    );
                } else if ( ua.indexOf( "Safari" ) >= 0 ) {
                    xlv.Browser.vendor = ua.indexOf( "Chrome" ) >= 0 ?
                        xlv.CONST.BROWSER.CHROME :
                        xlv.CONST.BROWSER.SAFARI;
                    xlv.Browser.version = parseFloat(
                        ua.substring(
                            ua.substring( 0, ua.indexOf( "Safari" ) ).lastIndexOf( "/" ) + 1,
                            ua.indexOf( "Safari" )
                        )
                    );
                } else {
                    regex = new RegExp( "Trident/.*rv:([0-9]{1,}[.0-9]{0,})");
                    if ( regex.exec( ua ) !== null ) {
                        xlv.Browser.vendor = xlv.CONST.BROWSER.IE;
                        xlv.Browser.version = parseFloat( RegExp.$1 );
                    }
                }
            }
            break;
        case "Opera":
            xlv.Browser.vendor = xlv.CONST.BROWSER.OPERA;
            xlv.Browser.version = parseFloat( ver );
            break;
    }

    //determine if this browser supports image alpha transparency
    xlv.Browser.alpha = !(
        (
            xlv.Browser.vendor == xlv.CONST.BROWSER.IE &&
            xlv.Browser.version < 9
        ) || (
            xlv.Browser.vendor == xlv.CONST.BROWSER.CHROME &&
            xlv.Browser.version < 2
        )
    );

    //determine if this browser supports element.style.opacity
    xlv.Browser.opacity = !(
        xlv.Browser.vendor == xlv.CONST.BROWSER.IE &&
        xlv.Browser.version < 9
    );

}(XLviewer));(function( xlv ) {
    /**
     * Determine native full screen support we can get from the browser.
     * @member fullScreenApi
     * @memberof XLviewer
     * @type {object}
     * @property {Boolean} supportsFullScreen Return true if full screen API is supported.
     * @property {Function} isFullScreen Return true if currently in full screen mode.
     * @property {Function} getFullScreenElement Return the element currently in full screen mode.
     * @property {Function} requestFullScreen Make a request to go in full screen mode.
     * @property {Function} exitFullScreen Make a request to exit full screen mode.
     * @property {Function} cancelFullScreen Deprecated, use exitFullScreen instead.
     * @property {String} fullScreenEventName Event fired when the full screen mode change.
     * @property {String} fullScreenErrorEventName Event fired when a request to go
     * in full screen mode failed.
     */
    var fullScreenApi = {
        supportsFullScreen: false,
        isFullScreen: function() { return false; },
        getFullScreenElement: function() { return null; },
        requestFullScreen: function() {},
        exitFullScreen: function() {},
        cancelFullScreen: function() {},
        fullScreenEventName: '',
        fullScreenErrorEventName: ''
    };

    // check for native support
    if ( document.exitFullscreen ) {
        // W3C standard
        fullScreenApi.supportsFullScreen = true;
        fullScreenApi.getFullScreenElement = function() {
            return document.fullscreenElement;
        };
        fullScreenApi.requestFullScreen = function( element ) {
            return element.requestFullscreen();
        };
        fullScreenApi.exitFullScreen = function() {
            document.exitFullscreen();
        };
        fullScreenApi.fullScreenEventName = "fullscreenchange";
        fullScreenApi.fullScreenErrorEventName = "fullscreenerror";
    } else if ( document.msExitFullscreen ) {
        // IE 11
        fullScreenApi.supportsFullScreen = true;
        fullScreenApi.getFullScreenElement = function() {
            return document.msFullscreenElement;
        };
        fullScreenApi.requestFullScreen = function( element ) {
            return element.msRequestFullscreen();
        };
        fullScreenApi.exitFullScreen = function() {
            document.msExitFullscreen();
        };
        fullScreenApi.fullScreenEventName = "MSFullscreenChange";
        fullScreenApi.fullScreenErrorEventName = "MSFullscreenError";
    } else if ( document.webkitExitFullscreen ) {
        // Recent webkit
        fullScreenApi.supportsFullScreen = true;
        fullScreenApi.getFullScreenElement = function() {
            return document.webkitFullscreenElement;
        };
        fullScreenApi.requestFullScreen = function( element ) {
            return element.webkitRequestFullscreen();
        };
        fullScreenApi.exitFullScreen = function() {
            document.webkitExitFullscreen();
        };
        fullScreenApi.fullScreenEventName = "webkitfullscreenchange";
        fullScreenApi.fullScreenErrorEventName = "webkitfullscreenerror";
    } else if ( document.webkitCancelFullScreen ) {
        // Old webkit
        fullScreenApi.supportsFullScreen = true;
        fullScreenApi.getFullScreenElement = function() {
            return document.webkitCurrentFullScreenElement;
        };
        fullScreenApi.requestFullScreen = function( element ) {
            return element.webkitRequestFullScreen();
        };
        fullScreenApi.exitFullScreen = function() {
            document.webkitCancelFullScreen();
        };
        fullScreenApi.fullScreenEventName = "webkitfullscreenchange";
        fullScreenApi.fullScreenErrorEventName = "webkitfullscreenerror";
    } else if ( document.mozCancelFullScreen ) {
        // Firefox
        fullScreenApi.supportsFullScreen = true;
        fullScreenApi.getFullScreenElement = function() {
            return document.mozFullScreenElement;
        };
        fullScreenApi.requestFullScreen = function( element ) {
            return element.mozRequestFullScreen();
        };
        fullScreenApi.exitFullScreen = function() {
            document.mozCancelFullScreen();
        };
        fullScreenApi.fullScreenEventName = "mozfullscreenchange";
        fullScreenApi.fullScreenErrorEventName = "mozfullscreenerror";
    }
    fullScreenApi.isFullScreen = function() {
        return fullScreenApi.getFullScreenElement() !== null;
    };
    fullScreenApi.cancelFullScreen = function() {
        xlv.log.e("cancelFullScreen is deprecated. Use exitFullScreen instead.");
        fullScreenApi.exitFullScreen();
    };

    // export api
    xlv.extend( xlv, fullScreenApi );

})( XLviewer );
(function(xlv){

    /**
     * EventDispatcher for use by classes which want to support custom, non-browser events.
     */
    xlv.EventDispatcher = function() {
        this.events = {};
    };

    xlv.EventDispatcher.prototype = {

        /**
         * Add an event handler to be triggered only once (or a given number of times)
         * for a given event.
         */
        addListenerOnce: function(eventName, handler, userData, times) {
            var self = this;
            times = times || 1;
            var count = 0;
            var onceHandler = function(event) {
                count++;
                if (count === times) {
                    self.removeListener(eventName, onceHandler);
                }
                handler(event);
            };
            this.addListener(eventName, onceHandler, userData);
        },

        /**
         * Add an event handler for a given event.
         */
        addListener: function ( eventName, handler, userData ) {
            var events = this.events[ eventName ];
            if ( !events ) {
                this.events[ eventName ] = events = [];
            }
            if ( handler && xlv.Utils.isFunction( handler ) ) {
                events[ events.length ] = { handler: handler, userData: userData || null };
            }
        },

        /**
         * Remove a specific event handler for a given event.
         */
        removeListener: function ( eventName, handler ) {
            var events = this.events[ eventName ],
                handlers = [],
                i;
            if ( !events ) {
                return;
            }
            if ( xlv.Utils.isArray( events ) ) {
                for ( i = 0; i < events.length; i++ ) {
                    if ( events[i].handler !== handler ) {
                        handlers.push( events[ i ] );
                    }
                }
                this.events[ eventName ] = handlers;
            }
        },


        /**
         * Remove all event handlers for a given event type. If no type is given all
         * event handlers for every event type are removed.
         */
        removeAllHandlers: function( eventName ) {
            if ( eventName ){
                this.events[ eventName ] = [];
            } else{
                for ( var eventType in this.events ) {
                    this.events[ eventType ] = [];
                }
            }
        },

        /**
         * Get a function which iterates the list of all handlers registered for a given event, calling the handler for each.
         */
        getHandler: function ( eventName ) {
            var events = this.events[ eventName ];
            if ( !events || !events.length ) {
                return null;
            }
            events = events.length === 1 ?
                [ events[ 0 ] ] :
                Array.apply( null, events );
            return function ( source, args ) {
                var i,
                    length = events.length;
                for ( i = 0; i < length; i++ ) {
                    if ( events[ i ] ) {
                        args.eventSource = source;
                        args.userData = events[ i ].userData;
                        events[ i ].handler( args );
                    }
                }
            };
        },

        /**
         * Dispatch an event, optionally passing additional information.
         */
        dispatchEvent: function( eventName, eventArgs ) {
            //uncomment if you want to get a log of all events
            //xlv.console.log( eventName );
            var handler = this.getHandler( eventName );

            if ( handler ) {
                if ( !eventArgs ) {
                    eventArgs = {};
                }

                handler( this, eventArgs );
            }
        }
    };

}( XLviewer ));
(function (xlv) {
    xlv.extend(xlv, {
        /**
         * Gets the latest event, useful internally for
         * specific IE behavior
         */
        getEvent: function( event ) {
            if( event ){
                xlv.getEvent = function( event ) {
                    return event;
                };
            } else {
                xlv.getEvent = function() {
                    return window.event;
                };
            }
            return xlv.getEvent( event );
        },
        /**
         * Adds an event listener for the given element, eventName and handler.
         * @function
         * @param {Element|String} element
         * @param {String} eventName
         * @param {Function} handler
         * @param {Boolean} [useCapture]
         */
        bind: (function () {
            if ( window.addEventListener ) {
                return function ( element, eventName, handler, useCapture ) {
                    element = xlv.getElement( element );
                    element.addEventListener( eventName, handler, useCapture );
                };
            } else if ( window.attachEvent ) {
                return function ( element, eventName, handler, useCapture ) {
                    element = xlv.getElement( element );
                    element.attachEvent( 'on' + eventName, handler );
                };
            } else {
                throw new Error( "No known event model." );
            }
        }()),


        /**
         * Remove a given event listener for the given element, event type and
         * handler.
         * @function
         * @param {Element|String} element
         * @param {String} eventName
         * @param {Function} handler
         * @param {Boolean} [useCapture]
         */
        unbind: (function () {
            if ( window.removeEventListener ) {
                return function ( element, eventName, handler, useCapture ) {
                    element = xlv.getElement( element );
                    element.removeEventListener( eventName, handler, useCapture );
                };
            } else if ( window.detachEvent ) {
                return function( element, eventName, handler, useCapture ) {
                    element = xlv.getElement( element );
                    element.detachEvent( 'on' + eventName, handler );
                };
            } else {
                throw new Error( "No known event model." );
            }
        }()),


        /**
         * Cancels the default browser behavior had the event propagated all
         * the way up the DOM to the window object.
         * @function
         * @param {Event} [event]
         */
        cancelEvent: function( event ) {
            event = xlv.getEvent( event );

            if ( event.preventDefault ) {
                xlv.cancelEvent = function( event ){
                    // W3C for preventing default
                    event.preventDefault();
                };
            } else {
                xlv.cancelEvent = function( event ){
                    event = xlv.getEvent( event );
                    // legacy for preventing default
                    event.cancel = true;
                    // IE for preventing default
                    event.returnValue = false;
                };
            }
            xlv.cancelEvent( event );
        },


        /**
         * Stops the propagation of the event (cross browser).
         * @param {Event} [event]
         */
        stopEvent: function( event ) {
            event = xlv.getEvent( event );

            if ( event.stopPropagation ) {
                // W3C for stopping propagation
                xlv.stopEvent = function( event ){
                    event.stopPropagation();
                };
            } else {
                // IE for stopping propagation
                xlv.stopEvent = function( event ){
                    event = xlv.getEvent( event );
                    event.cancelBubble = true;
                };

            }

            xlv.stopEvent( event );
        }
    });
}(XLviewer));(function ( xlv ) {

    // All InteractionManager instances
    var MANAGERS  = [];

    // dictionary from hash to private properties
    var INSTANCES           = {};


    /**
     * Provides simplified handling of common pointer device (mouse, touch, etc.) gestures
     * and keyboard events on a specified element.
     */
    xlv.InteractionManager = function ( options ) {

        MANAGERS.push( this );

        var args = arguments;

        if ( !xlv.Utils.isPlainObject( options ) ) {
            options = {
                element:            args[ 0 ],
                clickMaxDuration: args[ 1 ],
                clickAreaRadius: args[ 2 ]
            };
        }

        this.hash               = Math.random(); // An unique hash for this tracker.
        /**
         * The element for which pointer events are being monitored.
         */
        this.element            = xlv.getElement( options.element );
        /**
         * The number of milliseconds within which a pointer down-up event combination
         * will be treated as a click gesture.
         */
        this.clickMaxDuration = options.clickMaxDuration || xlv.DEFAULT_SETTINGS.clickMaxDuration;
        /**
         * The maximum distance allowed between a pointer down event and a pointer up event
         * to be treated as a click gesture.
         */
        this.clickAreaRadius = options.clickAreaRadius || xlv.DEFAULT_SETTINGS.clickAreaRadius;
        /**
         * The number of milliseconds within which two pointer down-up event combinations
         * will be treated as a double-click gesture.
         */
        this.doubleClickMaxDuration = options.doubleClickMaxDuration || xlv.DEFAULT_SETTINGS.doubleClickMaxDuration;
        /**
         * The maximum distance allowed between two pointer click events
         * to be treated as a click gesture.
         */
        this.doubleClickAreaRadius = options.doubleClickAreaRadius || xlv.DEFAULT_SETTINGS.doubleClickAreaRadius;
        this.userData              = options.userData          || null;
        this.stopDelay             = options.stopDelay         || 50;

        this.enterHandler             = options.enterHandler             || null;
        this.exitHandler              = options.exitHandler              || null;
        this.pressHandler             = options.pressHandler             || null;
        this.nonPrimaryPressHandler   = options.nonPrimaryPressHandler   || null;
        this.releaseHandler           = options.releaseHandler           || null;
        this.nonPrimaryReleaseHandler = options.nonPrimaryReleaseHandler || null;
        this.moveHandler              = options.moveHandler              || null;
        this.scrollHandler            = options.scrollHandler            || null;
        this.clickHandler             = options.clickHandler             || null;
        this.dblClickHandler          = options.dblClickHandler          || null;
        this.dragHandler              = options.dragHandler              || null;
        this.dragEndHandler           = options.dragEndHandler           || null;
        this.pinchHandler             = options.pinchHandler             || null;
        this.stopHandler              = options.stopHandler              || null;
        this.keyDownHandler           = options.keyDownHandler           || null;
        this.keyUpHandler             = options.keyUpHandler             || null;
        this.keyHandler               = options.keyHandler               || null;
        this.focusHandler             = options.focusHandler             || null;
        this.blurHandler              = options.blurHandler              || null;

        //Store private properties in a scope sealed hash map
        var _this = this;

        INSTANCES[ this.hash ] = {
            click:                 function ( event ) { onClick( _this, event ); },
            dblclick:              function ( event ) { onDblClick( _this, event ); },
            keydown:               function ( event ) { onKeyDown( _this, event ); },
            keyup:                 function ( event ) { onKeyUp( _this, event ); },
            keypress:              function ( event ) { onKeyPress( _this, event ); },
            focus:                 function ( event ) { onFocus( _this, event ); },
            blur:                  function ( event ) { onBlur( _this, event ); },

            wheel:                 function ( event ) { onWheel( _this, event ); },
            mousewheel:            function ( event ) { onMouseWheel( _this, event ); },
            DOMMouseScroll:        function ( event ) { onMouseWheel( _this, event ); },
            MozMousePixelScroll:   function ( event ) { onMouseWheel( _this, event ); },

            mouseenter:            function ( event ) { onMouseEnter( _this, event ); }, // Used on IE8 only
            mouseleave:            function ( event ) { onMouseLeave( _this, event ); }, // Used on IE8 only
            mouseover:             function ( event ) { onMouseOver( _this, event ); },
            mouseout:              function ( event ) { onMouseOut( _this, event ); },
            mousedown:             function ( event ) { onMouseDown( _this, event ); },
            mouseup:               function ( event ) { onMouseUp( _this, event ); },
            mouseupcaptured:       function ( event ) { onMouseUpCaptured( _this, event ); },
            mousemove:             function ( event ) { onMouseMove( _this, event ); },
            mousemovecaptured:     function ( event ) { onMouseMoveCaptured( _this, event ); },

            touchstart:            function ( event ) { onTouchStart( _this, event ); },
            touchend:              function ( event ) { onTouchEnd( _this, event ); },
            touchendcaptured:      function ( event ) { onTouchEndCaptured( _this, event ); },
            touchmove:             function ( event ) { onTouchMove( _this, event ); },
            touchmovecaptured:     function ( event ) { onTouchMoveCaptured( _this, event ); },
            touchcancel:           function ( event ) { onTouchCancel( _this, event ); },

            gesturestart:          function ( event ) { onGestureStart( _this, event ); },
            gesturechange:         function ( event ) { onGestureChange( _this, event ); },

            pointerover:           function ( event ) { onPointerOver( _this, event ); },
            MSPointerOver:         function ( event ) { onPointerOver( _this, event ); },
            pointerout:            function ( event ) { onPointerOut( _this, event ); },
            MSPointerOut:          function ( event ) { onPointerOut( _this, event ); },
            pointerdown:           function ( event ) { onPointerDown( _this, event ); },
            MSPointerDown:         function ( event ) { onPointerDown( _this, event ); },
            pointerup:             function ( event ) { onPointerUp( _this, event ); },
            MSPointerUp:           function ( event ) { onPointerUp( _this, event ); },
            pointermove:           function ( event ) { onPointerMove( _this, event ); },
            MSPointerMove:         function ( event ) { onPointerMove( _this, event ); },
            pointercancel:         function ( event ) { onPointerCancel( _this, event ); },
            MSPointerCancel:       function ( event ) { onPointerCancel( _this, event ); },
            pointerupcaptured:     function ( event ) { onPointerUpCaptured( _this, event ); },
            pointermovecaptured:   function ( event ) { onPointerMoveCaptured( _this, event ); },

            tracking:              false,

            // Active pointers lists. Array of GesturePointList objects, one for each pointer device type.
            // GesturePointList objects are added each time a pointer is tracked by a new pointer device type (see getActivePointersListByType()).
            // Active pointers are any pointer being tracked for this element which are in the hit-test area
            //     of the element (for hover-capable devices) and/or have contact or a button press initiated in the element.
            activePointersLists:   [],

            // Tracking for double-click gesture
            lastClickPos:          null,
            dblClickTimeOut:       null,

            // Tracking for pinch gesture
            pinchGPoints:          [],
            lastPinchDist:         0,
            currentPinchDist:      0,
            lastPinchCenter:       null,
            currentPinchCenter:    null
        };

        if ( !options.startDisabled ) {
            this.setTracking( true );
        }
    };

    xlv.InteractionManager.prototype = {

        /**
         * Clean up any events or objects created by the manager.
         */
        destroy: function () {
            var i;

            stopTracking( this );
            this.element = null;

            for ( i = 0; i < MANAGERS.length; i++ ) {
                if ( MANAGERS[ i ] === this ) {
                    MANAGERS.splice( i, 1 );
                    break;
                }
            }

            INSTANCES[ this.hash ] = null;
            delete INSTANCES[ this.hash ];
        },

        /**
         * Are we currently tracking events on this element.
         */
        isTracking: function () {
            return INSTANCES[ this.hash ].tracking;
        },

        /**
         * Enable or disable whether or not we are tracking events on this element.
         */
        setTracking: function ( track ) {
            if ( track ) {
                startTracking( this );
            } else {
                stopTracking( this );
            }
            //chain
            return this;
        },

        /**
         * Returns the gesture point list for the given pointer device type,
         * creating and caching a new gesture point list if one doesn't already exist for the type.
         */
        getActivePointersListByType: function ( type ) {
            var delegate = INSTANCES[ this.hash ],
                i,
                len = delegate.activePointersLists.length,
                list;

            for ( i = 0; i < len; i++ ) {
                if ( delegate.activePointersLists[ i ].type === type ) {
                    return delegate.activePointersLists[ i ];
                }
            }

            list = new xlv.InteractionManager.GesturePointList( type );
            delegate.activePointersLists.push( list );
            return list;
        },

        /**
         * Returns the total number of pointers currently active on the tracked element.
         */
        getActivePointerCount: function () {
            var delegate = INSTANCES[ this.hash ],
                i,
                len = delegate.activePointersLists.length,
                count = 0;

            for ( i = 0; i < len; i++ ) {
                count += delegate.activePointersLists[ i ].getLength();
            }

            return count;
        },

        /**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         */
        enterHandler: function () { },

        /**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         */
        exitHandler: function () { },

        /**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         */
        pressHandler: function () { },

        /**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         */
        nonPrimaryPressHandler: function () { },

        /**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         */
        releaseHandler: function () { },

        /**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         */
        nonPrimaryReleaseHandler: function () { },

        /**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         */
        moveHandler: function () { },

        /**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         */
        scrollHandler: function () { },

        /**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         */
        clickHandler: function () { },

        /**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         */
        dblClickHandler: function () { },

        /**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         */
        dragHandler: function () { },

        /**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         */
        dragEndHandler: function () { },

        /**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         */
        pinchHandler: function () { },

        /**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         */
        stopHandler: function () { },

        /**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         */
        keyDownHandler: function () { },

        /**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         *
         */
        keyUpHandler: function () { },

        /**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         *
         */
        keyHandler: function () { },

        /**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         *
         */
        focusHandler: function () { },

        /**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         *
         */
        blurHandler: function () { }
    };


    /**
     * Provides continuous computation of velocity (speed and direction) of active pointers.
     * This is a singleton, used by all InteractionManager instances, as it is unlikely there will ever be more than
     * two active gesture pointers at a time.
     *
     */
    xlv.InteractionManager.gesturePointVelocityTracker = (function () {
        var trackerPoints = [],
            intervalId = 0,
            lastTime = 0;

        // Generates a unique identifier for a tracked gesture point
        var _generateGuid = function ( tracker, gPoint ) {
            return tracker.hash.toString() + gPoint.type + gPoint.id.toString();
        };

        // Interval timer callback. Computes velocity for all tracked gesture points.
        var _doTracking = function () {
            var i,
                len = trackerPoints.length,
                trackPoint,
                gPoint,
                now = xlv.Utils.now(),
                elapsedTime,
                distance,
                speed;

            elapsedTime = now - lastTime;
            lastTime = now;

            for ( i = 0; i < len; i++ ) {
                trackPoint = trackerPoints[ i ];
                gPoint = trackPoint.gPoint;
                // Math.atan2 gives us just what we need for a velocity vector, as we can simply
                //   use cos()/sin() to extract the x/y velocity components.
                gPoint.direction = Math.atan2( gPoint.currentPos.y - trackPoint.lastPos.y, gPoint.currentPos.x - trackPoint.lastPos.x );
                // speed = distance / elapsed time
                distance = trackPoint.lastPos.distanceTo( gPoint.currentPos );
                trackPoint.lastPos = gPoint.currentPos;
                speed = 1000 * distance / ( elapsedTime + 1 );
                // Simple biased average, favors the most recent speed computation. Smooths out erratic gestures a bit.
                gPoint.speed = 0.75 * speed + 0.25 * gPoint.speed;
            }
        };

        // Public. Add a gesture point to be tracked
        var addPoint = function ( tracker, gPoint ) {
            var guid = _generateGuid( tracker, gPoint );

            trackerPoints.push(
                {
                    guid: guid,
                    gPoint: gPoint,
                    lastPos: gPoint.currentPos
                } );

            // Only fire up the interval timer when there's gesture pointers to track
            if ( trackerPoints.length === 1 ) {
                lastTime = xlv.Utils.now();
                intervalId = window.setInterval( _doTracking, 50 );
            }
        };

        // Public. Stop tracking a gesture point
        var removePoint = function ( tracker, gPoint ) {
            var guid = _generateGuid( tracker, gPoint ),
                i,
                len = trackerPoints.length;
            for ( i = 0; i < len; i++ ) {
                if ( trackerPoints[ i ].guid === guid ) {
                    trackerPoints.splice( i, 1 );
                    // Only run the interval timer if theres gesture pointers to track
                    len--;
                    if ( len === 0 ) {
                        window.clearInterval( intervalId );
                    }
                    break;
                }
            }
        };

        return {
            addPoint:    addPoint,
            removePoint: removePoint
        };
    } )();


    xlv.InteractionManager.captureElement = document;

    /**
     * Detect available mouse wheel event name.
     */
    xlv.InteractionManager.wheelEventName = ( xlv.Browser.vendor == xlv.CONST.BROWSER.IE && xlv.Browser.version > 8 ) ||
    ( 'onwheel' in document.createElement( 'div' ) ) ? 'wheel' : // Modern browsers support 'wheel'
        document.onmousewheel !== undefined ? 'mousewheel' :                     // Webkit and IE support at least 'mousewheel'
            'DOMMouseScroll';                                                        // Assume old Firefox

    /**
     * Detect legacy mouse capture support.
     */
    xlv.InteractionManager.supportsMouseCapture = (function () {
        var divElement = document.createElement( 'div' );
        return xlv.Utils.isFunction( divElement.setCapture ) && xlv.Utils.isFunction( divElement.releaseCapture );
    }());

    /**
     * Detect browser pointer device event model(s) and build appropriate list of events to subscribe to.
     */
    xlv.InteractionManager.subscribeEvents = [ "click", "dblclick", "keydown", "keyup", "keypress", "focus", "blur", xlv.InteractionManager.wheelEventName ];

    if( xlv.InteractionManager.wheelEventName == "DOMMouseScroll" ) {
        // Older Firefox
        xlv.InteractionManager.subscribeEvents.push( "MozMousePixelScroll" );
    }

    // Note: window.navigator.pointerEnable is deprecated on IE 11 and not part of W3C spec.
    if ( window.PointerEvent && ( window.navigator.pointerEnabled || xlv.Browser.vendor !== xlv.CONST.BROWSER.IE ) ) {
        // IE11 and other W3C Pointer Event implementations (see http://www.w3.org/TR/pointerevents)
        xlv.InteractionManager.havePointerEvents = true;
        xlv.InteractionManager.subscribeEvents.push( "pointerover", "pointerout", "pointerdown", "pointerup", "pointermove", "pointercancel" );
        xlv.InteractionManager.unprefixedPointerEvents = true;
        if( navigator.maxTouchPoints ) {
            xlv.InteractionManager.maxTouchPoints = navigator.maxTouchPoints;
        } else {
            xlv.InteractionManager.maxTouchPoints = 0;
        }
        xlv.InteractionManager.haveMouseEnter = false;
    } else if ( window.MSPointerEvent && window.navigator.msPointerEnabled ) {
        // IE10
        xlv.InteractionManager.havePointerEvents = true;
        xlv.InteractionManager.subscribeEvents.push( "MSPointerOver", "MSPointerOut", "MSPointerDown", "MSPointerUp", "MSPointerMove", "MSPointerCancel" );
        xlv.InteractionManager.unprefixedPointerEvents = false;
        if( navigator.msMaxTouchPoints ) {
            xlv.InteractionManager.maxTouchPoints = navigator.msMaxTouchPoints;
        } else {
            xlv.InteractionManager.maxTouchPoints = 0;
        }
        xlv.InteractionManager.haveMouseEnter = false;
    } else {
        // Legacy W3C mouse events
        xlv.InteractionManager.havePointerEvents = false;
        if ( xlv.Browser.vendor === xlv.CONST.BROWSER.IE && xlv.Browser.version < 9 ) {
            xlv.InteractionManager.subscribeEvents.push( "mouseenter", "mouseleave" );
            xlv.InteractionManager.haveMouseEnter = true;
        } else {
            xlv.InteractionManager.subscribeEvents.push( "mouseover", "mouseout" );
            xlv.InteractionManager.haveMouseEnter = false;
        }
        xlv.InteractionManager.subscribeEvents.push( "mousedown", "mouseup", "mousemove" );
        if ( 'ontouchstart' in window ) {
            // iOS, Android, and other W3c Touch Event implementations
            //    (see http://www.w3.org/TR/touch-events/)
            //    (see https://developer.apple.com/library/ios/documentation/AppleApplications/Reference/SafariWebContent/HandlingEvents/HandlingEvents.html)
            //    (see https://developer.apple.com/library/safari/documentation/AppleApplications/Reference/SafariWebContent/HandlingEvents/HandlingEvents.html)
            xlv.InteractionManager.subscribeEvents.push( "touchstart", "touchend", "touchmove", "touchcancel" );
        }
        if ( 'ongesturestart' in window ) {
            // iOS (see https://developer.apple.com/library/ios/documentation/AppleApplications/Reference/SafariWebContent/HandlingEvents/HandlingEvents.html)
            //   Subscribe to these to prevent default gesture handling
            xlv.InteractionManager.subscribeEvents.push( "gesturestart", "gesturechange" );
        }
        xlv.InteractionManager.mousePointerId = "legacy-mouse";
        xlv.InteractionManager.maxTouchPoints = 10;
    }

    /**
     * Represents a point of contact on the screen made by a mouse cursor, pen, touch, or other pointer device.
     *
     */


    /**
     * Provides an abstraction for a set of active gesture point objects for a given pointer device type.
     * Active pointers are any pointer being tracked for this element which are in the hit-test area
     * of the element (for hover-capable devices) and/or have contact or a button press initiated in the element.
     */
    xlv.InteractionManager.GesturePointList = function ( type ) {
        this._gPoints = [];
        /**
         * The pointer device type: "mouse", "touch", "pen", etc.
         */
        this.type = type;
        /**
         * Current buttons pressed for the device.
         * Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
         *
         */
        this.buttons = 0;
        /**
         * Current number of contact points (touch points, mouse down, etc.) for the device.
         *
         */
        this.contacts = 0;
        /**
         * Current number of clicks for the device. Used for multiple click gesture tracking.
         *
         */
        this.clicks = 0;
        /**
         * Current number of captured pointers for the device.
         *
         */
        this.captureCount = 0;
    };

    xlv.InteractionManager.GesturePointList.prototype = {

        getLength: function () {
            return this._gPoints.length;
        },
        asArray: function () {
            return this._gPoints;
        },
        add: function ( gp ) {
            return this._gPoints.push( gp );
        },
        removeById: function ( id ) {
            var i,
                len = this._gPoints.length;
            for ( i = 0; i < len; i++ ) {
                if ( this._gPoints[ i ].id === id ) {
                    this._gPoints.splice( i, 1 );
                    break;
                }
            }
            return this._gPoints.length;
        },
        getByIndex: function ( index ) {
            if ( index < this._gPoints.length) {
                return this._gPoints[ index ];
            }
            return null;
        },
        getById: function ( id ) {
            var i,
                len = this._gPoints.length;
            for ( i = 0; i < len; i++ ) {
                if ( this._gPoints[ i ].id === id ) {
                    return this._gPoints[ i ];
                }
            }
            return null;
        },
        getPrimary: function ( id ) {
            var i,
                len = this._gPoints.length;
            for ( i = 0; i < len; i++ ) {
                if ( this._gPoints[ i ].isPrimary ) {
                    return this._gPoints[ i ];
                }
            }
            return null;
        }
    };

    /**
     * Removes all tracked pointers.
     */
    function clearTrackedPointers( tracker ) {
        var delegate = INSTANCES[ tracker.hash ],
            i,
            pointerListCount = delegate.activePointersLists.length;

        for ( i = 0; i < pointerListCount; i++ ) {
            if ( delegate.activePointersLists[ i ].captureCount > 0 ) {
                xlv.unbind(
                    xlv.InteractionManager.captureElement,
                    'mousemove',
                    delegate.mousemovecaptured,
                    true
                );
                xlv.unbind(
                    xlv.InteractionManager.captureElement,
                    'mouseup',
                    delegate.mouseupcaptured,
                    true
                );
                xlv.unbind(
                    xlv.InteractionManager.captureElement,
                    xlv.InteractionManager.unprefixedPointerEvents ? 'pointermove' : 'MSPointerMove',
                    delegate.pointermovecaptured,
                    true
                );
                xlv.unbind(
                    xlv.InteractionManager.captureElement,
                    xlv.InteractionManager.unprefixedPointerEvents ? 'pointerup' : 'MSPointerUp',
                    delegate.pointerupcaptured,
                    true
                );
                xlv.unbind(
                    xlv.InteractionManager.captureElement,
                    'touchmove',
                    delegate.touchmovecaptured,
                    true
                );
                xlv.unbind(
                    xlv.InteractionManager.captureElement,
                    'touchend',
                    delegate.touchendcaptured,
                    true
                );

                delegate.activePointersLists[ i ].captureCount = 0;
            }
        }

        for ( i = 0; i < pointerListCount; i++ ) {
            delegate.activePointersLists.pop();
        }
    }

    /**
     * Starts tracking pointer events on the tracked element.
     */
    function startTracking( tracker ) {
        var delegate = INSTANCES[ tracker.hash ],
            event,
            i;

        if ( !delegate.tracking ) {
            for ( i = 0; i < xlv.InteractionManager.subscribeEvents.length; i++ ) {
                event = xlv.InteractionManager.subscribeEvents[ i ];
                xlv.bind(
                    tracker.element,
                    event,
                    delegate[ event ],
                    false
                );
            }

            clearTrackedPointers( tracker );

            delegate.tracking = true;
        }
    }

    /**
     * Stops tracking pointer events on the tracked element.
     */
    function stopTracking( tracker ) {
        var delegate = INSTANCES[ tracker.hash ],
            event,
            i;

        if ( delegate.tracking ) {
            for ( i = 0; i < xlv.InteractionManager.subscribeEvents.length; i++ ) {
                event = xlv.InteractionManager.subscribeEvents[ i ];
                xlv.unbind(
                    tracker.element,
                    event,
                    delegate[ event ],
                    false
                );
            }

            clearTrackedPointers( tracker );

            delegate.tracking = false;
        }
    }

    function getCaptureEventParams( tracker, pointerType ) {
        var delegate = INSTANCES[ tracker.hash ];

        if ( pointerType === 'pointerevent' ) {
            return {
                upName: xlv.InteractionManager.unprefixedPointerEvents ? 'pointerup' : 'MSPointerUp',
                upHandler: delegate.pointerupcaptured,
                moveName: xlv.InteractionManager.unprefixedPointerEvents ? 'pointermove' : 'MSPointerMove',
                moveHandler: delegate.pointermovecaptured
            };
        } else if ( pointerType === 'mouse' ) {
            return {
                upName: 'mouseup',
                upHandler: delegate.mouseupcaptured,
                moveName: 'mousemove',
                moveHandler: delegate.mousemovecaptured
            };
        } else if ( pointerType === 'touch' ) {
            return {
                upName: 'touchend',
                upHandler: delegate.touchendcaptured,
                moveName: 'touchmove',
                moveHandler: delegate.touchmovecaptured
            };
        } else {
            throw new Error( "InteractionManager.getCaptureEventParams: Unknown pointer type." );
        }
    }

    /**
     * Begin capturing pointer events to the tracked element.
     */
    function capturePointer( tracker, pointerType ) {
        var pointsList = tracker.getActivePointersListByType( pointerType ),
            eventParams;

        pointsList.captureCount++;

        if ( pointsList.captureCount === 1 ) {
            if ( xlv.Browser.vendor === xlv.CONST.BROWSER.IE && xlv.Browser.version < 9 ) {
                tracker.element.setCapture( true );
            } else {
                eventParams = getCaptureEventParams( tracker, xlv.InteractionManager.havePointerEvents ? 'pointerevent' : pointerType );
                // We emulate mouse capture by hanging listeners on the document object.
                //    (Note we listen on the capture phase so the captured handlers will get called first)
                if (isInIframe && canAccessEvents(window.top)) {
                    xlv.bind(
                        window.top,
                        eventParams.upName,
                        eventParams.upHandler,
                        true
                    );
                }
                xlv.bind(
                    xlv.InteractionManager.captureElement,
                    eventParams.upName,
                    eventParams.upHandler,
                    true
                );
                xlv.bind(
                    xlv.InteractionManager.captureElement,
                    eventParams.moveName,
                    eventParams.moveHandler,
                    true
                );
            }
        }
    }


    /**
     * Stop capturing pointer events to the tracked element.
     */
    function releasePointer( tracker, pointerType ) {
        var pointsList = tracker.getActivePointersListByType( pointerType ),
            eventParams;

        pointsList.captureCount--;

        if ( pointsList.captureCount === 0 ) {
            if ( xlv.Browser.vendor === xlv.CONST.BROWSER.IE && xlv.Browser.version < 9 ) {
                tracker.element.releaseCapture();
            } else {
                eventParams = getCaptureEventParams( tracker, xlv.InteractionManager.havePointerEvents ? 'pointerevent' : pointerType );
                // We emulate mouse capture by hanging listeners on the document object.
                //    (Note we listen on the capture phase so the captured handlers will get called first)
                if (isInIframe && canAccessEvents(window.top)) {
                    xlv.unbind(
                        window.top,
                        eventParams.upName,
                        eventParams.upHandler,
                        true
                    );
                }
                xlv.unbind(
                    xlv.InteractionManager.captureElement,
                    eventParams.moveName,
                    eventParams.moveHandler,
                    true
                );
                xlv.unbind(
                    xlv.InteractionManager.captureElement,
                    eventParams.upName,
                    eventParams.upHandler,
                    true
                );
            }
        }
    }


    /**
     * Gets a W3C Pointer Events model compatible pointer type string from a DOM pointer event.
     * IE10 used a long integer value, but the W3C specification (and IE11+) use a string "mouse", "touch", "pen", etc.
     */
    function getPointerType( event ) {
        var pointerTypeStr;
        if ( xlv.InteractionManager.unprefixedPointerEvents ) {
            pointerTypeStr = event.pointerType;
        } else {
            // IE10
            //  MSPOINTER_TYPE_TOUCH: 0x00000002
            //  MSPOINTER_TYPE_PEN:   0x00000003
            //  MSPOINTER_TYPE_MOUSE: 0x00000004
            switch( event.pointerType )
            {
                case 0x00000002:
                    pointerTypeStr = 'touch';
                    break;
                case 0x00000003:
                    pointerTypeStr = 'pen';
                    break;
                case 0x00000004:
                    pointerTypeStr = 'mouse';
                    break;
                default:
                    pointerTypeStr = '';
            }
        }
        return pointerTypeStr;
    }

    function getMouseAbsolute( event ) {
        return xlv.getMousePosition( event );
    }

    function getMouseRelative( event, element ) {
        return getPointRelativeToAbsolute( getMouseAbsolute( event ), element );
    }

    function getPointRelativeToAbsolute( point, element ) {
        var offset = xlv.getElementOffset( element );
        return point.minus( offset );
    }

    function getCenterPoint( point1, point2 ) {
        return new xlv.Point( ( point1.x + point2.x ) / 2, ( point1.y + point2.y ) / 2 );
    }

    function onClick( tracker, event ) {
        if ( tracker.clickHandler ) {
            xlv.cancelEvent( event );
        }
    }

    function onDblClick( tracker, event ) {
        if ( tracker.dblClickHandler ) {
            xlv.cancelEvent( event );
        }
    }

    function onKeyDown( tracker, event ) {
        //xlv.console.log( "keydown %s %s %s %s %s", event.keyCode, event.charCode, event.ctrlKey, event.shiftKey, event.altKey );
        var propagate;
        if ( tracker.keyDownHandler ) {
            event = xlv.getEvent( event );
            propagate = tracker.keyDownHandler(
                {
                    eventSource:          tracker,
                    keyCode:              event.keyCode ? event.keyCode : event.charCode,
                    ctrl:                 event.ctrlKey,
                    shift:                event.shiftKey,
                    alt:                  event.altKey,
                    meta:                 event.metaKey,
                    originalEvent:        event,
                    preventDefaultAction: false,
                    userData:             tracker.userData
                }
            );
            if ( !propagate ) {
                xlv.cancelEvent( event );
            }
        }
    }

    function onKeyUp( tracker, event ) {
        //xlv.console.log( "keyup %s %s %s %s %s", event.keyCode, event.charCode, event.ctrlKey, event.shiftKey, event.altKey );
        var propagate;
        if ( tracker.keyUpHandler ) {
            event = xlv.getEvent( event );
            propagate = tracker.keyUpHandler(
                {
                    eventSource:          tracker,
                    keyCode:              event.keyCode ? event.keyCode : event.charCode,
                    ctrl:                 event.ctrlKey,
                    shift:                event.shiftKey,
                    alt:                  event.altKey,
                    meta:                 event.metaKey,
                    originalEvent:        event,
                    preventDefaultAction: false,
                    userData:             tracker.userData
                }
            );
            if ( !propagate ) {
                xlv.cancelEvent( event );
            }
        }
    }

    function onKeyPress( tracker, event ) {
        //xlv.console.log( "keypress %s %s %s %s %s", event.keyCode, event.charCode, event.ctrlKey, event.shiftKey, event.altKey );
        var propagate;
        if ( tracker.keyHandler ) {
            event = xlv.getEvent( event );
            propagate = tracker.keyHandler(
                {
                    eventSource:          tracker,
                    keyCode:              event.keyCode ? event.keyCode : event.charCode,
                    ctrl:                 event.ctrlKey,
                    shift:                event.shiftKey,
                    alt:                  event.altKey,
                    meta:                 event.metaKey,
                    originalEvent:        event,
                    preventDefaultAction: false,
                    userData:             tracker.userData
                }
            );
            if ( !propagate ) {
                xlv.cancelEvent( event );
            }
        }
    }

    function onFocus( tracker, event ) {
        //console.log( "focus %s", event );
        var propagate;
        if ( tracker.focusHandler ) {
            event = xlv.getEvent( event );
            propagate = tracker.focusHandler(
                {
                    eventSource:          tracker,
                    originalEvent:        event,
                    preventDefaultAction: false,
                    userData:             tracker.userData
                }
            );
            if ( propagate === false ) {
                xlv.cancelEvent( event );
            }
        }
    }

    function onBlur( tracker, event ) {
        //console.log( "blur %s", event );
        var propagate;
        if ( tracker.blurHandler ) {
            event = xlv.getEvent( event );
            propagate = tracker.blurHandler(
                {
                    eventSource:          tracker,
                    originalEvent:        event,
                    preventDefaultAction: false,
                    userData:             tracker.userData
                }
            );
            if ( propagate === false ) {
                xlv.cancelEvent( event );
            }
        }
    }

    function onWheel( tracker, event ) {
        handleWheelEvent( tracker, event, event );
    }

    function onMouseWheel( tracker, event ) {
        event = xlv.getEvent( event );

        // Simulate a 'wheel' event
        var simulatedEvent = {
            target:     event.target || event.srcElement,
            type:       "wheel",
            shiftKey:   event.shiftKey || false,
            clientX:    event.clientX,
            clientY:    event.clientY,
            pageX:      event.pageX ? event.pageX : event.clientX,
            pageY:      event.pageY ? event.pageY : event.clientY,
            deltaMode:  event.type == "MozMousePixelScroll" ? 0 : 1, // 0=pixel, 1=line, 2=page
            deltaX:     0,
            deltaZ:     0
        };

        // Calculate deltaY
        if ( xlv.InteractionManager.wheelEventName == "mousewheel" ) {
            simulatedEvent.deltaY = - 1 / xlv.DEFAULT_SETTINGS.mouseScrollFactor * event.wheelDelta;
        } else {
            simulatedEvent.deltaY = event.detail;
        }

        handleWheelEvent( tracker, simulatedEvent, event );
    }


    /**
     * Handles 'wheel' events.
     * The event may be simulated by the legacy mouse wheel event handler (onMouseWheel()).
     */
    function handleWheelEvent( tracker, event, originalEvent ) {
        var propagate;

        // The nDelta variable is gated to provide smooth z-index scrolling
        //   since the mouse wheel allows for substantial deltas meant for rapid
        //   y-index scrolling.
        // event.deltaMode: 0=pixel, 1=line, 2=page
        // TODO: Deltas in pixel mode should be accumulated then a scroll value computed after xlv.DEFAULT_SETTINGS.mouseScrollFactor threshold reached
        var nDelta = event.deltaY < 0 ? 1 : -1;

        if ( tracker.scrollHandler ) {
            propagate = tracker.scrollHandler(
                {
                    eventSource:          tracker,
                    pointerType:          'mouse',
                    position:             getMouseRelative( event, tracker.element ),
                    scroll:               nDelta,
                    shift:                event.shiftKey,
                    isTouchEvent:         false,
                    originalEvent:        originalEvent,
                    preventDefaultAction: false,
                    userData:             tracker.userData
                }
            );
            if ( propagate === false ) {
                xlv.cancelEvent( originalEvent );
            }
        }
    }

    function isParentChild( parent, child )
    {
        if ( parent === child ) {
            return false;
        }
        while ( child && child !== parent ) {
            child = child.parentNode;
        }
        return child === parent;
    }


    /**
     * Only used on IE 8
     */
    function onMouseEnter( tracker, event ) {
        event = xlv.getEvent( event );

        handleMouseEnter( tracker, event );
    }

    function onMouseOver( tracker, event ) {
        event = xlv.getEvent( event );

        if ( event.currentTarget === event.relatedTarget || isParentChild( event.currentTarget, event.relatedTarget ) ) {
            return;
        }

        handleMouseEnter( tracker, event );
    }

    function handleMouseEnter( tracker, event ) {
        var gPoint = {
            id: xlv.InteractionManager.mousePointerId,
            type: 'mouse',
            isPrimary: true,
            currentPos: getMouseAbsolute( event ),
            currentTime: xlv.Utils.now()
        };

        updatePointersEnter( tracker, event, [ gPoint ] );
    }


    /**
     * Only used on IE 8
     */
    function onMouseLeave( tracker, event ) {
        event = xlv.getEvent( event );

        handleMouseExit( tracker, event );
    }

    function onMouseOut( tracker, event ) {
        event = xlv.getEvent( event );

        if ( event.currentTarget === event.relatedTarget || isParentChild( event.currentTarget, event.relatedTarget ) ) {
            return;
        }

        handleMouseExit( tracker, event );
    }

    function handleMouseExit( tracker, event ) {
        var gPoint = {
            id: xlv.InteractionManager.mousePointerId,
            type: 'mouse',
            isPrimary: true,
            currentPos: getMouseAbsolute( event ),
            currentTime: xlv.Utils.now()
        };

        updatePointersExit( tracker, event, [ gPoint ] );
    }


    /**
     * Returns a W3C DOM level 3 standard button value given an event.button property:
     *   -1 == none, 0 == primary/left, 1 == middle, 2 == secondary/right, 3 == X1/back, 4 == X2/forward, 5 == eraser (pen)
     */
    function getStandardizedButton( button ) {
        if ( xlv.Browser.vendor === xlv.CONST.BROWSER.IE && xlv.Browser.version < 9 ) {
            // On IE 8, 0 == none, 1 == left, 2 == right, 3 == left and right, 4 == middle, 5 == left and middle, 6 == right and middle, 7 == all three
            // TODO: Support chorded (multiple) button presses on IE 8?
            if ( button === 1 ) {
                return 0;
            } else if ( button === 2 ) {
                return 2;
            } else if ( button === 4 ) {
                return 1;
            } else {
                return -1;
            }
        } else {
            return button;
        }
    }

    function onMouseDown( tracker, event ) {
        var gPoint;

        event = xlv.getEvent( event );

        gPoint = {
            id: xlv.InteractionManager.mousePointerId,
            type: 'mouse',
            isPrimary: true,
            currentPos: getMouseAbsolute( event ),
            currentTime: xlv.Utils.now()
        };

        if ( updatePointersDown( tracker, event, [ gPoint ], getStandardizedButton( event.button ) ) ) {
            xlv.stopEvent( event );
            capturePointer( tracker, 'mouse' );
        }

        if ( tracker.clickHandler || tracker.dblClickHandler || tracker.pressHandler || tracker.dragHandler || tracker.dragEndHandler ) {
            xlv.cancelEvent( event );
        }
    }

    function onMouseUp( tracker, event ) {
        handleMouseUp( tracker, event );
    }

    /**
     * This handler is attached to the window object (on the capture phase) to emulate mouse capture.
     * onMouseUp is still attached to the tracked element, so stop propagation to avoid processing twice.
     */
    function onMouseUpCaptured( tracker, event ) {
        handleMouseUp( tracker, event );
        xlv.stopEvent( event );
    }

    function handleMouseUp( tracker, event ) {
        var gPoint;

        event = xlv.getEvent( event );

        gPoint = {
            id: xlv.InteractionManager.mousePointerId,
            type: 'mouse',
            isPrimary: true,
            currentPos: getMouseAbsolute( event ),
            currentTime: xlv.Utils.now()
        };

        if ( updatePointersUp( tracker, event, [ gPoint ], getStandardizedButton( event.button ) ) ) {
            releasePointer( tracker, 'mouse' );
        }
    }

    function onMouseMove( tracker, event ) {
        handleMouseMove( tracker, event );
    }


    /**
     * This handler is attached to the window object (on the capture phase) to emulate mouse capture.
     * onMouseMove is still attached to the tracked element, so stop propagation to avoid processing twice.
     */
    function onMouseMoveCaptured( tracker, event ) {
        handleMouseMove( tracker, event );
        xlv.stopEvent( event );
    }

    function handleMouseMove( tracker, event ) {
        var gPoint;

        event = xlv.getEvent( event );

        gPoint = {
            id: xlv.InteractionManager.mousePointerId,
            type: 'mouse',
            isPrimary: true,
            currentPos: getMouseAbsolute( event ),
            currentTime: xlv.Utils.now()
        };

        updatePointersMove( tracker, event, [ gPoint ] );
    }

    function abortTouchContacts( tracker, event, pointsList ) {
        var i,
            gPointCount = pointsList.getLength(),
            abortGPoints = [];

        for ( i = 0; i < gPointCount; i++ ) {
            abortGPoints.push( pointsList.getByIndex( i ) );
        }

        if ( abortGPoints.length > 0 ) {
            // simulate touchend
            updatePointersUp( tracker, event, abortGPoints, 0 ); // 0 means primary button press/release or touch contact
            // release pointer capture
            pointsList.captureCount = 1;
            releasePointer( tracker, 'touch' );
            // simulate touchleave
            updatePointersExit( tracker, event, abortGPoints );
        }
    }

    function onTouchStart( tracker, event ) {
        var time,
            i,
            j,
            touchCount = event.changedTouches.length,
            gPoints = [],
            parentGPoints,
            pointsList = tracker.getActivePointersListByType( 'touch' );

        time = xlv.Utils.now();

        if ( pointsList.getLength() > event.touches.length - touchCount ) {
            xlv.console.warn('Tracked touch contact count doesn\'t match event.touches.length. Removing all tracked touch pointers.');
            abortTouchContacts( tracker, event, pointsList );
        }

        for ( i = 0; i < touchCount; i++ ) {
            gPoints.push( {
                id: event.changedTouches[ i ].identifier,
                type: 'touch',
                // isPrimary not set - let the updatePointers functions determine it
                currentPos: getMouseAbsolute( event.changedTouches[ i ] ),
                currentTime: time
            } );
        }

        // simulate touchenter on our tracked element
        updatePointersEnter( tracker, event, gPoints );

        // simulate touchenter on our tracked element's tracked ancestor elements
        for ( i = 0; i < MANAGERS.length; i++ ) {
            if ( MANAGERS[ i ] !== tracker && MANAGERS[ i ].isTracking() && isParentChild( MANAGERS[ i ].element, tracker.element ) ) {
                parentGPoints = [];
                for ( j = 0; j < touchCount; j++ ) {
                    parentGPoints.push( {
                        id: event.changedTouches[ j ].identifier,
                        type: 'touch',
                        // isPrimary not set - let the updatePointers functions determine it
                        currentPos: getMouseAbsolute( event.changedTouches[ j ] ),
                        currentTime: time
                    } );
                }
                updatePointersEnter( MANAGERS[ i ], event, parentGPoints );
            }
        }

        if ( updatePointersDown( tracker, event, gPoints, 0 ) ) { // 0 means primary button press/release or touch contact
            xlv.stopEvent( event );
            capturePointer( tracker, 'touch' );
        }

        xlv.cancelEvent( event );
    }

    function onTouchEnd( tracker, event ) {
        handleTouchEnd( tracker, event );
    }


    /**
     * This handler is attached to the window object (on the capture phase) to emulate pointer capture.
     * onTouchEnd is still attached to the tracked element, so stop propagation to avoid processing twice.
     */
    function onTouchEndCaptured( tracker, event ) {
        handleTouchEnd( tracker, event );
        xlv.stopEvent( event );
    }

    function handleTouchEnd( tracker, event ) {
        var time,
            i,
            j,
            touchCount = event.changedTouches.length,
            gPoints = [],
            parentGPoints;

        time = xlv.Utils.now();

        for ( i = 0; i < touchCount; i++ ) {
            gPoints.push( {
                id: event.changedTouches[ i ].identifier,
                type: 'touch',
                // isPrimary not set - let the updatePointers functions determine it
                currentPos: getMouseAbsolute( event.changedTouches[ i ] ),
                currentTime: time
            } );
        }

        if ( updatePointersUp( tracker, event, gPoints, 0 ) ) {
            releasePointer( tracker, 'touch' );
        }

        // simulate touchleave on our tracked element
        updatePointersExit( tracker, event, gPoints );

        // simulate touchleave on our tracked element's tracked ancestor elements
        for ( i = 0; i < MANAGERS.length; i++ ) {
            if ( MANAGERS[ i ] !== tracker && MANAGERS[ i ].isTracking() && isParentChild( MANAGERS[ i ].element, tracker.element ) ) {
                parentGPoints = [];
                for ( j = 0; j < touchCount; j++ ) {
                    parentGPoints.push( {
                        id: event.changedTouches[ j ].identifier,
                        type: 'touch',
                        // isPrimary not set - let the updatePointers functions determine it
                        currentPos: getMouseAbsolute( event.changedTouches[ j ] ),
                        currentTime: time
                    } );
                }
                updatePointersExit( MANAGERS[ i ], event, parentGPoints );
            }
        }

        xlv.cancelEvent( event );
    }

    function onTouchMove( tracker, event ) {
        handleTouchMove( tracker, event );
    }


    /**
     * This handler is attached to the window object (on the capture phase) to emulate pointer capture.
     * onTouchMove is still attached to the tracked element, so stop propagation to avoid processing twice.
     */
    function onTouchMoveCaptured( tracker, event ) {
        handleTouchMove( tracker, event );
        xlv.stopEvent( event );
    }

    function handleTouchMove( tracker, event ) {
        var i,
            touchCount = event.changedTouches.length,
            gPoints = [];

        for ( i = 0; i < touchCount; i++ ) {
            gPoints.push( {
                id: event.changedTouches[ i ].identifier,
                type: 'touch',
                // isPrimary not set - let the updatePointers functions determine it
                currentPos: getMouseAbsolute( event.changedTouches[ i ] ),
                currentTime: xlv.Utils.now()
            } );
        }

        updatePointersMove( tracker, event, gPoints );

        xlv.cancelEvent( event );
    }

    function onTouchCancel( tracker, event ) {
        var pointsList = tracker.getActivePointersListByType( 'touch' );
        abortTouchContacts( tracker, event, pointsList );
    }

    function onGestureStart( tracker, event ) {
        event.stopPropagation();
        event.preventDefault();
        return false;
    }

    function onGestureChange( tracker, event ) {
        event.stopPropagation();
        event.preventDefault();
        return false;
    }

    function onPointerOver( tracker, event ) {
        var gPoint;

        if ( event.currentTarget === event.relatedTarget || isParentChild( event.currentTarget, event.relatedTarget ) ) {
            return;
        }

        gPoint = {
            id: event.pointerId,
            type: getPointerType( event ),
            isPrimary: event.isPrimary,
            currentPos: getMouseAbsolute( event ),
            currentTime: xlv.Utils.now()
        };

        updatePointersEnter( tracker, event, [ gPoint ] );
    }

    function onPointerOut( tracker, event ) {
        var gPoint;

        if ( event.currentTarget === event.relatedTarget || isParentChild( event.currentTarget, event.relatedTarget ) ) {
            return;
        }

        gPoint = {
            id: event.pointerId,
            type: getPointerType( event ),
            isPrimary: event.isPrimary,
            currentPos: getMouseAbsolute( event ),
            currentTime: xlv.Utils.now()
        };

        updatePointersExit( tracker, event, [ gPoint ] );
    }

    function onPointerDown( tracker, event ) {
        var gPoint;

        gPoint = {
            id: event.pointerId,
            type: getPointerType( event ),
            isPrimary: event.isPrimary,
            currentPos: getMouseAbsolute( event ),
            currentTime: xlv.Utils.now()
        };

        if ( updatePointersDown( tracker, event, [ gPoint ], event.button ) ) {
            xlv.stopEvent( event );
            capturePointer( tracker, gPoint.type );
        }

        if ( tracker.clickHandler || tracker.dblClickHandler || tracker.pressHandler || tracker.dragHandler || tracker.dragEndHandler || tracker.pinchHandler ) {
            xlv.cancelEvent( event );
        }
    }

    function onPointerUp( tracker, event ) {
        handlePointerUp( tracker, event );
    }


    /**
     * This handler is attached to the window object (on the capture phase) to emulate mouse capture.
     * onPointerUp is still attached to the tracked element, so stop propagation to avoid processing twice.
     */
    function onPointerUpCaptured( tracker, event ) {
        var pointsList = tracker.getActivePointersListByType( getPointerType( event ) );
        if ( pointsList.getById( event.pointerId ) ) {
            handlePointerUp( tracker, event );
        }
        xlv.stopEvent( event );
    }

    function handlePointerUp( tracker, event ) {
        var gPoint;

        gPoint = {
            id: event.pointerId,
            type: getPointerType( event ),
            isPrimary: event.isPrimary,
            currentPos: getMouseAbsolute( event ),
            currentTime: xlv.Utils.now()
        };

        if ( updatePointersUp( tracker, event, [ gPoint ], event.button ) ) {
            releasePointer( tracker, gPoint.type );
        }
    }

    function onPointerMove( tracker, event ) {
        handlePointerMove( tracker, event );
    }


    /**
     * This handler is attached to the window object (on the capture phase) to emulate mouse capture.
     * onPointerMove is still attached to the tracked element, so stop propagation to avoid processing twice.
     */
    function onPointerMoveCaptured( tracker, event ) {
        var pointsList = tracker.getActivePointersListByType( getPointerType( event ) );
        if ( pointsList.getById( event.pointerId ) ) {
            handlePointerMove( tracker, event );
        }
        xlv.stopEvent( event );
    }

    function handlePointerMove( tracker, event ) {
        // Pointer changed coordinates, button state, pressure, tilt, or contact geometry (e.g. width and height)
        var gPoint;

        gPoint = {
            id: event.pointerId,
            type: getPointerType( event ),
            isPrimary: event.isPrimary,
            currentPos: getMouseAbsolute( event ),
            currentTime: xlv.Utils.now()
        };

        updatePointersMove( tracker, event, [ gPoint ] );
    }

    function onPointerCancel( tracker, event ) {
        var gPoint;

        gPoint = {
            id: event.pointerId,
            type: getPointerType( event )
        };

        updatePointersCancel( tracker, event, [ gPoint ] );
    }

    function startTrackingPointer( pointsList, gPoint ) {

        // If isPrimary is not known for the pointer then set it according to our rules:
        //    true if the first pointer in the gesture, otherwise false
        if ( !gPoint.hasOwnProperty( 'isPrimary' ) ) {
            gPoint.isPrimary = pointsList.getLength() === 0;
        }
        gPoint.speed = 0;
        gPoint.direction = 0;
        gPoint.contactPos = gPoint.currentPos;
        gPoint.contactTime = gPoint.currentTime;
        gPoint.lastPos = gPoint.currentPos;
        gPoint.lastTime = gPoint.currentTime;

        return pointsList.add( gPoint );
    }

    function stopTrackingPointer( pointsList, gPoint ) {
        var listLength,
            primaryPoint;

        if ( pointsList.getById( gPoint.id ) ) {
            listLength = pointsList.removeById( gPoint.id );

            // If isPrimary is not known for the pointer and we just removed the primary pointer from the list then we need to set another pointer as primary
            if ( !gPoint.hasOwnProperty( 'isPrimary' ) ) {
                primaryPoint = pointsList.getPrimary();
                if ( !primaryPoint ) {
                    primaryPoint = pointsList.getByIndex( 0 );
                    if ( primaryPoint ) {
                        primaryPoint.isPrimary = true;
                    }
                }
            }
        } else {
            listLength = pointsList.getLength();
        }

        return listLength;
    }

    function updatePointersEnter( tracker, event, gPoints ) {
        var pointsList = tracker.getActivePointersListByType( gPoints[ 0 ].type ),
            i,
            gPointCount = gPoints.length,
            curGPoint,
            updateGPoint,
            propagate;

        for ( i = 0; i < gPointCount; i++ ) {
            curGPoint = gPoints[ i ];
            updateGPoint = pointsList.getById( curGPoint.id );

            if ( updateGPoint ) {
                // Already tracking the pointer...update it
                updateGPoint.insideElement = true;
                updateGPoint.lastPos = updateGPoint.currentPos;
                updateGPoint.lastTime = updateGPoint.currentTime;
                updateGPoint.currentPos = curGPoint.currentPos;
                updateGPoint.currentTime = curGPoint.currentTime;

                curGPoint = updateGPoint;
            } else {
                // Initialize for tracking and add to the tracking list
                curGPoint.captured = false;
                curGPoint.insideElementPressed = false;
                curGPoint.insideElement = true;
                startTrackingPointer( pointsList, curGPoint );
            }

            // Enter
            if ( tracker.enterHandler ) {
                propagate = tracker.enterHandler(
                    {
                        eventSource:          tracker,
                        pointerType:          curGPoint.type,
                        position:             getPointRelativeToAbsolute( curGPoint.currentPos, tracker.element ),
                        buttons:              pointsList.buttons,
                        pointers:             tracker.getActivePointerCount(),
                        insideElementPressed: curGPoint.insideElementPressed,
                        buttonDownAny:        pointsList.buttons !== 0,
                        isTouchEvent:         curGPoint.type === 'touch',
                        originalEvent:        event,
                        preventDefaultAction: false,
                        userData:             tracker.userData
                    }
                );
                if ( propagate === false ) {
                    xlv.cancelEvent( event );
                }
            }
        }
    }

    function updatePointersExit( tracker, event, gPoints ) {
        var pointsList = tracker.getActivePointersListByType( gPoints[ 0 ].type ),
            i,
            gPointCount = gPoints.length,
            curGPoint,
            updateGPoint,
            propagate;

        for ( i = 0; i < gPointCount; i++ ) {
            curGPoint = gPoints[ i ];
            updateGPoint = pointsList.getById( curGPoint.id );

            if ( updateGPoint ) {
                // Already tracking the pointer. If captured then update it, else stop tracking it
                if ( updateGPoint.captured ) {
                    updateGPoint.insideElement = false;
                    updateGPoint.lastPos = updateGPoint.currentPos;
                    updateGPoint.lastTime = updateGPoint.currentTime;
                    updateGPoint.currentPos = curGPoint.currentPos;
                    updateGPoint.currentTime = curGPoint.currentTime;
                } else {
                    stopTrackingPointer( pointsList, updateGPoint );
                }

                curGPoint = updateGPoint;
            }

            // Exit
            if ( tracker.exitHandler ) {
                var absPos = curGPoint.currentPos ? getPointRelativeToAbsolute( curGPoint.currentPos, tracker.element ) : curGPoint.currentPos;
                propagate = tracker.exitHandler(
                    {
                        eventSource:          tracker,
                        pointerType:          curGPoint.type,
                        position:             absPos,
                        buttons:              pointsList.buttons,
                        pointers:             tracker.getActivePointerCount(),
                        insideElementPressed: updateGPoint ? updateGPoint.insideElementPressed : false,
                        buttonDownAny:        pointsList.buttons !== 0,
                        isTouchEvent:         curGPoint.type === 'touch',
                        originalEvent:        event,
                        preventDefaultAction: false,
                        userData:             tracker.userData
                    }
                );

                if ( propagate === false ) {
                    xlv.cancelEvent( event );
                }
            }
        }
    }

    function updatePointersDown( tracker, event, gPoints, buttonChanged ) {
        var delegate = INSTANCES[ tracker.hash ],
            propagate,
            pointsList = tracker.getActivePointersListByType( gPoints[ 0 ].type ),
            i,
            gPointCount = gPoints.length,
            curGPoint,
            updateGPoint;

        if ( typeof event.buttons !== 'undefined' ) {
            pointsList.buttons = event.buttons;
        } else {
            if ( xlv.Browser.vendor === xlv.CONST.BROWSER.IE && xlv.Browser.version < 9 ) {
                if ( buttonChanged === 0 ) {
                    // Primary
                    pointsList.buttons += 1;
                } else if ( buttonChanged === 1 ) {
                    // Aux
                    pointsList.buttons += 4;
                } else if ( buttonChanged === 2 ) {
                    // Secondary
                    pointsList.buttons += 2;
                } else if ( buttonChanged === 3 ) {
                    // X1 (Back)
                    pointsList.buttons += 8;
                } else if ( buttonChanged === 4 ) {
                    // X2 (Forward)
                    pointsList.buttons += 16;
                } else if ( buttonChanged === 5 ) {
                    // Pen Eraser
                    pointsList.buttons += 32;
                }
            } else {
                if ( buttonChanged === 0 ) {
                    // Primary
                    pointsList.buttons |= 1;
                } else if ( buttonChanged === 1 ) {
                    // Aux
                    pointsList.buttons |= 4;
                } else if ( buttonChanged === 2 ) {
                    // Secondary
                    pointsList.buttons |= 2;
                } else if ( buttonChanged === 3 ) {
                    // X1 (Back)
                    pointsList.buttons |= 8;
                } else if ( buttonChanged === 4 ) {
                    // X2 (Forward)
                    pointsList.buttons |= 16;
                } else if ( buttonChanged === 5 ) {
                    // Pen Eraser
                    pointsList.buttons |= 32;
                }
            }
        }

        // Only capture and track primary button, pen, and touch contacts
        if ( buttonChanged !== 0 ) {
            // Aux Press
            if ( tracker.nonPrimaryPressHandler ) {
                propagate = tracker.nonPrimaryPressHandler(
                    {
                        eventSource:          tracker,
                        pointerType:          gPoints[ 0 ].type,
                        position:             getPointRelativeToAbsolute( gPoints[ 0 ].currentPos, tracker.element ),
                        button:               buttonChanged,
                        buttons:              pointsList.buttons,
                        isTouchEvent:         gPoints[ 0 ].type === 'touch',
                        originalEvent:        event,
                        preventDefaultAction: false,
                        userData:             tracker.userData
                    }
                );
                if ( propagate === false ) {
                    xlv.cancelEvent( event );
                }
            }

            return false;
        }

        for ( i = 0; i < gPointCount; i++ ) {
            curGPoint = gPoints[ i ];
            updateGPoint = pointsList.getById( curGPoint.id );

            if ( updateGPoint ) {
                // Already tracking the pointer...update it
                updateGPoint.captured = true;
                updateGPoint.insideElementPressed = true;
                updateGPoint.insideElement = true;
                updateGPoint.contactPos = curGPoint.currentPos;
                updateGPoint.contactTime = curGPoint.currentTime;
                updateGPoint.lastPos = updateGPoint.currentPos;
                updateGPoint.lastTime = updateGPoint.currentTime;
                updateGPoint.currentPos = curGPoint.currentPos;
                updateGPoint.currentTime = curGPoint.currentTime;

                curGPoint = updateGPoint;
            } else {
                // Initialize for tracking and add to the tracking list (no pointerover or pointermove event occurred before this)
                curGPoint.captured = true;
                curGPoint.insideElementPressed = true;
                curGPoint.insideElement = true;
                startTrackingPointer( pointsList, curGPoint );
            }

            pointsList.contacts++;
            //xlv.console.log('contacts++ ', pointsList.contacts);

            if ( tracker.dragHandler || tracker.dragEndHandler || tracker.pinchHandler ) {
                xlv.InteractionManager.gesturePointVelocityTracker.addPoint( tracker, curGPoint );
            }

            if ( pointsList.contacts === 1 ) {
                // Press
                if ( tracker.pressHandler ) {
                    propagate = tracker.pressHandler(
                        {
                            eventSource:          tracker,
                            pointerType:          curGPoint.type,
                            position:             getPointRelativeToAbsolute( curGPoint.contactPos, tracker.element ),
                            buttons:              pointsList.buttons,
                            isTouchEvent:         curGPoint.type === 'touch',
                            originalEvent:        event,
                            preventDefaultAction: false,
                            userData:             tracker.userData
                        }
                    );
                    if ( propagate === false ) {
                        xlv.cancelEvent( event );
                    }
                }
            } else if ( pointsList.contacts === 2 ) {
                if ( tracker.pinchHandler && curGPoint.type === 'touch' ) {
                    // Initialize for pinch
                    delegate.pinchGPoints = pointsList.asArray();
                    delegate.lastPinchDist = delegate.currentPinchDist = delegate.pinchGPoints[ 0 ].currentPos.distanceTo( delegate.pinchGPoints[ 1 ].currentPos );
                    delegate.lastPinchCenter = delegate.currentPinchCenter = getCenterPoint( delegate.pinchGPoints[ 0 ].currentPos, delegate.pinchGPoints[ 1 ].currentPos );
                }
            }
        }

        return true;
    }

    function updatePointersUp( tracker, event, gPoints, buttonChanged ) {
        var delegate = INSTANCES[ tracker.hash ],
            pointsList = tracker.getActivePointersListByType( gPoints[ 0 ].type ),
            propagate,
            releasePoint,
            releaseTime,
            i,
            gPointCount = gPoints.length,
            curGPoint,
            updateGPoint,
            releaseCapture = false,
            wasCaptured = false,
            quick;

        if ( typeof event.buttons !== 'undefined' ) {
            pointsList.buttons = event.buttons;
        } else {
            if ( xlv.Browser.vendor === xlv.CONST.BROWSER.IE && xlv.Browser.version < 9 ) {
                if ( buttonChanged === 0 ) {
                    // Primary
                    pointsList.buttons -= 1;
                } else if ( buttonChanged === 1 ) {
                    // Aux
                    pointsList.buttons -= 4;
                } else if ( buttonChanged === 2 ) {
                    // Secondary
                    pointsList.buttons -= 2;
                } else if ( buttonChanged === 3 ) {
                    // X1 (Back)
                    pointsList.buttons -= 8;
                } else if ( buttonChanged === 4 ) {
                    // X2 (Forward)
                    pointsList.buttons -= 16;
                } else if ( buttonChanged === 5 ) {
                    // Pen Eraser
                    pointsList.buttons -= 32;
                }
            } else {
                if ( buttonChanged === 0 ) {
                    // Primary
                    pointsList.buttons ^= ~1;
                } else if ( buttonChanged === 1 ) {
                    // Aux
                    pointsList.buttons ^= ~4;
                } else if ( buttonChanged === 2 ) {
                    // Secondary
                    pointsList.buttons ^= ~2;
                } else if ( buttonChanged === 3 ) {
                    // X1 (Back)
                    pointsList.buttons ^= ~8;
                } else if ( buttonChanged === 4 ) {
                    // X2 (Forward)
                    pointsList.buttons ^= ~16;
                } else if ( buttonChanged === 5 ) {
                    // Pen Eraser
                    pointsList.buttons ^= ~32;
                }
            }
        }

        // Only capture and track primary button, pen, and touch contacts
        if ( buttonChanged !== 0 ) {
            // Aux Release
            if ( tracker.nonPrimaryReleaseHandler ) {
                propagate = tracker.nonPrimaryReleaseHandler(
                    {
                        eventSource:           tracker,
                        pointerType:           gPoints[ 0 ].type,
                        position:              getPointRelativeToAbsolute(  gPoints[ 0 ].currentPos, tracker.element ),
                        button:                buttonChanged,
                        buttons:               pointsList.buttons,
                        isTouchEvent:          gPoints[ 0 ].type === 'touch',
                        originalEvent:         event,
                        preventDefaultAction:  false,
                        userData:              tracker.userData
                    }
                );
                if ( propagate === false ) {
                    xlv.cancelEvent( event );
                }
            }

            return false;
        }

        for ( i = 0; i < gPointCount; i++ ) {
            curGPoint = gPoints[ i ];
            updateGPoint = pointsList.getById( curGPoint.id );

            if ( updateGPoint ) {
                // Update the pointer, stop tracking it if not still in this element
                if ( updateGPoint.captured ) {
                    updateGPoint.captured = false;
                    releaseCapture = true;
                    wasCaptured = true;
                }
                updateGPoint.lastPos = updateGPoint.currentPos;
                updateGPoint.lastTime = updateGPoint.currentTime;
                updateGPoint.currentPos = curGPoint.currentPos;
                updateGPoint.currentTime = curGPoint.currentTime;
                if ( !updateGPoint.insideElement ) {
                    stopTrackingPointer( pointsList, updateGPoint );
                }

                releasePoint = updateGPoint.currentPos;
                releaseTime = updateGPoint.currentTime;

                if ( wasCaptured ) {
                    // Pointer was activated in our element but could have been removed in any element since events are captured to our element

                    pointsList.contacts--;
                    //xlv.console.log('contacts-- ', pointsList.contacts);

                    if ( tracker.dragHandler || tracker.dragEndHandler || tracker.pinchHandler ) {
                        xlv.InteractionManager.gesturePointVelocityTracker.removePoint( tracker, updateGPoint );
                    }

                    if ( pointsList.contacts === 0 ) {

                        // Release (pressed in our element)
                        if ( tracker.releaseHandler ) {
                            propagate = tracker.releaseHandler(
                                {
                                    eventSource:           tracker,
                                    pointerType:           updateGPoint.type,
                                    position:              getPointRelativeToAbsolute( releasePoint, tracker.element ),
                                    buttons:               pointsList.buttons,
                                    insideElementPressed:  updateGPoint.insideElementPressed,
                                    insideElementReleased: updateGPoint.insideElement,
                                    isTouchEvent:          updateGPoint.type === 'touch',
                                    originalEvent:         event,
                                    preventDefaultAction:  false,
                                    userData:              tracker.userData
                                }
                            );
                            if ( propagate === false ) {
                                xlv.cancelEvent( event );
                            }
                        }

                        // Drag End
                        if ( tracker.dragEndHandler && !updateGPoint.currentPos.equals( updateGPoint.contactPos ) ) {
                            propagate = tracker.dragEndHandler(
                                {
                                    eventSource:          tracker,
                                    pointerType:          updateGPoint.type,
                                    position:             getPointRelativeToAbsolute( updateGPoint.currentPos, tracker.element ),
                                    speed:                updateGPoint.speed,
                                    direction:            updateGPoint.direction,
                                    shift:                event.shiftKey,
                                    isTouchEvent:         updateGPoint.type === 'touch',
                                    originalEvent:        event,
                                    preventDefaultAction: false,
                                    userData:             tracker.userData
                                }
                            );
                            if ( propagate === false ) {
                                xlv.cancelEvent( event );
                            }
                        }

                        // Click / Double-Click
                        if ( ( tracker.clickHandler || tracker.dblClickHandler ) && updateGPoint.insideElement ) {
                            quick = releaseTime - updateGPoint.contactTime <= tracker.clickMaxDuration &&
                                updateGPoint.contactPos.distanceTo( releasePoint ) <= tracker.clickAreaRadius;

                            // Click
                            if ( tracker.clickHandler ) {
                                propagate = tracker.clickHandler(
                                    {
                                        eventSource:          tracker,
                                        pointerType:          updateGPoint.type,
                                        position:             getPointRelativeToAbsolute( updateGPoint.currentPos, tracker.element ),
                                        quick:                quick,
                                        shift:                event.shiftKey,
                                        isTouchEvent:         updateGPoint.type === 'touch',
                                        originalEvent:        event,
                                        preventDefaultAction: false,
                                        userData:             tracker.userData
                                    }
                                );
                                if ( propagate === false ) {
                                    xlv.cancelEvent( event );
                                }
                            }

                            // Double-Click
                            if ( tracker.dblClickHandler && quick ) {
                                pointsList.clicks++;
                                if ( pointsList.clicks === 1 ) {
                                    delegate.lastClickPos = releasePoint;
                                    /*jshint loopfunc:true*/
                                    delegate.dblClickTimeOut = setTimeout( function() {
                                        pointsList.clicks = 0;
                                    }, tracker.doubleClickMaxDuration );
                                    /*jshint loopfunc:false*/
                                } else if ( pointsList.clicks === 2 ) {
                                    clearTimeout( delegate.dblClickTimeOut );
                                    pointsList.clicks = 0;
                                    if ( delegate.lastClickPos.distanceTo( releasePoint ) <= tracker.doubleClickAreaRadius ) {
                                        propagate = tracker.dblClickHandler(
                                            {
                                                eventSource:          tracker,
                                                pointerType:          updateGPoint.type,
                                                position:             getPointRelativeToAbsolute( updateGPoint.currentPos, tracker.element ),
                                                shift:                event.shiftKey,
                                                isTouchEvent:         updateGPoint.type === 'touch',
                                                originalEvent:        event,
                                                preventDefaultAction: false,
                                                userData:             tracker.userData
                                            }
                                        );
                                        if ( propagate === false ) {
                                            xlv.cancelEvent( event );
                                        }
                                    }
                                    delegate.lastClickPos = null;
                                }
                            }
                        }
                    } else if ( pointsList.contacts === 2 ) {
                        if ( tracker.pinchHandler && updateGPoint.type === 'touch' ) {
                            // Reset for pinch
                            delegate.pinchGPoints = pointsList.asArray();
                            delegate.lastPinchDist = delegate.currentPinchDist = delegate.pinchGPoints[ 0 ].currentPos.distanceTo( delegate.pinchGPoints[ 1 ].currentPos );
                            delegate.lastPinchCenter = delegate.currentPinchCenter = getCenterPoint( delegate.pinchGPoints[ 0 ].currentPos, delegate.pinchGPoints[ 1 ].currentPos );
                        }
                    }
                } else {
                    // Pointer was activated in another element but removed in our element

                    // Release (pressed in another element)
                    if ( tracker.releaseHandler ) {
                        propagate = tracker.releaseHandler(
                            {
                                eventSource:           tracker,
                                pointerType:           updateGPoint.type,
                                position:              getPointRelativeToAbsolute( releasePoint, tracker.element ),
                                buttons:               pointsList.buttons,
                                insideElementPressed:  updateGPoint.insideElementPressed,
                                insideElementReleased: updateGPoint.insideElement,
                                isTouchEvent:          updateGPoint.type === 'touch',
                                originalEvent:         event,
                                preventDefaultAction:  false,
                                userData:              tracker.userData
                            }
                        );
                        if ( propagate === false ) {
                            xlv.cancelEvent( event );
                        }
                    }
                }
            }
        }

        return releaseCapture;
    }


    /**
     * Call when pointer(s) change coordinates, button state, pressure, tilt, or contact geometry (e.g. width and height)
     */
    function updatePointersMove( tracker, event, gPoints ) {
        var delegate = INSTANCES[ tracker.hash ],
            pointsList = tracker.getActivePointersListByType( gPoints[ 0 ].type ),
            i,
            gPointCount = gPoints.length,
            curGPoint,
            updateGPoint,
            gPointArray,
            delta,
            propagate;

        if ( typeof event.buttons !== 'undefined' ) {
            pointsList.buttons = event.buttons;
        }

        for ( i = 0; i < gPointCount; i++ ) {
            curGPoint = gPoints[ i ];
            updateGPoint = pointsList.getById( curGPoint.id );

            if ( updateGPoint ) {
                // Already tracking the pointer...update it
                if ( curGPoint.hasOwnProperty( 'isPrimary' ) ) {
                    updateGPoint.isPrimary = curGPoint.isPrimary;
                }
                updateGPoint.lastPos = updateGPoint.currentPos;
                updateGPoint.lastTime = updateGPoint.currentTime;
                updateGPoint.currentPos = curGPoint.currentPos;
                updateGPoint.currentTime = curGPoint.currentTime;
            } else {
                // Initialize for tracking and add to the tracking list (no pointerover or pointerdown event occurred before this)
                curGPoint.captured = false;
                curGPoint.insideElementPressed = false;
                curGPoint.insideElement = true;
                startTrackingPointer( pointsList, curGPoint );
            }
        }

        // Stop (mouse only)
        if ( tracker.stopHandler && gPoints[ 0 ].type === 'mouse' ) {
            clearTimeout( tracker.stopTimeOut );
            tracker.stopTimeOut = setTimeout( function() {
                handlePointerStop( tracker, event, gPoints[ 0 ].type );
            }, tracker.stopDelay );
        }

        if ( pointsList.contacts === 0 ) {
            // Move (no contacts: hovering mouse or other hover-capable device)
            if ( tracker.moveHandler ) {
                propagate = tracker.moveHandler(
                    {
                        eventSource:          tracker,
                        pointerType:          gPoints[ 0 ].type,
                        position:             getPointRelativeToAbsolute( gPoints[ 0 ].currentPos, tracker.element ),
                        buttons:              pointsList.buttons,
                        isTouchEvent:         gPoints[ 0 ].type === 'touch',
                        originalEvent:        event,
                        preventDefaultAction: false,
                        userData:             tracker.userData
                    }
                );
                if ( propagate === false ) {
                    xlv.cancelEvent( event );
                }
            }
        } else if ( pointsList.contacts === 1 ) {
            // Move (1 contact)
            if ( tracker.moveHandler ) {
                updateGPoint = pointsList.asArray()[ 0 ];
                propagate = tracker.moveHandler(
                    {
                        eventSource:          tracker,
                        pointerType:          updateGPoint.type,
                        position:             getPointRelativeToAbsolute( updateGPoint.currentPos, tracker.element ),
                        buttons:              pointsList.buttons,
                        isTouchEvent:         updateGPoint.type === 'touch',
                        originalEvent:        event,
                        preventDefaultAction: false,
                        userData:             tracker.userData
                    }
                );
                if ( propagate === false ) {
                    xlv.cancelEvent( event );
                }
            }

            // Drag
            if ( tracker.dragHandler ) {
                updateGPoint = pointsList.asArray()[ 0 ];
                delta = updateGPoint.currentPos.minus( updateGPoint.lastPos );
                propagate = tracker.dragHandler(
                    {
                        eventSource:          tracker,
                        pointerType:          updateGPoint.type,
                        position:             getPointRelativeToAbsolute( updateGPoint.currentPos, tracker.element ),
                        buttons:              pointsList.buttons,
                        delta:                delta,
                        speed:                updateGPoint.speed,
                        direction:            updateGPoint.direction,
                        shift:                event.shiftKey,
                        isTouchEvent:         updateGPoint.type === 'touch',
                        originalEvent:        event,
                        preventDefaultAction: false,
                        userData:             tracker.userData
                    }
                );
                if ( propagate === false ) {
                    xlv.cancelEvent( event );
                }
            }
        } else if ( pointsList.contacts === 2 ) {
            // Move (2 contacts, use center)
            if ( tracker.moveHandler ) {
                gPointArray = pointsList.asArray();
                propagate = tracker.moveHandler(
                    {
                        eventSource:          tracker,
                        pointerType:          gPointArray[ 0 ].type,
                        position:             getPointRelativeToAbsolute( getCenterPoint( gPointArray[ 0 ].currentPos, gPointArray[ 1 ].currentPos ), tracker.element ),
                        buttons:              pointsList.buttons,
                        isTouchEvent:         gPointArray[ 0 ].type === 'touch',
                        originalEvent:        event,
                        preventDefaultAction: false,
                        userData:             tracker.userData
                    }
                );
                if ( propagate === false ) {
                    xlv.cancelEvent( event );
                }
            }

            // Pinch
            if ( tracker.pinchHandler && gPoints[ 0 ].type === 'touch' ) {
                delta = delegate.pinchGPoints[ 0 ].currentPos.distanceTo( delegate.pinchGPoints[ 1 ].currentPos );
                if ( delta != delegate.currentPinchDist ) {
                    delegate.lastPinchDist = delegate.currentPinchDist;
                    delegate.currentPinchDist = delta;
                    delegate.lastPinchCenter = delegate.currentPinchCenter;
                    delegate.currentPinchCenter = getCenterPoint( delegate.pinchGPoints[ 0 ].currentPos, delegate.pinchGPoints[ 1 ].currentPos );
                    propagate = tracker.pinchHandler(
                        {
                            eventSource:          tracker,
                            pointerType:          'touch',
                            gesturePoints:        delegate.pinchGPoints,
                            lastCenter:           getPointRelativeToAbsolute( delegate.lastPinchCenter, tracker.element ),
                            center:               getPointRelativeToAbsolute( delegate.currentPinchCenter, tracker.element ),
                            lastDistance:         delegate.lastPinchDist,
                            distance:             delegate.currentPinchDist,
                            shift:                event.shiftKey,
                            originalEvent:        event,
                            preventDefaultAction: false,
                            userData:             tracker.userData
                        }
                    );
                    if ( propagate === false ) {
                        xlv.cancelEvent( event );
                    }
                }
            }
        }
    }


    function updatePointersCancel( tracker, event, gPoints ) {
        updatePointersUp( tracker, event, gPoints, 0 );
        updatePointersExit( tracker, event, gPoints );
    }

    function handlePointerStop( tracker, originalMoveEvent, pointerType ) {
        if ( tracker.stopHandler ) {
            tracker.stopHandler( {
                eventSource:          tracker,
                pointerType:          pointerType,
                position:             getMouseRelative( originalMoveEvent, tracker.element ),
                buttons:              tracker.getActivePointersListByType( pointerType ).buttons,
                isTouchEvent:         pointerType === 'touch',
                originalEvent:        originalMoveEvent,
                preventDefaultAction: false,
                userData:             tracker.userData
            } );
        }
    }

    // True if inside an iframe, otherwise false.
    var isInIframe = (function() {
        try {
            return window.self !== window.top;
        } catch (e) {
            return true;
        }
    })();

    // returns True if the target has access rights to events, otherwise false.
    function canAccessEvents (target) {
        try {
            return target.addEventListener && target.removeEventListener;
        } catch (e) {
            return false;
        }
    }

} ( XLviewer ) );
(function( xlv ){

    /**
     * An enumeration of supported locations where controls can be anchored.
     * The anchoring is always relative to the container.
     * @member ControlAnchor
     * @memberof XLviewer
     * @static
     * @type {Object}
     * @property {Number} NONE
     * @property {Number} TOP_LEFT
     * @property {Number} TOP_RIGHT
     * @property {Number} BOTTOM_LEFT
     * @property {Number} BOTTOM_RIGHT
     * @property {Number} ABSOLUTE
     */
    xlv.ControlAnchor = {
        NONE: 0,
        TOP_LEFT: 1,
        TOP_RIGHT: 2,
        BOTTOM_RIGHT: 3,
        BOTTOM_LEFT: 4,
        BOTTOM_CENTER: 6,
        TOP_CENTER: 7,
        ABSOLUTE: 5
    };

    /**
     * @class Control
     * @classdesc A Control represents any interface element which is meant to allow the user
     * to interact with the zoomable interface. Any control can be anchored to any
     * element.
     *
     * @memberof XLviewer
     * @param {Element} element - the control element to be anchored in the container.
     * @param {Object } options - All required and optional settings for configuring a control element.
     * @param {XLviewer.ControlAnchor} [options.anchor=XLviewer.ControlAnchor.NONE] - the position of the control
     *  relative to the container.
     * @param {Boolean} [options.attachToViewer=true] - Whether the control should be added directly to the viewer, or
     *  directly to the container
     * @param {Boolean} [options.autoFade=true] - Whether the control should have the autofade behavior
     * @param {Element} container - the element to control will be anchored too.
     */
    xlv.Control = function ( element, options, container ) {
        var parent = element.parentNode;
        if (typeof options === 'number')
        {
            xlv.log.e("Passing an anchor directly into the XLviewer.Control constructor is deprecated; " +
                "please use an options object instead.  " +
                "Support for this deprecated variant is scheduled for removal in December 2013");
            options = {anchor: options};
        }
        options.attachToViewer = (typeof options.attachToViewer === 'undefined') ? true : options.attachToViewer;
        /**
         * True if the control should have autofade behavior.
         * @member {Boolean} autoFade
         * @memberof XLviewer.Control#
         */
        this.autoFade = (typeof options.autoFade === 'undefined') ? true : options.autoFade;
        /**
         * The element providing the user interface with some type of control (e.g. a zoom-in button).
         * @member {Element} element
         * @memberof XLviewer.Control#
         */
        this.element    = element;
        /**
         * The position of the Control relative to its container.
         * @member {XLviewer.ControlAnchor} anchor
         * @memberof XLviewer.Control#
         */
        this.anchor     = options.anchor;
        /**
         * The Control's containing element.
         * @member {Element} container
         * @memberof XLviewer.Control#
         */
        this.container  = container;
        /**
         * A neutral element surrounding the control element.
         * @member {Element} wrapper
         * @memberof XLviewer.Control#
         */
        if ( this.anchor == xlv.ControlAnchor.ABSOLUTE ) {
            this.wrapper    = xlv.makeNeutralElement( "div" );
            this.wrapper.style.position = "absolute";
            this.wrapper.style.top = typeof ( options.top )  == "number" ? ( options.top + 'px' ) : options.top;
            this.wrapper.style.left  = typeof ( options.left )  == "number" ?  (options.left + 'px' ) : options.left;
            this.wrapper.style.height = typeof ( options.height )  == "number" ? ( options.height + 'px' ) : options.height;
            this.wrapper.style.width  = typeof ( options.width )  == "number" ? ( options.width + 'px' ) : options.width;
            this.wrapper.style.margin = "0px";
            this.wrapper.style.padding = "0px";

            this.element.style.position = "relative";
            this.element.style.top = "0px";
            this.element.style.left = "0px";
            this.element.style.height = "100%";
            this.element.style.width = "100%";
        } else {
            this.wrapper    = xlv.makeNeutralElement( "div" );
            this.wrapper.style.display = "inline-block";
            this.wrapper.className = "xlv-control-wrapper";
            if ( this.anchor == xlv.ControlAnchor.NONE ) {
                // IE6 fix
                this.wrapper.style.width = this.wrapper.style.height = "100%";
            }
        }
        this.wrapper.appendChild( this.element );

        if (options.attachToViewer ) {
            if ( this.anchor == xlv.ControlAnchor.TOP_RIGHT ||
                this.anchor == xlv.ControlAnchor.BOTTOM_RIGHT ) {
                this.container.insertBefore(
                    this.wrapper,
                    this.container.firstChild
                );
            } else {
                this.container.appendChild( this.wrapper );
            }
        } else {
            parent.appendChild( this.wrapper );
        }
    };

    /** @lends XLviewer.Control.prototype */
    xlv.Control.prototype = {

        /**
         * Removes the control from the container.
         * @function
         */
        destroy: function() {
            this.wrapper.removeChild( this.element );
            this.container.removeChild( this.wrapper );
        },

        /**
         * Determines if the control is currently visible.
         * @function
         * @return {Boolean} true if currenly visible, false otherwise.
         */
        isVisible: function() {
            return this.wrapper.style.display != "none";
        },

        /**
         * Toggles the visibility of the control.
         * @function
         * @param {Boolean} visible - true to make visible, false to hide.
         */
        setVisible: function( visible ) {
            this.wrapper.style.display = visible ?
                ( this.anchor == xlv.ControlAnchor.ABSOLUTE ? 'block' : 'inline-block' ) :
                "none";
        },

        /**
         * Sets the opacity level for the control.
         * @function
         * @param {Number} opactiy - a value between 1 and 0 inclusively.
         */
        setOpacity: function( opacity ) {
            if ( this.element[ xlv.SIGNAL ] && xlv.Browser.vendor == xlv.BROWSERS.IE ) {
                xlv.setElementOpacity( this.element, opacity, true );
            } else {
                xlv.setElementOpacity( this.wrapper, opacity, true );
            }
        }
    };

}( XLviewer ));
(function( xlv ){
    /**
     * @class ControlDock
     * @classdesc Provides a container element (a &lt;form&gt; element) with support for the layout of control elements.
     *
     * @memberof XLviewer
     */
    xlv.ControlDock = function( options ){
        var layouts = [ 'topleft', 'topright', 'bottomright', 'bottomleft', 'bottomcenter', 'topcenter'],
            layout,
            i;

        xlv.extend( true, this, {
            id: 'controldock-'+xlv.Utils.now()+'-'+Math.floor(Math.random()*1000000),
            container: xlv.makeNeutralElement( 'div' ),
            controls: []
        }, options );

        // Disable the form's submit; otherwise button clicks and return keys
        // can trigger it.
        this.container.onsubmit = function() {
            return false;
        };

        if( this.element ){
            this.element = xlv.getElement( this.element );
            this.element.appendChild( this.container );
            this.element.style.position = 'relative';
            this.container.style.width = '100%';
            this.container.style.height = '100%';
        }

        for( i = 0; i < layouts.length; i++ ){
            layout = layouts[ i ];
            this.controls[ layout ] = xlv.makeNeutralElement( "div" );
            this.controls[ layout ].style.position = 'absolute';
            this.controls[ layout ].className = 'xlv-controls xlv-controls-' + layout.toLowerCase();
            if ( layout.match( 'left' ) ){
                this.controls[ layout ].style.left = '0px';
            }
            if ( layout.match( 'right' ) ){
                this.controls[ layout ].style.right = '0px';
            }
            if ( layout.match( 'top' ) ){
                this.controls[ layout ].style.top = '0px';
            }
            if ( layout.match( 'bottom' ) ){
                this.controls[ layout ].style.bottom = '0px';
            }
            if ( layout.match( 'center' ) ){
                this.controls[ layout ].style.width = '100%';
                this.controls[ layout ].style.textAlign = 'center';
            }
        }

        this.container.appendChild( this.controls.topleft );
        this.container.appendChild( this.controls.topright );
        this.container.appendChild( this.controls.bottomright );
        this.container.appendChild( this.controls.bottomleft );
        this.container.appendChild( this.controls.bottomcenter );
        this.container.appendChild( this.controls.topcenter );
    };

    /** @lends XLviewer.ControlDock.prototype */
    xlv.ControlDock.prototype = {

        /**
         * @function
         */
        addControl: function ( element, controlOptions ) {
            element = xlv.getElement( element );
            var div = null;

            if ( getControlIndex( this, element ) >= 0 ) {
                return;     // they're trying to add a duplicate control
            }

            switch ( controlOptions.anchor ) {
                case xlv.ControlAnchor.TOP_RIGHT:
                    div = this.controls.topright;
                    element.style.position = "relative";
                    element.style.paddingRight = "0px";
                    element.style.paddingTop = "0px";
                    break;
                case xlv.ControlAnchor.BOTTOM_RIGHT:
                    div = this.controls.bottomright;
                    element.style.position = "relative";
                    element.style.paddingRight = "0px";
                    element.style.paddingBottom = "0px";
                    break;
                case xlv.ControlAnchor.BOTTOM_LEFT:
                    div = this.controls.bottomleft;
                    element.style.position = "relative";
                    element.style.paddingLeft = "0px";
                    element.style.paddingBottom = "0px";
                    break;
                case xlv.ControlAnchor.TOP_LEFT:
                    div = this.controls.topleft;
                    element.style.position = "relative";
                    element.style.paddingLeft = "0px";
                    element.style.paddingTop = "0px";
                    break;
                case xlv.ControlAnchor.ABSOLUTE:
                    div = this.container;
                    element.style.position = "relative";
                    element.style.margin = "0px";
                    element.style.padding = "0px";
                    break;
                case xlv.ControlAnchor.TOP_CENTER:
                    div = this.controls.topcenter;
                    element.style.position = "relative";
                    break;
                case xlv.ControlAnchor.BOTTOM_CENTER:
                    div = this.controls.bottomcenter;
                    element.style.position = "relative";
                    break;
                default:
                case xlv.ControlAnchor.NONE:
                    div = this.container;
                    element.style.margin = "0px";
                    element.style.padding = "0px";
                    break;

            }

            this.controls.push(
                new xlv.Control( element, controlOptions, div )
            );
            element.style.display = "inline-block";
        },


        /**
         * @function
         * @return {XLviewer.ControlDock} Chainable.
         */
        removeControl: function ( element ) {
            element = xlv.getElement( element );
            var i = getControlIndex( this, element );

            if ( i >= 0 ) {
                this.controls[ i ].destroy();
                this.controls.splice( i, 1 );
            }

            return this;
        },

        /**
         * @function
         * @return {XLviewer.ControlDock} Chainable.
         */
        clearControls: function () {
            while ( this.controls.length > 0 ) {
                this.controls.pop().destroy();
            }

            return this;
        },


        /**
         * @function
         * @return {Boolean}
         */
        areControlsEnabled: function () {
            var i;

            for ( i = this.controls.length - 1; i >= 0; i-- ) {
                if ( this.controls[ i ].isVisible() ) {
                    return true;
                }
            }

            return false;
        },


        /**
         * @function
         * @return {XLviewer.ControlDock} Chainable.
         */
        setControlsEnabled: function( enabled ) {
            var i;

            for ( i = this.controls.length - 1; i >= 0; i-- ) {
                this.controls[ i ].setVisible( enabled );
            }

            return this;
        }

    };


    ///////////////////////////////////////////////////////////////////////////////
    // Utility methods
    ///////////////////////////////////////////////////////////////////////////////
    function getControlIndex( dock, element ) {
        var controls = dock.controls,
            i;

        for ( i = controls.length - 1; i >= 0; i-- ) {
            if ( controls[ i ].element == element ) {
                return i;
            }
        }

        return -1;
    }

}( XLviewer ));
(function(xlv) {

    /**
     * An enumeration of positions to anchor an element.
     * @member Placement
     * @memberOf XLviewer
     * @static
     * @readonly
     * @property {XLviewer.Placement} CENTER
     * @property {XLviewer.Placement} TOP_LEFT
     * @property {XLviewer.Placement} TOP
     * @property {XLviewer.Placement} TOP_RIGHT
     * @property {XLviewer.Placement} RIGHT
     * @property {XLviewer.Placement} BOTTOM_RIGHT
     * @property {XLviewer.Placement} BOTTOM
     * @property {XLviewer.Placement} BOTTOM_LEFT
     * @property {XLviewer.Placement} LEFT
     */
    xlv.Placement = xlv.Utils.freezeObject({
        CENTER:       0,
        TOP_LEFT:     1,
        TOP:          2,
        TOP_RIGHT:    3,
        RIGHT:        4,
        BOTTOM_RIGHT: 5,
        BOTTOM:       6,
        BOTTOM_LEFT:  7,
        LEFT:         8,
        properties: {
            0: {
                isLeft: false,
                isHorizontallyCentered: true,
                isRight: false,
                isTop: false,
                isVerticallyCentered: true,
                isBottom: false
            },
            1: {
                isLeft: true,
                isHorizontallyCentered: false,
                isRight: false,
                isTop: true,
                isVerticallyCentered: false,
                isBottom: false
            },
            2: {
                isLeft: false,
                isHorizontallyCentered: true,
                isRight: false,
                isTop: true,
                isVerticallyCentered: false,
                isBottom: false
            },
            3: {
                isLeft: false,
                isHorizontallyCentered: false,
                isRight: true,
                isTop: true,
                isVerticallyCentered: false,
                isBottom: false
            },
            4: {
                isLeft: false,
                isHorizontallyCentered: false,
                isRight: true,
                isTop: false,
                isVerticallyCentered: true,
                isBottom: false
            },
            5: {
                isLeft: false,
                isHorizontallyCentered: false,
                isRight: true,
                isTop: false,
                isVerticallyCentered: false,
                isBottom: true
            },
            6: {
                isLeft: false,
                isHorizontallyCentered: true,
                isRight: false,
                isTop: false,
                isVerticallyCentered: false,
                isBottom: true
            },
            7: {
                isLeft: true,
                isHorizontallyCentered: false,
                isRight: false,
                isTop: false,
                isVerticallyCentered: false,
                isBottom: true
            },
            8: {
                isLeft: true,
                isHorizontallyCentered: false,
                isRight: false,
                isTop: false,
                isVerticallyCentered: true,
                isBottom: false
            }
        }
    });

}(XLviewer));
(function (xlv) {
    var nextHash = 1;
    var INSTANCES = {};

    xlv.Core = function(options) {
        var args  = arguments,
            self = this;

        //backward compatibility for positional args while prefering more
        //idiomatic javascript options object as the only argument
        if( !xlv.Utils.isPlainObject( options ) ){
            options = {
                id:                 args[ 0 ],
                source:            args.length > 1 ? args[ 1 ] : undefined,
                image:          args.length > 2 ? args[ 2 ] : undefined
            };
        }

        if(!options.image && Array.isArray(options.images) && options.images.length) {
            options.image = options.images[0];
        }

        xlv.extend( true, this, {
            //internal state and dom identifiers
            id:             options.id,
            hash:           options.hash || nextHash++,
            //dom nodes
            element:        null,
            container:      null,
            canvas:         null,
            drawer:         null,
            viewport:       null,
            navigator:      null
        }, xlv.DEFAULT_SETTINGS, options );

        // make new instance of console
        xlv.log = new xlv.Logger(this.logLevel);

        //Private state properties
        INSTANCES[ this.hash ] = {
            "fsBoundsDelta":     new xlv.Point( 1, 1 ),
            "prevContainerSize": null,
            "animating":         false,
            "forceRedraw":       false,
            "mouseInside":       false,
            "group":             null,
            // whether we should be continuously zooming
            "zooming":           false,
            // how much we should be continuously zooming by
            "zoomFactor":        null,
            "lastZoomTime":      null,
            "fullPage":          false,
            "onfullscreenchange": null
        };

        //init private vars
        this._firstOpen = true;
        this._updateRequestId = null;
        this._loadQueue = [];
        this._lastScrollTime = xlv.Utils.now();
        this._rotateEnabled = false;
        this._currentImageIndex = 0;

        //Inherit some behaviors and properties
        xlv.EventDispatcher.call( this );
        /*
         this.addListener( 'openFailed', function ( event ) {
         var msg = $.getString( "Errors.OpenFailed", event.eventSource, event.message);
         self._showMessage( msg );
         });
         */
        xlv.ControlDock.call( this, options );

        this.element              = this.element || document.getElementById( this.id );
        this.canvas               = xlv.makeNeutralElement( "div" );
        this.canvas.className = "xlv-stage"; //"xlv-canvas"

        xlv.Utils.applyStyle(this.canvas, {
            width : "100%",
            height : "100%",
            overflow : "hidden",
            position : "absolute",
            top : "0px",
            left : "0px"
        });
        xlv.setElementTouchActionNone( this.canvas );

        this.container.className = "xlv-root"; //"xlv-container"
        xlv.Utils.applyStyle(this.container, {
            width : "100%",
            height : "100%",
            overflow : "hidden",
            position : "relative",
            textAlign : "left",
            top : "0px",
            left : "0px"
        });

        this.container.insertBefore( this.canvas, this.container.firstChild );
        this.element.appendChild( this.container );

        this.bodyWidth      = document.body.style.width;
        this.bodyHeight     = document.body.style.height;

        this.innerTracker = new xlv.InteractionManager({
            element:                  this.canvas,
            startDisabled:            !this.mouseEnabled,
            clickMaxDuration:       this.clickMaxDuration,
            clickAreaRadius:       this.clickAreaRadius,
            doubleClickMaxDuration:    this.doubleClickMaxDuration,
            doubleClickAreaRadius:    this.doubleClickAreaRadius,
            keyDownHandler:           xlv.Utils.delegate( this, onCanvasKeyDown ),
            keyHandler:               xlv.Utils.delegate( this, onCanvasKeyPress ),
            clickHandler:             xlv.Utils.delegate( this, onCanvasClick ),
            dblClickHandler:          xlv.Utils.delegate( this, onCanvasDoubleClick ),
            dragHandler:              xlv.Utils.delegate( this, onCanvasDrag ),
            dragEndHandler:           xlv.Utils.delegate( this, onCanvasDragEnd ),
            enterHandler:             xlv.Utils.delegate( this, onCanvasEnter ),
            exitHandler:              xlv.Utils.delegate( this, onCanvasExit ),
            pressHandler:             xlv.Utils.delegate( this, onCanvasPress ),
            releaseHandler:           xlv.Utils.delegate( this, onCanvasRelease ),
            nonPrimaryPressHandler:   xlv.Utils.delegate( this, onCanvasNonPrimaryPress ),
            nonPrimaryReleaseHandler: xlv.Utils.delegate( this, onCanvasNonPrimaryRelease ),
            scrollHandler:            xlv.Utils.delegate( this, onCanvasScroll ),
            pinchHandler:             xlv.Utils.delegate( this, onCanvasPinch ),
            moveHandler :             xlv.Utils.delegate( this, onCanvasMove )
        });

        this.outerTracker = new xlv.InteractionManager({
            element:               this.container,
            startDisabled:         !this.mouseEnabled,
            clickMaxDuration:    this.clickMaxDuration,
            clickAreaRadius:    this.clickAreaRadius,
            doubleClickMaxDuration: this.doubleClickMaxDuration,
            doubleClickAreaRadius: this.doubleClickAreaRadius,
            enterHandler:          xlv.Utils.delegate( this, onContainerEnter ),
            exitHandler:           xlv.Utils.delegate( this, onContainerExit )
        });


        INSTANCES[ this.hash ].prevContainerSize = _getSafeElemSize( this.container );

        this.addStaticPreview = function(staticPreview) {
            if(!staticPreview) {
                return;
            }
            self.staticPreview = staticPreview;
            self.container.insertBefore( self.staticPreview.element, self.container.firstChild );
        };
        this.addHotspotLayer = function(layer) {
            if(!layer) {
                return;
            }
            self.hotspotLayer = layer;
            this.addControl(self.hotspotLayer.element, {anchor:XLviewer.ControlAnchor.NONE});
            //self.container.appendChild( self.hotspotLayer.element );
        };

        this.setImageVisibility = function (visible) {
            var visibility = visible ? "visible" : "hidden";
            xlv.Utils.applyStyle(this.canvas,{
                "visibility": visibility
            });
        };

        // Create the manager
        this.manager = new xlv.Manager({
            core: this
        });

        this.manager.addListener('addItem', function(event) {
            INSTANCES[ self.hash ].forceRedraw = true;

            if (!self._updateRequestId) {
                self._updateRequestId = scheduleUpdate( self, updateMulti );
            }
        });

        this.manager.addListener('removeItem', function(event) {
            INSTANCES[ self.hash ].forceRedraw = true;
        });

        this.manager.addListener('metricsChange', function(event) {
            if (self.viewport) {
                self.viewport._setContentBounds(self.manager.getHomeBounds(), self.manager.getContentFactor());
            }
        });

        // Create the viewport
        this.viewport = new xlv.Viewport({
            containerSize:      INSTANCES[ this.hash ].prevContainerSize,
            tweenSmoothness:    this.tweenSmoothness,
            tweenDuration:      this.tweenDuration,
            underZoomRatio:  this.underZoomRatio,
            overZoomRatio:  this.overZoomRatio,
            visibilityRatio:    this.visibilityRatio,
            wrapHorizontal:     this.wrapHorizontal,
            wrapVertical:       this.wrapVertical,
            defaultZoomLevel:   this.defaultZoomLevel,
            minZoomLevel:       this.minZoomLevel,
            maxZoomLevel:       this.maxZoomLevel,
            viewer:             this,
            rotation:            this.rotation,
            homeFillsViewer:    this.homeFillsViewer,
            margins:            this.viewportMargins
        });

        this.viewport._setContentBounds(this.manager.getHomeBounds(), this.manager.getContentFactor());

        // Create the image loader
        this.imageLoader = new xlv.ImageLoader({
            jobLimit: this.imageLoaderLimit
        });

        // Create the tile cache
        this.tileCache = new xlv.TileCache({
            maxImageCacheCount: this.maxImageCacheCount
        });

        // Create the drawer
        this.drawer = new xlv.Drawer({
            viewer:             this,
            viewport:           this.viewport,
            element:            this.canvas,
            debugGridColor:     this.debugGridColor
        });


        // Now that we have a drawer, see if it supports rotate. If not we need to remove the rotate buttons
        /*
         if (!this.drawer.canRotate()) {
         // Disable/remove the rotate left/right buttons since they aren't supported
         if (this.rotateLeft) {
         i = this.buttons.buttons.indexOf(this.rotateLeft);
         this.buttons.buttons.splice(i, 1);
         this.buttons.element.removeChild(this.rotateLeft.element);
         }
         if (this.rotateRight) {
         i = this.buttons.buttons.indexOf(this.rotateRight);
         this.buttons.buttons.splice(i, 1);
         this.buttons.element.removeChild(this.rotateRight.element);
         }
         }
         */


        //Instantiate a navigator if configured
        if ( this.useNavigator){
            this.navigator = new xlv.Navigator({
                id:                this.navigatorConfig.id,
                source :           this.source,
                image:             this.image,
                quality:           this.quality,
                position:          this.navigatorConfig.position,
                sizeRatio:         this.navigatorConfig.sizeRatio,
                maintainSizeRatio: this.navigatorConfig.maintainSizeRatio,
                top:               this.navigatorConfig.top,
                left:              this.navigatorConfig.left,
                width:             this.navigatorConfig.width,
                height:            this.navigatorConfig.height,
                autoResize:        this.navigatorConfig.autoResize,
                rotate:            this.navigatorConfig.rotate,
                viewer:            this,
                enableCORS:        this.enableCORS
            });
        }

        this.imageInfoUrl = xlv.Imgf.buildInfoUrl(this.source, this.image);
        // Open initial tilesources
        if (this.imageInfoUrl) {
            this.open( { imageInfoUrl : this.imageInfoUrl } );
        }
    };


    xlv.extend( xlv.Core.prototype, xlv.EventDispatcher.prototype, xlv.ControlDock.prototype, {


        /**
         * @function
         * @return {Boolean}
         */
        isOpen: function () {
            return !!this.manager.getItemCount();
        },

        /**
         * @function
         * Open an imgf image
         * @param image {string} - filename widthout server url
         * @param onOpenCallback {function} - callback called when image is opened, can be undefined
         */
        openImage : function(image, onOpenCallback) {
            this.image = image;
            this.imageInfoUrl = xlv.Imgf.buildInfoUrl(this.source, this.image);
            if(this.navigator) {
                this.navigator.image = this.image;
                this.navigator.imageInfoUrl = this.imageInfoUrl;
            }

            // Open initial tilesources
            if (this.imageInfoUrl) {
                this.open( { imageInfoUrl : this.imageInfoUrl }, onOpenCallback );
            }
        },

        /**
         * @function
         * Open tiled images into the viewer, closing any others.
         * @param options {Object} - viewer options
         * @param onOpenCallback {function} - callback called when image is opened, can be undefined
         * @returns {XLviewer} - instance of the viewer
         */
        open: function (options, onOpenCallback) {
            var self = this;
            this.options = options;
            this.close();
            if (!options.imageInfoUrl) {
                return;
            }

            this._opening = true;
            var expected = 1;
            var successes = 0;
            var failures = 0;
            var failEvent;

            var onComplete = function(success) {
                if(onOpenCallback) {
                    onOpenCallback(success);
                }
                if (success) {
                    if (self._firstOpen || !self.preserveViewport) {
                        self.viewport.doZoomReset( true );
                        self.viewport.update();
                    }

                    self._firstOpen = false;
                    self._opening = false;
                    /**
                     * Dispatched when the viewer has opened and loaded one or more TileSources.
                     */
                    // TODO: what if there are multiple sources?
                    self.dispatchEvent( 'open' );
                } else {
                    self._opening = false;

                    /**
                     * Dispatched when an error occurs loading a TileSource.
                     */
                    self.dispatchEvent( 'openFailed', failEvent );
                }
            };


            if (options.index !== undefined) {
                xlv.log.e('[Viewer.open] setting indexes here is not supported; use addTiledImage instead');
                delete options.index;
            }

            if (options.collectionImmediately === undefined) {
                options.collectionImmediately = true;
            }

            var originalSuccess = options.success;
            options.success = function(event) {
                if (originalSuccess) {
                    originalSuccess(event);
                }
                onComplete(true);
            };

            var originalError = options.error;
            options.error = function(event) {
                failures++;

                if (!failEvent) {
                    failEvent = event;
                }

                if (originalError) {
                    originalError(event);
                }

                onComplete(false);
            };

            self.addTiledImage(options);

            return this;
        },

        /**
         * Close the currently opened image
         * @returns {XLviewer} - instance of the viewer
         */
        close: function ( ) {
            if ( !INSTANCES[ this.hash ] ) {
                //this viewer has already been destroyed: returning immediately
                return this;
            }

            this._opening = false;

            if ( this.navigator ) {
                this.navigator.close();
            }

            INSTANCES[ this.hash ].animating = false;
            this.manager.removeAll();
            this.imageLoader.clear();

            /**
             * Dispatched when the viewer is closed

             */
            this.dispatchEvent( 'close' );

            return this;
        },


        /**
         * Function to destroy the viewer and clean up everything created by XLviewer.
         */
        destroy: function( ) {
            if ( !INSTANCES[ this.hash ] ) {
                //this viewer has already been destroyed: returning immediately
                return;
            }

            this.close();

            //TODO: implement this...
            //this.unbindSequenceControls()
            //this.unbindStandardControls()

            if (this.referenceStrip) {
                this.referenceStrip.destroy();
                this.referenceStrip = null;
            }

            if ( this._updateRequestId !== null ) {
                xlv.cancelAnimationFrame( this._updateRequestId );
                this._updateRequestId = null;
            }

            if ( this.drawer ) {
                this.drawer.destroy();
            }

            this.removeAllHandlers();

            // Go through top element (passed to us) and remove all children
            // Use removeChild to make sure it handles SVG or any non-html
            // also it performs better - http://jsperf.com/innerhtml-vs-removechild/15
            if (this.element){
                while (this.element.firstChild) {
                    this.element.removeChild(this.element.firstChild);
                }
            }

            // destroy the mouse trackers
            if (this.innerTracker){
                this.innerTracker.destroy();
            }
            if (this.outerTracker){
                this.outerTracker.destroy();
            }

            INSTANCES[ this.hash ] = null;
            delete INSTANCES[ this.hash ];

            // clear all our references to dom objects
            this.canvas = null;
            this.container = null;

            // clear our reference to the main element - they will need to pass it in again, creating a new viewer
            this.element = null;
        },

        /**
         *  true/false to enable/disable mouse
         *  @param enabled {boolean}
         */
        setMouseNavEnabled: function( enabled ){
            this.innerTracker.setTracking( enabled );
            this.outerTracker.setTracking( enabled );
            /**
             * Dispatched when mouse/touch navigation is enabled or disabled (see setMouseNavEnabled).
             */
            this.dispatchEvent( 'mouseEnabled', { enabled: enabled } );
            return this;
        },

        /**
         * @function
         * return if is ion full page
         * @return {boolean}
         */
        isFullPage: function () {
            return INSTANCES[ this.hash ].fullPage;
        },


        /**
         * Toggle full page mode.
         * @function
         * @param {boolean} fullPage
         *      If true, enter full page mode.  If false, exit full page mode.
         * @return {XLviewer.Core} Chainable.
         * @fires XLviewer.Viewer.event:pre-full-page
         * @fires XLviewer.Viewer.event:full-page
         */
        setFullPage: function( fullPage ) {

            var body = document.body,
                bodyStyle = body.style,
                docStyle = document.documentElement.style,
                self = this,
                hash,
                nodes,
                i;

            //dont bother modifying the DOM if we are already in full page mode.
            if ( fullPage == this.isFullPage() ) {
                return this;
            }

            var fullPageEventArgs = {
                fullPage: fullPage,
                preventDefaultAction: false
            };
            /**
             * Dispatched when the viewer is about to change to/from fullPage mode.
             */
            this.dispatchEvent( 'preFullPage', fullPageEventArgs );
            if ( fullPageEventArgs.preventDefaultAction ) {
                return this;
            }

            if ( fullPage ) {

                this.elementSize = xlv.getElementSize( this.element );
                this.pageScroll = xlv.getPageScroll();

                this.elementMargin = this.element.style.margin;
                this.element.style.margin = "0";
                this.elementPadding = this.element.style.padding;
                this.element.style.padding = "0";

                this.bodyMargin = bodyStyle.margin;
                this.docMargin = docStyle.margin;
                bodyStyle.margin = "0";
                docStyle.margin = "0";

                this.bodyPadding = bodyStyle.padding;
                this.docPadding = docStyle.padding;
                bodyStyle.padding = "0";
                docStyle.padding = "0";

                this.bodyWidth = bodyStyle.width;
                this.bodyHeight = bodyStyle.height;
                bodyStyle.width = "100%";
                bodyStyle.height = "100%";

                //when entering full screen on the ipad it wasnt sufficient to leave
                //the body intact as only only the top half of the screen would
                //respond to touch events on the canvas, while the bottom half treated
                //them as touch events on the document body.  Thus we remove and store
                //the bodies elements and replace them when we leave full screen.
                this.previousBody = [];
                INSTANCES[ this.hash ].prevElementParent = this.element.parentNode;
                INSTANCES[ this.hash ].prevNextSibling = this.element.nextSibling;
                INSTANCES[ this.hash ].prevElementWidth = this.element.style.width;
                INSTANCES[ this.hash ].prevElementHeight = this.element.style.height;
                nodes = body.childNodes.length;
                for ( i = 0; i < nodes; i++ ) {
                    this.previousBody.push( body.childNodes[ 0 ] );
                    body.removeChild( body.childNodes[ 0 ] );
                }

                xlv.addClass( this.element, 'fullpage' );
                body.appendChild( this.element );

                this.element.style.height = xlv.getWindowSize().y + 'px';
                this.element.style.width = xlv.getWindowSize().x + 'px';

                INSTANCES[ this.hash ].fullPage = true;

                // mouse will be inside container now
                xlv.Utils.delegate( this, onContainerEnter )( {} );

            } else {

                this.element.style.margin = this.elementMargin;
                this.element.style.padding = this.elementPadding;

                bodyStyle.margin = this.bodyMargin;
                docStyle.margin = this.docMargin;

                bodyStyle.padding = this.bodyPadding;
                docStyle.padding = this.docPadding;

                bodyStyle.width = this.bodyWidth;
                bodyStyle.height = this.bodyHeight;

                body.removeChild( this.element );
                nodes = this.previousBody.length;
                for ( i = 0; i < nodes; i++ ) {
                    body.appendChild( this.previousBody.shift() );
                }

                xlv.removeClass( this.element, 'fullpage' );
                INSTANCES[ this.hash ].prevElementParent.insertBefore(
                    this.element,
                    INSTANCES[ this.hash ].prevNextSibling
                );

                this.element.style.width = INSTANCES[ this.hash ].prevElementWidth;
                this.element.style.height = INSTANCES[ this.hash ].prevElementHeight;

                // After exiting fullPage or fullScreen, it can take some time
                // before the browser can actually set the scroll.
                var restoreScrollCounter = 0;
                var restoreScroll = function() {
                    xlv.setPageScroll( self.pageScroll );
                    var pageScroll = xlv.getPageScroll();
                    restoreScrollCounter++;
                    if ( restoreScrollCounter < 10 &&
                        pageScroll.x !== self.pageScroll.x ||
                        pageScroll.y !== self.pageScroll.y ) {
                        xlv.requestAnimationFrame( restoreScroll );
                    }
                };
                xlv.requestAnimationFrame( restoreScroll );

                INSTANCES[ this.hash ].fullPage = false;

                // mouse will likely be outside now
                xlv.Utils.delegate( this, onContainerExit )( { } );

            }

            if ( this.navigator && this.viewport ) {
                this.navigator.update( this.viewport );
            }

            /**
             * Dispatched when the viewer has changed to/from fullPage mode
             */
            this.dispatchEvent( 'fullPage', { fullPage: fullPage } );

            return this;
        },

        /**
         * Toggle full screen mode if supported. Toggle full page mode otherwise.
         * @param fullScreen {boolean} - true to go fullscreen, false to exit
         */
        setFullScreen: function( fullScreen ) {
            var self = this;

            if ( !xlv.supportsFullScreen ) {
                return this.setFullPage( fullScreen );
            }

            if ( xlv.isFullScreen() === fullScreen ) {
                return this;
            }

            var fullScreeEventArgs = {
                fullScreen: fullScreen,
                preventDefaultAction: false
            };
            /**
             * Dispatched when the viewer is about to change to/from full screen mode
             * Note: the preFullScreen event is not raised when the user is exiting
             * fullScreen mode by pressing the Esc key. In that case, consider using
             * the fullScreen, preFullPage or fullPage events.
             */
            this.dispatchEvent( 'preFullScreen', fullScreeEventArgs );
            if ( fullScreeEventArgs.preventDefaultAction ) {
                return this;
            }

            if ( fullScreen ) {

                this.setFullPage( true );
                // If the full page mode is not actually entered, we need to prevent
                // the full screen mode.
                if ( !this.isFullPage() ) {
                    return this;
                }

                this.fullPageStyleWidth = this.element.style.width;
                this.fullPageStyleHeight = this.element.style.height;
                this.element.style.width = '100%';
                this.element.style.height = '100%';

                var onFullScreenChange = function() {
                    var isFullScreen = xlv.isFullScreen();
                    if ( !isFullScreen ) {
                        xlv.unbind( document, xlv.fullScreenEventName, onFullScreenChange );
                        xlv.unbind( document, xlv.fullScreenErrorEventName, onFullScreenChange );

                        self.setFullPage( false );
                        if ( self.isFullPage() ) {
                            self.element.style.width = self.fullPageStyleWidth;
                            self.element.style.height = self.fullPageStyleHeight;
                        }
                    }
                    if ( self.navigator && self.viewport ) {
                        self.navigator.update( self.viewport );
                    }
                    /**
                     * Dispatched when the viewer has changed to/from full-screen mode.
                     */
                    self.dispatchEvent( 'fullScreen', { fullScreen: isFullScreen } );
                };
                xlv.bind( document, xlv.fullScreenEventName, onFullScreenChange );
                xlv.bind( document, xlv.fullScreenErrorEventName, onFullScreenChange );

                xlv.requestFullScreen( document.body );

            } else {
                xlv.exitFullScreen();
            }
            return this;
        },

        /**
         * @function
         * Toggle the ratotation state of the viewer
         */
        toggleRotate : function () {
            this._rotateEnabled = !this._rotateEnabled;
        },

        /**
         * Return if viewer is visible
         * @returns {boolean}
         */
        isVisible: function () {
            return this.container.style.visibility !== "hidden";
        },

        /**
         * Set viewer visibility
         * @param visible {boolean}
         * @returns {XLviewer} - viewer instance
         */
        setVisible: function( visible ){
            this.container.style.visibility = visible ? "" : "hidden";
            /**
             * Dispatched when the viewer is shown or hidden (see {@link XLviewer.Core#setVisible}).
             */
            this.dispatchEvent( 'visible', { visible: visible } );
            return this;
        },

        /**
         * @ignore
         * Add a tiled image to the viewer.
         * options.tileSource can be anything that {@link XLviewer.Core#open}
         *  supports except arrays of images.
         * Note that you can specify options.width or options.height, but not both.
         * The other dimension will be calculated according to the item's aspect ratio.
         */
        addTiledImage: function( options ) {
            xlv.log.d(options, "[Core.addTiledImage] options is required");
            xlv.log.d(!options.replace || (options.index > -1 && options.index < this.manager.getItemCount()),
                "[Core.addTiledImage] if options.replace is used, options.index must be a valid index in Core.manager");

            var self = this;

            if (options.replace) {
                options.replaceItem = self.manager.getItemAt(options.index);
            }

            this._hideMessage();

            if (options.placeholderFillStyle === undefined) {
                options.placeholderFillStyle = this.placeholderFillStyle;
            }
            if (options.opacity === undefined) {
                options.opacity = this.opacity;
            }
            if (options.blendingType === undefined) {
                options.blendingType = this.blendingType;
            }

            var myQueueItem = {
                options: options
            };

            function raiseAddItemFailed( event ) {
                for (var i = 0; i < self._loadQueue.length; i++) {
                    if (self._loadQueue[i] === myQueueItem) {
                        self._loadQueue.splice(i, 1);
                        break;
                    }
                }

                if (self._loadQueue.length === 0) {
                    refreshScene(myQueueItem);
                }

                /**
                 * Dispatched when an error occurs while adding a item.
                 */
                self.dispatchEvent( 'addItemFailed', event );

                if (options.error) {
                    options.error(event);
                }
            }

            function refreshScene(theItem) {
                if (self.collectionMode) {
                    self.manager.arrange({
                        immediately: theItem.options.collectionImmediately,
                        rows: self.collectionRows,
                        columns: self.collectionColumns,
                        layout: self.collectionLayout,
                        tileSize: self.collectionTileSize,
                        tileMargin: self.collectionTileMargin
                    });
                    self.manager.setAutoRefigureSizes(true);
                }
            }

            if (xlv.Utils.isArray(options.tileSource)) {
                setTimeout(function() {
                    raiseAddItemFailed({
                        message: "[Viewer.addTiledImage] Sequences can not be added; add them one at a time instead.",
                        source: options.tileSource,
                        options: options
                    });
                });
                return;
            }

            this._loadQueue.push(myQueueItem);
            xlv.Imgf.loadTileSource( this, this.imageInfoUrl, function( tileSource ) {

                myQueueItem.tileSource = tileSource;

                // add everybody at the front of the queue that's ready to go
                var queueItem, tiledImage, optionsClone;
                while (self._loadQueue.length) {
                    queueItem = self._loadQueue[0];
                    if (!queueItem.tileSource) {
                        break;
                    }

                    self._loadQueue.splice(0, 1);

                    if (queueItem.options.replace) {
                        var newIndex = self.manager.getIndexOfItem(queueItem.options.replaceItem);
                        if (newIndex != -1) {
                            queueItem.options.index = newIndex;
                        }
                        self.manager.removeItem(queueItem.options.replaceItem);
                    }

                    tiledImage = new xlv.TiledImage({
                        viewer: self,
                        quality: self.quality,
                        source: queueItem.tileSource,
                        viewport: self.viewport,
                        drawer: self.drawer,
                        tileCache: self.tileCache,
                        imageLoader: self.imageLoader,
                        x: queueItem.options.x,
                        y: queueItem.options.y,
                        width: queueItem.options.width,
                        height: queueItem.options.height,
                        fitBounds: queueItem.options.fitBounds,
                        fitBoundsPlacement: queueItem.options.fitBoundsPlacement,
                        clip: queueItem.options.clip,
                        placeholderFillStyle: queueItem.options.placeholderFillStyle,
                        opacity: queueItem.options.opacity,
                        blendingType: queueItem.options.blendingType,
                        tweenSmoothness: self.tweenSmoothness,
                        tweenDuration: self.tweenDuration,
                        underZoomRatio: self.underZoomRatio,
                        wrapHorizontal: self.wrapHorizontal,
                        wrapVertical: self.wrapVertical,
                        noWaitForRendering: self.noWaitForRendering,
                        blendDuration: self.blendDuration,
                        alwaysBlend: self.alwaysBlend,
                        minPixelRatio: self.minPixelRatio,
                        overZoomRatioForSmoothingTile: self.overZoomRatioForSmoothingTile,
                        enableCORS: self.enableCORS,
                        debug: self.debug
                    });

                    self.manager.addItem( tiledImage, {
                        index: queueItem.options.index
                    });

                    if (self._loadQueue.length === 0) {
                        //this restores the autoRefigureSizes flag to true.
                        refreshScene(queueItem);
                    }

                    if (self.manager.getItemCount() === 1 && !self.preserveViewport) {
                        self.viewport.doZoomReset(true);
                    }

                    if (self.navigator) {
                        optionsClone = xlv.extend({}, queueItem.options, {
                            originalTiledImage: tiledImage,
                            tileSource: queueItem.tileSource
                        });

                        self.navigator.addTiledImage(optionsClone);
                    }

                    if (queueItem.options.success) {
                        queueItem.options.success({
                            item: tiledImage
                        });
                    }
                }
            }, function( event ) {
                event.options = options;
                raiseAddItemFailed(event);
            } );
        },
        /**
         * If is set param "images" on the XLviewer instance, go to next image.
         * If "is3D" is true, it maintains the selected bounds
         */
        next: function () {
            if(!Array.isArray(this.images) || this.images.length < 2) {
                return
            }
            this._currentImageIndex++;
            if(this._currentImageIndex >= this.images.length) {
                this._currentImageIndex = 0;
            }
            if (this.is3D) {
                this.preserveViewport = true;
                this.blendDuration = 0;
            }
            this.openImage(this.images[this._currentImageIndex]);
            if(this.staticPreview) {
                this.staticPreview.update();
            }
        },
        /**
         *  If is set "images" on the XLviewer instance, go to previous image.
         *  If "is3D" is true, it mantains the selected bounds
         */
        prev: function () {
            if(!Array.isArray(this.images) || this.images.length < 2) {
                return
            }
            this._currentImageIndex--;
            if(this._currentImageIndex < 0) {
                this._currentImageIndex = this.images.length - 1
            }
            if (this.is3D) {
                this.preserveViewport = true;
                this.blendDuration = 0;
            }
            this.openImage(this.images[this._currentImageIndex])
            if(this.staticPreview) {
                this.staticPreview.update();
            }
        },

        /**
         * Force the viewer to redraw its contents.
         */
        forceRedraw: function() {
            INSTANCES[ this.hash ].forceRedraw = true;
            return this;
        },

        /**
         * @ignore
         * Display a message in the viewport
         */
        _showMessage: function ( message ) {
            this._hideMessage();

            var div = xlv.makeNeutralElement( "div" );
            div.appendChild( document.createTextNode( message ) );

            this.messageDiv = xlv.makeCenteredNode( div );

            xlv.addClass(this.messageDiv, "xlv-message");

            this.container.appendChild( this.messageDiv );
        },

        /**
         * @ignore
         * Hide any currently displayed viewport message
         */
        _hideMessage: function () {
            var div = this.messageDiv;
            if (div) {
                div.parentNode.removeChild(div);
                delete this.messageDiv;
            }
        },

        /**
         * @ignore
         * Gets this viewer's gesture settings for the given pointer device type.
         */
        gestureSettingsByDeviceType: function ( type ) {
            switch ( type ) {
                case 'touch':
                    return this.touchBehavior;
                case 'mouse':
                default:
                    return this.mouseBehavior;
            }
        },

        /**
         * @ignore
         * Cancel the "in flight" images.
         */
        _cancelPendingImages: function() {
            this._loadQueue = [];
        },


        /**
         * Do an automatic zoom in
         */
        zoomIn: function () {
            if ( this.viewport ) {
                this.zooming = false;
                this.viewport.zoomBy(
                    this.clickZoomFactor / 1.0
                );
                this.viewport.applyConstraints();
            }
            if(this.staticPreview) {
                this.staticPreview.stopAutorotate();
            }
        },
        /**
         * Do an automatic zoom out
         */
        zoomOut: function () {
            if ( this.viewport ) {
                this.zooming = false;
                this.viewport.zoomBy(
                    1.0 / this.clickZoomFactor
                );
                this.viewport.applyConstraints();
            }
            if(this.staticPreview) {
                this.staticPreview.stopAutorotate();
            }
        },
        /**
         * Reset the zoom to fit the image in viewport
         */
        zoomReset: function () {
            if ( this.viewport ) {
                this.viewport.setRotation(0);
                this.viewport.doZoomReset();
            }
            if(this.staticPreview) {
                this.staticPreview.stopAutorotate();
            }
        },

        /**
         * Rotate left by 90°
         */
        rotateLeft: function () {
            if ( this.viewport ) {
                if(this.staticPreview && this.staticPreview.enabled) {
                    this.staticPreview.stopAutorotate();
                    this.staticPreview.toggle();
                }
                var currRotation = this.viewport.getRotation();
                if (currRotation === 0) {
                    currRotation = 270;
                }
                else {
                    currRotation -= 90;
                }
                this.viewport.setRotation(currRotation);
            }
        },

        /**
         * Rotate right by 90°
         */
        rotateRight: function () {
            if ( this.viewport ) {
                if(this.staticPreview && this.staticPreview.enabled) {
                    this.staticPreview.stopAutorotate();
                    this.staticPreview.toggle();
                }
                var currRotation = this.viewport.getRotation();
                if (currRotation === 270) {
                    currRotation = 0;
                }
                else {
                    currRotation += 90;
                }
                this.viewport.setRotation(currRotation);
            }
        },

        /**
         * Effettua uno zoom verso un certo rettangolo {XLviewer.Rect}
         * le dimensioni del rettangolo vanno da 0 a 1.
         * @param bounds {XLviewer.Rect} rettangolo di destinazione
         * @param immediately {boolean} se false va al rettangolo di destinazione con una animazioneù
         * @param applyConstraint {boolean} se true aggiusta il bpounds fornito per non violare delle regole di corretta visualizzazione
         */
        zoomToBounds: function(bounds, immediately, applyConstraint) {
            this.viewport.fitNormalizedBounds(bounds, immediately, applyConstraint);
        },

        /**
         * Ritorna il rettangolo dei bounds normalizzato alle dimensioni che vanno da 0 a 1
         * @param current {boolean} - se false indica di ritornare il bounds di destinazione invece di quello corrente in caso di animazione in corso
         * @returns {XLviewer.Rect}
         */
        getBounds: function ( current ) {
            return this.viewport.getNormalizedBounds( current );
        },


        /**
         * Ritorna il rettangolo dei bounds normalizzato alle dimensioni che vanno da 0 a 1
         * @returns {XLviewer.Rect}
         */
        getCurrentImageBounds: function ( current ) {
            var bounds = this.getBounds(current);
            var contSize = this.viewport.getContainerSize();
            var w = Math.round(contSize.x / bounds.width);
            var h = Math.round(contSize.y / bounds.height);
            var x = -Math.round(w * bounds.x);
            var y = -Math.round(h * bounds.y);
            return new xlv.Rect(x,y,w,h);
        },




        /**
         * data un un punto con coordinate (0 - 1) ritorna la stesso punto in pixel rispetto la scene
         * @param coord {XLviewer.Point}
         * @param current {Boolean}
         * @returns {XLviewer.Point}
         */
        localToScene: function(coord , current) {
            // prendo le misure reali dell'immagine alla view corrente
            var imageBounds = this.getCurrentImageBounds( current );
            if(!imageBounds)
                return null;
            let x = Math.round(coord.x * imageBounds.width + imageBounds.x);
            let y = Math.round(coord.y * imageBounds.height + imageBounds.y);
            return new xlv.Point(x, y);
        },

        sceneToLocal : function (coord , current, notNormalized) {
            var bounds = this.getBounds( current );
            var contSize = this.viewport.getContainerSize();

            var rawX = (coord.x * bounds.width) / contSize.x + bounds.x;
            var rawY = (coord.y * bounds.height) / contSize.y + bounds.y;

            if(notNormalized) {
                return new xlv.Point(rawX, rawY);
            }

            var localX = xlv.Utils.clamp(rawX, 0, 1);
            var localY = xlv.Utils.clamp(rawY, 0, 1);
            return new xlv.Point(localX, localY);
        }

    });


    /**
     * _getSafeElemSize is like getElementSize(), but refuses to return 0 for x or y,
     * which was causing some calling operations to return NaN.
     */
    function _getSafeElemSize (oElement) {
        oElement = xlv.getElement( oElement );

        return new xlv.Point(
            (oElement.clientWidth === 0 ? 1 : oElement.clientWidth),
            (oElement.clientHeight === 0 ? 1 : oElement.clientHeight)
        );
    }

///////////////////////////////////////////////////////////////////////////////
// Schedulers provide the general engine for animation
///////////////////////////////////////////////////////////////////////////////
    function scheduleUpdate( viewer, updateFunc ){
        return xlv.requestAnimationFrame( function(){
            updateFunc( viewer );
        } );
    }


//provides a sequence in the fade animation
    function scheduleControlsFade( viewer ) {
        xlv.requestAnimationFrame( function(){
            updateControlsFade( viewer );
        });
    }


//determines if fade animation is done or continues the animation
    function updateControlsFade( viewer ) {
        var currentTime,
            deltaTime,
            opacity,
            i;
        if ( viewer.controlsShouldFade ) {
            currentTime = xlv.Utils.now();
            deltaTime = currentTime - viewer.controlsFadeBeginTime;
            opacity = 1.0 - deltaTime / viewer.controlsFadeLength;

            opacity = Math.min( 1.0, opacity );
            opacity = Math.max( 0.0, opacity );

            for ( i = viewer.controls.length - 1; i >= 0; i--) {
                if (viewer.controls[ i ].autoFade) {
                    viewer.controls[ i ].setOpacity( opacity );
                }
            }

            if ( opacity > 0 ) {
                // fade again
                scheduleControlsFade( viewer );
            }
        }
    }



///////////////////////////////////////////////////////////////////////////////
// Default view event handlers.
///////////////////////////////////////////////////////////////////////////////

    function onCanvasKeyDown( event ) {
        if ( !event.preventDefaultAction && !event.ctrl && !event.alt && !event.meta ) {
            switch( event.keyCode ){
                case 38://up arrow
                    if ( event.shift ) {
                        this.viewport.zoomBy(1.1);
                    } else {
                        this.viewport.panBy(this.viewport.deltaPointsFromPixels(new xlv.Point(0, -40)));
                    }
                    this.viewport.applyConstraints();
                    return false;
                case 40://down arrow
                    if ( event.shift ) {
                        this.viewport.zoomBy(0.9);
                    } else {
                        this.viewport.panBy(this.viewport.deltaPointsFromPixels(new xlv.Point(0, 40)));
                    }
                    this.viewport.applyConstraints();
                    return false;
                case 37://left arrow
                    this.viewport.panBy(this.viewport.deltaPointsFromPixels(new xlv.Point(-40, 0)));
                    this.viewport.applyConstraints();
                    return false;
                case 39://right arrow
                    this.viewport.panBy(this.viewport.deltaPointsFromPixels(new xlv.Point(40, 0)));
                    this.viewport.applyConstraints();
                    return false;
                default:
                    //console.log( 'navigator keycode %s', event.keyCode );
                    return true;
            }
        } else {
            return true;
        }
    }

    function onCanvasKeyPress( event ) {
        if ( !event.preventDefaultAction && !event.ctrl && !event.alt && !event.meta ) {
            switch( event.keyCode ){
                case 43://=|+
                case 61://=|+
                    this.viewport.zoomBy(1.1);
                    this.viewport.applyConstraints();
                    return false;
                case 45://-|_
                    this.viewport.zoomBy(0.9);
                    this.viewport.applyConstraints();
                    return false;
                case 48://0|)
                    this.viewport.doZoomReset();
                    this.viewport.applyConstraints();
                    return false;
                case 119://w
                case 87://W
                    if ( event.shift ) {
                        this.viewport.zoomBy(1.1);
                    } else {
                        this.viewport.panBy(this.viewport.deltaPointsFromPixels(new xlv.Point(0, -40)));
                    }
                    this.viewport.applyConstraints();
                    return false;
                case 115://s
                case 83://S
                    if ( event.shift ) {
                        this.viewport.zoomBy(0.9);
                    } else {
                        this.viewport.panBy(this.viewport.deltaPointsFromPixels(new xlv.Point(0, 40)));
                    }
                    this.viewport.applyConstraints();
                    return false;
                case 97://a
                    this.viewport.panBy(this.viewport.deltaPointsFromPixels(new xlv.Point(-40, 0)));
                    this.viewport.applyConstraints();
                    return false;
                case 100://d
                    this.viewport.panBy(this.viewport.deltaPointsFromPixels(new xlv.Point(40, 0)));
                    this.viewport.applyConstraints();
                    return false;
                default:
                    //console.log( 'navigator keycode %s', event.keyCode );
                    return true;
            }
        } else {
            return true;
        }
    }

    function onCanvasClick( event ) {
        var gestureSettings;

        var haveKeyboardFocus = document.activeElement == this.canvas;

        // If we don't have keyboard focus, request it.
        if ( !haveKeyboardFocus ) {
            this.canvas.focus();
        }

        if ( !event.preventDefaultAction && this.viewport && event.quick ) {
            gestureSettings = this.gestureSettingsByDeviceType( event.pointerType );
            if ( gestureSettings.trackClickZoom ) {
                this.viewport.zoomBy(
                    event.shift ? 1.0 / this.clickZoomFactor : this.clickZoomFactor,
                    this.viewport.pointFromPixel( event.position, true )
                );
                this.viewport.applyConstraints();
            }
        }
        /**
         * Raised when a mouse press/release or touch/remove occurs on the canvas element.
         */
        this.dispatchEvent( 'canvasClick', {
            tracker: event.eventSource,
            position: event.position,
            quick: event.quick,
            shift: event.shift,
            originalEvent: event.originalEvent
        });
    }

    function onCanvasDoubleClick( event ) {
        var gestureSettings;

        if ( !event.preventDefaultAction && this.viewport ) {
            gestureSettings = this.gestureSettingsByDeviceType( event.pointerType );
            if ( gestureSettings.trackDoubleClickZoom ) {
                this.viewport.zoomBy(
                    event.shift ? 1.0 / this.clickZoomFactor : this.clickZoomFactor,
                    this.viewport.pointFromPixel( event.position, true )
                );
                this.viewport.applyConstraints();
            }
        }
        /**
         * Raised when a double mouse press/release or touch/remove occurs on the canvas element.
         */
        this.dispatchEvent( 'canvasDoubleClick', {
            tracker: event.eventSource,
            position: event.position,
            shift: event.shift,
            originalEvent: event.originalEvent
        });
    }

    function onCanvasDrag( event ) {
        var gestureSettings;

        if ( !event.preventDefaultAction && this.viewport ) {
            gestureSettings = this.gestureSettingsByDeviceType( event.pointerType );
            this.viewport.panBy( this.viewport.deltaPointsFromPixels( event.delta.negate() ), gestureSettings.afterDragTweenEnabled );
            this.viewport.applyConstraints();
        }
        /**
         * Raised when a mouse or touch drag operation occurs on the canvas element.
         */
        this.dispatchEvent( 'canvasDrag', {
            tracker: event.eventSource,
            position: event.position,
            delta: event.delta,
            speed: event.speed,
            direction: event.direction,
            shift: event.shift,
            originalEvent: event.originalEvent
        });
    }

    function onCanvasDragEnd( event ) {
        if (!event.preventDefaultAction && this.viewport) {
            var gestureSettings = this.gestureSettingsByDeviceType(event.pointerType);
            if (gestureSettings.afterDragTweenEnabled &&
                event.speed >= gestureSettings.afterDragTweenMinSpeed) {
                var amplitudeX = gestureSettings.afterDragTweenAccel * event.speed * Math.cos(event.direction);
                var amplitudeY = gestureSettings.afterDragTweenAccel * event.speed * Math.sin(event.direction);
                var center = this.viewport.pixelFromPoint(
                    this.viewport.getCenter(true));
                var target = this.viewport.pointFromPixel(
                    new xlv.Point(center.x - amplitudeX, center.y - amplitudeY));
                this.viewport.panTo(target, false);
            }
            this.viewport.applyConstraints();
        }
        /**
         * Raised when a mouse or touch drag operation ends on the canvas element.
         */
        this.dispatchEvent('canvasDragEnd', {
            tracker: event.eventSource,
            position: event.position,
            speed: event.speed,
            direction: event.direction,
            shift: event.shift,
            originalEvent: event.originalEvent
        });
    }

    function onCanvasEnter( event ) {
        /**
         * Raised when a pointer enters the canvas element.
         */
        this.dispatchEvent( 'canvasEnter', {
            tracker: event.eventSource,
            pointerType: event.pointerType,
            position: event.position,
            buttons: event.buttons,
            pointers: event.pointers,
            insideElementPressed: event.insideElementPressed,
            buttonDownAny: event.buttonDownAny,
            originalEvent: event.originalEvent
        });
    }

    function onCanvasExit( event ) {
        /**
         * Raised when a pointer leaves the canvas element.
         */
        this.dispatchEvent( 'canvasExit', {
            tracker: event.eventSource,
            pointerType: event.pointerType,
            position: event.position,
            buttons: event.buttons,
            pointers: event.pointers,
            insideElementPressed: event.insideElementPressed,
            buttonDownAny: event.buttonDownAny,
            originalEvent: event.originalEvent
        });
    }

    function onCanvasPress( event ) {
        /**
         * Raised when the primary mouse button is pressed or touch starts on the canvas element.
         */
        this.dispatchEvent( 'canvasPress', {
            tracker: event.eventSource,
            pointerType: event.pointerType,
            position: event.position,
            insideElementPressed: event.insideElementPressed,
            insideElementReleased: event.insideElementReleased,
            originalEvent: event.originalEvent
        });
    }

    function onCanvasRelease( event ) {
        /**
         * Raised when the primary mouse button is released or touch ends on the canvas element.
         */
        this.dispatchEvent( 'canvasRelease', {
            tracker: event.eventSource,
            pointerType: event.pointerType,
            position: event.position,
            insideElementPressed: event.insideElementPressed,
            insideElementReleased: event.insideElementReleased,
            originalEvent: event.originalEvent
        });
    }

    function onCanvasMove( event ) {
        /**
         * Raised when the primary mouse button is released or touch ends on the canvas element.
         */
        this.dispatchEvent( 'canvasMove', {
            tracker: event.eventSource,
            pointerType: event.pointerType,
            position: event.position,
            insideElementPressed: event.insideElementPressed,
            insideElementReleased: event.insideElementReleased,
            originalEvent: event.originalEvent
        });
    }

    function onCanvasNonPrimaryPress( event ) {
        /**
         * Raised when any non-primary pointer button is pressed on the canvas element.
         */
        this.dispatchEvent( 'canvasNonprimaryPress', {
            tracker: event.eventSource,
            position: event.position,
            pointerType: event.pointerType,
            button: event.button,
            buttons: event.buttons,
            originalEvent: event.originalEvent
        });
    }

    function onCanvasNonPrimaryRelease( event ) {
        /**
         * Raised when any non-primary pointer button is released on the canvas element.
         */
        this.dispatchEvent( 'canvasNonprimaryRelease', {
            tracker: event.eventSource,
            position: event.position,
            pointerType: event.pointerType,
            button: event.button,
            buttons: event.buttons,
            originalEvent: event.originalEvent
        });
    }

    function onCanvasPinch( event ) {
        console.log("canvas pinch");
        var gestureSettings,
            centerPt,
            lastCenterPt,
            panByPt;

        if ( !event.preventDefaultAction && this.viewport ) {
            gestureSettings = this.gestureSettingsByDeviceType( event.pointerType );
            if ( gestureSettings.trackPinchZoom ) {
                centerPt = this.viewport.pointFromPixel( event.center, true );
                lastCenterPt = this.viewport.pointFromPixel( event.lastCenter, true );
                panByPt = lastCenterPt.minus( centerPt );
                if( this.blockHorizontalPanning ) {
                    panByPt.x = 0;
                }
                if( this.blockVerticalPanning ) {
                    panByPt.y = 0;
                }
                this.viewport.zoomBy( event.distance / event.lastDistance, centerPt, true );
                this.viewport.panBy( panByPt, true );
                this.viewport.applyConstraints();
            }
            if ( gestureSettings.trackPinchRotate && this._rotateEnabled ) {
                // Pinch rotate
                var angle1 = Math.atan2(event.gesturePoints[0].currentPos.y - event.gesturePoints[1].currentPos.y,
                    event.gesturePoints[0].currentPos.x - event.gesturePoints[1].currentPos.x);
                var angle2 = Math.atan2(event.gesturePoints[0].lastPos.y - event.gesturePoints[1].lastPos.y,
                    event.gesturePoints[0].lastPos.x - event.gesturePoints[1].lastPos.x);
                this.viewport.setRotation(this.viewport.getRotation() + ((angle1 - angle2) * (180 / Math.PI)));
            }
        }
        /**
         * Raised when a pinch event occurs on the canvaS element.
         */
        this.dispatchEvent('canvasPinch', {
            tracker: event.eventSource,
            gesturePoints: event.gesturePoints,
            lastCenter: event.lastCenter,
            center: event.center,
            lastDistance: event.lastDistance,
            distance: event.distance,
            shift: event.shift,
            originalEvent: event.originalEvent
        });
        //cancels event
        return false;
    }

    function onCanvasScroll( event ) {
        var gestureSettings,
            factor,
            thisScrollTime,
            scrollTrackDuration;

        /* Certain scroll devices fire the scroll event way too fast so we are injecting a simple adjustment to keep things
         * partially normalized. If we have already fired an event within the last 'minScrollDelta' milliseconds we skip
         * this one and wait for the next event. */
        thisScrollTime = xlv.Utils.now();
        scrollTrackDuration = thisScrollTime - this._lastScrollTime;
        if (scrollTrackDuration > this.scrollTrackMinDuration) {
            this._lastScrollTime = thisScrollTime;

            if ( !event.preventDefaultAction && this.viewport ) {
                gestureSettings = this.gestureSettingsByDeviceType( event.pointerType );
                if ( gestureSettings.trackScrollZoom ) {
                    factor = Math.pow( this.scrollZoomFactor, event.scroll );
                    this.viewport.zoomBy(
                        factor,
                        this.viewport.pointFromPixel( event.position, true )
                    );
                    this.viewport.applyConstraints();
                }
            }
            /**
             * Raised when a scroll event occurs on the canvas element (mouse wheel).
             */
            this.dispatchEvent( 'canvasScroll', {
                tracker: event.eventSource,
                position: event.position,
                scroll: event.scroll,
                shift: event.shift,
                originalEvent: event.originalEvent
            });
            if (gestureSettings && gestureSettings.trackScrollZoom) {
                //cancels event
                return false;
            }
        }
        else {
            gestureSettings = this.gestureSettingsByDeviceType( event.pointerType );
            if (gestureSettings && gestureSettings.trackScrollZoom) {
                return false;   // We are swallowing this event
            }
        }
    }

    function onContainerEnter( event ) {
        INSTANCES[ this.hash ].mouseInside = true;
        /**
         * Raised when the cursor enters the container element.
         */
        this.dispatchEvent( 'containerEnter', {
            tracker: event.eventSource,
            position: event.position,
            buttons: event.buttons,
            pointers: event.pointers,
            insideElementPressed: event.insideElementPressed,
            buttonDownAny: event.buttonDownAny,
            originalEvent: event.originalEvent
        });
    }

    function onContainerExit( event ) {
        if ( event.pointers < 1 ) {
            INSTANCES[ this.hash ].mouseInside = false;
        }
        /**
         * Raised when the cursor leaves the container element.
         */
        this.dispatchEvent( 'containerExit', {
            tracker: event.eventSource,
            position: event.position,
            buttons: event.buttons,
            pointers: event.pointers,
            insideElementPressed: event.insideElementPressed,
            buttonDownAny: event.buttonDownAny,
            originalEvent: event.originalEvent
        });
    }


    function updateMulti( viewer ) {
        updateOnce( viewer );

        // Request the next frame, unless we've been closed
        if ( viewer.isOpen() ) {
            viewer._updateRequestId = scheduleUpdate( viewer, updateMulti );
        } else {
            viewer._updateRequestId = false;
        }
    }

    function updateOnce( viewer ) {

        //viewer.profiler.beginUpdate();

        if (viewer._opening) {
            return;
        }

        var containerSize;
        if ( viewer.autoResizeViewer ) {
            containerSize = _getSafeElemSize( viewer.container );
            if ( !containerSize.equals( INSTANCES[ viewer.hash ].prevContainerSize ) ) {
                if ( !viewer.autoResizeImage ) {
                    var prevContainerSize = INSTANCES[ viewer.hash ].prevContainerSize;
                    var bounds = viewer.viewport.getBounds(true);
                    var deltaX = (containerSize.x - prevContainerSize.x);
                    var deltaY = (containerSize.y - prevContainerSize.y);
                    var viewportDiff = viewer.viewport.deltaPointsFromPixels(new XLviewer.Point(deltaX, deltaY), true);
                    viewer.viewport.resize(new XLviewer.Point(containerSize.x, containerSize.y), false);

                    // Keep the center of the image in the center and just adjust the amount of image shown
                    bounds.width += viewportDiff.x;
                    bounds.height += viewportDiff.y;
                    bounds.x -= (viewportDiff.x / 2);
                    bounds.y -= (viewportDiff.y / 2);
                    viewer.viewport.fitBoundsWithConstraints(bounds, true);
                }
                else {
                    // maintain image position
                    var oldBounds = viewer.viewport.getBounds();
                    var oldCenter = viewer.viewport.getCenter();
                    resizeViewportAndRecenter(viewer, containerSize, oldBounds, oldCenter);
                }
                INSTANCES[ viewer.hash ].prevContainerSize = containerSize;
                INSTANCES[ viewer.hash ].forceRedraw = true;
            }
        }

        var viewportChange = viewer.viewport.update();
        var animated = viewer.manager.update() || viewportChange;

        if (viewportChange) {
            /**
             * Raised when any spring animation update occurs (zoom, pan, etc.),
             * before the viewer has drawn the new location.
             */
            viewer.dispatchEvent('viewportChange');
        }

        if( viewer.referenceStrip ){
            animated = viewer.referenceStrip.update( viewer.viewport ) || animated;
        }

        if ( !INSTANCES[ viewer.hash ].animating && animated ) {
            /**
             * Raised when any spring animation starts (zoom, pan, etc.).
             */
            viewer.dispatchEvent( "animationStart" );
        }

        if ( animated || INSTANCES[ viewer.hash ].forceRedraw || viewer.manager.needsDraw() ) {
            drawWorld( viewer );
            if( viewer.navigator ){
                viewer.navigator.update( viewer.viewport );
            }

            INSTANCES[ viewer.hash ].forceRedraw = false;

            if (animated) {
                /**
                 * Raised when any spring animation update occurs (zoom, pan, etc.),
                 * after the viewer has drawn the new location.
                 */
                viewer.dispatchEvent( "animation" );
            }
        }

        if ( INSTANCES[ viewer.hash ].animating && !animated ) {
            /**
             * Raised when any spring animation ends (zoom, pan, etc.).
             */
            viewer.dispatchEvent( "animationFinish" );
        }

        INSTANCES[ viewer.hash ].animating = animated;

        //viewer.profiler.endUpdate();
    }

// This function resizes the viewport and recenters the image
// as it was before resizing.
// TODO: better adjust width and height. The new width and height
// should depend on the image dimensions and on the dimensions
// of the viewport before and after switching mode.
    function resizeViewportAndRecenter( viewer, containerSize, oldBounds, oldCenter ) {
        var viewport = viewer.viewport;

        viewport.resize( containerSize, true );

        var newBounds = new xlv.Rect(
            oldCenter.x - ( oldBounds.width / 2.0 ),
            oldCenter.y - ( oldBounds.height / 2.0 ),
            oldBounds.width,
            oldBounds.height
        );

        // let the viewport decide if the bounds are too big or too small
        viewport.fitBoundsWithConstraints( newBounds, true );
    }

    function drawWorld( viewer ) {
        viewer.imageLoader.clear();
        viewer.drawer.clear();
        viewer.manager.draw();

        viewer.dispatchEvent( 'updateViewport', {} );
    }

///////////////////////////////////////////////////////////////////////////////
// Navigation Controls
///////////////////////////////////////////////////////////////////////////////






}(XLviewer));

(function (xlv) {
    xlv.Imgf = {
        buildInfoUrl: function (source, image) {
            if(!source || !image) {
                return null;
            }
            return source + image + "?cmd=info";
        },
        loadTileSource : function (viewer, url, successCallback, failCallback) {
            var tileSource = new xlv.Imgf.TileSource({
                url: url,
                enableCORS: viewer.enableCORS,
                ajaxWithCredentials: viewer.ajaxWithCredentials,
                useCanvas: viewer.useCanvas,
                success: function( event ) {
                    successCallback( event.tileSource );
                }
            });
            tileSource.addListener( 'openFailed', function( event ) {
                failCallback( event );
            } );
        }
    };


    (function( Imgf ){


        /**
         * @ignore
         * @class TileSource
         * @classdesc The TileSource contains the most basic implementation required to create a
         * smooth transition between layers in an image pyramid. It has only a single key
         * interface that must be implemented to complete its key functionality:
         * 'getTileUrl'.  It also has several optional interfaces that can be
         * implemented if a new TileSource wishes to support configuration via a simple
         * object or array ('configure') and if the tile source supports or requires
         * configuration via retrieval of a document on the network ala AJAX or JSONP,
         * ('getImageInfo').
         * <br/>
         * By default the image pyramid is split into N layers where the image's longest
         * side in M (in pixels), where N is the smallest integer which satisfies
         *      <strong>2^(N+1) >= M</strong>.
         */
        Imgf.TileSource = function( width, height, tileSize, tileOverlap, minLevel, maxLevel ) {
            var _this = this;

            var args = arguments,
                options,
                i;

            if( xlv.Utils.isPlainObject( width ) ){
                options = width;
            }else{
                options = {
                    width: args[0],
                    height: args[1],
                    tileSize: args[2],
                    tileOverlap: args[3],
                    minLevel: args[4],
                    maxLevel: args[5]
                };
            }

            //Tile sources supply some events, namely 'ready' when they must be configured
            //by asynchronously fetching their configuration data.
            XLviewer.EventDispatcher.call( this );

            //we allow options to override anything we dont treat as
            //required via idiomatic options or which is functionally
            //set depending on the state of the readiness of this tile
            //source
            XLviewer.extend( true, this, options );

            if (!this.success) {
                //Any functions that are passed as arguments are bound to the ready callback
                for ( i = 0; i < arguments.length; i++ ) {
                    if ( xlv.Utils.isFunction( arguments[ i ] ) ) {
                        this.success = arguments[ i ];
                        //only one callback per constructor
                        break;
                    }
                }
            }

            if (this.success) {
                this.addListener( 'ready', function ( event ) {
                    _this.success( event );
                } );
            }

            /**
             * Ratio of width to height
             * @member {Number} aspectRatio
             * @memberof XLviewer.TileSource#
             */
            /**
             * Vector storing x and y dimensions ( width and height respectively ).
             * @member {XLviewer.Point} dimensions
             * @memberof XLviewer.TileSource#
             */
            /**
             * The overlap in pixels each tile shares with its adjacent neighbors.
             * @member {Number} tileOverlap
             * @memberof XLviewer.TileSource#
             */
            /**
             * The minimum pyramid level this tile source supports or should attempt to load.
             * @member {Number} minLevel
             * @memberof XLviewer.TileSource#
             */
            /**
             * The maximum pyramid level this tile source supports or should attempt to load.
             * @member {Number} maxLevel
             * @memberof XLviewer.TileSource#
             */
            /**
             *
             * @member {Boolean} ready
             * @memberof XLviewer.TileSource#
             */

            if( 'string' == XLviewer.Utils.type( arguments[ 0 ] ) ){
                this.url = arguments[0];

            }

            if (this.url) {
                this.baseUrl = this.url.replace('?cmd=info','');
                //in case the getImageInfo method is overriden and/or implies an
                //async mechanism set some safe defaults first
                this.aspectRatio = 1;
                this.dimensions  = new XLviewer.Point( 10, 10 );
                this._tileWidth  = 0;
                this._tileHeight = 0;
                this.tileOverlap = 0;
                this.minLevel    = 0;
                this.maxLevel    = 0;
                this.ready       = false;
                //configuration via url implies the extending class
                //implements and 'configure'
                this.getImageInfo( this.url );

            } else {

                //explicit configuration via positional args in constructor
                //or the more idiomatic 'options' object
                this.ready       = true;
                this.aspectRatio = ( options.width && options.height ) ?
                    (  options.width / options.height ) : 1;
                this.dimensions  = new XLviewer.Point( options.width, options.height );

                if ( this.tileSize ){
                    this._tileWidth = this._tileHeight = this.tileSize;
                    delete this.tileSize;
                } else {
                    if( this.tileWidth ){
                        // We were passed tileWidth in options, but we want to rename it
                        // with a leading underscore to make clear that it is not safe to directly modify it
                        this._tileWidth = this.tileWidth;
                        delete this.tileWidth;
                    } else {
                        this._tileWidth = 0;
                    }

                    if( this.tileHeight ){
                        // See note above about renaming this.tileWidth
                        this._tileHeight = this.tileHeight;
                        delete this.tileHeight;
                    } else {
                        this._tileHeight = 0;
                    }
                }

                this.tileOverlap = options.tileOverlap ? options.tileOverlap : 0;
                this.minLevel    = options.minLevel ? options.minLevel : 0;
                this.maxLevel    = ( undefined !== options.maxLevel && null !== options.maxLevel ) ?
                    options.maxLevel : (
                        ( options.width && options.height ) ? Math.ceil(
                            Math.log( Math.max( options.width, options.height ) ) /
                            Math.log( 2 )
                        ) : 0
                    );
                if( this.success && xlv.Utils.isFunction( this.success ) ){
                    this.success( this );
                }
            }


        };

        /** @lends XLviewer.TileSource.prototype */
        Imgf.TileSource.prototype = {

            getTileSize: function( level ) {
                Imgf.console.error(
                    "[TileSource.getTileSize] is deprecated." +
                    "Use TileSource.getTileWidth() and TileSource.getTileHeight() instead"
                );
                return this._tileWidth;
            },

            /**
             * Return the tileWidth for a given level.
             * Subclasses should override this if tileWidth can be different at different levels
             *   such as in IIIFTileSource.  Code should use this function rather than reading
             *   from ._tileWidth directly.
             * @function
             * @param {Number} level
             */
            getTileWidth: function( level ) {
                if (!this._tileWidth) {
                    return this.getTileSize(level);
                }
                return this._tileWidth;
            },

            /**
             * Return the tileHeight for a given level.
             * Subclasses should override this if tileHeight can be different at different levels
             *   such as in IIIFTileSource.  Code should use this function rather than reading
             *   from ._tileHeight directly.
             * @function
             * @param {Number} level
             */
            getTileHeight: function( level ) {
                if (!this._tileHeight) {
                    return this.getTileSize(level);
                }
                return this._tileHeight;
            },

            /**
             * @function
             * @param {Number} level
             */
            getLevelScale: function( level ) {

                // we use the tilesources implementation of getLevelScale to generate
                // a memoized re-implementation
                var levelScaleCache = {},
                    i;
                for( i = 0; i <= this.maxLevel; i++ ){
                    levelScaleCache[ i ] = 1 / Math.pow(2, this.maxLevel - i);
                }
                this.getLevelScale = function( _level ){
                    return levelScaleCache[ _level ];
                };
                return this.getLevelScale( level );
            },

            /**
             * @function
             * @param {Number} level
             */
            getNumTiles: function( level ) {
                var scale = this.getLevelScale( level ),
                    x = Math.ceil( scale * this.dimensions.x / this.getTileWidth(level) ),
                    y = Math.ceil( scale * this.dimensions.y / this.getTileHeight(level) );

                return new XLviewer.Point( x, y );
            },

            /**
             * @function
             * @param {Number} level
             */
            getPixelRatio: function( level ) {
                var imageSizeScaled = this.dimensions.times( this.getLevelScale( level ) ),
                    rx = 1.0 / imageSizeScaled.x,
                    ry = 1.0 / imageSizeScaled.y;

                return new XLviewer.Point(rx, ry);
            },


            /**
             * @function
             * @param {Number} level
             */
            getClosestLevel: function( rect ) {
                var i,
                    tilesPerSide,
                    tiles;

                for( i = this.minLevel; i < this.maxLevel; i++ ){
                    tiles = this.getNumTiles( i );
                    tilesPerSide = new XLviewer.Point(
                        Math.floor( rect.x / this.getTileWidth(i) ),
                        Math.floor( rect.y / this.getTileHeight(i) )
                    );

                    if( tiles.x + 1 >= tilesPerSide.x && tiles.y + 1 >= tilesPerSide.y ){
                        break;
                    }
                }
                return Math.max( 0, i - 1 );
            },

            /**
             * @function
             * @param {Number} level
             * @param {XLviewer.Point} point
             */
            getTileAtPoint: function( level, point ) {
                var pixel = point.times( this.dimensions.x ).times( this.getLevelScale(level) ),
                    tx = Math.floor( pixel.x / this.getTileWidth(level) ),
                    ty = Math.floor( pixel.y / this.getTileHeight(level) );

                return new XLviewer.Point( tx, ty );
            },

            /**
             * @function
             * @param {Number} level
             * @param {Number} x
             * @param {Number} y
             */
            getTileBounds: function( level, x, y ) {
                var dimensionsScaled = this.dimensions.times( this.getLevelScale( level ) ),
                    tileWidth = this.getTileWidth(level),
                    tileHeight = this.getTileHeight(level),
                    px = ( x === 0 ) ? 0 : tileWidth * x - this.tileOverlap,
                    py = ( y === 0 ) ? 0 : tileHeight * y - this.tileOverlap,
                    sx = tileWidth + ( x === 0 ? 1 : 2 ) * this.tileOverlap,
                    sy = tileHeight + ( y === 0 ? 1 : 2 ) * this.tileOverlap,
                    scale = 1.0 / dimensionsScaled.x;

                sx = Math.min( sx, dimensionsScaled.x - px );
                sy = Math.min( sy, dimensionsScaled.y - py );

                return new XLviewer.Rect( px * scale, py * scale, sx * scale, sy * scale );
            },


            /**
             * Responsible for retrieving, and caching the
             * image metadata pertinent to this TileSources implementation.
             * @function
             * @param {String} url
             * @throws {Error}
             */
            getImageInfo: function( url ) {
                var _this = this,
                    callbackName,
                    callback,
                    readySource,
                    options,
                    urlParts,
                    filename,
                    lastDot;


                if( url ) {
                    urlParts = url.split( '/' );
                    filename = urlParts[ urlParts.length - 1 ];
                    lastDot  = filename.lastIndexOf( '.' );
                    if ( lastDot > -1 ) {
                        urlParts[ urlParts.length - 1 ] = filename.slice( 0, lastDot );
                    }
                }

                callback = function( success, data ){

                    if ( !success ) {
                        /**
                         * Raised when an error occurs loading a TileSource.
                         *
                         * @event open-failed
                         * @memberof XLviewer.TileSource
                         * @type {object}
                         * @property {XLviewer.TileSource} eventSource - A reference to the TileSource which raised the event.
                         * @property {String} message
                         * @property {String} source
                         * @property {?Object} userData - Arbitrary subscriber-defined object.
                         */
                        _this.dispatchEvent( 'openFailed', { message: "Unable to load TileSource", source: url } );
                        return;
                    }
                    data = xlv.Utils.xmlToJSON.parseString(data,{
                        mergeCDATA: false,   // extract cdata and merge with text nodes
                        grokAttr: true,     // convert truthy attributes to boolean, etc
                        grokText: true,     // convert truthy text/attr to boolean, etc
                        normalize: true,    // collapse multiple spaces to single space
                        xmlns: false,        // include namespaces as attributes in output
                        namespaceKey: '_ns',    // tag name for namespace objects
                        textKey: '_text',   // tag name for text nodes
                        valueKey: '_value',     // tag name for attribute values
                        attrKey: '_attr',   // tag for attr groups
                        attrsAsObject: true,    // if false, key is used as prefix to name, set prefix to '' to merge children and attrs.
                        stripAttrPrefix: true,  // remove namespace prefixes from attributes
                        stripElemPrefix: true,  // for elements of same name in diff namespaces, you can enable namespaces and access the nskey property
                        childrenAsArray: false   // force children into arrays
                    });

                    var parseddata = {
                        baseUrl : _this.baseUrl,
                        width : data["package"]["width"]["_text"],
                        height : data["package"]["height"]["_text"],
                        levels : data["package"]["levels"]["_text"],
                        tileside : data["package"]["tileside"]["_text"]
                    };

                    readySource = new xlv.ImgfTileSource( parseddata );
                    _this.ready = true;
                    /**
                     * Raised when a TileSource is opened and initialized.
                     *
                     * @event ready
                     * @memberof XLviewer.TileSource
                     * @type {object}
                     * @property {XLviewer.TileSource} eventSource - A reference to the TileSource which raised the event.
                     * @property {Object} tileSource
                     * @property {?Object} userData - Arbitrary subscriber-defined object.
                     */
                    _this.dispatchEvent( 'ready', { tileSource: readySource } );
                };

                // request info via xhr asynchronously.
                XLviewer.Net.makeAjaxRequest( {
                    url: url,
                    withCredentials: this.ajaxWithCredentials,
                    success: function( xhr ) {
                        var data = processResponse( xhr );
                        callback( true, data );
                    },
                    error: function ( xhr, exc ) {
                        var msg;

                        /*
                         IE < 10 will block XHR requests to different origins. Any property access on the request
                         object will raise an exception which we'll attempt to handle by formatting the original
                         exception rather than the second one raised when we try to access xhr.status
                         */
                        try {
                            msg = "HTTP " + xhr.status + " attempting to load TileSource";
                        } catch ( e ) {
                            var formattedExc;
                            if ( typeof( exc ) == "undefined" || !exc.toString ) {
                                formattedExc = "Unknown error";
                            } else {
                                formattedExc = exc.toString();
                            }

                            msg = formattedExc + " attempting to load TileSource";
                        }

                        /***
                         * Raised when an error occurs loading a TileSource.
                         *
                         * @event open-failed
                         * @memberof XLviewer.TileSource
                         * @type {object}
                         * @property {XLviewer.TileSource} eventSource - A reference to the TileSource which raised the event.
                         * @property {String} message
                         * @property {String} source
                         * @property {?Object} userData - Arbitrary subscriber-defined object.
                         */
                        _this.dispatchEvent( 'openFailed', {
                            message: msg,
                            source: url
                        });
                    }
                });

            },

            /**
             * Responsible determining if a the particular TileSource supports the
             * data format ( and allowed to apply logic against the url the data was
             * loaded from, if any ). Overriding implementations are expected to do
             * something smart with data and / or url to determine support.  Also
             * understand that iteration order of TileSources is not guarunteed so
             * please make sure your data or url is expressive enough to ensure a simple
             * and sufficient mechanisim for clear determination.
             * @function
             * @param {String|Object|Array|Document} data
             * @param {String} url - the url the data was loaded
             *      from if any.
             * @return {Boolean}
             */
            supports: function( data, url ) {
                return false;
            },

            /**
             * Responsible for parsing and configuring the
             * image metadata pertinent to this TileSources implementation.
             * This method is not implemented by this class other than to throw an Error
             * announcing you have to implement it.  Because of the variety of tile
             * server technologies, and various specifications for building image
             * pyramids, this method is here to allow easy integration.
             * @function
             * @param {String|Object|Array|Document} data
             * @param {String} url - the url the data was loaded
             *      from if any.
             * @return {Object} options - A dictionary of keyword arguments sufficient
             *      to configure this tile sources constructor.
             * @throws {Error}
             */
            configure: function( data, url ) {
                throw new Error( "Method not implemented." );
            },

            /**
             * Responsible for retriving the url which will return an image for the
             * region specified by the given x, y, and level components.
             * This method is not implemented by this class other than to throw an Error
             * announcing you have to implement it.  Because of the variety of tile
             * server technologies, and various specifications for building image
             * pyramids, this method is here to allow easy integration.
             * @function
             * @param {Number} level
             * @param {Number} x
             * @param {Number} y
             * @param {Number} q
             * @throws {Error}
             */
            getTileUrl: function( level, x, y, q ) {
                throw new Error( "Method not implemented." );
            },

            /**
             * @function
             * @param {Number} level
             * @param {Number} x
             * @param {Number} y
             */
            tileExists: function( level, x, y ) {
                var numTiles = this.getNumTiles( level );
                return  level >= this.minLevel &&
                    level <= this.maxLevel &&
                    x >= 0 &&
                    y >= 0 &&
                    x < numTiles.x &&
                    y < numTiles.y;
            }
        };


        XLviewer.extend( true, Imgf.TileSource.prototype, XLviewer.EventDispatcher.prototype );


        /**
         * Decides whether to try to process the response as xml, json, or hand back
         * the text
         * @private
         * @inner
         * @function
         * @param {XMLHttpRequest} xhr - the completed network request
         */
        function processResponse( xhr ){
            var status = xhr.status,
                statusText;

            if ( !xhr ) {
                throw new Error( "Security Error" );
            } else if ( xhr.status !== 200 && xhr.status !== 0 ) {
                status     = xhr.status;
                statusText = ( status == 404 ) ?
                    "Not Found" :
                    xhr.statusText;
                throw new Error( "XHR Error: " + status + " - " + statusText  );
            }

            return xhr.responseText;
        }
    }( xlv.Imgf ));

}(XLviewer));



(function( xlv ){

    function calculateNumLevels(mMaxZoom, width, height)
    {
        var r = mMaxZoom;
        var count = 0;
        var currWidth = width;
        var currHeight = height;
        for(var i =0; i < mMaxZoom; i++) {
            count++;
            currWidth = Math.floor(currWidth/2);
            currHeight = Math.floor(currHeight/2);
            if(Math.ceil(r) == 1)
                break;
            r /= 2;
        }
        return count;
    }


    /**
     * @ignore
     * @class ImgfTileSource
     * @classdesc A client implementation of the International Image Interoperability Framework
     * Format: Image API 1.0 - 2.1
     *
     * @memberof XLviewer
     * @extends XLviewer.TileSource
     * @see http://iiif.io/api/image/
     */
    xlv.ImgfTileSource = function( options ){
        xlv.extend( true, this, options );

        if ( !( this.height && this.width  && this.tileside && this.levels) ) {
            throw new Error( 'XLimage required parameters not in image info.' );
        }
        options.tileWidth = options.tileHeight = options.tileSize = this.tileside;
        options.maxLevel = calculateNumLevels(this.levels / 2, this.width, this.height);//7;//Number(Math.ceil(Math.log(Math.max(this.width, this.height), 2)));
        xlv.Imgf.TileSource.apply( this, [ options ] );
    };

    xlv.extend( xlv.ImgfTileSource.prototype, xlv.Imgf.TileSource.prototype, /** @lends XLviewer.ImgfTileSource.prototype */{
        /**
         * Determine if the data and/or url imply the image service is supported by
         * this tile source.
         * @function
         * @param {Object|Array} data
         * @param {String} optional - url
         */

        supports: function( data, url ) {
            return true;
        },

        /**
         *
         * @function
         * @param {Object} data - the raw configuration
         * @example <caption>IIIF 1.1 Info Looks like this</caption>
         * {
         *   "@context" : "http://library.stanford.edu/iiif/image-api/1.1/context.json",
         *   "@id" : "http://iiif.example.com/prefix/1E34750D-38DB-4825-A38A-B60A345E591C",
         *   "width" : 6000,
         *   "height" : 4000,
         *   "scale_factors" : [ 1, 2, 4 ],
         *   "tile_width" : 1024,
         *   "tile_height" : 1024,
         *   "formats" : [ "jpg", "png" ],
         *   "qualities" : [ "native", "grey" ],
         *   "profile" : "http://library.stanford.edu/iiif/image-api/1.1/compliance.html#level0"
         * }
         */
        configure: function( data, url ){
            return data;
        },

        /**
         * Return the tileWidth for the given level.
         * @function
         * @param {Number} level
         */
        getTileWidth: function( level ) {
            return this._tileWidth;
        },

        /**
         * Return the tileHeight for the given level.
         * @function
         * @param {Number} level
         */
        getTileHeight: function( level ) {
            return this._tileHeight;
        },

        /**
         * @function
         * @param {Number} level
         */
        getLevelScale: function ( level ) {
            return xlv.Imgf.TileSource.prototype.getLevelScale.call(this, level);
        },

        /**
         * @function
         * @param {Number} level
         */
        getNumTiles: function( level ) {
            return xlv.Imgf.TileSource.prototype.getNumTiles.call(this, level);
        },


        /**
         * @function
         * @param {Number} level
         * @param {XLviewer.Point} point
         */
        getTileAtPoint: function( level, point ) {
            return xlv.Imgf.TileSource.prototype.getTileAtPoint.call(this, level, point);
        },


        /**
         * Responsible for retrieving the url which will return an image for the
         * region specified by the given x, y, and level components.
         * @function
         * @param {Number} level - z index
         * @param {Number} x
         * @param {Number} y
         * @param {Number} q
         * @throws {Error}
         */
        getTileUrl: function( level, x, y, q ){
            var zoomLev = this.levels;
            var i = level;
            while (i > 0) {
                zoomLev /= 2;
                i--;
            }
            //TODO gestire la qualità dei tile e dell'immagine
            return [this.baseUrl, "?cmd=tile&x=", x, "&y=", y, "&z=", zoomLev, "&q=", q].join("");
        }

    });

}( XLviewer ));
(function( xlv ){

    /**
     * @class Point
     * @classdesc A Point is really used as a 2-dimensional vector, equally useful for
     * representing a point on a plane, or the height and width of a plane
     * not requiring any other frame of reference.
     *
     * @memberof XLviewer
     * @param {Number} [x] The vector component 'x'. Defaults to the origin at 0.
     * @param {Number} [y] The vector component 'y'. Defaults to the origin at 0.
     */
    xlv.Point = function( x, y ) {
        /**
         * The vector component 'x'.
         * @member {Number} x
         * @memberof XLviewer.Point#
         */
        this.x = typeof ( x ) == "number" ? x : 0;
        /**
         * The vector component 'y'.
         * @member {Number} y
         * @memberof XLviewer.Point#
         */
        this.y = typeof ( y ) == "number" ? y : 0;
    };

    /** @lends XLviewer.Point.prototype */
    xlv.Point.prototype = {
        /**
         * @function
         * @returns {XLviewer.Point} a duplicate of this Point
         */
        clone: function() {
            return new xlv.Point(this.x, this.y);
        },

        /**
         * Add another Point to this point and return a new Point.
         * @function
         * @param {XLviewer.Point} point The point to add vector components.
         * @returns {XLviewer.Point} A new point representing the sum of the
         *  vector components
         */
        plus: function( point ) {
            return new xlv.Point(
                this.x + point.x,
                this.y + point.y
            );
        },

        /**
         * Substract another Point to this point and return a new Point.
         * @function
         * @param {XLviewer.Point} point The point to substract vector components.
         * @returns {XLviewer.Point} A new point representing the substraction of the
         *  vector components
         */
        minus: function( point ) {
            return new xlv.Point(
                this.x - point.x,
                this.y - point.y
            );
        },

        /**
         * Multiply this point by a factor and return a new Point.
         * @function
         * @param {Number} factor The factor to multiply vector components.
         * @returns {XLviewer.Point} A new point representing the multiplication
         *  of the vector components by the factor
         */
        times: function( factor ) {
            return new xlv.Point(
                this.x * factor,
                this.y * factor
            );
        },

        /**
         * Divide this point by a factor and return a new Point.
         * @function
         * @param {Number} factor The factor to divide vector components.
         * @returns {XLviewer.Point} A new point representing the division of the
         *  vector components by the factor
         */
        divide: function( factor ) {
            return new xlv.Point(
                this.x / factor,
                this.y / factor
            );
        },

        /**
         * Compute the opposite of this point and return a new Point.
         * @function
         * @returns {XLviewer.Point} A new point representing the opposite of the
         *  vector components
         */
        negate: function() {
            return new xlv.Point( -this.x, -this.y );
        },

        /**
         * Compute the distance between this point and another point.
         * @function
         * @param {XLviewer.Point} point The point to compute the distance with.
         * @returns {Number} The distance between the 2 points
         */
        distanceTo: function( point ) {
            return Math.sqrt(
                Math.pow( this.x - point.x, 2 ) +
                Math.pow( this.y - point.y, 2 )
            );
        },

        /**
         * Apply a function to each coordinate of this point and return a new point.
         * @function
         * @param {function} func The function to apply to each coordinate.
         * @returns {XLviewer.Point} A new point with the coordinates computed
         * by the specified function
         */
        apply: function( func ) {
            return new xlv.Point( func( this.x ), func( this.y ) );
        },

        /**
         * Check if this point is equal to another one.
         * @function
         * @param {XLviewer.Point} point The point to compare this point with.
         * @returns {Boolean} true if they are equal, false otherwise.
         */
        equals: function( point ) {
            return (
                point instanceof xlv.Point
            ) && (
                this.x === point.x
            ) && (
                this.y === point.y
            );
        },

        /**
         * Rotates the point around the specified pivot
         * From http://stackoverflow.com/questions/4465931/rotate-rectangle-around-a-point
         * @function
         * @param {Number} degress to rotate around the pivot.
         * @param {XLviewer.Point} [pivot=(0,0)] Point around which to rotate.
         * Defaults to the origin.
         * @returns {XLviewer.Point}. A new point representing the point rotated around the specified pivot
         */
        rotate: function (rotation, pivot) {
            pivot = pivot || new xlv.Point(0, 0);
            var cos;
            var sin;
            // Avoid float computations when possible
            if (rotation % 90 === 0) {
                var d = rotation % 360;
                if (d < 0) {
                    d += 360;
                }
                switch (d) {
                    case 0:
                        cos = 1;
                        sin = 0;
                        break;
                    case 90:
                        cos = 0;
                        sin = 1;
                        break;
                    case 180:
                        cos = -1;
                        sin = 0;
                        break;
                    case 270:
                        cos = 0;
                        sin = -1;
                        break;
                }
            } else {
                var angle = rotation * Math.PI / 180.0;
                cos = Math.cos(angle);
                sin = Math.sin(angle);
            }
            var x = cos * (this.x - pivot.x) - sin * (this.y - pivot.y) + pivot.x;
            var y = sin * (this.x - pivot.x) + cos * (this.y - pivot.y) + pivot.y;
            return new xlv.Point(x, y);
        },

        /**
         * Convert this point to a string in the format (x,y) where x and y are
         * rounded to the nearest integer.
         * @function
         * @returns {String} A string representation of this point.
         */
        toString: function() {
            return "(" + (Math.round(this.x * 100) / 100) + "," + (Math.round(this.y * 100) / 100) + ")";
        }
    };


    /**
     * @class Rect
     * @classdesc A Rectangle is described by it top left coordinates (x, y), width,
     * height and rotation of rotation around (x, y).
     * Note that the coordinate system used is the one commonly used with images:
     * x increases when going to the right
     * y increases when going to the bottom
     * rotation increases clockwise with 0 being the horizontal
     *
     * The constructor normalizes the rectangle to always have 0 <= rotation < 90
     *
     * @memberof XLviewer
     * @param {Number} [x=0] The vector component 'x'.
     * @param {Number} [y=0] The vector component 'y'.
     * @param {Number} [width=0] The vector component 'width'.
     * @param {Number} [height=0] The vector component 'height'.
     * @param {Number} [rotation=0] Rotation of the rectangle around (x,y) in rotation.
     */
    xlv.Rect = function(x, y, width, height, rotation) {
        /**
         * The vector component 'x'.
         * @member {Number} x
         * @memberof XLviewer.Rect#
         */
        this.x = typeof(x) === "number" ? x : 0;
        /**
         * The vector component 'y'.
         * @member {Number} y
         * @memberof XLviewer.Rect#
         */
        this.y = typeof(y) === "number" ? y : 0;
        /**
         * The vector component 'width'.
         * @member {Number} width
         * @memberof XLviewer.Rect#
         */
        this.width  = typeof(width) === "number" ? width : 0;
        /**
         * The vector component 'height'.
         * @member {Number} height
         * @memberof XLviewer.Rect#
         */
        this.height = typeof(height) === "number" ? height : 0;

        this.rotation = typeof(rotation) === "number" ? rotation : 0;

        // Normalizes the rectangle.
        this.rotation = this.rotation % 360;
        if (this.rotation < 0) {
            this.rotation += 360;
        }
        var newTopLeft, newWidth;
        if (this.rotation >= 270) {
            newTopLeft = this.getTopRight();
            this.x = newTopLeft.x;
            this.y = newTopLeft.y;
            newWidth = this.height;
            this.height = this.width;
            this.width = newWidth;
            this.rotation -= 270;
        } else if (this.rotation >= 180) {
            newTopLeft = this.getBottomRight();
            this.x = newTopLeft.x;
            this.y = newTopLeft.y;
            this.rotation -= 180;
        } else if (this.rotation >= 90) {
            newTopLeft = this.getBottomLeft();
            this.x = newTopLeft.x;
            this.y = newTopLeft.y;
            newWidth = this.height;
            this.height = this.width;
            this.width = newWidth;
            this.rotation -= 90;
        }
    };

    /**
     * Builds a rectangle having the 3 specified points as summits.
     * @static
     * @memberof XLviewer.Rect
     * @param {XLviewer.Point} topLeft
     * @param {XLviewer.Point} topRight
     * @param {XLviewer.Point} bottomLeft
     * @returns {XLviewer.Rect}
     */
    xlv.Rect.fromSummits = function(topLeft, topRight, bottomLeft) {
        var width = topLeft.distanceTo(topRight);
        var height = topLeft.distanceTo(bottomLeft);
        var diff = topRight.minus(topLeft);
        var radians = Math.atan(diff.y / diff.x);
        if (diff.x < 0) {
            radians += Math.PI;
        } else if (diff.y < 0) {
            radians += 2 * Math.PI;
        }
        return new xlv.Rect(
            topLeft.x,
            topLeft.y,
            width,
            height,
            radians / Math.PI * 180);
    };

    /** @lends XLviewer.Rect.prototype */
    xlv.Rect.prototype = {
        /**
         * @function
         * @returns {XLviewer.Rect} a duplicate of this Rect
         */
        clone: function() {
            return new xlv.Rect(
                this.x,
                this.y,
                this.width,
                this.height,
                this.rotation);
        },

        /**
         * The aspect ratio is simply the ratio of width to height.
         * @function
         * @returns {Number} The ratio of width to height.
         */
        getAspectRatio: function() {
            return this.width / this.height;
        },

        /**
         * Provides the coordinates of the upper-left corner of the rectangle as a
         * point.
         * @function
         * @returns {XLviewer.Point} The coordinate of the upper-left corner of
         *  the rectangle.
         */
        getTopLeft: function() {
            return new xlv.Point(
                this.x,
                this.y
            );
        },

        /**
         * Provides the coordinates of the bottom-right corner of the rectangle as a
         * point.
         * @function
         * @returns {XLviewer.Point} The coordinate of the bottom-right corner of
         *  the rectangle.
         */
        getBottomRight: function() {
            return new xlv.Point(this.x + this.width, this.y + this.height)
                .rotate(this.rotation, this.getTopLeft());
        },

        /**
         * Provides the coordinates of the top-right corner of the rectangle as a
         * point.
         * @function
         * @returns {XLviewer.Point} The coordinate of the top-right corner of
         *  the rectangle.
         */
        getTopRight: function() {
            return new xlv.Point(this.x + this.width, this.y)
                .rotate(this.rotation, this.getTopLeft());
        },

        /**
         * Provides the coordinates of the bottom-left corner of the rectangle as a
         * point.
         * @function
         * @returns {XLviewer.Point} The coordinate of the bottom-left corner of
         *  the rectangle.
         */
        getBottomLeft: function() {
            return new xlv.Point(this.x, this.y + this.height)
                .rotate(this.rotation, this.getTopLeft());
        },

        /**
         * Computes the center of the rectangle.
         * @function
         * @returns {XLviewer.Point} The center of the rectangle as represented
         *  as represented by a 2-dimensional vector (x,y)
         */
        getCenter: function() {
            return new xlv.Point(
                this.x + this.width / 2.0,
                this.y + this.height / 2.0
            ).rotate(this.rotation, this.getTopLeft());
        },

        /**
         * Returns the width and height component as a vector XLviewer.Point
         * @function
         * @returns {XLviewer.Point} The 2 dimensional vector representing the
         *  the width and height of the rectangle.
         */
        getSize: function() {
            return new xlv.Point(this.width, this.height);
        },

        /**
         * Determines if two Rectangles have equivalent components.
         * @function
         * @param {XLviewer.Rect} rectangle The Rectangle to compare to.
         * @return {Boolean} 'true' if all components are equal, otherwise 'false'.
         */
        equals: function(other) {
            return (other instanceof xlv.Rect) &&
                this.x === other.x &&
                this.y === other.y &&
                this.width === other.width &&
                this.height === other.height &&
                this.rotation === other.rotation;
        },

        /**
         * Multiply all dimensions (except rotation) in this Rect by a factor and
         * return a new Rect.
         * @function
         * @param {Number} factor The factor to multiply vector components.
         * @returns {XLviewer.Rect} A new rect representing the multiplication
         *  of the vector components by the factor
         */
        times: function(factor) {
            return new xlv.Rect(
                this.x * factor,
                this.y * factor,
                this.width * factor,
                this.height * factor,
                this.rotation);
        },

        /**
         * Translate/move this Rect by a vector and return new Rect.
         * @function
         * @param {XLviewer.Point} delta The translation vector.
         * @returns {XLviewer.Rect} A new rect with altered position
         */
        translate: function(delta) {
            return new xlv.Rect(
                this.x + delta.x,
                this.y + delta.y,
                this.width,
                this.height,
                this.rotation);
        },

        /**
         * Returns the smallest rectangle that will contain this and the given
         * rectangle bounding boxes.
         * @param {XLviewer.Rect} rect
         * @return {XLviewer.Rect} The new rectangle.
         */
        union: function(rect) {
            var thisBoundingBox = this.getBoundingBox();
            var otherBoundingBox = rect.getBoundingBox();

            var left = Math.min(thisBoundingBox.x, otherBoundingBox.x);
            var top = Math.min(thisBoundingBox.y, otherBoundingBox.y);
            var right = Math.max(
                thisBoundingBox.x + thisBoundingBox.width,
                otherBoundingBox.x + otherBoundingBox.width);
            var bottom = Math.max(
                thisBoundingBox.y + thisBoundingBox.height,
                otherBoundingBox.y + otherBoundingBox.height);

            return new xlv.Rect(
                left,
                top,
                right - left,
                bottom - top);
        },

        /**
         * Rotates a rectangle around a point.
         * @function
         * @param {Number} rotation The angle in rotation to rotate.
         * @param {XLviewer.Point} [pivot] The point about which to rotate.
         * Defaults to the center of the rectangle.
         * @return {XLviewer.Rect}
         */
        rotate: function(rotation, pivot) {
            rotation = rotation % 360;
            if (rotation === 0) {
                return this.clone();
            }
            if (rotation < 0) {
                rotation += 360;
            }

            pivot = pivot || this.getCenter();
            var newTopLeft = this.getTopLeft().rotate(rotation, pivot);
            var newTopRight = this.getTopRight().rotate(rotation, pivot);

            var diff = newTopRight.minus(newTopLeft);
            var radians = Math.atan(diff.y / diff.x);
            if (diff.x < 0) {
                radians += Math.PI;
            } else if (diff.y < 0) {
                radians += 2 * Math.PI;
            }
            return new xlv.Rect(
                newTopLeft.x,
                newTopLeft.y,
                this.width,
                this.height,
                radians / Math.PI * 180);
        },

        /**
         * Retrieves the smallest horizontal (rotation=0) rectangle which contains
         * this rectangle.
         * @returns {XLviewer.Rect}
         */
        getBoundingBox: function() {
            if (this.rotation === 0) {
                return this.clone();
            }
            var topLeft = this.getTopLeft();
            var topRight = this.getTopRight();
            var bottomLeft = this.getBottomLeft();
            var bottomRight = this.getBottomRight();
            var minX = Math.min(topLeft.x, topRight.x, bottomLeft.x, bottomRight.x);
            var maxX = Math.max(topLeft.x, topRight.x, bottomLeft.x, bottomRight.x);
            var minY = Math.min(topLeft.y, topRight.y, bottomLeft.y, bottomRight.y);
            var maxY = Math.max(topLeft.y, topRight.y, bottomLeft.y, bottomRight.y);
            return new xlv.Rect(
                minX,
                minY,
                maxX - minX,
                maxY - minY);
        },

        /**
         *
         * @param other {XLviewer.Rect}
         * @returns {boolean}
         */
        overlap : function ( other ) {
            var l1 = this.getTopLeft();
            var r1 = this.getBottomRight();

            var l2 = other.getTopLeft();
            var r2 = other.getBottomRight();

            // If one rectangle is on left side of other && If one rectangle is above other
            return !(l1.x > r2.x || l2.x > r1.x) && !(l1.y < r2.y || l2.y < r1.y)
        },

        /**
         *
         * @param point {XLviewer.Point}
         * @returns {boolean}
         */
        overlapPoint : function ( point ) {
            var topLeft = this.getTopLeft();
            var bottomRight = this.getBottomRight();

            return (point.x >= topLeft.x && point.x <= bottomRight.x && point.y >= topLeft.y && point.y <= bottomRight.y);
        },

        /**
         * Provides a string representation of the rectangle which is useful for
         * debugging.
         * @function
         * @returns {String} A string representation of the rectangle.
         */
        toString: function() {
            return "[" +
                (Math.round(this.x * 100) / 100) + "," +
                (Math.round(this.y * 100) / 100) + "," +
                (Math.round(this.width * 100) / 100) + "x" +
                (Math.round(this.height * 100) / 100) + "," +
                (Math.round(this.rotation * 100) / 100) + "deg" +
                "]";
        }
    };

}( XLviewer ));
(function( xlv ){

    /**
     * Tween animator of the viewer
     */
    xlv.Tween = function( options ) {
        var args = arguments;

        if( typeof( options ) != 'object' ){
            //allows backward compatible use of ( initialValue, config ) as
            //constructor parameters
            options = {
                initial: args.length && typeof ( args[ 0 ] ) == "number" ?
                    args[ 0 ] :
                    undefined,
                /**
                 * Spring stiffness.
                 * @member {Number} tweenSmoothness
                 * @memberof XLviewer.Spring#
                 */
                tweenSmoothness: args.length > 1 ?
                    args[ 1 ].tweenSmoothness :
                    5.0,
                /**
                 * Animation duration per spring.
                 * @member {Number} tweenDuration
                 * @memberof XLviewer.Spring#
                 */
                tweenDuration: args.length > 1 ?
                    args[ 1 ].tweenDuration :
                    1.5
            };
        }

        xlv.log.d(typeof options.tweenSmoothness === "number" && options.tweenSmoothness !== 0,
            "[XLviewer.Spring] options.tweenSmoothness must be a non-zero number");

        xlv.log.d(typeof options.tweenDuration === "number" && options.tweenDuration >= 0,
            "[XLviewer.Spring] options.tweenDuration must be a number greater than or equal to 0");

        if (options.exponential) {
            this._exponential = true;
            delete options.exponential;
        }

        xlv.extend( true, this, options);

        /**
         * @member {Object} current
         * @memberof XLviewer.Spring#
         * @property {Number} value
         * @property {Number} time
         */
        this.current = {
            value: typeof ( this.initial ) == "number" ?
                this.initial :
                (this._exponential ? 0 : 1),
            time:  xlv.Utils.now() // always work in milliseconds
        };

        xlv.log.d(!this._exponential || this.current.value !== 0,
            "[XLviewer.Spring] value must be non-zero for exponential springs");

        /**
         * @member {Object} start
         * @memberof XLviewer.Spring#
         * @property {Number} value
         * @property {Number} time
         */
        this.start = {
            value: this.current.value,
            time:  this.current.time
        };

        /**
         * @member {Object} target
         * @memberof XLviewer.Spring#
         * @property {Number} value
         * @property {Number} time
         */
        this.target = {
            value: this.current.value,
            time:  this.current.time
        };

        if (this._exponential) {
            this.start._logValue = Math.log(this.start.value);
            this.target._logValue = Math.log(this.target.value);
            this.current._logValue = Math.log(this.current.value);
        }
    };

    /** @lends XLviewer.Spring.prototype */
    xlv.Tween.prototype = {

        /**
         * @function
         * @param {Number} target
         */
        resetTo: function( target ) {
            xlv.log.d(!this._exponential || target !== 0,
                "[XLviewer.Spring.resetTo] target must be non-zero for exponential springs");

            this.start.value = this.target.value = this.current.value = target;
            this.start.time = this.target.time = this.current.time = xlv.Utils.now();

            if (this._exponential) {
                this.start._logValue = Math.log(this.start.value);
                this.target._logValue = Math.log(this.target.value);
                this.current._logValue = Math.log(this.current.value);
            }
        },

        /**
         * @function
         * @param {Number} target
         */
        springTo: function( target ) {
            xlv.log.d(!this._exponential || target !== 0,
                "[XLviewer.Spring.springTo] target must be non-zero for exponential springs");

            this.start.value  = this.current.value;
            this.start.time   = this.current.time;
            this.target.value = target;
            this.target.time  = this.start.time + 1000 * this.tweenDuration;

            if (this._exponential) {
                this.start._logValue = Math.log(this.start.value);
                this.target._logValue = Math.log(this.target.value);
            }
        },

        /**
         * @function
         * @param {Number} delta
         */
        shiftBy: function( delta ) {
            this.start.value  += delta;
            this.target.value += delta;

            if (this._exponential) {
                xlv.log.d(this.target.value !== 0 && this.start.value !== 0,
                    "[XLviewer.Spring.shiftBy] spring value must be non-zero for exponential springs");

                this.start._logValue = Math.log(this.start.value);
                this.target._logValue = Math.log(this.target.value);
            }
        },

        setExponential: function(value) {
            this._exponential = value;

            if (this._exponential) {
                xlv.log.d(this.current.value !== 0 && this.target.value !== 0 && this.start.value !== 0,
                    "[XLviewer.Spring.setExponential] spring value must be non-zero for exponential springs");

                this.start._logValue = Math.log(this.start.value);
                this.target._logValue = Math.log(this.target.value);
                this.current._logValue = Math.log(this.current.value);
            }
        },

        /**
         * @function
         */
        update: function() {
            this.current.time  = xlv.Utils.now();

            var startValue, targetValue;
            if (this._exponential) {
                startValue = this.start._logValue;
                targetValue = this.target._logValue;
            } else {
                startValue = this.start.value;
                targetValue = this.target.value;
            }

            var currentValue = (this.current.time >= this.target.time) ?
                targetValue :
                startValue +
                ( targetValue - startValue ) *
                transform(
                    this.tweenSmoothness,
                    ( this.current.time - this.start.time ) /
                    ( this.target.time  - this.start.time )
                );

            if (this._exponential) {
                this.current.value = Math.exp(currentValue);
            } else {
                this.current.value = currentValue;
            }
        }
    };

    /**
     * @private
     */
    function transform( stiffness, x ) {
        return ( 1.0 - Math.exp( stiffness * -x ) ) /
            ( 1.0 - Math.exp( -stiffness ) );
    }

}( XLviewer ));
/*
 * XLviewer - ImageLoader
 *
 * Copyright (C) 2009 CodePlex Foundation
 * Copyright (C) 2010-2013 XLviewer contributors

 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */

(function( xlv ){

// private class
    function ImageJob ( options ) {

        xlv.extend( true, this, {
            timeout:        xlv.DEFAULT_SETTINGS.timeout,
            jobId:          null
        }, options );

        /**
         * Image object which will contain downloaded image.
         * @member {Image} image
         * @memberof XLviewer.ImageJob#
         */
        this.image = null;
    }

    ImageJob.prototype = {
        errorMsg: null,
        start: function(){
            var _this = this;

            this.image = new Image();

            if ( this.enableCORS !== false ) {
                this.image.crossOrigin = this.enableCORS;
            }

            this.image.onload = function(){
                _this.finish( true );
            };
            this.image.onabort = this.image.onerror = function(){
                _this.errorMsg = "Image load aborted";
                _this.finish( false );
            };

            this.jobId = window.setTimeout( function(){
                _this.errorMsg = "Image load exceeded timeout";
                _this.finish( false );
            }, this.timeout);

            this.image.src = this.src;
        },

        finish: function( successful ) {
            this.image.onload = this.image.onerror = this.image.onabort = null;
            if (!successful) {
                this.image = null;
            }

            if ( this.jobId ) {
                window.clearTimeout( this.jobId );
            }

            this.callback( this );
        }

    };

    /**
     * @ignore
     * @class ImageLoader
     * @memberof XLviewer
     * @classdesc Handles downloading of a set of images using asynchronous queue pattern.
     * You generally won't have to interact with the ImageLoader directly.
     * @param {Object} options - Options for this ImageLoader.
     * @param {Number} [options.jobLimit] - The number of concurrent image requests. See imageLoaderLimit in {@link XLviewer.Options} for details.
     */
    xlv.ImageLoader = function( options ) {

        xlv.extend( true, this, {
            jobLimit:       xlv.DEFAULT_SETTINGS.imageLoaderLimit,
            jobQueue:       [],
            jobsInProgress: 0
        }, options );

    };

    /** @lends XLviewer.ImageLoader.prototype */
    xlv.ImageLoader.prototype = {

        /**
         * Add an unloaded image to the loader queue.
         * @method
         * @param {String} src - URL of image to download.
         * @param {String} enableCORS - CORS policy to use for downloads
         * @param {Function} callback - Called once image has been downloaded.
         */
        addJob: function( options ) {
            var _this = this,
                complete = function( job ) {
                    completeJob( _this, job, options.callback );
                },
                jobOptions = {
                    src: options.src,
                    enableCORS: options.enableCORS,
                    callback: complete,
                    abort: options.abort
                },
                newJob = new ImageJob( jobOptions );

            if ( !this.jobLimit || this.jobsInProgress < this.jobLimit ) {
                newJob.start();
                this.jobsInProgress++;
            }
            else {
                this.jobQueue.push( newJob );
            }
        },

        /**
         * Clear any unstarted image loading jobs from the queue.
         * @method
         */
        clear: function() {
            for( var i = 0; i < this.jobQueue.length; i++ ) {
                var job = this.jobQueue[i];
                if ( typeof job.abort === "function" ) {
                    job.abort();
                }
            }

            this.jobQueue = [];
        }
    };

    /**
     * Cleans up ImageJob once completed.
     * @method
     * @private
     * @param loader - ImageLoader used to start job.
     * @param job - The ImageJob that has completed.
     * @param callback - Called once cleanup is finished.
     */
    function completeJob( loader, job, callback ) {
        var nextJob;

        loader.jobsInProgress--;

        if ( (!loader.jobLimit || loader.jobsInProgress < loader.jobLimit) && loader.jobQueue.length > 0) {
            nextJob = loader.jobQueue.shift();
            nextJob.start();
            loader.jobsInProgress++;
        }

        callback( job.image, job.errorMsg );
    }

}( XLviewer ));
(function (xlv) {
    xlv.Net = {
        URLPARAMS : {}
    };

    var query = window.location.search.substring( 1 ),
        parts = query.split('&'),
        part,
        sep,
        i;

    for ( i = 0; i < parts.length; i++ ) {
        part = parts[ i ];
        sep  = part.indexOf( '=' );

        if ( sep > 0 ) {
            xlv.Net.URLPARAMS[ part.substring( 0, sep ) ] =
                decodeURIComponent( part.substring( sep + 1 ) );
        }
    }
    /**
     * Retreives the value of a url parameter from the window.location string.
     */
    xlv.Net.getUrlParameter = function( key ) {
        var value = xlv.Net.URLPARAMS[ key ];
        return value ? value : null;
    };

    /**
     * Retrieves the protocol used by the url. The url can either be absolute
     * or relative.
     * @function
     * @private
     * @param {String} url The url to retrieve the protocol from.
     * @return {String} The protocol (http:, https:, file:, ftp: ...)
     */
    xlv.Net.getUrlProtocol = function( url ) {
        var match = url.match(/^([a-z]+:)\/\//i);
        if ( match === null ) {
            // Relative URL, retrive the protocol from window.location
            return window.location.protocol;
        }
        return match[1].toLowerCase();
    };

    /**
     * Create an XHR object
     * @private
     * @param {type} [local] If set to true, the XHR will be file: protocol
     * compatible if possible (but may raise a warning in the browser).
     * @returns {XMLHttpRequest}
     */
    xlv.Net.createAjaxRequest = function( local ) {
        // IE11 does not support window.ActiveXObject so we just try to
        // create one to see if it is supported.
        // See: http://msdn.microsoft.com/en-us/library/ie/dn423948%28v=vs.85%29.aspx
        var supportActiveX;
        try {
            /* global ActiveXObject:true */
            supportActiveX = !!new ActiveXObject( "Microsoft.XMLHTTP" );
        } catch( e ) {
            supportActiveX = false;
        }

        if ( supportActiveX ) {
            if ( window.XMLHttpRequest ) {
                xlv.Net.createAjaxRequest = function( local ) {
                    if ( local ) {
                        return new ActiveXObject( "Microsoft.XMLHTTP" );
                    }
                    return new XMLHttpRequest();
                };
            } else {
                xlv.Net.createAjaxRequest = function() {
                    return new ActiveXObject( "Microsoft.XMLHTTP" );
                };
            }
        } else if ( window.XMLHttpRequest ) {
            xlv.Net.createAjaxRequest = function() {
                return new XMLHttpRequest();
            };
        } else {
            throw new Error( "Browser doesn't support XMLHttpRequest." );
        }
        return xlv.Net.createAjaxRequest( local );
    };

    /**
     * Makes an AJAX request.
     * @throws {Error}
     */
    xlv.Net.makeAjaxRequest = function( url, onSuccess, onError, method, body ) {



        var withCredentials;

        // Note that our preferred API is that you pass in a single object; the named
        // arguments are for legacy support.
        if( xlv.Utils.isPlainObject( url ) ){
            onSuccess = url.success;
            onError = url.error;
            withCredentials = url.withCredentials;
            method = url.method || 'GET';
            body = url.body || null;
            url = url.url;
        } else {
            if(!method) {
                method = 'GET';
            }
        }




        var protocol = xlv.Net.getUrlProtocol( url );
        var request = xlv.Net.createAjaxRequest( protocol === "file:" );

        if ( !xlv.Utils.isFunction( onSuccess ) ) {
            throw new Error( "makeAjaxRequest requires a success callback" );
        }

        request.onreadystatechange = function() {
            // 4 = DONE (https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest#Properties)
            if ( request.readyState == 4 ) {
                request.onreadystatechange = function(){};

                // With protocols other than http/https, the status is 200
                // on Firefox and 0 on other browsers
                if ( request.status === 200 ||
                    ( request.status === 0 &&
                        protocol !== "http:" &&
                        protocol !== "https:" )) {
                    onSuccess( request );
                } else {
                    xlv.log.l( "AJAX request returned %d: %s", request.status, url );

                    if ( xlv.Utils.isFunction( onError ) ) {
                        onError( request );
                    }
                }
            }
        };

        if (withCredentials) {
            request.withCredentials = true;
        }

        try {
            request.open( method , url, true );
            request.send( body );
        } catch (e) {
            var msg = e.message;

            /*
             IE < 10 does not support CORS and an XHR request to a different origin will fail as soon
             as send() is called. This is particularly easy to miss during development and appear in
             production if you use a CDN or domain sharding and the security policy is likely to break
             exception handlers since any attempt to access a property of the request object will
             raise an access denied TypeError inside the catch block.

             To be friendlier, we'll check for this specific error and add a documentation pointer
             to point developers in the right direction. We test the exception number because IE's
             error messages are localized.
             */
            var oldIE = xlv.Browser.vendor == xlv.CONST.BROWSER.IE && xlv.Browser.version < 10;
            if ( oldIE && typeof( e.number ) != "undefined" && e.number == -2147024891 ) {
                msg += "\nSee http://msdn.microsoft.com/en-us/library/ms537505(v=vs.85).aspx#xdomain";
            }

            xlv.log.l( "%s while making AJAX request: %s", e.name, msg );

            request.onreadystatechange = function(){};

            if (window.XDomainRequest) { // IE9 or IE8 might as well try to use XDomainRequest
                var xdr = new XDomainRequest();
                if (xdr) {
                    xdr.onload = function (e) {
                        if ( xlv.Utils.isFunction( onSuccess ) ) {
                            onSuccess({ // Faking an xhr object
                                responseText: xdr.responseText,
                                status: 200, // XDomainRequest doesn't support status codes, so we just fake one! :/
                                statusText: 'OK'
                            });
                        }
                    };
                    xdr.onerror = function (e) {
                        if ( xlv.Utils.isFunction ( onError ) ) {
                            onError({ // Faking an xhr object
                                responseText: xdr.responseText,
                                status: 444, // 444 No Response
                                statusText: 'An error happened. Due to an XDomainRequest deficiency we can not extract any information about this error. Upgrade your browser.'
                            });
                        }
                    };
                    try {
                        xdr.open(method, url);
                        xdr.send(body);
                    } catch (e2) {
                        if ( xlv.Utils.isFunction( onError ) ) {
                            onError( request, e );
                        }
                    }
                }
            } else {
                if ( xlv.Utils.isFunction( onError ) ) {
                    onError( request, e );
                }
            }
        }
    };

    xlv.Net.thumbUrl = function (source, image, w, h, q) {
        return source + image + "?cmd=whole&w=" + w.toString() + "&h=" +  h.toString() + "&q=" + q.toString();
    }
}(XLviewer));(function( xlv ){

    /**
     * @ignore
     * @class Tile
     * @memberof XLviewer
     * @param {Number} level The zoom level this tile belongs to.
     * @param {Number} x The vector component 'x'.
     * @param {Number} y The vector component 'y'.
     * @param {XLviewer.Point} bounds Where this tile fits, in normalized
     *      coordinates.
     * @param {Boolean} exists Is this tile a part of a sparse image? ( Also has
     *      this tile failed to load? )
     * @param {String} url The URL of this tile's image.
     * @param {CanvasRenderingContext2D} context2D The context2D of this tile if it
     * is provided directly by the tile source.
     */
    xlv.Tile = function(level, x, y, bounds, exists, url, context2D) {
        /**
         * The zoom level this tile belongs to.
         * @member {Number} level
         * @memberof XLviewer.Tile#
         */
        this.level   = level;
        /**
         * The vector component 'x'.
         * @member {Number} x
         * @memberof XLviewer.Tile#
         */
        this.x       = x;
        /**
         * The vector component 'y'.
         * @member {Number} y
         * @memberof XLviewer.Tile#
         */
        this.y       = y;
        /**
         * Where this tile fits, in normalized coordinates
         * @member {XLviewer.Rect} bounds
         * @memberof XLviewer.Tile#
         */
        this.bounds  = bounds;
        /**
         * Is this tile a part of a sparse image? Also has this tile failed to load?
         * @member {Boolean} exists
         * @memberof XLviewer.Tile#
         */
        this.exists  = exists;
        /**
         * The URL of this tile's image.
         * @member {String} url
         * @memberof XLviewer.Tile#
         */
        this.url     = url;
        /**
         * The context2D of this tile if it is provided directly by the tile source.
         * @member {CanvasRenderingContext2D} context2D
         * @memberOf XLviewer.Tile#
         */
        this.context2D = context2D;
        /**
         * Is this tile loaded?
         * @member {Boolean} loaded
         * @memberof XLviewer.Tile#
         */
        this.loaded  = false;
        /**
         * Is this tile loading?
         * @member {Boolean} loading
         * @memberof XLviewer.Tile#
         */
        this.loading = false;

        /**
         * The HTML div element for this tile
         * @member {Element} element
         * @memberof XLviewer.Tile#
         */
        this.element    = null;
        /**
         * The HTML img element for this tile.
         * @member {Element} imgElement
         * @memberof XLviewer.Tile#
         */
        this.imgElement = null;
        /**
         * The Image object for this tile.
         * @member {Object} image
         * @memberof XLviewer.Tile#
         */
        this.image      = null;

        /**
         * The alias of this.element.style.
         * @member {String} style
         * @memberof XLviewer.Tile#
         */
        this.style      = null;
        /**
         * This tile's position on screen, in pixels.
         * @member {XLviewer.Point} position
         * @memberof XLviewer.Tile#
         */
        this.position   = null;
        /**
         * This tile's size on screen, in pixels.
         * @member {XLviewer.Point} size
         * @memberof XLviewer.Tile#
         */
        this.size       = null;
        /**
         * The start time of this tile's blending.
         * @member {Number} blendStart
         * @memberof XLviewer.Tile#
         */
        this.blendStart = null;
        /**
         * The current opacity this tile should be.
         * @member {Number} opacity
         * @memberof XLviewer.Tile#
         */
        this.opacity    = null;
        /**
         * The distance of this tile to the viewport center.
         * @member {Number} distance
         * @memberof XLviewer.Tile#
         */
        this.distance   = null;
        /**
         * The visibility score of this tile.
         * @member {Number} visibility
         * @memberof XLviewer.Tile#
         */
        this.visibility = null;

        /**
         * Whether this tile is currently being drawn.
         * @member {Boolean} beingDrawn
         * @memberof XLviewer.Tile#
         */
        this.beingDrawn     = false;
        /**
         * Timestamp the tile was last touched.
         * @member {Number} lastTouchTime
         * @memberof XLviewer.Tile#
         */
        this.lastTouchTime  = 0;
    };

    /** @lends XLviewer.Tile.prototype */
    xlv.Tile.prototype = {

        /**
         * Provides a string representation of this tiles level and (x,y)
         * components.
         * @function
         * @returns {String}
         */
        toString: function() {
            return this.level + "/" + this.x + "_" + this.y;
        },

        // private
        _hasTransparencyChannel: function() {
            return this.context2D || this.url.match('.png');
        },

        /**
         * Renders the tile in an html container.
         * @function
         * @param {Element} container
         */
        drawHTML: function( container ) {
            if (!this.cacheImageRecord) {
                xlv.log.w(
                    '[Tile.drawHTML] attempting to draw tile %s when it\'s not cached',
                    this.toString());
                return;
            }

            if ( !this.loaded ) {
                xlv.log.w(
                    "Attempting to draw tile %s when it's not yet loaded.",
                    this.toString()
                );
                return;
            }

            //EXPERIMENTAL - trying to figure out how to scale the container
            //               content during animation of the container size.

            if ( !this.element ) {
                this.element                              = xlv.makeNeutralElement( "div" );
                this.imgElement                           = this.cacheImageRecord.getImage().cloneNode();
                this.imgElement.style.msInterpolationMode = "nearest-neighbor";
                this.imgElement.style.width               = "100%";
                this.imgElement.style.height              = "100%";

                this.style                     = this.element.style;
                this.style.position            = "absolute";
            }
            if ( this.element.parentNode != container ) {
                container.appendChild( this.element );
            }
            if ( this.imgElement.parentNode != this.element ) {
                this.element.appendChild( this.imgElement );
            }

            this.style.top     = this.position.y + "px";
            this.style.left    = this.position.x + "px";
            this.style.height  = this.size.y + "px";
            this.style.width   = this.size.x + "px";

            xlv.setElementOpacity( this.element, this.opacity );
        },

        /**
         * Renders the tile in a canvas-based context.
         * @function
         * @param {Canvas} context
         * @param {Function} drawingHandler - Method for firing the drawing event.
         * drawingHandler({context, tile, rendered})
         * where <code>rendered</code> is the context with the pre-drawn image.
         * @param {Number} [scale=1] - Apply a scale to position and size
         * @param {XLviewer.Point} [translate] - A translation vector
         */
        drawCanvas: function( context, drawingHandler, scale, translate ) {

            var position = this.position.times(xlv.Utils.pixelDensityRatio),
                size     = this.size.times(xlv.Utils.pixelDensityRatio),
                rendered;

            if (!this.context2D && !this.cacheImageRecord) {
                xlv.log.w(
                    '[Tile.drawCanvas] attempting to draw tile %s when it\'s not cached',
                    this.toString());
                return;
            }

            rendered = this.context2D || this.cacheImageRecord.getRenderedContext();

            if ( !this.loaded || !rendered ){
                xlv.log.w(
                    "Attempting to draw tile %s when it's not yet loaded.",
                    this.toString()
                );

                return;
            }

            context.save();

            context.globalAlpha = this.opacity;

            if (typeof scale === 'number' && scale !== 1) {
                // draw tile at a different scale
                position = position.times(scale);
                size = size.times(scale);
            }

            if (translate instanceof xlv.Point) {
                // shift tile position slightly
                position = position.plus(translate);
            }

            //if we are supposed to be rendering fully opaque rectangle,
            //ie its done fading or fading is turned off, and if we are drawing
            //an image with an alpha channel, then the only way
            //to avoid seeing the tile underneath is to clear the rectangle
            if (context.globalAlpha === 1 && this._hasTransparencyChannel()) {
                //clearing only the inside of the rectangle occupied
                //by the png prevents edge flikering
                context.clearRect(
                    position.x + 1,
                    position.y + 1,
                    size.x - 2,
                    size.y - 2
                );
            }

            // This gives the application a chance to make image manipulation
            // changes as we are rendering the image
            drawingHandler({context: context, tile: this, rendered: rendered});

            context.drawImage(
                rendered.canvas,
                0,
                0,
                rendered.canvas.width,
                rendered.canvas.height,
                position.x,
                position.y,
                size.x,
                size.y
            );

            context.restore();
        },

        /**
         * Get the ratio between current and original size.
         * @function
         * @return {Float}
         */
        getScaleForEdgeSmoothing: function() {
            if (!this.cacheImageRecord) {
                xlv.log.w(
                    '[Tile.drawCanvas] attempting to get tile scale %s when tile\'s not cached',
                    this.toString());
                return 1;
            }

            var rendered = this.cacheImageRecord.getRenderedContext();
            return rendered.canvas.width / this.size.times(xlv.Utils.pixelDensityRatio).x;
        },

        /**
         * Get a translation vector that when applied to the tile position produces integer coordinates.
         * Needed to avoid swimming and twitching.
         * @function
         * @param {Number} [scale=1] - Scale to be applied to position.
         * @return {XLviewer.Point}
         */
        getTranslationForEdgeSmoothing: function(scale, canvasSize, sketchCanvasSize) {
            // The translation vector must have positive values, otherwise the image goes a bit off
            // the sketch canvas to the top and left and we must use negative coordinates to repaint it
            // to the main canvas. In that case, some browsers throw:
            // INDEX_SIZE_ERR: DOM Exception 1: Index or size was negative, or greater than the allowed value.
            var x = Math.max(1, Math.ceil((sketchCanvasSize.x - canvasSize.x) / 2));
            var y = Math.max(1, Math.ceil((sketchCanvasSize.y - canvasSize.y) / 2));
            return new xlv.Point(x, y).minus(
                this.position
                    .times(xlv.Utils.pixelDensityRatio)
                    .times(scale || 1)
                    .apply(function(x) {
                        return x % 1;
                    })
            );
        },

        /**
         * Removes tile from its container.
         * @function
         */
        unload: function() {
            if ( this.imgElement && this.imgElement.parentNode ) {
                this.imgElement.parentNode.removeChild( this.imgElement );
            }
            if ( this.element && this.element.parentNode ) {
                this.element.parentNode.removeChild( this.element );
            }

            this.element    = null;
            this.imgElement = null;
            this.loaded     = false;
            this.loading    = false;
        }
    };

    // private class
    var TileRecord = function( options ) {
        xlv.log.d( options, "[TileCache.cacheTile] options is required" );
        xlv.log.d( options.tile, "[TileCache.cacheTile] options.tile is required" );
        xlv.log.d( options.tiledImage, "[TileCache.cacheTile] options.tiledImage is required" );
        this.tile = options.tile;
        this.tiledImage = options.tiledImage;
    };

// private class
    var ImageRecord = function(options) {
        xlv.log.d( options, "[ImageRecord] options is required" );
        xlv.log.d( options.image, "[ImageRecord] options.image is required" );
        this._image = options.image;
        this._tiles = [];
    };

    ImageRecord.prototype = {
        destroy: function() {
            this._image = null;
            this._renderedContext = null;
            this._tiles = null;
        },

        getImage: function() {
            return this._image;
        },

        getRenderedContext: function() {
            if (!this._renderedContext) {
                var canvas = document.createElement( 'canvas' );
                canvas.width = this._image.width;
                canvas.height = this._image.height;
                this._renderedContext = canvas.getContext('2d');
                this._renderedContext.drawImage( this._image, 0, 0 );
                //since we are caching the prerendered image on a canvas
                //allow the image to not be held in memory
                this._image = null;
            }
            return this._renderedContext;
        },

        setRenderedContext: function(renderedContext) {
            xlv.log.e("ImageRecord.setRenderedContext is deprecated. " +
                "The rendered context should be created by the ImageRecord " +
                "itself when calling ImageRecord.getRenderedContext.");
            this._renderedContext = renderedContext;
        },

        addTile: function(tile) {
            xlv.log.d(tile, '[ImageRecord.addTile] tile is required');
            this._tiles.push(tile);
        },

        removeTile: function(tile) {
            for (var i = 0; i < this._tiles.length; i++) {
                if (this._tiles[i] === tile) {
                    this._tiles.splice(i, 1);
                    return;
                }
            }

            xlv.log.w('[ImageRecord.removeTile] trying to remove unknown tile', tile);
        },

        getTileCount: function() {
            return this._tiles.length;
        }
    };

    /**
     * @ignore
     * @class TileCache
     * @memberof XLviewer
     * @classdesc Stores all the tiles displayed in a {@link XLviewer.Viewer}.
     * You generally won't have to interact with the TileCache directly.
     * @param {Object} options - Configuration for this TileCache.
     * @param {Number} [options.maxImageCacheCount] - See maxImageCacheCount in
     * {@link XLviewer.Options} for details.
     */
    xlv.TileCache = function( options ) {
        options = options || {};

        this._maxImageCacheCount = options.maxImageCacheCount || xlv.DEFAULT_SETTINGS.maxImageCacheCount;
        this._tilesLoaded = [];
        this._imagesLoaded = [];
        this._imagesLoadedCount = 0;
    };

    /** @lends XLviewer.TileCache.prototype */
    xlv.TileCache.prototype = {
        /**
         * @returns {Number} The total number of tiles that have been loaded by
         * this TileCache.
         */
        numTilesLoaded: function() {
            return this._tilesLoaded.length;
        },

        /**
         * Caches the specified tile, removing an old tile if necessary to stay under the
         * maxImageCacheCount specified on construction. Note that if multiple tiles reference
         * the same image, there may be more tiles than maxImageCacheCount; the goal is to keep
         * the number of images below that number. Note, as well, that even the number of images
         * may temporarily surpass that number, but should eventually come back down to the max specified.
         * @param {Object} options - Tile info.
         * @param {XLviewer.Tile} options.tile - The tile to cache.
         * @param {Image} options.image - The image of the tile to cache.
         * @param {XLviewer.TiledImage} options.tiledImage - The TiledImage that owns that tile.
         * @param {Number} [options.cutoff=0] - If adding this tile goes over the cache max count, this
         * function will release an old tile. The cutoff option specifies a tile level at or below which
         * tiles will not be released.
         */
        cacheTile: function( options ) {
            xlv.log.d( options, "[TileCache.cacheTile] options is required" );
            xlv.log.d( options.tile, "[TileCache.cacheTile] options.tile is required" );
            xlv.log.d( options.tile.url, "[TileCache.cacheTile] options.tile.url is required" );
            xlv.log.d( options.tiledImage, "[TileCache.cacheTile] options.tiledImage is required" );

            var cutoff = options.cutoff || 0;
            var insertionIndex = this._tilesLoaded.length;

            var imageRecord = this._imagesLoaded[options.tile.url];
            if (!imageRecord) {
                xlv.log.d( options.image, "[TileCache.cacheTile] options.image is required to create an ImageRecord" );
                imageRecord = this._imagesLoaded[options.tile.url] = new ImageRecord({
                    image: options.image
                });

                this._imagesLoadedCount++;
            }

            imageRecord.addTile(options.tile);
            options.tile.cacheImageRecord = imageRecord;

            // Note that just because we're unloading a tile doesn't necessarily mean
            // we're unloading an image. With repeated calls it should sort itself out, though.
            if ( this._imagesLoadedCount > this._maxImageCacheCount ) {
                var worstTile       = null;
                var worstTileIndex  = -1;
                var worstTileRecord = null;
                var prevTile, worstTime, worstLevel, prevTime, prevLevel, prevTileRecord;

                for ( var i = this._tilesLoaded.length - 1; i >= 0; i-- ) {
                    prevTileRecord = this._tilesLoaded[ i ];
                    prevTile = prevTileRecord.tile;

                    if ( prevTile.level <= cutoff || prevTile.beingDrawn ) {
                        continue;
                    } else if ( !worstTile ) {
                        worstTile       = prevTile;
                        worstTileIndex  = i;
                        worstTileRecord = prevTileRecord;
                        continue;
                    }

                    prevTime    = prevTile.lastTouchTime;
                    worstTime   = worstTile.lastTouchTime;
                    prevLevel   = prevTile.level;
                    worstLevel  = worstTile.level;

                    if ( prevTime < worstTime ||
                        ( prevTime == worstTime && prevLevel > worstLevel ) ) {
                        worstTile       = prevTile;
                        worstTileIndex  = i;
                        worstTileRecord = prevTileRecord;
                    }
                }

                if ( worstTile && worstTileIndex >= 0 ) {
                    this._unloadTile(worstTileRecord);
                    insertionIndex = worstTileIndex;
                }
            }

            this._tilesLoaded[ insertionIndex ] = new TileRecord({
                tile: options.tile,
                tiledImage: options.tiledImage
            });
        },

        /**
         * Clears all tiles associated with the specified tiledImage.
         * @param {XLviewer.TiledImage} tiledImage
         */
        clearTilesFor: function( tiledImage ) {
            xlv.log.d(tiledImage, '[TileCache.clearTilesFor] tiledImage is required');
            var tileRecord;
            for ( var i = 0; i < this._tilesLoaded.length; ++i ) {
                tileRecord = this._tilesLoaded[ i ];
                if ( tileRecord.tiledImage === tiledImage ) {
                    this._unloadTile(tileRecord);
                    this._tilesLoaded.splice( i, 1 );
                    i--;
                }
            }
        },

        // private
        getImageRecord: function(url) {
            xlv.log.d(url, '[TileCache.getImageRecord] url is required');
            return this._imagesLoaded[url];
        },

        // private
        _unloadTile: function(tileRecord) {
            xlv.log.d(tileRecord, '[TileCache._unloadTile] tileRecord is required');
            var tile = tileRecord.tile;
            var tiledImage = tileRecord.tiledImage;

            tile.unload();
            tile.cacheImageRecord = null;

            var imageRecord = this._imagesLoaded[tile.url];
            imageRecord.removeTile(tile);
            if (!imageRecord.getTileCount()) {
                imageRecord.destroy();
                delete this._imagesLoaded[tile.url];
                this._imagesLoadedCount--;
            }

            /**
             * Triggered when a tile has just been unloaded from memory.
             */
            tiledImage.viewer.dispatchEvent("tileUnloaded", {
                tile: tile,
                tiledImage: tiledImage
            });
        }
    };


}( XLviewer ));
(function( xlv ){
    /**
     * Handles rendering of tiles. A new instance is created for each TileSource opened.
     */
    xlv.TiledImage = function( options ) {
        var _this = this;

        xlv.log.d( options.tileCache, "[TiledImage] options.tileCache is required" );
        xlv.log.d( options.drawer, "[TiledImage] options.drawer is required" );
        xlv.log.d( options.viewer, "[TiledImage] options.viewer is required" );
        xlv.log.d( options.imageLoader, "[TiledImage] options.imageLoader is required" );
        xlv.log.d( options.source, "[TiledImage] options.source is required" );
        xlv.log.d(!options.clip || options.clip instanceof xlv.Rect,
            "[TiledImage] options.clip must be an XLviewer.Rect if present");

        xlv.EventDispatcher.call( this );

        this.quality = options.quality || xlv.DEFAULT_SETTINGS.quality;
        this._tileCache = options.tileCache;
        delete options.tileCache;

        this._drawer = options.drawer;
        delete options.drawer;

        this._imageLoader = options.imageLoader;
        delete options.imageLoader;

        if (options.clip instanceof xlv.Rect) {
            this._clip = options.clip.clone();
        }

        delete options.clip;

        var x = options.x || 0;
        delete options.x;
        var y = options.y || 0;
        delete options.y;

        // Ratio of zoomable image height to width.
        this.normHeight = options.source.dimensions.y / options.source.dimensions.x;
        this.contentAspectX = options.source.dimensions.x / options.source.dimensions.y;

        var scale = 1;
        if ( options.width ) {
            scale = options.width;
            delete options.width;

            if ( options.height ) {
                xlv.log.e( "specifying both width and height to a tiledImage is not supported" );
                delete options.height;
            }
        } else if ( options.height ) {
            scale = options.height / this.normHeight;
            delete options.height;
        }

        var fitBounds = options.fitBounds;
        delete options.fitBounds;
        var fitBoundsPlacement = options.fitBoundsPlacement || XLviewer.Placement.CENTER;
        delete options.fitBoundsPlacement;

        xlv.extend( true, this, {

            //internal state properties
            viewer:         null,
            tilesMatrix:    {},    // A '3d' dictionary [level][x][y] --> Tile.
            coverage:       {},    // A '3d' dictionary [level][x][y] --> Boolean.
            lastDrawn:      [],    // An unordered list of Tiles drawn last frame.
            lastResetTime:  0,     // Last time for which the tiledImage was reset.
            _midDraw:       false, // Is the tiledImage currently updating the viewport?
            _needsDraw:     true,  // Does the tiledImage need to update the viewport again?
            _hasOpaqueTile: false,  // Do we have even one fully opaque tile?
            //configurable settings
            tweenSmoothness:        xlv.DEFAULT_SETTINGS.tweenSmoothness,
            tweenDuration:          xlv.DEFAULT_SETTINGS.tweenDuration,
            underZoomRatio:      xlv.DEFAULT_SETTINGS.underZoomRatio,
            wrapHorizontal:         xlv.DEFAULT_SETTINGS.wrapHorizontal,
            wrapVertical:           xlv.DEFAULT_SETTINGS.wrapVertical,
            noWaitForRendering:        xlv.DEFAULT_SETTINGS.noWaitForRendering,
            blendDuration:              xlv.DEFAULT_SETTINGS.blendDuration,
            alwaysBlend:            xlv.DEFAULT_SETTINGS.alwaysBlend,
            minPixelRatio:          xlv.DEFAULT_SETTINGS.minPixelRatio,
            overZoomRatioForSmoothingTile: xlv.DEFAULT_SETTINGS.overZoomRatioForSmoothingTile,
            debug:              xlv.DEFAULT_SETTINGS.debug,
            enableCORS:      xlv.DEFAULT_SETTINGS.enableCORS,
            placeholderFillStyle:   xlv.DEFAULT_SETTINGS.placeholderFillStyle,
            opacity:                xlv.DEFAULT_SETTINGS.opacity,
            blendingType:     xlv.DEFAULT_SETTINGS.blendingType

        }, options );

        this._xSpring = new xlv.Tween({
            initial: x,
            tweenSmoothness: this.tweenSmoothness,
            tweenDuration: this.tweenDuration
        });

        this._ySpring = new xlv.Tween({
            initial: y,
            tweenSmoothness: this.tweenSmoothness,
            tweenDuration: this.tweenDuration
        });

        this._scaleSpring = new xlv.Tween({
            initial: scale,
            tweenSmoothness: this.tweenSmoothness,
            tweenDuration: this.tweenDuration
        });

        this._updateForScale();

        if (fitBounds) {
            this.fitBounds(fitBounds, fitBoundsPlacement, true);
        }

        // We need a callback to give image manipulation a chance to happen
        this._drawingHandler = function(args) {
            /**
             * This event is fired just before the tile is drawn giving the application a chance to alter the image.
             *
             * NOTE: This event is only fired when the drawer is using a &lt;canvas&gt;.
             *
             * @event tile-drawing
             * @memberof XLviewer.Viewer
             * @type {object}
             * @property {XLviewer.Viewer} eventSource - A reference to the Viewer which dispatchd the event.
             * @property {XLviewer.Tile} tile - The Tile being drawn.
             * @property {XLviewer.TiledImage} tiledImage - Which TiledImage is being drawn.
             * @property {XLviewer.Tile} context - The HTML canvas context being drawn into.
             * @property {XLviewer.Tile} rendered - The HTML canvas context containing the tile imagery.
             * @property {?Object} userData - Arbitrary subscriber-defined object.
             */
            _this.viewer.dispatchEvent('tileDrawing', xlv.extend({
                tiledImage: _this
            }, args));
        };
    };

    xlv.extend(xlv.TiledImage.prototype, xlv.EventDispatcher.prototype, /** @lends XLviewer.TiledImage.prototype */{
        /**
         * @returns {Boolean} Whether the TiledImage needs to be drawn.
         */
        needsDraw: function() {
            return this._needsDraw;
        },

        /**
         * Clears all tiles and triggers an update on the next call to
         * {@link XLviewer.TiledImage#update}.
         */
        reset: function() {
            this._tileCache.clearTilesFor(this);
            this.lastResetTime = xlv.Utils.now();
            this._needsDraw = true;
        },

        /**
         * Updates the TiledImage's bounds, animating if needed.
         * @returns {Boolean} Whether the TiledImage animated.
         */
        update: function() {
            var oldX = this._xSpring.current.value;
            var oldY = this._ySpring.current.value;
            var oldScale = this._scaleSpring.current.value;

            this._xSpring.update();
            this._ySpring.update();
            this._scaleSpring.update();

            if (this._xSpring.current.value !== oldX || this._ySpring.current.value !== oldY ||
                this._scaleSpring.current.value !== oldScale) {
                this._updateForScale();
                this._needsDraw = true;
                return true;
            }

            return false;
        },

        /**
         * Draws the TiledImage to its Drawer.
         */
        draw: function() {
            if (this.opacity !== 0) {
                this._midDraw = true;
                updateViewport(this);
                this._midDraw = false;
            }
        },

        /**
         * Destroy the TiledImage (unload current loaded tiles).
         */
        destroy: function() {
            this.reset();
        },

        /**
         * @returns {XLviewer.Rect} This TiledImage's bounds in viewport coordinates.
         * @param {Boolean} [current=false] - Pass true for the current location; false for target location.
         */
        getBounds: function(current) {
            if (current) {
                return new xlv.Rect( this._xSpring.current.value, this._ySpring.current.value,
                    this._worldWidthCurrent, this._worldHeightCurrent );
            }

            return new xlv.Rect( this._xSpring.target.value, this._ySpring.target.value,
                this._worldWidthTarget, this._worldHeightTarget );
        },

        // deprecated
        getWorldBounds: function() {
            xlv.log.e('[TiledImage.getWorldBounds] is deprecated; use TiledImage.getBounds instead');
            return this.getBounds();
        },

        /**
         * @returns {XLviewer.Point} This TiledImage's content size, in original pixels.
         */
        getContentSize: function() {
            return new xlv.Point(this.source.dimensions.x, this.source.dimensions.y);
        },

        // private
        _viewportToImageDelta: function( viewerX, viewerY, current ) {
            var scale = (current ? this._scaleSpring.current.value : this._scaleSpring.target.value);
            return new xlv.Point(viewerX * (this.source.dimensions.x / scale),
                viewerY * ((this.source.dimensions.y * this.contentAspectX) / scale));
        },

        /**
         * Translates from XLviewer viewer coordinate system to image coordinate system.
         * This method can be called either by passing X,Y coordinates or an {@link XLviewer.Point}.
         * @param {Number|XLviewer.Point} viewerX - The X coordinate or point in viewport coordinate system.
         * @param {Number} [viewerY] - The Y coordinate in viewport coordinate system.
         * @param {Boolean} [current=false] - Pass true to use the current location; false for target location.
         * @return {XLviewer.Point} A point representing the coordinates in the image.
         */
        viewportToImageCoordinates: function( viewerX, viewerY, current ) {
            if (viewerX instanceof xlv.Point) {
                //they passed a point instead of individual components
                current = viewerY;
                viewerY = viewerX.y;
                viewerX = viewerX.x;
            }

            if (current) {
                return this._viewportToImageDelta(viewerX - this._xSpring.current.value,
                    viewerY - this._ySpring.current.value);
            }

            return this._viewportToImageDelta(viewerX - this._xSpring.target.value,
                viewerY - this._ySpring.target.value);
        },

        // private
        _imageToViewportDelta: function( imageX, imageY, current ) {
            var scale = (current ? this._scaleSpring.current.value : this._scaleSpring.target.value);
            return new xlv.Point((imageX / this.source.dimensions.x) * scale,
                (imageY / this.source.dimensions.y / this.contentAspectX) * scale);
        },

        /**
         * Translates from image coordinate system to XLviewer viewer coordinate system
         * This method can be called either by passing X,Y coordinates or an {@link XLviewer.Point}.
         * @param {Number|XLviewer.Point} imageX - The X coordinate or point in image coordinate system.
         * @param {Number} [imageY] - The Y coordinate in image coordinate system.
         * @param {Boolean} [current=false] - Pass true to use the current location; false for target location.
         * @return {XLviewer.Point} A point representing the coordinates in the viewport.
         */
        imageToViewportCoordinates: function( imageX, imageY, current ) {
            if (imageX instanceof xlv.Point) {
                //they passed a point instead of individual components
                current = imageY;
                imageY = imageX.y;
                imageX = imageX.x;
            }

            var point = this._imageToViewportDelta(imageX, imageY);
            if (current) {
                point.x += this._xSpring.current.value;
                point.y += this._ySpring.current.value;
            } else {
                point.x += this._xSpring.target.value;
                point.y += this._ySpring.target.value;
            }

            return point;
        },

        /**
         * Translates from a rectangle which describes a portion of the image in
         * pixel coordinates to XLviewer viewport rectangle coordinates.
         * This method can be called either by passing X,Y,width,height or an {@link XLviewer.Rect}.
         * @param {Number|XLviewer.Rect} imageX - The left coordinate or rectangle in image coordinate system.
         * @param {Number} [imageY] - The top coordinate in image coordinate system.
         * @param {Number} [pixelWidth] - The width in pixel of the rectangle.
         * @param {Number} [pixelHeight] - The height in pixel of the rectangle.
         * @param {Boolean} [current=false] - Pass true to use the current location; false for target location.
         * @return {XLviewer.Rect} A rect representing the coordinates in the viewport.
         */
        imageToViewportRectangle: function( imageX, imageY, pixelWidth, pixelHeight, current ) {
            var rect = imageX;
            if (rect instanceof xlv.Rect) {
                //they passed a rect instead of individual components
                current = imageY;
            } else {
                rect = new xlv.Rect(imageX, imageY, pixelWidth, pixelHeight);
            }

            var coordA = this.imageToViewportCoordinates(rect.getTopLeft(), current);
            var coordB = this._imageToViewportDelta(rect.width, rect.height, current);

            return new xlv.Rect(
                coordA.x,
                coordA.y,
                coordB.x,
                coordB.y,
                rect.rotation
            );
        },

        /**
         * Translates from a rectangle which describes a portion of
         * the viewport in point coordinates to image rectangle coordinates.
         * This method can be called either by passing X,Y,width,height or an {@link XLviewer.Rect}.
         * @param {Number|XLviewer.Rect} viewerX - The left coordinate or rectangle in viewport coordinate system.
         * @param {Number} [viewerY] - The top coordinate in viewport coordinate system.
         * @param {Number} [pointWidth] - The width in viewport coordinate system.
         * @param {Number} [pointHeight] - The height in viewport coordinate system.
         * @param {Boolean} [current=false] - Pass true to use the current location; false for target location.
         * @return {XLviewer.Rect} A rect representing the coordinates in the image.
         */
        viewportToImageRectangle: function( viewerX, viewerY, pointWidth, pointHeight, current ) {
            var rect = viewerX;
            if (viewerX instanceof xlv.Rect) {
                //they passed a rect instead of individual components
                current = viewerY;
            } else {
                rect = new xlv.Rect(viewerX, viewerY, pointWidth, pointHeight);
            }

            var coordA = this.viewportToImageCoordinates(rect.getTopLeft(), current);
            var coordB = this._viewportToImageDelta(rect.width, rect.height, current);

            return new xlv.Rect(
                coordA.x,
                coordA.y,
                coordB.x,
                coordB.y,
                rect.rotation
            );
        },

        /**
         * Convert pixel coordinates relative to the viewer element to image
         * coordinates.
         * @param {XLviewer.Point} pixel
         * @returns {XLviewer.Point}
         */
        viewerElementToImageCoordinates: function( pixel ) {
            var point = this.viewport.pointFromPixel( pixel, true );
            return this.viewportToImageCoordinates( point );
        },

        /**
         * Convert pixel coordinates relative to the image to
         * viewer element coordinates.
         * @param {XLviewer.Point} pixel
         * @returns {XLviewer.Point}
         */
        imageToViewerElementCoordinates: function( pixel ) {
            var point = this.imageToViewportCoordinates( pixel );
            return this.viewport.pixelFromPoint( point, true );
        },

        /**
         * Convert pixel coordinates relative to the window to image coordinates.
         * @param {XLviewer.Point} pixel
         * @returns {XLviewer.Point}
         */
        windowToImageCoordinates: function( pixel ) {
            var viewerCoordinates = pixel.minus(
                XLviewer.getElementPosition( this.viewer.element ));
            return this.viewerElementToImageCoordinates( viewerCoordinates );
        },

        /**
         * Convert image coordinates to pixel coordinates relative to the window.
         * @param {XLviewer.Point} pixel
         * @returns {XLviewer.Point}
         */
        imageToWindowCoordinates: function( pixel ) {
            var viewerCoordinates = this.imageToViewerElementCoordinates( pixel );
            return viewerCoordinates.plus(
                XLviewer.getElementPosition( this.viewer.element ));
        },

        /**
         * Convert a viewport zoom to an image zoom.
         * Image zoom: ratio of the original image size to displayed image size.
         * 1 means original image size, 0.5 half size...
         * Viewport zoom: ratio of the displayed image's width to viewport's width.
         * 1 means identical width, 2 means image's width is twice the viewport's width...
         * @function
         * @param {Number} viewportZoom The viewport zoom
         * @returns {Number} imageZoom The image zoom
         */
        viewportToImageZoom: function( viewportZoom ) {
            var ratio = this._scaleSpring.current.value *
                this.viewport._containerInnerSize.x / this.source.dimensions.x;
            return ratio * viewportZoom ;
        },

        /**
         * Convert an image zoom to a viewport zoom.
         * Image zoom: ratio of the original image size to displayed image size.
         * 1 means original image size, 0.5 half size...
         * Viewport zoom: ratio of the displayed image's width to viewport's width.
         * 1 means identical width, 2 means image's width is twice the viewport's width...
         * Note: not accurate with multi-image.
         * @function
         * @param {Number} imageZoom The image zoom
         * @returns {Number} viewportZoom The viewport zoom
         */
        imageToViewportZoom: function( imageZoom ) {
            var ratio = this._scaleSpring.current.value *
                this.viewport._containerInnerSize.x / this.source.dimensions.x;
            return imageZoom / ratio;
        },

        /**
         * Sets the TiledImage's position in the manager.
         * @param {XLviewer.Point} position - The new position, in viewport coordinates.
         * @param {Boolean} [immediately=false] - Whether to animate to the new position or snap immediately.
         * @fires XLviewer.TiledImage.event:bounds-change
         */
        setPosition: function(position, immediately) {
            var sameTarget = (this._xSpring.target.value === position.x &&
                this._ySpring.target.value === position.y);

            if (immediately) {
                if (sameTarget && this._xSpring.current.value === position.x &&
                    this._ySpring.current.value === position.y) {
                    return;
                }

                this._xSpring.resetTo(position.x);
                this._ySpring.resetTo(position.y);
                this._needsDraw = true;
            } else {
                if (sameTarget) {
                    return;
                }

                this._xSpring.springTo(position.x);
                this._ySpring.springTo(position.y);
                this._needsDraw = true;
            }

            if (!sameTarget) {
                this._raiseBoundsChange();
            }
        },

        /**
         * Sets the TiledImage's width in the manager, adjusting the height to match based on aspect ratio.
         * @param {Number} width - The new width, in viewport coordinates.
         * @param {Boolean} [immediately=false] - Whether to animate to the new size or snap immediately.
         * @fires XLviewer.TiledImage.event:bounds-change
         */
        setWidth: function(width, immediately) {
            this._setScale(width, immediately);
        },

        /**
         * Sets the TiledImage's height in the manager, adjusting the width to match based on aspect ratio.
         * @param {Number} height - The new height, in viewport coordinates.
         * @param {Boolean} [immediately=false] - Whether to animate to the new size or snap immediately.
         * @fires XLviewer.TiledImage.event:bounds-change
         */
        setHeight: function(height, immediately) {
            this._setScale(height / this.normHeight, immediately);
        },

        /**
         * Positions and scales the TiledImage to fit in the specified bounds.
         * Note: this method fires XLviewer.TiledImage.event:bounds-change
         * twice
         * @param {XLviewer.Rect} bounds The bounds to fit the image into.
         * @param {XLviewer.Placement} [anchor=XLviewer.Placement.CENTER]
         * How to anchor the image in the bounds.
         * @param {Boolean} [immediately=false] Whether to animate to the new size
         * or snap immediately.
         * @fires XLviewer.TiledImage.event:bounds-change
         */
        fitBounds: function(bounds, anchor, immediately) {
            anchor = anchor || xlv.Placement.CENTER;
            var anchorProperties = xlv.Placement.properties[anchor];
            var aspectRatio = this.contentAspectX;
            var xOffset = 0;
            var yOffset = 0;
            var displayedWidthRatio = 1;
            var displayedHeightRatio = 1;
            if (this._clip) {
                aspectRatio = this._clip.getAspectRatio();
                displayedWidthRatio = this._clip.width / this.source.dimensions.x;
                displayedHeightRatio = this._clip.height / this.source.dimensions.y;
                if (bounds.getAspectRatio() > aspectRatio) {
                    xOffset = this._clip.x / this._clip.height * bounds.height;
                    yOffset = this._clip.y / this._clip.height * bounds.height;
                } else {
                    xOffset = this._clip.x / this._clip.width * bounds.width;
                    yOffset = this._clip.y / this._clip.width * bounds.width;
                }
            }

            if (bounds.getAspectRatio() > aspectRatio) {
                // We will have margins on the X axis
                var height = bounds.height / displayedHeightRatio;
                var marginLeft = 0;
                if (anchorProperties.isHorizontallyCentered) {
                    marginLeft = (bounds.width - bounds.height * aspectRatio) / 2;
                } else if (anchorProperties.isRight) {
                    marginLeft = bounds.width - bounds.height * aspectRatio;
                }
                this.setPosition(
                    new xlv.Point(bounds.x - xOffset + marginLeft, bounds.y - yOffset),
                    immediately);
                this.setHeight(height, immediately);
            } else {
                // We will have margins on the Y axis
                var width = bounds.width / displayedWidthRatio;
                var marginTop = 0;
                if (anchorProperties.isVerticallyCentered) {
                    marginTop = (bounds.height - bounds.width / aspectRatio) / 2;
                } else if (anchorProperties.isBottom) {
                    marginTop = bounds.height - bounds.width / aspectRatio;
                }
                this.setPosition(
                    new xlv.Point(bounds.x - xOffset, bounds.y - yOffset + marginTop),
                    immediately);
                this.setWidth(width, immediately);
            }
        },

        /**
         * @returns {XLviewer.Rect|null} The TiledImage's current clip rectangle,
         * in image pixels, or null if none.
         */
        getClip: function() {
            if (this._clip) {
                return this._clip.clone();
            }

            return null;
        },

        /**
         * @param {XLviewer.Rect|null} newClip - An area, in image pixels, to clip to
         * (portions of the image outside of this area will not be visible). Only works on
         * browsers that support the HTML5 canvas.
         */
        setClip: function(newClip) {
            xlv.log.d(!newClip || newClip instanceof xlv.Rect,
                "[TiledImage.setClip] newClip must be an XLviewer.Rect or null");

            if (newClip instanceof xlv.Rect) {
                this._clip = newClip.clone();
            } else {
                this._clip = null;
            }

            this._needsDraw = true;
        },

        /**
         * @returns {Number} The TiledImage's current opacity.
         */
        getOpacity: function() {
            return this.opacity;
        },

        /**
         * @param {Number} opacity Opacity the tiled image should be drawn at.
         */
        setOpacity: function(opacity) {
            this.opacity = opacity;
            this._needsDraw = true;
        },

        /**
         * @returns {String} The TiledImage's current blendingType.
         */
        getCompositeOperation: function() {
            return this.blendingType;
        },

        /**
         * @param {String} blendingType the tiled image should be drawn with this globalCompositeOperation.
         */
        setCompositeOperation: function(blendingType) {
            this.blendingType = blendingType;
            this._needsDraw = true;
        },

        // private
        _setScale: function(scale, immediately) {
            var sameTarget = (this._scaleSpring.target.value === scale);
            if (immediately) {
                if (sameTarget && this._scaleSpring.current.value === scale) {
                    return;
                }

                this._scaleSpring.resetTo(scale);
                this._updateForScale();
                this._needsDraw = true;
            } else {
                if (sameTarget) {
                    return;
                }

                this._scaleSpring.springTo(scale);
                this._updateForScale();
                this._needsDraw = true;
            }

            if (!sameTarget) {
                this._raiseBoundsChange();
            }
        },

        // private
        _updateForScale: function() {
            this._worldWidthTarget = this._scaleSpring.target.value;
            this._worldHeightTarget = this.normHeight * this._scaleSpring.target.value;
            this._worldWidthCurrent = this._scaleSpring.current.value;
            this._worldHeightCurrent = this.normHeight * this._scaleSpring.current.value;
        },

        // private
        _raiseBoundsChange: function() {
            /**
             * Raised when the TiledImage's bounds are changed.
             * Note that this event is triggered only when the animation target is changed;
             * not for every frame of animation.
             * @event bounds-change
             * @memberOf XLviewer.TiledImage
             * @type {object}
             * @property {XLviewer.World} eventSource - A reference to the TiledImage which raised the event.
             * @property {?Object} userData - Arbitrary subscriber-defined object.
             */
            this.dispatchEvent('boundsChange');
        },

        // private
        _isBottomItem: function() {
            return this.viewer.manager.getItemAt(0) === this;
        }
    });

    /**
     * @private
     * @inner
     * Pretty much every other line in this needs to be documented so it's clear
     * how each piece of this routine contributes to the drawing process.  That's
     * why there are so many TODO's inside this function.
     */
    function updateViewport( tiledImage ) {

        tiledImage._needsDraw = false;

        var tile,
            level,
            best            = null,
            haveDrawn       = false,
            currentTime     = xlv.Utils.now(),
            viewportBounds  = tiledImage.viewport.getBoundsWithMargins( true ),
            zeroRatioC      = tiledImage.viewport.deltaPixelsFromPointsNoRotate(
                tiledImage.source.getPixelRatio( 0 ),
                true
            ).x * tiledImage._scaleSpring.current.value,
            lowestLevel     = Math.max(
                tiledImage.source.minLevel,
                Math.floor(
                    Math.log( tiledImage.underZoomRatio ) /
                    Math.log( 2 )
                )
            ),
            highestLevel    = Math.min(
                Math.abs(tiledImage.source.maxLevel),
                Math.abs(Math.floor(
                    Math.log( zeroRatioC / tiledImage.minPixelRatio ) /
                    Math.log( 2 )
                ))
            ),
            rotation         = tiledImage.viewport.rotation,
            renderPixelRatioC,
            renderPixelRatioT,
            zeroRatioT,
            optimalRatio,
            levelOpacity,
            levelVisibility;

        viewportBounds.x -= tiledImage._xSpring.current.value;
        viewportBounds.y -= tiledImage._ySpring.current.value;

        // Reset tile's internal drawn state
        while ( tiledImage.lastDrawn.length > 0 ) {
            tile = tiledImage.lastDrawn.pop();
            tile.beingDrawn = false;
        }

        //Change bounds for rotation
        if (rotation === 90 || rotation === 270) {
            viewportBounds = viewportBounds.rotate( rotation );
        } else if (rotation !== 0 && rotation !== 180) {
            // This is just an approximation.
            var orthBounds = viewportBounds.rotate(90);
            viewportBounds.x -= orthBounds.width / 2;
            viewportBounds.y -= orthBounds.height / 2;
            viewportBounds.width += orthBounds.width;
            viewportBounds.height += orthBounds.height;
        }

        var viewportTL = viewportBounds.getTopLeft();
        var viewportBR = viewportBounds.getBottomRight();

        //Don't draw if completely outside of the viewport
        if  ( !tiledImage.wrapHorizontal && (viewportBR.x < 0 || viewportTL.x > tiledImage._worldWidthCurrent ) ) {
            return;
        }

        if ( !tiledImage.wrapVertical && ( viewportBR.y < 0 || viewportTL.y > tiledImage._worldHeightCurrent ) ) {
            return;
        }

        // Calculate viewport rect / bounds
        if ( !tiledImage.wrapHorizontal ) {
            viewportTL.x = Math.max( viewportTL.x, 0 );
            viewportBR.x = Math.min( viewportBR.x, tiledImage._worldWidthCurrent );
        }

        if ( !tiledImage.wrapVertical ) {
            viewportTL.y = Math.max( viewportTL.y, 0 );
            viewportBR.y = Math.min( viewportBR.y, tiledImage._worldHeightCurrent );
        }

        // Calculations for the interval of levels to draw
        // (above in initial var statement)
        // can return invalid intervals; fix that here if necessary
        lowestLevel = Math.min( lowestLevel, highestLevel );

        // Update any level that will be drawn
        var drawLevel; // FIXME: drawLevel should have a more explanatory name
        for ( level = highestLevel; level >= lowestLevel; level-- ) {
            drawLevel = false;

            //Avoid calculations for draw if we have already drawn this
            renderPixelRatioC = tiledImage.viewport.deltaPixelsFromPointsNoRotate(
                tiledImage.source.getPixelRatio( level ),
                true
            ).x * tiledImage._scaleSpring.current.value;

            if ( ( !haveDrawn && renderPixelRatioC >= tiledImage.minPixelRatio ) ||
                ( level == lowestLevel ) ) {
                drawLevel = true;
                haveDrawn = true;
            } else if ( !haveDrawn ) {
                continue;
            }

            //Perform calculations for draw if we haven't drawn this
            renderPixelRatioT = tiledImage.viewport.deltaPixelsFromPointsNoRotate(
                tiledImage.source.getPixelRatio( level ),
                false
            ).x * tiledImage._scaleSpring.current.value;

            zeroRatioT      = tiledImage.viewport.deltaPixelsFromPointsNoRotate(
                tiledImage.source.getPixelRatio(
                    Math.max(
                        tiledImage.source.getClosestLevel( tiledImage.viewport.containerSize ) - 1,
                        0
                    )
                ),
                false
            ).x * tiledImage._scaleSpring.current.value;

            optimalRatio    = tiledImage.noWaitForRendering ?
                1 :
                zeroRatioT;

            levelOpacity    = Math.min( 1, ( renderPixelRatioC - 0.5 ) / 0.5 );

            levelVisibility = optimalRatio / Math.abs(
                optimalRatio - renderPixelRatioT
            );

            // Update the level and keep track of 'best' tile to load
            best = updateLevel(
                tiledImage,
                haveDrawn,
                drawLevel,
                level,
                levelOpacity,
                levelVisibility,
                viewportTL,
                viewportBR,
                currentTime,
                best
            );

            // Stop the loop if lower-res tiles would all be covered by
            // already drawn tiles
            if (  providesCoverage( tiledImage.coverage, level ) ) {
                break;
            }
        }

        // Perform the actual drawing
        drawTiles( tiledImage, tiledImage.lastDrawn );

        // Load the new 'best' tile
        if (best && !best.context2D) {
            loadTile( tiledImage, best, currentTime );
        }

    }


    function updateLevel( tiledImage, haveDrawn, drawLevel, level, levelOpacity, levelVisibility, viewportTL, viewportBR, currentTime, best ){

        var x, y,
            tileTL,
            tileBR,
            numberOfTiles,
            viewportCenter  = tiledImage.viewport.pixelFromPoint( tiledImage.viewport.getCenter() );


        if( tiledImage.viewer ){
            /**
             * <em>- Needs documentation -</em>
             *
             * @event update-level
             * @memberof XLviewer.Viewer
             * @type {object}
             * @property {XLviewer.Viewer} eventSource - A reference to the Viewer which raised the event.
             * @property {XLviewer.TiledImage} tiledImage - Which TiledImage is being drawn.
             * @property {Object} havedrawn
             * @property {Object} level
             * @property {Object} opacity
             * @property {Object} visibility
             * @property {Object} topleft
             * @property {Object} bottomright
             * @property {Object} currenttime
             * @property {Object} best
             * @property {?Object} userData - Arbitrary subscriber-defined object.
             */
            tiledImage.viewer.dispatchEvent( 'updateLevel', {
                tiledImage: tiledImage,
                havedrawn: haveDrawn,
                level: level,
                opacity: levelOpacity,
                visibility: levelVisibility,
                topleft: viewportTL,
                bottomright: viewportBR,
                currenttime: currentTime,
                best: best
            });
        }

        //OK, a new drawing so do your calculations
        tileTL    = tiledImage.source.getTileAtPoint( level, viewportTL.divide( tiledImage._scaleSpring.current.value ));
        tileBR    = tiledImage.source.getTileAtPoint( level, viewportBR.divide( tiledImage._scaleSpring.current.value ));
        numberOfTiles  = tiledImage.source.getNumTiles( level );

        resetCoverage( tiledImage.coverage, level );

        if ( !tiledImage.wrapHorizontal ) {
            tileBR.x = Math.min( tileBR.x, numberOfTiles.x - 1 );
        }
        if ( !tiledImage.wrapVertical ) {
            tileBR.y = Math.min( tileBR.y, numberOfTiles.y - 1 );
        }
        for ( x = tileTL.x; x <= tileBR.x; x++ ) {
            for ( y = tileTL.y; y <= tileBR.y; y++ ) {

                best = updateTile(
                    tiledImage,
                    drawLevel,
                    haveDrawn,
                    x, y, tiledImage.quality,
                    level,
                    levelOpacity,
                    levelVisibility,
                    viewportCenter,
                    numberOfTiles,
                    currentTime,
                    best
                );

            }
        }

        return best;
    }

    function updateTile( tiledImage, drawLevel, haveDrawn, x, y, quality, level, levelOpacity, levelVisibility, viewportCenter, numberOfTiles, currentTime, best){

        var tile = getTile(
            x, y,
            level,
            tiledImage.source,
            tiledImage.tilesMatrix,
            currentTime,
            numberOfTiles,
            tiledImage._worldWidthCurrent,
            tiledImage._worldHeightCurrent,
            quality
            ),
            drawTile = drawLevel;

        if( tiledImage.viewer ){
            /**
             * <em>- Needs documentation -</em>
             *
             * @event update-tile
             * @memberof XLviewer.Viewer
             * @type {object}
             * @property {XLviewer.Viewer} eventSource - A reference to the Viewer which raised the event.
             * @property {XLviewer.TiledImage} tiledImage - Which TiledImage is being drawn.
             * @property {XLviewer.Tile} tile
             * @property {?Object} userData - Arbitrary subscriber-defined object.
             */
            tiledImage.viewer.dispatchEvent( 'updateTile', {
                tiledImage: tiledImage,
                tile: tile
            });
        }

        setCoverage( tiledImage.coverage, level, x, y, false );

        if ( !tile.exists ) {
            return best;
        }

        if ( haveDrawn && !drawTile ) {
            if ( isCovered( tiledImage.coverage, level, x, y ) ) {
                setCoverage( tiledImage.coverage, level, x, y, true );
            } else {
                drawTile = true;
            }
        }

        if ( !drawTile ) {
            return best;
        }

        positionTile(
            tile,
            tiledImage.source.tileOverlap,
            tiledImage.viewport,
            viewportCenter,
            levelVisibility,
            tiledImage
        );

        if (!tile.loaded) {
            if (tile.context2D) {
                setTileLoaded(tiledImage, tile);
            } else {
                var imageRecord = tiledImage._tileCache.getImageRecord(tile.url);
                if (imageRecord) {
                    var image = imageRecord.getImage();
                    setTileLoaded(tiledImage, tile, image);
                }
            }
        }

        if ( tile.loaded ) {
            var needsDraw = blendTile(
                tiledImage,
                tile,
                x, y,
                level,
                levelOpacity,
                currentTime
            );

            if ( needsDraw ) {
                tiledImage._needsDraw = true;
            }
        } else if ( tile.loading ) {
            // the tile is already in the download queue
            // thanks josh1093 for finally translating this typo
        } else {
            best = compareTiles( best, tile );
        }

        return best;
    }

    function getTile( x, y, level, tileSource, tilesMatrix, time, numTiles, worldWidth, worldHeight, quality ) {
        var xMod,
            yMod,
            bounds,
            exists,
            url,
            context2D,
            tile;

        if ( !tilesMatrix[ level ] ) {
            tilesMatrix[ level ] = {};
        }
        if ( !tilesMatrix[ level ][ x ] ) {
            tilesMatrix[ level ][ x ] = {};
        }

        if ( !tilesMatrix[ level ][ x ][ y ] ) {
            xMod    = ( numTiles.x + ( x % numTiles.x ) ) % numTiles.x;
            yMod    = ( numTiles.y + ( y % numTiles.y ) ) % numTiles.y;
            bounds  = tileSource.getTileBounds( level, xMod, yMod );
            exists  = tileSource.tileExists( level, xMod, yMod );
            url     = tileSource.getTileUrl( level, xMod, yMod, quality );
            context2D = tileSource.getContext2D ?
                tileSource.getContext2D(level, xMod, yMod) : undefined;

            bounds.x += ( x - xMod ) / numTiles.x;
            bounds.y += (worldHeight / worldWidth) * (( y - yMod ) / numTiles.y);

            tilesMatrix[ level ][ x ][ y ] = new xlv.Tile(
                level,
                x,
                y,
                bounds,
                exists,
                url,
                context2D
            );
        }

        tile = tilesMatrix[ level ][ x ][ y ];
        tile.lastTouchTime = time;

        return tile;
    }

    function loadTile( tiledImage, tile, time ) {
        tile.loading = true;
        tiledImage._imageLoader.addJob({
            src: tile.url,
            enableCORS: tiledImage.enableCORS,
            callback: function( image, errorMsg ){
                onTileLoad( tiledImage, tile, time, image, errorMsg );
            },
            abort: function() {
                tile.loading = false;
            }
        });
    }

    function onTileLoad( tiledImage, tile, time, image, errorMsg ) {
        if ( !image ) {
            xlv.log.l( "Tile %s failed to load: %s - error: %s", tile, tile.url, errorMsg );
            /**
             * Triggered when a tile fails to load.
             *
             * @event tile-load-failed
             * @memberof XLviewer.Viewer
             * @type {object}
             * @property {XLviewer.Tile} tile - The tile that failed to load.
             * @property {XLviewer.TiledImage} tiledImage - The tiled image the tile belongs to.
             * @property {number} time - The time in milliseconds when the tile load began.
             * @property {string} message - The error message.
             */
            tiledImage.viewer.dispatchEvent("tileLoadFailed", {tile: tile, tiledImage: tiledImage, time: time, message: errorMsg});
            tile.loading = false;
            tile.exists = false;
            return;
        }

        if ( time < tiledImage.lastResetTime ) {
            xlv.log.l( "Ignoring tile %s loaded before reset: %s", tile, tile.url );
            tile.loading = false;
            return;
        }

        var finish = function() {
            var cutoff = Math.ceil( Math.log(
                tiledImage.source.getTileWidth(tile.level) ) / Math.log( 2 ) );
            setTileLoaded(tiledImage, tile, image, cutoff);
        };

        // Check if we're mid-update; this can happen on IE8 because image load events for
        // cached images happen immediately there
        if ( !tiledImage._midDraw ) {
            finish();
        } else {
            // Wait until after the update, in case caching unloads any tiles
            window.setTimeout( finish, 1);
        }
    }

    function setTileLoaded(tiledImage, tile, image, cutoff) {
        var increment = 0;

        function getCompletionCallback() {
            increment++;
            return completionCallback;
        }

        function completionCallback() {
            increment--;
            if (increment === 0) {
                tile.loading = false;
                tile.loaded = true;
                if (!tile.context2D) {
                    tiledImage._tileCache.cacheTile({
                        image: image,
                        tile: tile,
                        cutoff: cutoff,
                        tiledImage: tiledImage
                    });
                }
                tiledImage._needsDraw = true;
            }
        }

        /**
         * Triggered when a tile has just been loaded in memory. That means that the
         * image has been downloaded and can be modified before being drawn to the canvas.
         *
         * @event tile-loaded
         * @memberof XLviewer.Viewer
         * @type {object}
         * @property {Image} image - The image of the tile.
         * @property {XLviewer.TiledImage} tiledImage - The tiled image of the loaded tile.
         * @property {XLviewer.Tile} tile - The tile which has been loaded.
         * @property {function} getCompletionCallback - A function giving a callback to call
         * when the asynchronous processing of the image is done. The image will be
         * marked as entirely loaded when the callback has been called once for each
         * call to getCompletionCallback.
         */
        tiledImage.viewer.dispatchEvent("tileLoaded", {
            tile: tile,
            tiledImage: tiledImage,
            image: image,
            getCompletionCallback: getCompletionCallback
        });
        // In case the completion callback is never called, we at least force it once.
        getCompletionCallback()();
    }

    function positionTile( tile, overlap, viewport, viewportCenter, levelVisibility, tiledImage ){
        var boundsTL     = tile.bounds.getTopLeft();

        boundsTL.x *= tiledImage._scaleSpring.current.value;
        boundsTL.y *= tiledImage._scaleSpring.current.value;
        boundsTL.x += tiledImage._xSpring.current.value;
        boundsTL.y += tiledImage._ySpring.current.value;

        var boundsSize   = tile.bounds.getSize();

        boundsSize.x *= tiledImage._scaleSpring.current.value;
        boundsSize.y *= tiledImage._scaleSpring.current.value;

        var positionC    = viewport.pixelFromPointNoRotate(boundsTL, true),
            positionT    = viewport.pixelFromPointNoRotate(boundsTL, false),
            sizeC        = viewport.deltaPixelsFromPointsNoRotate(boundsSize, true),
            sizeT        = viewport.deltaPixelsFromPointsNoRotate(boundsSize, false),
            tileCenter   = positionT.plus( sizeT.divide( 2 ) ),
            tileDistance = viewportCenter.distanceTo( tileCenter );

        if ( !overlap ) {
            sizeC = sizeC.plus( new xlv.Point( 1, 1 ) );
        }

        tile.position   = positionC;
        tile.size       = sizeC;
        tile.distance   = tileDistance;
        tile.visibility = levelVisibility;
    }


    function blendTile( tiledImage, tile, x, y, level, levelOpacity, currentTime ){
        var blendTimeMillis = 1000 * tiledImage.blendDuration,
            deltaTime,
            opacity;

        if ( !tile.blendStart ) {
            tile.blendStart = currentTime;
        }

        deltaTime   = currentTime - tile.blendStart;
        opacity     = blendTimeMillis ? Math.min( 1, deltaTime / ( blendTimeMillis ) ) : 1;

        if ( tiledImage.alwaysBlend ) {
            opacity *= levelOpacity;
        }

        tile.opacity = opacity;

        tiledImage.lastDrawn.push( tile );

        if ( opacity == 1 ) {
            setCoverage( tiledImage.coverage, level, x, y, true );
            tiledImage._hasOpaqueTile = true;
        } else if ( deltaTime < blendTimeMillis ) {
            return true;
        }

        return false;
    }

    /**
     * @private
     * @inner
     * Returns true if the given tile provides coverage to lower-level tiles of
     * lower resolution representing the same content. If neither x nor y is
     * given, returns true if the entire visible level provides coverage.
     *
     * Note that out-of-bounds tiles provide coverage in this sense, since
     * there's no content that they would need to cover. Tiles at non-existent
     * levels that are within the image bounds, however, do not.
     */
    function providesCoverage( coverage, level, x, y ) {
        var rows,
            cols,
            i, j;

        if ( !coverage[ level ] ) {
            return false;
        }

        if ( x === undefined || y === undefined ) {
            rows = coverage[ level ];
            for ( i in rows ) {
                if ( rows.hasOwnProperty( i ) ) {
                    cols = rows[ i ];
                    for ( j in cols ) {
                        if ( cols.hasOwnProperty( j ) && !cols[ j ] ) {
                            return false;
                        }
                    }
                }
            }

            return true;
        }

        return (
            coverage[ level ][ x] === undefined ||
            coverage[ level ][ x ][ y ] === undefined ||
            coverage[ level ][ x ][ y ] === true
        );
    }

    /**
     * @private
     * @inner
     * Returns true if the given tile is completely covered by higher-level
     * tiles of higher resolution representing the same content. If neither x
     * nor y is given, returns true if the entire visible level is covered.
     */
    function isCovered( coverage, level, x, y ) {
        if ( x === undefined || y === undefined ) {
            return providesCoverage( coverage, level + 1 );
        } else {
            return (
                providesCoverage( coverage, level + 1, 2 * x, 2 * y ) &&
                providesCoverage( coverage, level + 1, 2 * x, 2 * y + 1 ) &&
                providesCoverage( coverage, level + 1, 2 * x + 1, 2 * y ) &&
                providesCoverage( coverage, level + 1, 2 * x + 1, 2 * y + 1 )
            );
        }
    }

    /**
     * @private
     * @inner
     * Sets whether the given tile provides coverage or not.
     */
    function setCoverage( coverage, level, x, y, covers ) {
        if ( !coverage[ level ] ) {
            xlv.console.warn(
                "Setting coverage for a tile before its level's coverage has been reset: %s",
                level
            );
            return;
        }

        if ( !coverage[ level ][ x ] ) {
            coverage[ level ][ x ] = {};
        }

        coverage[ level ][ x ][ y ] = covers;
    }

    /**
     * @private
     * @inner
     * Resets coverage information for the given level. This should be called
     * after every draw routine. Note that at the beginning of the next draw
     * routine, coverage for every visible tile should be explicitly set.
     */
    function resetCoverage( coverage, level ) {
        coverage[ level ] = {};
    }

    /**
     * @private
     * @inner
     * Determines whether the 'last best' tile for the area is better than the
     * tile in question.
     */
    function compareTiles( previousBest, tile ) {
        if ( !previousBest ) {
            return tile;
        }

        if ( tile.visibility > previousBest.visibility ) {
            return tile;
        } else if ( tile.visibility == previousBest.visibility ) {
            if ( tile.distance < previousBest.distance ) {
                return tile;
            }
        }

        return previousBest;
    }

    function drawTiles( tiledImage, lastDrawn ) {
        if (lastDrawn.length === 0) {
            return;
        }
        var tile = lastDrawn[0];

        var useSketch = tiledImage.opacity < 1 ||
            (tiledImage.blendingType &&
                tiledImage.blendingType !== 'source-over') ||
            (!tiledImage._isBottomItem() && tile._hasTransparencyChannel());

        var sketchScale;
        var sketchTranslate;

        var zoom = tiledImage.viewport.getZoom(true);
        var imageZoom = tiledImage.viewportToImageZoom(zoom);
        if (imageZoom > tiledImage.overZoomRatioForSmoothingTile) {
            // When zoomed in a lot (>100%) the tile edges are visible.
            // So we have to composite them at ~100% and scale them up together.
            useSketch = true;
            sketchScale = tile.getScaleForEdgeSmoothing();
            sketchTranslate = tile.getTranslationForEdgeSmoothing(sketchScale,
                tiledImage._drawer.getCanvasSize(false),
                tiledImage._drawer.getCanvasSize(true));
        }

        if ( useSketch ) {
            tiledImage._drawer._clear( true );
        }

        // When scaling, we must rotate only when blending the sketch canvas to avoid
        // interpolation
        if (tiledImage.viewport.rotation !== 0 && !sketchScale) {
            tiledImage._drawer._offsetForRotation(tiledImage.viewport.rotation, useSketch);
        }

        var usedClip = false;
        if ( tiledImage._clip ) {
            tiledImage._drawer.saveContext(useSketch);

            var box = tiledImage.imageToViewportRectangle(tiledImage._clip, true);
            var clipRect = tiledImage._drawer.viewportToDrawerRectangle(box);
            if (sketchScale) {
                clipRect = clipRect.times(sketchScale);
            }
            if (sketchTranslate) {
                clipRect = clipRect.translate(sketchTranslate);
            }
            tiledImage._drawer.setClip(clipRect, useSketch);

            usedClip = true;
        }

        if ( tiledImage.placeholderFillStyle && tiledImage._hasOpaqueTile === false ) {
            var placeholderRect = tiledImage._drawer.viewportToDrawerRectangle(tiledImage.getBounds(true));
            if (sketchScale) {
                placeholderRect = placeholderRect.times(sketchScale);
            }
            if (sketchTranslate) {
                placeholderRect = placeholderRect.translate(sketchTranslate);
            }

            var fillStyle = null;
            if ( typeof tiledImage.placeholderFillStyle === "function" ) {
                fillStyle = tiledImage.placeholderFillStyle(tiledImage, tiledImage._drawer.context);
            }
            else {
                fillStyle = tiledImage.placeholderFillStyle;
            }

            tiledImage._drawer.drawRectangle(placeholderRect, fillStyle, useSketch);
        }

        for (var i = lastDrawn.length - 1; i >= 0; i--) {
            tile = lastDrawn[ i ];
            tiledImage._drawer.drawTile( tile, tiledImage._drawingHandler, useSketch, sketchScale, sketchTranslate );
            tile.beingDrawn = true;

            if( tiledImage.viewer ){
                /**
                 * <em>- Needs documentation -</em>
                 *
                 * @event tile-drawn
                 * @memberof XLviewer.Viewer
                 * @type {object}
                 * @property {XLviewer.Viewer} eventSource - A reference to the Viewer which raised the event.
                 * @property {XLviewer.TiledImage} tiledImage - Which TiledImage is being drawn.
                 * @property {XLviewer.Tile} tile
                 * @property {?Object} userData - Arbitrary subscriber-defined object.
                 */
                tiledImage.viewer.dispatchEvent( 'tileDrawn', {
                    tiledImage: tiledImage,
                    tile: tile
                });
            }
        }

        if ( usedClip ) {
            tiledImage._drawer.restoreContext( useSketch );
        }

        if (tiledImage.viewport.rotation !== 0 && !sketchScale) {
            tiledImage._drawer._restoreRotationChanges(useSketch);
        }

        if (useSketch) {
            var offsetForRotation = tiledImage.viewport.rotation !== 0 && sketchScale;
            if (offsetForRotation) {
                tiledImage._drawer._offsetForRotation(tiledImage.viewport.rotation, false);
            }
            tiledImage._drawer.blendSketch(tiledImage.opacity, sketchScale, sketchTranslate, tiledImage.blendingType);
            if (offsetForRotation) {
                tiledImage._drawer._restoreRotationChanges(false);
            }
        }
        drawDebugInfo( tiledImage, lastDrawn );
    }

    function drawDebugInfo( tiledImage, lastDrawn ) {
        if( tiledImage.debug ) {
            for ( var i = lastDrawn.length - 1; i >= 0; i-- ) {
                var tile = lastDrawn[ i ];
                try {
                    tiledImage._drawer.drawDebugInfo( tile, lastDrawn.length, i );
                } catch(e) {
                    xlv.log.e(e);
                }
            }
        }
    }

}( XLviewer ));
(function( xlv ){

    xlv.Drawer = function( options ) {

        xlv.log.d( options.viewer, "[Drawer] options.viewer is required" );

        //backward compatibility for positional args while prefering more
        //idiomatic javascript options object as the only argument
        var args  = arguments;

        if( !xlv.Utils.isPlainObject( options ) ){
            options = {
                source:     args[ 0 ], // Reference to Viewer tile source.
                viewport:   args[ 1 ], // Reference to Viewer viewport.
                element:    args[ 2 ]  // Parent element.
            };
        }

        xlv.log.d( options.viewport, "[Drawer] options.viewport is required" );
        xlv.log.d( options.element, "[Drawer] options.element is required" );

        if ( options.source ) {
            xlv.log.e( "[Drawer] options.source is no longer accepted; use TiledImage instead" );
        }

        this.viewer = options.viewer;
        this.viewport = options.viewport;
        this.debugGridColor = options.debugGridColor || xlv.DEFAULT_SETTINGS.debugGridColor;
        if (options.opacity) {
            xlv.log.e( "[Drawer] options.opacity is no longer accepted; set the opacity on the TiledImage instead" );
        }

        this.useCanvas  = xlv.Utils.supportsCanvas && ( this.viewer ? this.viewer.useCanvas : true );
        /**
         * The parent element of this Drawer instance, passed in when the Drawer was created.
         * The parent of {@link XLviewer.Drawer#canvas}.
         * @member {Element} container
         * @memberof XLviewer.Drawer#
         */
        this.container  = xlv.getElement( options.element );
        /**
         * A &lt;canvas&gt; element if the browser supports them, otherwise a &lt;div&gt; element.
         * Child element of {@link XLviewer.Drawer#container}.
         * @member {Element} canvas
         * @memberof XLviewer.Drawer#
         */
        this.canvas     = xlv.makeNeutralElement( this.useCanvas ? "canvas" : "div" );
        /**
         * 2d drawing context for {@link XLviewer.Drawer#canvas} if it's a &lt;canvas&gt; element, otherwise null.
         * @member {Object} context
         * @memberof XLviewer.Drawer#
         */
        this.context    = this.useCanvas ? this.canvas.getContext( "2d" ) : null;

        /**
         * Sketch canvas used to temporarily draw tiles which cannot be drawn directly
         * to the main canvas due to opacity. Lazily initialized.
         */
        this.sketchCanvas = null;
        this.sketchContext = null;

        /**
         * @member {Element} element
         * @memberof XLviewer.Drawer#
         * @deprecated Alias for {@link XLviewer.Drawer#container}.
         */
        this.element    = this.container;

        // We force our container to ltr because our drawing math doesn't work in rtl.
        // This issue only affects our canvas renderer, but we do it always for consistency.
        // Note that this means overlays you want to be rtl need to be explicitly set to rtl.
        this.container.dir = 'ltr';

        // check canvas available width and height, set canvas width and height such that the canvas backing store is set to the proper pixel density
        if (this.useCanvas) {
            var viewportSize = this._calculateCanvasSize();
            this.canvas.width = viewportSize.x;
            this.canvas.height = viewportSize.y;
        }

        this.canvas.style.width     = "100%";
        this.canvas.style.height    = "100%";
        this.canvas.style.position  = "absolute";
        xlv.setElementOpacity( this.canvas, this.opacity, true );

        // explicit left-align
        this.container.style.textAlign = "left";
        this.container.appendChild( this.canvas );


    };

    /** @lends XLviewer.Drawer.prototype */
    xlv.Drawer.prototype = {
        /**
         * Set the opacity of the drawer.
         * @param {Number} opacity
         * @return {XLviewer.Drawer} Chainable.
         */
        setOpacity: function( opacity ) {
            xlv.log.e("drawer.setOpacity is deprecated. Use tiledImage.setOpacity instead.");
            var manager = this.viewer.manager;
            for (var i = 0; i < manager.getItemCount(); i++) {
                manager.getItemAt( i ).setOpacity( opacity );
            }
            return this;
        },

        /**
         * Get the opacity of the drawer.
         * @returns {Number}
         */
        getOpacity: function() {
            xlv.log.e("drawer.getOpacity is deprecated. Use tiledImage.getOpacity instead.");
            var manager = this.viewer.manager;
            var maxOpacity = 0;
            for (var i = 0; i < manager.getItemCount(); i++) {
                var opacity = manager.getItemAt( i ).getOpacity();
                if ( opacity > maxOpacity ) {
                    maxOpacity = opacity;
                }
            }
            return maxOpacity;
        },
        /**
         * @return {Boolean} True if rotation is supported.
         */
        canRotate: function() {
            return this.useCanvas;
        },

        /**
         * Destroy the drawer (unload current loaded tiles)
         */
        destroy: function() {
            //force unloading of current canvas (1x1 will be gc later, trick not necessarily needed)
            this.canvas.width  = 1;
            this.canvas.height = 1;
            this.sketchCanvas = null;
            this.sketchContext = null;
        },

        /**
         * Clears the Drawer so it's ready to draw another frame.
         */
        clear: function() {
            this.canvas.innerHTML = "";
            if ( this.useCanvas ) {
                var viewportSize = this._calculateCanvasSize();
                if( this.canvas.width != viewportSize.x ||
                    this.canvas.height != viewportSize.y ) {
                    this.canvas.width = viewportSize.x;
                    this.canvas.height = viewportSize.y;
                    if ( this.sketchCanvas !== null ) {
                        var sketchCanvasSize = this._calculateSketchCanvasSize();
                        this.sketchCanvas.width = sketchCanvasSize.x;
                        this.sketchCanvas.height = sketchCanvasSize.y;
                    }
                }
                this._clear();
            }
        },

        _clear: function ( useSketch ) {
            if ( !this.useCanvas ) {
                return;
            }
            var context = this._getContext( useSketch );
            var canvas = context.canvas;
            context.clearRect( 0, 0, canvas.width, canvas.height );
        },

        /**
         * Scale from XLviewer viewer rectangle to drawer rectangle
         * (ignoring rotation)
         * @param {XLviewer.Rect} rectangle - The rectangle in viewport coordinate system.
         * @return {XLviewer.Rect} Rectangle in drawer coordinate system.
         */
        viewportToDrawerRectangle: function(rectangle) {
            var topLeft = this.viewport.pixelFromPointNoRotate(rectangle.getTopLeft(), true);
            var size = this.viewport.deltaPixelsFromPointsNoRotate(rectangle.getSize(), true);

            return new xlv.Rect(
                topLeft.x * xlv.Utils.pixelDensityRatio,
                topLeft.y * xlv.Utils.pixelDensityRatio,
                size.x    * xlv.Utils.pixelDensityRatio,
                size.y    * xlv.Utils.pixelDensityRatio
            );
        },

        /**
         * Draws the given tile.
         * @param {XLviewer.Tile} tile - The tile to draw.
         * @param {Function} drawingHandler - Method for firing the drawing event if using canvas.
         * drawingHandler({context, tile, rendered})
         * @param {Boolean} useSketch - Whether to use the sketch canvas or not.
         * where <code>rendered</code> is the context with the pre-drawn image.
         * @param {Float} [scale=1] - Apply a scale to tile position and size. Defaults to 1.
         * @param {XLviewer.Point} [translate] A translation vector to offset tile position
         */
        drawTile: function(tile, drawingHandler, useSketch, scale, translate) {
            xlv.log.d(tile, '[Drawer.drawTile] tile is required');
            xlv.log.d(drawingHandler, '[Drawer.drawTile] drawingHandler is required');

            if (this.useCanvas) {
                var context = this._getContext(useSketch);
                scale = scale || 1;
                tile.drawCanvas(context, drawingHandler, scale, translate);
            } else {
                tile.drawHTML( this.canvas );
            }
        },

        _getContext: function( useSketch ) {
            var context = this.context;
            if ( useSketch ) {
                if (this.sketchCanvas === null) {
                    this.sketchCanvas = document.createElement( "canvas" );
                    var sketchCanvasSize = this._calculateSketchCanvasSize();
                    this.sketchCanvas.width = sketchCanvasSize.x;
                    this.sketchCanvas.height = sketchCanvasSize.y;
                    this.sketchContext = this.sketchCanvas.getContext( "2d" );

                    // If the viewport is not currently rotated, the sketchCanvas
                    // will have the same size as the main canvas. However, if
                    // the viewport get rotated later on, we will need to resize it.
                    if (this.viewport.getRotation() === 0) {
                        var self = this;
                        this.viewer.addListener('rotate', function resizeSketchCanvas() {
                            self.viewer.removeListener('rotate', resizeSketchCanvas);
                            var sketchCanvasSize = self._calculateSketchCanvasSize();
                            self.sketchCanvas.width = sketchCanvasSize.x;
                            self.sketchCanvas.height = sketchCanvasSize.y;
                        });
                    }
                }
                context = this.sketchContext;
            }
            return context;
        },

        // private
        saveContext: function( useSketch ) {
            if (!this.useCanvas) {
                return;
            }

            this._getContext( useSketch ).save();
        },

        // private
        restoreContext: function( useSketch ) {
            if (!this.useCanvas) {
                return;
            }

            this._getContext( useSketch ).restore();
        },

        // private
        setClip: function(rect, useSketch) {
            if (!this.useCanvas) {
                return;
            }

            var context = this._getContext( useSketch );
            context.beginPath();
            context.rect(rect.x, rect.y, rect.width, rect.height);
            context.clip();
        },

        // private
        drawRectangle: function(rect, fillStyle, useSketch) {
            if (!this.useCanvas) {
                return;
            }

            var context = this._getContext( useSketch );
            context.save();
            context.fillStyle = fillStyle;
            context.fillRect(rect.x, rect.y, rect.width, rect.height);
            context.restore();
        },

        /**
         * Blends the sketch canvas in the main canvas.
         * @param {Float} opacity The opacity of the blending.
         * @param {Float} [scale=1] The scale at which tiles were drawn on the sketch. Default is 1.
         *   Use scale to draw at a lower scale and then enlarge onto the main canvas.
         * @param {XLviewer.Point} [translate] A translation vector that was used to draw the tiles
         * @param {String} [options.blendingType] - How the image is composited onto other images; see blendingType in {@link XLviewer.Options} for possible values.
         * @returns {undefined}
         */
        blendSketch: function(opacity, scale, translate, blendingType) {
            if (!this.useCanvas || !this.sketchCanvas) {
                return;
            }
            scale = scale || 1;
            var position = translate instanceof xlv.Point ?
                translate :
                new xlv.Point(0, 0);

            var widthExt = 0;
            var heightExt = 0;
            if (translate) {
                var widthDiff = this.sketchCanvas.width - this.canvas.width;
                var heightDiff = this.sketchCanvas.height - this.canvas.height;
                widthExt = Math.round(widthDiff / 2);
                heightExt = Math.round(heightDiff / 2);
            }

            this.context.save();
            this.context.globalAlpha = opacity;
            if (blendingType) {
                this.context.globalCompositeOperation = blendingType;
            }
            this.context.drawImage(
                this.sketchCanvas,
                position.x - widthExt * scale,
                position.y - heightExt * scale,
                (this.canvas.width + 2 * widthExt) * scale,
                (this.canvas.height  + 2 * heightExt) * scale,
                -widthExt,
                -heightExt,
                this.canvas.width + 2 * widthExt,
                this.canvas.height + 2 * heightExt
            );
            this.context.restore();
        },

        // private
        drawDebugInfo: function( tile, count, i ){
            if ( !this.useCanvas ) {
                return;
            }

            var context = this.context;
            context.save();
            context.lineWidth = 2 * xlv.Utils.pixelDensityRatio;
            context.font = 'small-caps bold ' + (13 * xlv.Utils.pixelDensityRatio) + 'px arial';
            context.strokeStyle = this.debugGridColor;
            context.fillStyle = this.debugGridColor;

            if ( this.viewport.rotation !== 0 ) {
                this._offsetForRotation(this.viewport.rotation);
            }

            context.strokeRect(
                tile.position.x * xlv.Utils.pixelDensityRatio,
                tile.position.y * xlv.Utils.pixelDensityRatio,
                tile.size.x * xlv.Utils.pixelDensityRatio,
                tile.size.y * xlv.Utils.pixelDensityRatio
            );

            var tileCenterX = (tile.position.x + (tile.size.x / 2)) * xlv.Utils.pixelDensityRatio;
            var tileCenterY = (tile.position.y + (tile.size.y / 2)) * xlv.Utils.pixelDensityRatio;

            // Rotate the text the right way around.
            context.translate( tileCenterX, tileCenterY );
            context.rotate( Math.PI / 180 * -this.viewport.rotation );
            context.translate( -tileCenterX, -tileCenterY );

            if( tile.x === 0 && tile.y === 0 ){
                context.fillText(
                    "Zoom: " + this.viewport.getZoom(),
                    tile.position.x * xlv.Utils.pixelDensityRatio,
                    (tile.position.y - 30) * xlv.Utils.pixelDensityRatio
                );
                context.fillText(
                    "Pan: " + this.viewport.getBounds().toString(),
                    tile.position.x * xlv.Utils.pixelDensityRatio,
                    (tile.position.y - 20) * xlv.Utils.pixelDensityRatio
                );
            }
            context.fillText(
                "Level: " + tile.level,
                (tile.position.x + 10) * xlv.Utils.pixelDensityRatio,
                (tile.position.y + 20) * xlv.Utils.pixelDensityRatio
            );
            context.fillText(
                "Column: " + tile.x,
                (tile.position.x + 10) * xlv.Utils.pixelDensityRatio,
                (tile.position.y + 30) * xlv.Utils.pixelDensityRatio
            );
            context.fillText(
                "Row: " + tile.y,
                (tile.position.x + 10) * xlv.Utils.pixelDensityRatio,
                (tile.position.y + 40) * xlv.Utils.pixelDensityRatio
            );
            context.fillText(
                "Order: " + i + " of " + count,
                (tile.position.x + 10) * xlv.Utils.pixelDensityRatio,
                (tile.position.y + 50) * xlv.Utils.pixelDensityRatio
            );
            context.fillText(
                "Size: " + tile.size.toString(),
                (tile.position.x + 10) * xlv.Utils.pixelDensityRatio,
                (tile.position.y + 60) * xlv.Utils.pixelDensityRatio
            );
            context.fillText(
                "Position: " + tile.position.toString(),
                (tile.position.x + 10) * xlv.Utils.pixelDensityRatio,
                (tile.position.y + 70) * xlv.Utils.pixelDensityRatio
            );

            if ( this.viewport.rotation !== 0 ) {
                this._restoreRotationChanges();
            }
            context.restore();
        },

        // private
        debugRect: function(rect) {
            if ( this.useCanvas ) {
                var context = this.context;
                context.save();
                context.lineWidth = 2 * xlv.Utils.pixelDensityRatio;
                context.strokeStyle = this.debugGridColor;
                context.fillStyle = this.debugGridColor;

                context.strokeRect(
                    rect.x * xlv.Utils.pixelDensityRatio,
                    rect.y * xlv.Utils.pixelDensityRatio,
                    rect.width * xlv.Utils.pixelDensityRatio,
                    rect.height * xlv.Utils.pixelDensityRatio
                );

                context.restore();
            }
        },

        /**
         * Get the canvas size
         * @param {Boolean} sketch If set to true return the size of the sketch canvas
         * @returns {XLviewer.Point} The size of the canvas
         */
        getCanvasSize: function(sketch) {
            var canvas = this._getContext(sketch).canvas;
            return new xlv.Point(canvas.width, canvas.height);
        },

        // private
        _offsetForRotation: function(rotation, useSketch) {
            var cx = this.canvas.width / 2;
            var cy = this.canvas.height / 2;

            var context = this._getContext(useSketch);
            context.save();

            context.translate(cx, cy);
            context.rotate(Math.PI / 180 * rotation);
            context.translate(-cx, -cy);
        },

        // private
        _restoreRotationChanges: function(useSketch) {
            var context = this._getContext(useSketch);
            context.restore();
        },

        // private
        _calculateCanvasSize: function() {
            var pixelDensityRatio = xlv.Utils.pixelDensityRatio;
            var viewportSize = this.viewport.getContainerSize();
            return {
                x: viewportSize.x * pixelDensityRatio,
                y: viewportSize.y * pixelDensityRatio
            };
        },

        // private
        _calculateSketchCanvasSize: function() {
            var canvasSize = this._calculateCanvasSize();
            if (this.viewport.getRotation() === 0) {
                return canvasSize;
            }
            // If the viewport is rotated, we need a larger sketch canvas in order
            // to support edge smoothing.
            var sketchCanvasSize = Math.ceil(Math.sqrt(
                canvasSize.x * canvasSize.x +
                canvasSize.y * canvasSize.y));
            return {
                x: sketchCanvasSize,
                y: sketchCanvasSize
            };
        }
    };

}( XLviewer ));
/*
 * XLviewer - Viewport
 *
 * Copyright (C) 2009 CodePlex Foundation
 * Copyright (C) 2010-2013 XLviewer contributors
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */

(function( xlv ){


    /**
     * Handles coordinate-related functionality (zoom, pan, rotation, etc.)
     */
    xlv.Viewport = function( options ) {

        //backward compatibility for positional args while prefering more
        //idiomatic javascript options object as the only argument
        var args = arguments;
        if(  args.length && args[ 0 ] instanceof xlv.Point ){
            options = {
                containerSize:  args[ 0 ],
                contentSize:    args[ 1 ],
                config:         args[ 2 ]
            };
        }

        //options.config and the general config argument are deprecated
        //in favor of the more direct specification of optional settings
        //being passed directly on the options object
        if ( options.config ){
            xlv.extend( true, options, options.config );
            delete options.config;
        }

        this._margins = xlv.extend({
            left: 0,
            top: 0,
            right: 0,
            bottom: 0
        }, options.margins || {});

        delete options.margins;

        xlv.extend( true, this, {

            //required settings
            containerSize:      null,
            contentSize:        null,

            //internal state properties
            zoomPoint:          null,
            viewer:           null,

            //configurable options
            tweenSmoothness:    xlv.DEFAULT_SETTINGS.tweenSmoothness,
            tweenDuration:      xlv.DEFAULT_SETTINGS.tweenDuration,
            underZoomRatio:  xlv.DEFAULT_SETTINGS.underZoomRatio,
            overZoomRatio:  xlv.DEFAULT_SETTINGS.overZoomRatio,
            visibilityRatio:    xlv.DEFAULT_SETTINGS.visibilityRatio,
            wrapHorizontal:     xlv.DEFAULT_SETTINGS.wrapHorizontal,
            wrapVertical:       xlv.DEFAULT_SETTINGS.wrapVertical,
            defaultZoomLevel:   xlv.DEFAULT_SETTINGS.defaultZoomLevel,
            minZoomLevel:       xlv.DEFAULT_SETTINGS.minZoomLevel,
            maxZoomLevel:       xlv.DEFAULT_SETTINGS.maxZoomLevel,
            rotation:            xlv.DEFAULT_SETTINGS.rotation,
            homeFillsViewer:    xlv.DEFAULT_SETTINGS.homeFillsViewer

        }, options );

        this._updateContainerInnerSize();

        this.centerSpringX = new xlv.Tween({
            initial: 0,
            tweenSmoothness: this.tweenSmoothness,
            tweenDuration:   this.tweenDuration
        });
        this.centerSpringY = new xlv.Tween({
            initial: 0,
            tweenSmoothness: this.tweenSmoothness,
            tweenDuration:   this.tweenDuration
        });
        this.zoomSpring    = new xlv.Tween({
            exponential: true,
            initial: 1,
            tweenSmoothness: this.tweenSmoothness,
            tweenDuration:   this.tweenDuration
        });

        this._oldCenterX = this.centerSpringX.current.value;
        this._oldCenterY = this.centerSpringY.current.value;
        this._oldZoom    = this.zoomSpring.current.value;

        this._setContentBounds(new xlv.Rect(0, 0, 1, 1), 1);

        this.doZoomReset(true);
        this.update();
    };

    /** @lends XLviewer.Viewport.prototype */
    xlv.Viewport.prototype = {
        /**
         * Updates the viewport's home bounds and constraints for the given content size.
         * @function
         * @param {XLviewer.Point} contentSize - size of the content in content units
         * @return {XLviewer.Viewport} Chainable.
         * @fires XLviewer.Viewer.event:reset-size
         */
        resetContentSize: function(contentSize) {
            xlv.log.d(contentSize, "[Viewport.resetContentSize] contentSize is required");
            xlv.log.d(contentSize instanceof xlv.Point, "[Viewport.resetContentSize] contentSize must be an XLviewer.Point");
            xlv.log.d(contentSize.x > 0, "[Viewport.resetContentSize] contentSize.x must be greater than 0");
            xlv.log.d(contentSize.y > 0, "[Viewport.resetContentSize] contentSize.y must be greater than 0");

            this._setContentBounds(new xlv.Rect(0, 0, 1, contentSize.y / contentSize.x), contentSize.x);
            return this;
        },

        // deprecated
        setHomeBounds: function(bounds, contentFactor) {
            xlv.log.e("[Viewport.setHomeBounds] this function is deprecated; The content bounds should not be set manually.");
            this._setContentBounds(bounds, contentFactor);
        },

        // Set the viewport's content bounds
        // @param {XLviewer.Rect} bounds - the new bounds in viewport coordinates
        // without rotation
        // @param {Number} contentFactor - how many content units per viewport unit
        // @fires XLviewer.Viewer.event:reset-size
        // @private
        _setContentBounds: function(bounds, contentFactor) {
            xlv.log.d(bounds, "[Viewport._setContentBounds] bounds is required");
            xlv.log.d(bounds instanceof xlv.Rect, "[Viewport._setContentBounds] bounds must be an XLviewer.Rect");
            xlv.log.d(bounds.width > 0, "[Viewport._setContentBounds] bounds.width must be greater than 0");
            xlv.log.d(bounds.height > 0, "[Viewport._setContentBounds] bounds.height must be greater than 0");

            this._contentBoundsNoRotate = bounds.clone();
            this._contentSizeNoRotate = this._contentBoundsNoRotate.getSize().times(
                contentFactor);

            this._contentBounds = bounds.rotate(this.rotation).getBoundingBox();
            this._contentSize = this._contentBounds.getSize().times(contentFactor);
            this._contentAspectRatio = this._contentSize.x / this._contentSize.y;

            if (this.viewer) {
                /**
                 * Raised when the viewer's content size or home bounds are reset
                 * (see {@link XLviewer.Viewport#resetContentSize}).
                 *
                 * @event reset-size
                 * @memberof XLviewer.Viewer
                 * @type {object}
                 * @property {XLviewer.Viewer} eventSource - A reference to the Viewer which raised this event.
                 * @property {XLviewer.Point} contentSize
                 * @property {XLviewer.Rect} contentBounds - Content bounds.
                 * @property {XLviewer.Rect} homeBounds - Content bounds.
                 * Deprecated use contentBounds instead.
                 * @property {Number} contentFactor
                 * @property {?Object} userData - Arbitrary subscriber-defined object.
                 */
                this.viewer.dispatchEvent('resetSize', {
                    contentSize: this._contentSizeNoRotate.clone(),
                    contentFactor: contentFactor,
                    homeBounds: this._contentBoundsNoRotate.clone(),
                    contentBounds: this._contentBounds.clone()
                });
            }
        },

        /**
         * Returns the home zoom in "viewport zoom" value.
         * @function
         * @returns {Number} The home zoom in "viewport zoom".
         */
        getHomeZoom: function() {
            if (this.defaultZoomLevel) {
                return this.defaultZoomLevel;
            }

            var aspectFactor = this._contentAspectRatio / this.getAspectRatio();
            var output;
            if (this.homeFillsViewer) { // fill the viewer and clip the image
                output = aspectFactor >= 1 ? aspectFactor : 1;
            } else {
                output = aspectFactor >= 1 ? 1 : aspectFactor;
            }

            return output / this._contentBounds.width;
        },

        /**
         * Returns the home bounds in viewport coordinates.
         * @function
         * @returns {XLviewer.Rect} The home bounds in vewport coordinates.
         */
        getHomeBounds: function() {
            var center = this._contentBounds.getCenter();
            var width  = 1.0 / this.getHomeZoom();
            var height = width / this.getAspectRatio();

            return new xlv.Rect(
                center.x - (width / 2.0),
                center.y - (height / 2.0),
                width,
                height
            );
        },

        /**
         * @function
         * @param {Boolean} immediately
         * @fires XLviewer.Viewer.event:home
         */
        doZoomReset: function( immediately ) {
            if( this.viewer ){
                /**
                 * Raised when the "home" operation occurs (see {@link XLviewer.Viewport#doZoomReset}).
                 *
                 * @event home
                 * @memberof XLviewer.Viewer
                 * @type {object}
                 * @property {XLviewer.Viewer} eventSource - A reference to the Viewer which raised this event.
                 * @property {Boolean} immediately
                 * @property {?Object} userData - Arbitrary subscriber-defined object.
                 */
                this.viewer.dispatchEvent( 'home', {
                    immediately: immediately
                });
            }
            return this.fitBounds( this.getHomeBounds(), immediately );
        },

        /**
         * @function
         */
        getMinZoom: function() {
            var homeZoom = this.getHomeZoom(),
                zoom = this.minZoomLevel ?
                    this.minZoomLevel :
                    this.underZoomRatio * homeZoom;

            return zoom;
        },

        /**
         * @function
         */
        getMaxZoom: function() {
            var zoom = this.maxZoomLevel;
            if (!zoom) {
                zoom = this._contentSize.x * this.overZoomRatio / this._containerInnerSize.x;
                zoom /= this._contentBounds.width;
            }

            return Math.max( zoom, this.getHomeZoom() );
        },

        /**
         * @function
         */
        getAspectRatio: function() {
            return this._containerInnerSize.x / this._containerInnerSize.y;
        },

        /**
         * @function
         * @returns {XLviewer.Point} The size of the container, in screen coordinates.
         */
        getContainerSize: function() {
            return new xlv.Point(
                this.containerSize.x,
                this.containerSize.y
            );
        },

        /**
         * The margins push the "home" region in from the sides by the specified amounts.
         * @function
         * @returns {Object} Properties (Numbers, in screen coordinates): left, top, right, bottom.
         */
        getMargins: function() {
            return xlv.extend({}, this._margins); // Make a copy so we are not returning our original
        },

        /**
         * The margins push the "home" region in from the sides by the specified amounts.
         * @function
         * @param {Object} margins - Properties (Numbers, in screen coordinates): left, top, right, bottom.
         */
        setMargins: function(margins) {
            xlv.log.d(xlv.Utils.type(margins) === 'object', '[Viewport.setMargins] margins must be an object');

            this._margins = xlv.extend({
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            }, margins);

            this._updateContainerInnerSize();
            this.viewer.forceRedraw();
        },

        /**
         * Returns the bounds of the visible area in viewport coordinates.
         * @function
         * @param {Boolean} current - Pass true for the current location; defaults to false (target location).
         * @returns {XLviewer.Rect} The location you are zoomed/panned to, in viewport coordinates.
         */
        getBounds: function( current ) {
            var center = this.getCenter( current ),
                width  = 1.0 / this.getZoom( current ),
                height = width / this.getAspectRatio();

            return new xlv.Rect(
                center.x - ( width / 2.0 ),
                center.y - ( height / 2.0 ),
                width,
                height
            );
        },

        /**
         * Returns the bounds of the visible area in normalized viewport coordinates (dimensions from 0 to 1).
         * @function
         * @param {Boolean} current - Pass true for the current location; defaults to false (target location).
         * @returns {XLviewer.Rect} The location you are zoomed/panned to, in viewport coordinates.
         */
        getNormalizedBounds: function( current ) {
            var bounds = this.getBounds( current );
            bounds.x /= this._contentBounds.width;
            bounds.width /= this._contentBounds.width;
            bounds.y /= this._contentBounds.height;
            bounds.height /= this._contentBounds.height;
            return bounds;
        },

        /**
         * @function
         * @param {Boolean} current - Pass true for the current location; defaults to false (target location).
         * @returns {XLviewer.Rect} The location you are zoomed/panned to,
         * including the space taken by margins, in viewport coordinates.
         */
        getBoundsWithMargins: function( current ) {
            var bounds = this.getBounds(current);
            var factor = this._containerInnerSize.x * this.getZoom(current);
            bounds.x -= this._margins.left / factor;
            bounds.y -= this._margins.top / factor;
            bounds.width += (this._margins.left + this._margins.right) / factor;
            bounds.height += (this._margins.top + this._margins.bottom) / factor;
            return bounds;
        },

        /**
         * @function
         * @param {Boolean} current - Pass true for the current location; defaults to false (target location).
         */
        getCenter: function( current ) {
            var centerCurrent = new xlv.Point(
                this.centerSpringX.current.value,
                this.centerSpringY.current.value
                ),
                centerTarget = new xlv.Point(
                    this.centerSpringX.target.value,
                    this.centerSpringY.target.value
                ),
                oldZoomPixel,
                zoom,
                width,
                height,
                bounds,
                newZoomPixel,
                deltaZoomPixels,
                deltaZoomPoints;

            if ( current ) {
                return centerCurrent;
            } else if ( !this.zoomPoint ) {
                return centerTarget;
            }

            oldZoomPixel = this.pixelFromPoint(this.zoomPoint, true);

            zoom    = this.getZoom();
            width   = 1.0 / zoom;
            height  = width / this.getAspectRatio();
            bounds  = new xlv.Rect(
                centerCurrent.x - width / 2.0,
                centerCurrent.y - height / 2.0,
                width,
                height
            );

            newZoomPixel = this._pixelFromPoint(this.zoomPoint, bounds);
            deltaZoomPixels = newZoomPixel.minus( oldZoomPixel );
            deltaZoomPoints = deltaZoomPixels.divide( this._containerInnerSize.x * zoom );

            return centerTarget.plus( deltaZoomPoints );
        },

        /**
         * @function
         * @param {Boolean} current - Pass true for the current location; defaults to false (target location).
         */
        getZoom: function( current ) {
            if ( current ) {
                return this.zoomSpring.current.value;
            } else {
                return this.zoomSpring.target.value;
            }
        },

        /**
         * @function
         * @private
         * @param {XLviewer.Rect} bounds
         * @param {Boolean} immediately
         * @return {XLviewer.Rect} constrained bounds.
         */
        _applyBoundaryConstraints: function(bounds, immediately) {
            var newBounds = new xlv.Rect(
                bounds.x,
                bounds.y,
                bounds.width,
                bounds.height);

            var horizontalThreshold = this.visibilityRatio * newBounds.width;
            var verticalThreshold   = this.visibilityRatio * newBounds.height;

            if (this.wrapHorizontal) {
                //do nothing
            } else {
                var dx = 0;
                var thresholdLeft = newBounds.x + (newBounds.width - horizontalThreshold);
                if (this._contentBoundsNoRotate.x > thresholdLeft) {
                    dx = this._contentBoundsNoRotate.x - thresholdLeft;
                }

                var contentRight = this._contentBoundsNoRotate.x + this._contentBoundsNoRotate.width;
                var thresholdRight = newBounds.x + horizontalThreshold;
                if (contentRight < thresholdRight) {
                    var newDx = contentRight - thresholdRight;
                    if (dx) {
                        dx = (dx + newDx) / 2;
                    } else {
                        dx = newDx;
                    }
                }
                newBounds.x += dx;
            }

            if (this.wrapVertical) {
                //do nothing
            } else {
                var dy = 0;
                var thresholdTop = newBounds.y + (newBounds.height - verticalThreshold);
                if (this._contentBoundsNoRotate.y > thresholdTop) {
                    dy = this._contentBoundsNoRotate.y - thresholdTop;
                }

                var contentBottom = this._contentBoundsNoRotate.y + this._contentBoundsNoRotate.height;
                var thresholdBottom = newBounds.y + verticalThreshold;
                if (contentBottom < thresholdBottom) {
                    var newDy = contentBottom - thresholdBottom;
                    if (dy) {
                        dy = (dy + newDy) / 2;
                    } else {
                        dy = newDy;
                    }
                }
                newBounds.y += dy;
            }

            if (this.viewer) {
                /**
                 * Raised when the viewport constraints are applied (see {@link XLviewer.Viewport#applyConstraints}).
                 *
                 * @event constrain
                 * @memberof XLviewer.Viewer
                 * @type {object}
                 * @property {XLviewer.Viewer} eventSource - A reference to the Viewer which raised this event.
                 * @property {Boolean} immediately
                 * @property {?Object} userData - Arbitrary subscriber-defined object.
                 */
                this.viewer.dispatchEvent( 'constrain', {
                    immediately: immediately
                });
            }

            return newBounds;
        },

        /**
         * @function
         * @return {XLviewer.Viewport} Chainable.
         * @fires XLviewer.Viewer.event:constrain
         */
        applyConstraints: function( immediately ) {
            var actualZoom = this.getZoom(),
                constrainedZoom = Math.max(
                    Math.min( actualZoom, this.getMaxZoom() ),
                    this.getMinZoom()
                ),
                bounds,
                constrainedBounds;

            if ( actualZoom != constrainedZoom ) {
                this.zoomTo( constrainedZoom, this.zoomPoint, immediately );
            }

            bounds = this.getBounds();

            constrainedBounds = this._applyBoundaryConstraints( bounds, immediately );

            if ( bounds.x !== constrainedBounds.x || bounds.y !== constrainedBounds.y || immediately ){
                this.fitBounds( constrainedBounds, immediately );
            }

            return this;
        },

        /**
         * @function
         * @param {Boolean} immediately
         */
        ensureVisible: function( immediately ) {
            return this.applyConstraints( immediately );
        },

        /**
         * @function
         * @private
         * @param {XLviewer.Rect} bounds
         * @param {Object} options (immediately=false, constraints=false)
         * @return {XLviewer.Viewport} Chainable.
         */
        _fitBounds: function( bounds, options ) {
            options = options || {};
            var immediately = options.immediately || false;
            var constraints = options.constraints || false;

            var aspect = this.getAspectRatio();
            var center = bounds.getCenter();
            var newBounds = new xlv.Rect(
                bounds.x,
                bounds.y,
                bounds.width,
                bounds.height
            );

            if ( newBounds.getAspectRatio() >= aspect ) {
                newBounds.height = bounds.width / aspect;
                newBounds.y      = center.y - newBounds.height / 2;
            } else {
                newBounds.width = bounds.height * aspect;
                newBounds.x     = center.x - newBounds.width / 2;
            }

            this.panTo( this.getCenter( true ), true );
            this.zoomTo( this.getZoom( true ), null, true );

            var oldBounds = this.getBounds();
            var oldZoom   = this.getZoom();
            var newZoom   = 1.0 / newBounds.width;

            if (constraints) {
                var newBoundsAspectRatio = newBounds.getAspectRatio();
                var newConstrainedZoom = Math.max(
                    Math.min(newZoom, this.getMaxZoom() ),
                    this.getMinZoom()
                );

                if (newZoom !== newConstrainedZoom) {
                    newZoom = newConstrainedZoom;
                    newBounds.width = 1.0 / newZoom;
                    newBounds.x = center.x - newBounds.width / 2;
                    newBounds.height = newBounds.width / newBoundsAspectRatio;
                    newBounds.y = center.y - newBounds.height / 2;
                }

                newBounds = this._applyBoundaryConstraints( newBounds, immediately );
                center = newBounds.getCenter();
            }

            if (immediately) {
                this.panTo( center, true );
                return this.zoomTo(newZoom, null, true);
            }

            if (Math.abs(newZoom - oldZoom) < 0.00000001 ||
                Math.abs(newBounds.width - oldBounds.width) < 0.00000001) {
                return this.panTo( center, immediately );
            }

            var referencePoint = oldBounds.getTopLeft().times(
                this._containerInnerSize.x / oldBounds.width
            ).minus(
                newBounds.getTopLeft().times(
                    this._containerInnerSize.x / newBounds.width
                )
            ).divide(
                this._containerInnerSize.x / oldBounds.width -
                this._containerInnerSize.x / newBounds.width
            );

            return this.zoomTo( newZoom, referencePoint, immediately );
        },

        /**
         * @function
         * @param {XLviewer.Rect} bounds
         * @param {Boolean} immediately
         * @return {XLviewer.Viewport} Chainable.
         */
        fitBounds: function( bounds, immediately ) {
            return this._fitBounds( bounds, {
                immediately: immediately,
                constraints: false
            } );
        },

        /**
         * Effettua uno zoom verso un certo rettangolo {XLviewer.Rect}
         * le dimensioni del rettangolo vanno da 0 a 1.
         * @param bounds
         * @param immediately
         * @param applyContraints
         */
        fitNormalizedBounds: function( bounds, immediately, applyContraints ) {
            bounds.x *= this._contentBounds.width;
            bounds.width *= this._contentBounds.width;
            bounds.y *= this._contentBounds.height;
            bounds.height *= this._contentBounds.height;
            if(applyContraints) {
                this.fitBoundsWithConstraints(bounds, immediately);
            } else {
                this.fitBounds(bounds, immediately);
            }

        },

        /**
         * @function
         * @param {XLviewer.Rect} bounds
         * @param {Boolean} immediately
         * @return {XLviewer.Viewport} Chainable.
         */
        fitBoundsWithConstraints: function( bounds, immediately ) {
            return this._fitBounds( bounds, {
                immediately: immediately,
                constraints: true
            } );
        },

        /**
         * Zooms so the image just fills the viewer vertically.
         * @param {Boolean} immediately
         * @return {XLviewer.Viewport} Chainable.
         */
        fitVertically: function(immediately) {
            var box = new xlv.Rect(
                this._contentBounds.x + (this._contentBounds.width / 2),
                this._contentBounds.y,
                0,
                this._contentBounds.height);
            return this.fitBounds(box, immediately);
        },

        /**
         * Zooms so the image just fills the viewer horizontally.
         * @param {Boolean} immediately
         * @return {XLviewer.Viewport} Chainable.
         */
        fitHorizontally: function(immediately) {
            var box = new xlv.Rect(
                this._contentBounds.x,
                this._contentBounds.y + (this._contentBounds.height / 2),
                this._contentBounds.width,
                0);
            return this.fitBounds(box, immediately);
        },


        /**
         * @function
         * @param {XLviewer.Point} delta
         * @param {Boolean} immediately
         * @return {XLviewer.Viewport} Chainable.
         * @fires XLviewer.Viewer.event:pan
         */
        panBy: function( delta, immediately ) {
            var center = new xlv.Point(
                this.centerSpringX.target.value,
                this.centerSpringY.target.value
            );
            return this.panTo( center.plus( delta ), immediately );
        },

        /**
         * @function
         * @param {XLviewer.Point} center
         * @param {Boolean} immediately
         * @return {XLviewer.Viewport} Chainable.
         * @fires XLviewer.Viewer.event:pan
         */
        panTo: function( center, immediately ) {
            if ( immediately ) {
                this.centerSpringX.resetTo( center.x );
                this.centerSpringY.resetTo( center.y );
            } else {
                this.centerSpringX.springTo( center.x );
                this.centerSpringY.springTo( center.y );
            }

            if( this.viewer ){
                /**
                 * Raised when the viewport is panned (see {@link XLviewer.Viewport#panBy} and {@link XLviewer.Viewport#panTo}).
                 *
                 * @event pan
                 * @memberof XLviewer.Viewer
                 * @type {object}
                 * @property {XLviewer.Viewer} eventSource - A reference to the Viewer which raised this event.
                 * @property {XLviewer.Point} center
                 * @property {Boolean} immediately
                 * @property {?Object} userData - Arbitrary subscriber-defined object.
                 */
                this.viewer.dispatchEvent( 'pan', {
                    center: center,
                    immediately: immediately
                });
            }

            return this;
        },

        /**
         * @function
         * @return {XLviewer.Viewport} Chainable.
         * @fires XLviewer.Viewer.event:zoom
         */
        zoomBy: function(factor, refPoint, immediately) {
            return this.zoomTo(
                this.zoomSpring.target.value * factor, refPoint, immediately);
        },

        /**
         * @function
         * @return {XLviewer.Viewport} Chainable.
         * @fires XLviewer.Viewer.event:zoom
         */
        zoomTo: function( zoom, refPoint, immediately ) {

            this.zoomPoint = refPoint instanceof xlv.Point &&
            !isNaN(refPoint.x) &&
            !isNaN(refPoint.y) ?
                refPoint :
                null;

            if ( immediately ) {
                this.zoomSpring.resetTo( zoom );
            } else {
                this.zoomSpring.springTo( zoom );
            }

            if( this.viewer ){
                /**
                 * Raised when the viewport zoom level changes (see {@link XLviewer.Viewport#zoomBy} and {@link XLviewer.Viewport#zoomTo}).
                 *
                 * @event zoom
                 * @memberof XLviewer.Viewer
                 * @type {object}
                 * @property {XLviewer.Viewer} eventSource - A reference to the Viewer which raised this event.
                 * @property {Number} zoom
                 * @property {XLviewer.Point} refPoint
                 * @property {Boolean} immediately
                 * @property {?Object} userData - Arbitrary subscriber-defined object.
                 */
                this.viewer.dispatchEvent( 'zoom', {
                    zoom: zoom,
                    refPoint: refPoint,
                    immediately: immediately
                });
            }

            return this;
        },

        /**
         * Rotates this viewport to the angle specified.
         * @function
         * @return {XLviewer.Viewport} Chainable.
         */
        setRotation: function(rotation) {
            if (!this.viewer || !this.viewer.drawer.canRotate()) {
                return this;
            }

            rotation = rotation % 360;
            if (rotation < 0) {
                rotation += 360;
            }
            this.rotation = rotation;
            this._setContentBounds(
                this.viewer.manager.getHomeBounds(),
                this.viewer.manager.getContentFactor());
            this.viewer.forceRedraw();

            /**
             * Raised when rotation has been changed.
             *
             * @event rotate
             * @memberof XLviewer.Viewer
             * @type {object}
             * @property {XLviewer.Viewer} eventSource - A reference to the Viewer which raised the event.
             * @property {Number} rotation - The number of rotation the rotation was set to.
             * @property {?Object} userData - Arbitrary subscriber-defined object.
             */
            this.viewer.dispatchEvent('rotate', {"rotation": rotation});
            return this;
        },

        /**
         * Gets the current rotation in rotation.
         * @function
         * @return {Number} The current rotation in rotation.
         */
        getRotation: function() {
            return this.rotation;
        },

        /**
         * @function
         * @return {XLviewer.Viewport} Chainable.
         * @fires XLviewer.Viewer.event:resize
         */
        resize: function( newContainerSize, maintain ) {
            var oldBounds = this.getBounds(),
                newBounds = oldBounds,
                widthDeltaFactor;

            this.containerSize.x = newContainerSize.x;
            this.containerSize.y = newContainerSize.y;

            this._updateContainerInnerSize();

            if ( maintain ) {
                // TODO: widthDeltaFactor will always be 1; probably not what's intended
                widthDeltaFactor = newContainerSize.x / this.containerSize.x;
                newBounds.width  = oldBounds.width * widthDeltaFactor;
                newBounds.height = newBounds.width / this.getAspectRatio();
            }

            if( this.viewer ){
                /**
                 * Raised when the viewer is resized (see {@link XLviewer.Viewport#resize}).
                 *
                 * @event resize
                 * @memberof XLviewer.Viewer
                 * @type {object}
                 * @property {XLviewer.Viewer} eventSource - A reference to the Viewer which raised this event.
                 * @property {XLviewer.Point} newContainerSize
                 * @property {Boolean} maintain
                 * @property {?Object} userData - Arbitrary subscriber-defined object.
                 */
                this.viewer.dispatchEvent( 'resize', {
                    newContainerSize: newContainerSize,
                    maintain: maintain
                });
            }

            return this.fitBounds( newBounds, true );
        },

        // private
        _updateContainerInnerSize: function() {
            this._containerInnerSize = new xlv.Point(
                Math.max(1, this.containerSize.x - (this._margins.left + this._margins.right)),
                Math.max(1, this.containerSize.y - (this._margins.top + this._margins.bottom))
            );
        },

        /**
         * @function
         */
        update: function() {
            var oldZoomPixel,
                newZoomPixel,
                deltaZoomPixels,
                deltaZoomPoints;

            if (this.zoomPoint) {
                oldZoomPixel = this.pixelFromPoint( this.zoomPoint, true );
            }

            this.zoomSpring.update();

            if (this.zoomPoint && this.zoomSpring.current.value != this._oldZoom) {
                newZoomPixel    = this.pixelFromPoint( this.zoomPoint, true );
                deltaZoomPixels = newZoomPixel.minus( oldZoomPixel );
                deltaZoomPoints = this.deltaPointsFromPixels( deltaZoomPixels, true );

                this.centerSpringX.shiftBy( deltaZoomPoints.x );
                this.centerSpringY.shiftBy( deltaZoomPoints.y );
            } else {
                this.zoomPoint = null;
            }

            this.centerSpringX.update();
            this.centerSpringY.update();

            var changed = this.centerSpringX.current.value != this._oldCenterX ||
                this.centerSpringY.current.value != this._oldCenterY ||
                this.zoomSpring.current.value != this._oldZoom;

            this._oldCenterX = this.centerSpringX.current.value;
            this._oldCenterY = this.centerSpringY.current.value;
            this._oldZoom    = this.zoomSpring.current.value;

            return changed;
        },

        /**
         * Convert a delta (translation vector) from viewport coordinates to pixels
         * coordinates. This method does not take rotation into account.
         * Consider using deltaPixelsFromPoints if you need to account for rotation.
         * @param {XLviewer.Point} deltaPoints - The translation vector to convert.
         * @param {Boolean} [current=false] - Pass true for the current location;
         * defaults to false (target location).
         * @returns {XLviewer.Point}
         */
        deltaPixelsFromPointsNoRotate: function(deltaPoints, current) {
            return deltaPoints.times(
                this._containerInnerSize.x * this.getZoom(current)
            );
        },

        /**
         * Convert a delta (translation vector) from viewport coordinates to pixels
         * coordinates.
         * @param {XLviewer.Point} deltaPoints - The translation vector to convert.
         * @param {Boolean} [current=false] - Pass true for the current location;
         * defaults to false (target location).
         * @returns {XLviewer.Point}
         */
        deltaPixelsFromPoints: function(deltaPoints, current) {
            return this.deltaPixelsFromPointsNoRotate(
                deltaPoints.rotate(this.getRotation()),
                current);
        },

        /**
         * Convert a delta (translation vector) from pixels coordinates to viewport
         * coordinates. This method does not take rotation into account.
         * Consider using deltaPointsFromPixels if you need to account for rotation.
         * @param {XLviewer.Point} deltaPixels - The translation vector to convert.
         * @param {Boolean} [current=false] - Pass true for the current location;
         * defaults to false (target location).
         * @returns {XLviewer.Point}
         */
        deltaPointsFromPixelsNoRotate: function(deltaPixels, current) {
            return deltaPixels.divide(
                this._containerInnerSize.x * this.getZoom(current)
            );
        },

        /**
         * Convert a delta (translation vector) from pixels coordinates to viewport
         * coordinates.
         * @param {XLviewer.Point} deltaPixels - The translation vector to convert.
         * @param {Boolean} [current=false] - Pass true for the current location;
         * defaults to false (target location).
         * @returns {XLviewer.Point}
         */
        deltaPointsFromPixels: function(deltaPixels, current) {
            return this.deltaPointsFromPixelsNoRotate(deltaPixels, current)
                .rotate(-this.getRotation());
        },

        /**
         * Convert viewport coordinates to pixels coordinates.
         * This method does not take rotation into account.
         * Consider using pixelFromPoint if you need to account for rotation.
         * @param {XLviewer.Point} point the viewport coordinates
         * @param {Boolean} [current=false] - Pass true for the current location;
         * defaults to false (target location).
         * @returns {XLviewer.Point}
         */
        pixelFromPointNoRotate: function(point, current) {
            return this._pixelFromPointNoRotate(point, this.getBounds(current));
        },

        /**
         * Convert viewport coordinates to pixel coordinates.
         * @param {XLviewer.Point} point the viewport coordinates
         * @param {Boolean} [current=false] - Pass true for the current location;
         * defaults to false (target location).
         * @returns {XLviewer.Point}
         */
        pixelFromPoint: function(point, current) {
            return this._pixelFromPoint(point, this.getBounds(current));
        },

        // private
        _pixelFromPointNoRotate: function(point, bounds) {
            return point.minus(
                bounds.getTopLeft()
            ).times(
                this._containerInnerSize.x / bounds.width
            ).plus(
                new xlv.Point(this._margins.left, this._margins.top)
            );
        },

        // private
        _pixelFromPoint: function(point, bounds) {
            return this._pixelFromPointNoRotate(
                point.rotate(this.getRotation(), this.getCenter(true)),
                bounds);
        },

        /**
         * Convert pixel coordinates to viewport coordinates.
         * This method does not take rotation into account.
         * Consider using pointFromPixel if you need to account for rotation.
         * @param {XLviewer.Point} pixel Pixel coordinates
         * @param {Boolean} [current=false] - Pass true for the current location;
         * defaults to false (target location).
         * @returns {XLviewer.Point}
         */
        pointFromPixelNoRotate: function(pixel, current) {
            var bounds = this.getBounds( current );
            return pixel.minus(
                new xlv.Point(this._margins.left, this._margins.top)
            ).divide(
                this._containerInnerSize.x / bounds.width
            ).plus(
                bounds.getTopLeft()
            );
        },

        /**
         * Convert pixel coordinates to viewport coordinates.
         * @param {XLviewer.Point} pixel Pixel coordinates
         * @param {Boolean} [current=false] - Pass true for the current location;
         * defaults to false (target location).
         * @returns {XLviewer.Point}
         */
        pointFromPixel: function(pixel, current) {
            return this.pointFromPixelNoRotate(pixel, current).rotate(
                -this.getRotation(),
                this.getCenter(true)
            );
        },

        // private
        _viewportToImageDelta: function( viewerX, viewerY ) {
            var scale = this._contentBoundsNoRotate.width;
            return new xlv.Point(
                viewerX * this._contentSizeNoRotate.x / scale,
                viewerY * this._contentSizeNoRotate.x / scale);
        },

        /**
         * Translates from XLviewer viewer coordinate system to image coordinate system.
         * This method can be called either by passing X,Y coordinates or an
         * XLviewer.Point
         * Note: not accurate with multi-image; use TiledImage.viewportToImageCoordinates instead.
         * @function
         * @param {(XLviewer.Point|Number)} viewerX either a point or the X
         * coordinate in viewport coordinate system.
         * @param {Number} [viewerY] Y coordinate in viewport coordinate system.
         * @return {XLviewer.Point} a point representing the coordinates in the image.
         */
        viewportToImageCoordinates: function(viewerX, viewerY) {
            if (viewerX instanceof xlv.Point) {
                //they passed a point instead of individual components
                return this.viewportToImageCoordinates(viewerX.x, viewerX.y);
            }

            if (this.viewer && this.viewer.manager.getItemCount() > 1) {
                xlv.log.e('[Viewport.viewportToImageCoordinates] is not accurate with multi-image; use TiledImage.viewportToImageCoordinates instead.');
            }

            return this._viewportToImageDelta(
                viewerX - this._contentBoundsNoRotate.x,
                viewerY - this._contentBoundsNoRotate.y);
        },

        // private
        _imageToViewportDelta: function( imageX, imageY ) {
            var scale = this._contentBoundsNoRotate.width;
            return new xlv.Point(
                imageX / this._contentSizeNoRotate.x * scale,
                imageY / this._contentSizeNoRotate.x * scale);
        },

        /**
         * Translates from image coordinate system to XLviewer viewer coordinate system
         * This method can be called either by passing X,Y coordinates or an
         * XLviewer.Point
         * Note: not accurate with multi-image; use TiledImage.imageToViewportCoordinates instead.
         * @function
         * @param {(XLviewer.Point | Number)} imageX the point or the
         * X coordinate in image coordinate system.
         * @param {Number} [imageY] Y coordinate in image coordinate system.
         * @return {XLviewer.Point} a point representing the coordinates in the viewport.
         */
        imageToViewportCoordinates: function(imageX, imageY) {
            if (imageX instanceof xlv.Point) {
                //they passed a point instead of individual components
                return this.imageToViewportCoordinates(imageX.x, imageX.y);
            }

            if (this.viewer && this.viewer.manager.getItemCount() > 1) {
                xlv.log.e('[Viewport.imageToViewportCoordinates] is not accurate with multi-image; use TiledImage.imageToViewportCoordinates instead.');
            }

            var point = this._imageToViewportDelta(imageX, imageY);
            point.x += this._contentBoundsNoRotate.x;
            point.y += this._contentBoundsNoRotate.y;
            return point;
        },

        /**
         * Translates from a rectangle which describes a portion of the image in
         * pixel coordinates to XLviewer viewport rectangle coordinates.
         * This method can be called either by passing X,Y,width,height or an
         * XLviewer.Rect
         * Note: not accurate with multi-image; use TiledImage.imageToViewportRectangle instead.
         * @function
         * @param {(XLviewer.Rect | Number)} imageX the rectangle or the X
         * coordinate of the top left corner of the rectangle in image coordinate system.
         * @param {Number} [imageY] the Y coordinate of the top left corner of the rectangle
         * in image coordinate system.
         * @param {Number} [pixelWidth] the width in pixel of the rectangle.
         * @param {Number} [pixelHeight] the height in pixel of the rectangle.
         */
        imageToViewportRectangle: function(imageX, imageY, pixelWidth, pixelHeight) {
            var rect = imageX;
            if (!(rect instanceof xlv.Rect)) {
                //they passed individual components instead of a rectangle
                rect = new xlv.Rect(imageX, imageY, pixelWidth, pixelHeight);
            }

            var coordA = this.imageToViewportCoordinates(rect.x, rect.y);
            var coordB = this._imageToViewportDelta(rect.width, rect.height);
            return new xlv.Rect(
                coordA.x,
                coordA.y,
                coordB.x,
                coordB.y,
                rect.rotation
            );
        },

        /**
         * Translates from a rectangle which describes a portion of
         * the viewport in point coordinates to image rectangle coordinates.
         * This method can be called either by passing X,Y,width,height or an
         * XLviewer.Rect
         * Note: not accurate with multi-image; use TiledImage.viewportToImageRectangle instead.
         * @function
         * @param {(XLviewer.Rect | Number)} viewerX either a rectangle or
         * the X coordinate of the top left corner of the rectangle in viewport
         * coordinate system.
         * @param {Number} [viewerY] the Y coordinate of the top left corner of the rectangle
         * in viewport coordinate system.
         * @param {Number} [pointWidth] the width of the rectangle in viewport coordinate system.
         * @param {Number} [pointHeight] the height of the rectangle in viewport coordinate system.
         */
        viewportToImageRectangle: function(viewerX, viewerY, pointWidth, pointHeight) {
            var rect = viewerX;
            if (!(rect instanceof xlv.Rect)) {
                //they passed individual components instead of a rectangle
                rect = new xlv.Rect(viewerX, viewerY, pointWidth, pointHeight);
            }

            var coordA = this.viewportToImageCoordinates(rect.x, rect.y);
            var coordB = this._viewportToImageDelta(rect.width, rect.height);
            return new xlv.Rect(
                coordA.x,
                coordA.y,
                coordB.x,
                coordB.y,
                rect.rotation
            );
        },

        /**
         * Convert pixel coordinates relative to the viewer element to image
         * coordinates.
         * Note: not accurate with multi-image.
         * @param {XLviewer.Point} pixel
         * @returns {XLviewer.Point}
         */
        viewerElementToImageCoordinates: function( pixel ) {
            var point = this.pointFromPixel( pixel, true );
            return this.viewportToImageCoordinates( point );
        },

        /**
         * Convert pixel coordinates relative to the image to
         * viewer element coordinates.
         * Note: not accurate with multi-image.
         * @param {XLviewer.Point} pixel
         * @returns {XLviewer.Point}
         */
        imageToViewerElementCoordinates: function( pixel ) {
            var point = this.imageToViewportCoordinates( pixel );
            return this.pixelFromPoint( point, true );
        },

        /**
         * Convert pixel coordinates relative to the window to image coordinates.
         * Note: not accurate with multi-image.
         * @param {XLviewer.Point} pixel
         * @returns {XLviewer.Point}
         */
        windowToImageCoordinates: function( pixel ) {
            var viewerCoordinates = pixel.minus(
                XLviewer.getElementPosition( this.viewer.element ));
            return this.viewerElementToImageCoordinates( viewerCoordinates );
        },

        /**
         * Convert image coordinates to pixel coordinates relative to the window.
         * Note: not accurate with multi-image.
         * @param {XLviewer.Point} pixel
         * @returns {XLviewer.Point}
         */
        imageToWindowCoordinates: function( pixel ) {
            var viewerCoordinates = this.imageToViewerElementCoordinates( pixel );
            return viewerCoordinates.plus(
                XLviewer.getElementPosition( this.viewer.element ));
        },

        /**
         * Convert pixel coordinates relative to the viewer element to viewport
         * coordinates.
         * @param {XLviewer.Point} pixel
         * @returns {XLviewer.Point}
         */
        viewerElementToViewportCoordinates: function( pixel ) {
            return this.pointFromPixel( pixel, true );
        },

        /**
         * Convert viewport coordinates to pixel coordinates relative to the
         * viewer element.
         * @param {XLviewer.Point} point
         * @returns {XLviewer.Point}
         */
        viewportToViewerElementCoordinates: function( point ) {
            return this.pixelFromPoint( point, true );
        },

        /**
         * Convert a rectangle in pixel coordinates relative to the viewer element
         * to viewport coordinates.
         * @param {XLviewer.Rect} rectangle the rectangle to convert
         * @returns {XLviewer.Rect} the converted rectangle
         */
        viewerElementToViewportRectangle: function(rectangle) {
            return xlv.Rect.fromSummits(
                this.pointFromPixel(rectangle.getTopLeft(), true),
                this.pointFromPixel(rectangle.getTopRight(), true),
                this.pointFromPixel(rectangle.getBottomLeft(), true)
            );
        },

        /**
         * Convert a rectangle in viewport coordinates to pixel coordinates relative
         * to the viewer element.
         * @param {XLviewer.Rect} rectangle the rectangle to convert
         * @returns {XLviewer.Rect} the converted rectangle
         */
        viewportToViewerElementRectangle: function(rectangle) {
            return xlv.Rect.fromSummits(
                this.pixelFromPoint(rectangle.getTopLeft(), true),
                this.pixelFromPoint(rectangle.getTopRight(), true),
                this.pixelFromPoint(rectangle.getBottomLeft(), true)
            );
        },

        /**
         * Convert pixel coordinates relative to the window to viewport coordinates.
         * @param {XLviewer.Point} pixel
         * @returns {XLviewer.Point}
         */
        windowToViewportCoordinates: function( pixel ) {
            var viewerCoordinates = pixel.minus(
                XLviewer.getElementPosition( this.viewer.element ));
            return this.viewerElementToViewportCoordinates( viewerCoordinates );
        },

        /**
         * Convert viewport coordinates to pixel coordinates relative to the window.
         * @param {XLviewer.Point} point
         * @returns {XLviewer.Point}
         */
        viewportToWindowCoordinates: function( point ) {
            var viewerCoordinates = this.viewportToViewerElementCoordinates( point );
            return viewerCoordinates.plus(
                XLviewer.getElementPosition( this.viewer.element ));
        },

        /**
         * Convert a viewport zoom to an image zoom.
         * Image zoom: ratio of the original image size to displayed image size.
         * 1 means original image size, 0.5 half size...
         * Viewport zoom: ratio of the displayed image's width to viewport's width.
         * 1 means identical width, 2 means image's width is twice the viewport's width...
         * Note: not accurate with multi-image.
         * @function
         * @param {Number} viewportZoom The viewport zoom
         * target zoom.
         * @returns {Number} imageZoom The image zoom
         */
        viewportToImageZoom: function( viewportZoom ) {
            if (this.viewer && this.viewer.manager.getItemCount() > 1) {
                xlv.log.e('[Viewport.viewportToImageZoom] is not accurate with multi-image.');
            }

            var imageWidth = this._contentSizeNoRotate.x;
            var containerWidth = this._containerInnerSize.x;
            var scale = this._contentBoundsNoRotate.width;
            var viewportToImageZoomRatio = (containerWidth / imageWidth) * scale;
            return viewportZoom * viewportToImageZoomRatio;
        },

        /**
         * Convert an image zoom to a viewport zoom.
         * Image zoom: ratio of the original image size to displayed image size.
         * 1 means original image size, 0.5 half size...
         * Viewport zoom: ratio of the displayed image's width to viewport's width.
         * 1 means identical width, 2 means image's width is twice the viewport's width...
         * Note: not accurate with multi-image.
         * @function
         * @param {Number} imageZoom The image zoom
         * target zoom.
         * @returns {Number} viewportZoom The viewport zoom
         */
        imageToViewportZoom: function( imageZoom ) {
            if (this.viewer && this.viewer.manager.getItemCount() > 1) {
                xlv.log.e('[Viewport.imageToViewportZoom] is not accurate with multi-image.');
            }

            var imageWidth = this._contentSizeNoRotate.x;
            var containerWidth = this._containerInnerSize.x;
            var scale = this._contentBoundsNoRotate.width;
            var viewportToImageZoomRatio = (imageWidth / containerWidth) / scale;
            return imageZoom * viewportToImageZoomRatio;
        }
    };

}( XLviewer ));
(function( xlv ){

    /**
     * @ignore
     * @class World
     * @memberof XLviewer
     * @extends XLviewer.EventDispatcher
     * @classdesc Keeps track of all of the tiled images in the scene.
     * @param {Object} options - World options.
     * @param {XLviewer.Viewer} options.viewer - The Viewer that owns this World.
     **/
    xlv.Manager = function( options ) {
        var _this = this;

        xlv.log.d( options.core, "[Manager] options.core is required" );

        xlv.EventDispatcher.call( this );

        this.core = options.core;
        this._items = [];
        this._needsDraw = false;
        this._autoRefigureSizes = true;
        this._needsSizesFigured = false;
        this._delegatedFigureSizes = function(event) {
            if (_this._autoRefigureSizes) {
                _this._figureSizes();
            } else {
                _this._needsSizesFigured = true;
            }
        };

        this._figureSizes();
    };

    xlv.extend( xlv.Manager.prototype, xlv.EventDispatcher.prototype, /** @lends XLviewer.Manager.prototype */{
        /**
         * Add the specified item.
         * @param {XLviewer.TiledImage} item - The item to add.
         * @param {Number} [options.index] - Index for the item. If not specified, goes at the top.
         * @fires XLviewer.Manager.event:add-item
         * @fires XLviewer.Manager.event:metrics-change
         */
        addItem: function( item, options ) {
            xlv.log.d(item, "[Manager.addItem] item is required");
            xlv.log.d(item instanceof xlv.TiledImage, "[Manager.addItem] only TiledImages supported at this time");

            options = options || {};
            if (options.index !== undefined) {
                var index = Math.max(0, Math.min(this._items.length, options.index));
                this._items.splice(index, 0, item);
            } else {
                this._items.push( item );
            }

            if (this._autoRefigureSizes) {
                this._figureSizes();
            } else {
                this._needsSizesFigured = true;
            }

            this._needsDraw = true;

            item.addListener('boundsChange', this._delegatedFigureSizes);

            /**
             * Dispatched when an item is added to the Manager.
             * @event add-item
             * @memberOf XLviewer.Manager
             * @type {object}
             * @property {XLviewer.Viewer} eventSource - A reference to the Manager which raised the event.
             * @property {XLviewer.TiledImage} item - The item that has been added.
             * @property {?Object} userData - Arbitrary subscriber-defined object.
             */
            this.dispatchEvent( 'addItem', {
                item: item
            } );
        },

        /**
         * Get the item at the specified index.
         * @param {Number} index - The item's index.
         * @returns {XLviewer.TiledImage} The item at the specified index.
         */
        getItemAt: function( index ) {
            xlv.log.d(index !== undefined, "[Manager.getItemAt] index is required");
            return this._items[ index ];
        },

        /**
         * Get the index of the given item or -1 if not present.
         * @param {XLviewer.TiledImage} item - The item.
         * @returns {Number} The index of the item or -1 if not present.
         */
        getIndexOfItem: function( item ) {
            xlv.log.d(item, "[Manager.getIndexOfItem] item is required");
            return xlv.indexOf( this._items, item );
        },

        /**
         * @returns {Number} The number of items used.
         */
        getItemCount: function() {
            return this._items.length;
        },

        /**
         * Change the index of a item so that it appears over or under others.
         * @param {XLviewer.TiledImage} item - The item to move.
         * @param {Number} index - The new index.
         * @fires XLviewer.Manager.event:item-index-change
         */
        setItemIndex: function( item, index ) {
            xlv.log.d(item, "[Manager.setItemIndex] item is required");
            xlv.log.d(index !== undefined, "[Manager.setItemIndex] index is required");

            var oldIndex = this.getIndexOfItem( item );

            if ( index >= this._items.length ) {
                throw new Error( "Index bigger than number of layers." );
            }

            if ( index === oldIndex || oldIndex === -1 ) {
                return;
            }

            this._items.splice( oldIndex, 1 );
            this._items.splice( index, 0, item );
            this._needsDraw = true;

            /**
             * Dispatched when the order of the indexes has been changed.
             * @event item-index-change
             * @memberOf XLviewer.Manager
             * @type {object}
             * @property {XLviewer.Manager} eventSource - A reference to the Manager which raised the event.
             * @property {XLviewer.TiledImage} item - The item whose index has
             * been changed
             * @property {Number} previousIndex - The previous index of the item
             * @property {Number} newIndex - The new index of the item
             * @property {?Object} userData - Arbitrary subscriber-defined object.
             */
            this.dispatchEvent( 'itemIndexChange', {
                item: item,
                previousIndex: oldIndex,
                newIndex: index
            } );
        },

        /**
         * Remove an item.
         * @param {XLviewer.TiledImage} item - The item to remove.
         * @fires XLviewer.Manager.event:remove-item
         * @fires XLviewer.Manager.event:metrics-change
         */
        removeItem: function( item ) {
            xlv.log.d(item, "[Manager.removeItem] item is required");

            var index = xlv.indexOf(this._items, item );
            if ( index === -1 ) {
                return;
            }

            item.removeListener('boundsChange', this._delegatedFigureSizes);
            item.destroy();
            this._items.splice( index, 1 );
            this._figureSizes();
            this._needsDraw = true;
            this._raiseRemoveItem(item);
        },

        /**
         * Remove all items.
         * @fires XLviewer.Manager.event:remove-item
         * @fires XLviewer.Manager.event:metrics-change
         */
        removeAll: function() {
            // We need to make sure any pending images are canceled so the manager items don't get messed up
            this.core._cancelPendingImages();
            var item;
            for (var i = 0; i < this._items.length; i++) {
                item = this._items[i];
                item.removeListener('boundsChange', this._delegatedFigureSizes);
                item.destroy();
            }

            var removedItems = this._items;
            this._items = [];
            this._figureSizes();
            this._needsDraw = true;

            for (i = 0; i < removedItems.length; i++) {
                item = removedItems[i];
                this._raiseRemoveItem(item);
            }
        },

        /**
         * Clears all tiles and triggers updates for all items.
         */
        resetItems: function() {
            for ( var i = 0; i < this._items.length; i++ ) {
                this._items[i].reset();
            }
        },

        /**
         * Updates (i.e. animates bounds of) all items.
         */
        update: function() {
            var animated = false;
            for ( var i = 0; i < this._items.length; i++ ) {
                animated = this._items[i].update() || animated;
            }

            return animated;
        },

        /**
         * Draws all items.
         */
        draw: function() {
            for ( var i = 0; i < this._items.length; i++ ) {
                this._items[i].draw();
            }

            this._needsDraw = false;
        },

        /**
         * @returns {Boolean} true if any items need updating.
         */
        needsDraw: function() {
            for ( var i = 0; i < this._items.length; i++ ) {
                if ( this._items[i].needsDraw() ) {
                    return true;
                }
            }
            return this._needsDraw;
        },

        /**
         * @returns {XLviewer.Rect} The smallest rectangle that encloses all items, in viewport coordinates.
         */
        getHomeBounds: function() {
            return this._homeBounds.clone();
        },

        /**
         * To facilitate zoom constraints, we keep track of the pixel density of the
         * densest item in the Manager (i.e. the item whose content size to viewport size
         * ratio is the highest) and save it as this "content factor".
         * @returns {Number} the number of content units per viewport unit.
         */
        getContentFactor: function() {
            return this._contentFactor;
        },

        /**
         * As a performance optimization, setting this flag to false allows the bounds-change event handler
         * on tiledImages to skip calculations on the manager bounds. If a lot of images are going to be positioned in
         * rapid succession, this is a good idea. When finished, setAutoRefigureSizes should be called with true
         * or the system may behave oddly.
         * @param {Boolean} [value] The value to which to set the flag.
         */
        setAutoRefigureSizes: function(value) {
            this._autoRefigureSizes = value;
            if (value & this._needsSizesFigured) {
                this._figureSizes();
                this._needsSizesFigured = false;
            }
        },

        /**
         * Arranges all of the TiledImages with the specified settings.
         * @param {Object} options - Specifies how to arrange.
         * @param {Boolean} [options.immediately=false] - Whether to animate to the new arrangement.
         * @param {String} [options.layout] - See collectionLayout in {@link XLviewer.Options}.
         * @param {Number} [options.rows] - See collectionRows in {@link XLviewer.Options}.
         * @param {Number} [options.columns] - See collectionColumns in {@link XLviewer.Options}.
         * @param {Number} [options.tileSize] - See collectionTileSize in {@link XLviewer.Options}.
         * @param {Number} [options.tileMargin] - See collectionTileMargin in {@link XLviewer.Options}.
         * @fires XLviewer.Manager.event:metrics-change
         */
        arrange: function(options) {
            options = options || {};
            var immediately = options.immediately || false;
            var layout = options.layout || xlv.DEFAULT_SETTINGS.collectionLayout;
            var rows = options.rows || xlv.DEFAULT_SETTINGS.collectionRows;
            var columns = options.columns || xlv.DEFAULT_SETTINGS.collectionColumns;
            var tileSize = options.tileSize || xlv.DEFAULT_SETTINGS.collectionTileSize;
            var tileMargin = options.tileMargin || xlv.DEFAULT_SETTINGS.collectionTileMargin;
            var increment = tileSize + tileMargin;
            var wrap;
            if (!options.rows && columns) {
                wrap = columns;
            } else {
                wrap = Math.ceil(this._items.length / rows);
            }
            var x = 0;
            var y = 0;
            var item, box, width, height, position;

            this.setAutoRefigureSizes(false);
            for (var i = 0; i < this._items.length; i++) {
                if (i && (i % wrap) === 0) {
                    if (layout === 'horizontal') {
                        y += increment;
                        x = 0;
                    } else {
                        x += increment;
                        y = 0;
                    }
                }

                item = this._items[i];
                box = item.getBounds();
                if (box.width > box.height) {
                    width = tileSize;
                } else {
                    width = tileSize * (box.width / box.height);
                }

                height = width * (box.height / box.width);
                position = new xlv.Point(x + ((tileSize - width) / 2),
                    y + ((tileSize - height) / 2));

                item.setPosition(position, immediately);
                item.setWidth(width, immediately);

                if (layout === 'horizontal') {
                    x += increment;
                } else {
                    y += increment;
                }
            }
            this.setAutoRefigureSizes(true);
        },

        // private
        _figureSizes: function() {
            var oldHomeBounds = this._homeBounds ? this._homeBounds.clone() : null;
            var oldContentSize = this._contentSize ? this._contentSize.clone() : null;
            var oldContentFactor = this._contentFactor || 0;

            if ( !this._items.length ) {
                this._homeBounds = new xlv.Rect(0, 0, 1, 1);
                this._contentSize = new xlv.Point(1, 1);
                this._contentFactor = 1;
            } else {
                var bounds = this._items[0].getBounds();
                this._contentFactor = this._items[0].getContentSize().x / bounds.width;
                var left = bounds.x;
                var top = bounds.y;
                var right = bounds.x + bounds.width;
                var bottom = bounds.y + bounds.height;
                var box;
                for ( var i = 1; i < this._items.length; i++ ) {
                    box = this._items[i].getBounds();
                    this._contentFactor = Math.max(this._contentFactor, this._items[i].getContentSize().x / box.width);
                    left = Math.min( left, box.x );
                    top = Math.min( top, box.y );
                    right = Math.max( right, box.x + box.width );
                    bottom = Math.max( bottom, box.y + box.height );
                }

                this._homeBounds = new xlv.Rect( left, top, right - left, bottom - top );
                this._contentSize = new xlv.Point(this._homeBounds.width * this._contentFactor,
                    this._homeBounds.height * this._contentFactor);
            }

            if (this._contentFactor !== oldContentFactor || !this._homeBounds.equals(oldHomeBounds) ||
                !this._contentSize.equals(oldContentSize)) {
                /**
                 * Dispatched when the home bounds or content factor change.
                 * @event metrics-change
                 * @memberOf XLviewer.Manager
                 * @type {object}
                 * @property {XLviewer.Manager} eventSource - A reference to the Manager which raised the event.
                 * @property {?Object} userData - Arbitrary subscriber-defined object.
                 */
                this.dispatchEvent('metricsChange', {});
            }
        },

        // private
        _raiseRemoveItem: function(item) {
            /**
             * Dispatched when an item is removed.
             * @event remove-item
             * @memberOf XLviewer.Manager
             * @type {object}
             * @property {XLviewer.Manager} eventSource - A reference to the Manager which raised the event.
             * @property {XLviewer.TiledImage} item - The item's underlying item.
             * @property {?Object} userData - Arbitrary subscriber-defined object.
             */
            this.dispatchEvent( 'removeItem', { item: item } );
        }
    });

}( XLviewer ));
(function( xlv ){

    /**
     * The Navigator provides a small view of the current image as fixed
     * while representing the viewport as a moving box serving as a frame
     * of reference in the larger viewport as to which portion of the image
     * is currently being examined.  The navigator's viewport can be interacted
     * with using the keyboard or the mouse.
     */
    xlv.Navigator = function( options ){

        var viewer      = options.viewer,
            _this = this,
            viewerSize,
            navigatorSize;

        var baseURI = 'xlv' + xlv.Utils.now().toString();
        //We may need to create a new element and id if they did not
        //provide the id for the existing element
        if( !options.id ){
            options.id              = baseURI + "-nav";
            this.element            = xlv.makeNeutralElement( "div" );
            options.controlOptions  = {
                anchor:           xlv.ControlAnchor.TOP_RIGHT,
                attachToViewer:   true,
                autoFade:         true
            };

            if( options.position ){
                if( 'BOTTOM_RIGHT' == options.position ){
                    options.controlOptions.anchor = xlv.ControlAnchor.BOTTOM_RIGHT;
                } else if( 'BOTTOM_LEFT' == options.position ){
                    options.controlOptions.anchor = xlv.ControlAnchor.BOTTOM_LEFT;
                } else if( 'TOP_RIGHT' == options.position ){
                    options.controlOptions.anchor = xlv.ControlAnchor.TOP_RIGHT;
                } else if( 'TOP_LEFT' == options.position ){
                    options.controlOptions.anchor = xlv.ControlAnchor.TOP_LEFT;
                } else if( 'ABSOLUTE' == options.position ){
                    options.controlOptions.anchor = xlv.ControlAnchor.ABSOLUTE;
                    options.controlOptions.top = options.top;
                    options.controlOptions.left = options.left;
                    options.controlOptions.height = options.height;
                    options.controlOptions.width = options.width;
                }
            }

        } else {
            this.element            = document.getElementById( options.id );
            options.controlOptions  = {
                anchor:           xlv.ControlAnchor.NONE,
                attachToViewer:   false,
                autoFade:         false
            };
        }
        this.element.id         = options.id;
        this.element.className  += ' navigator';

        options = xlv.extend( true, {
            sizeRatio:     xlv.DEFAULT_SETTINGS.navigatorConfig.sizeRatio
        }, options, {
            element:                this.element,
            tabIndex:               -1, // No keyboard navigation, omit from tab order
            //These need to be overridden to prevent recursion since
            //the navigator is a viewer and a viewer has a navigator
            useNavigator:           false,
            mouseEnabled:           false,
            immediateRender:        true,
            blendTime:              0,
            animationTime:          0,
            autoResize:             options.autoResize,
            // prevent resizing the navigator from adding unwanted space around the image
            minZoomImageRatio:      1.0
        });

        options.minPixelRatio = this.minPixelRatio = viewer.minPixelRatio;

        xlv.setElementTouchActionNone( this.element );

        this.borderWidth = 2;
        //At some browser magnification levels the display regions lines up correctly, but at some there appears to
        //be a one pixel gap.
        this.fudge = new xlv.Point(1, 1);
        this.totalBorderWidths = new xlv.Point(this.borderWidth*2, this.borderWidth*2).minus(this.fudge);


        if ( options.controlOptions.anchor != xlv.ControlAnchor.NONE ) {
            xlv.Utils.applyStyle(this.element,{
                margin : '0px',
                border : this.borderWidth + 'px solid #555',
                padding : '0px',
                background : '#000',
                opacity : 0.8,
                overflow : 'hidden'
            });
        }

        this.focusRegion           = xlv.makeNeutralElement( "div" );
        this.focusRegion.id        = baseURI + '-navfocus';
        this.focusRegion.className = 'bounds';

        xlv.Utils.applyStyle(this.focusRegion, {
            position      : 'relative',
            top           : '0px',
            left          : '0px',
            fontSize      : '0px',
            overflow      : 'hidden',
            border        : this.borderWidth + 'px solid #900',
            margin        : '0px',
            padding       : '0px',
            //TODO: IE doesnt like this property being set
            //try{ outlined rounded  : '2px auto #909', }catch(e){/*ignore*/}
            background    : 'transparent',
            // We use square bracket notation on the statement below, because float is a keyword.
            // This is important for the Google Closure compiler, if nothing else.
            /*jshint sub:true */
            'float'      : 'left', //Webkit
            cssFloat      : 'left', //Firefox
            styleFloat    : 'left', //IE
            zIndex        : 999999999,
            cursor        : 'default'
        });

        this.focusRegionCont = xlv.makeNeutralElement("div");
        this.focusRegionCont.id = baseURI + '-navfocus-cont';
        this.focusRegionCont.className = "navfocus-cont";
        this.focusRegionCont.style.width = "100%";
        this.focusRegionCont.style.height = "100%";

        viewer.addControl(
            this.element,
            options.controlOptions
        );

        this._resizeWithViewer = options.controlOptions.anchor != xlv.ControlAnchor.ABSOLUTE &&
            options.controlOptions.anchor != xlv.ControlAnchor.NONE;

        if ( this._resizeWithViewer ) {
            if ( options.width && options.height ) {
                this.element.style.height = typeof ( options.height )  == "number" ? ( options.height + 'px' ) : options.height;
                this.element.style.width  = typeof ( options.width )  == "number" ? ( options.width + 'px' ) : options.width;
            } else {
                viewerSize = xlv.getElementSize( viewer.element );
                this.element.style.height = Math.round( viewerSize.y * options.sizeRatio ) + 'px';
                this.element.style.width  = Math.round( viewerSize.x * options.sizeRatio ) + 'px';
                this.oldViewerSize = viewerSize;
            }
            navigatorSize = xlv.getElementSize( this.element );
            this.elementArea = navigatorSize.x * navigatorSize.y;
        }

        this.oldContainerSize = new xlv.Point( 0, 0 );

        xlv.Core.apply( this, [ options ] );

        this.focusRegionCont.appendChild(this.focusRegion);
        this.element.getElementsByTagName('div')[0].appendChild(this.focusRegionCont);

        function rotate(rotation) {
            _setTransformRotate(_this.focusRegionCont, rotation);
            _setTransformRotate(_this.focusRegion, -rotation);
            _this.viewport.setRotation(rotation);
        }
        if (options.rotate) {
            var rotation = options.viewer.viewport ?
                options.viewer.viewport.getRotation() :
                options.viewer.rotation || 0;
            rotate(rotation);
            options.viewer.addListener("rotate", function (args) {
                rotate(args.rotation);
            });
        }

        // Remove the base class' (Viewer's) innerTracker and replace it with our own
        this.innerTracker.destroy();
        this.innerTracker = new xlv.InteractionManager({
            element:         this.element,
            dragHandler:     xlv.Utils.delegate( this, onCanvasDrag ),
            clickHandler:    xlv.Utils.delegate( this, onCanvasClick ),
            releaseHandler:  xlv.Utils.delegate( this, onCanvasRelease ),
            scrollHandler:   xlv.Utils.delegate( this, onCanvasScroll )
        });

        this.addListener("resetSize", function() {
            if (_this.viewport) {
                _this.viewport.doZoomReset(true);
            }
        });

        viewer.manager.addListener("itemIndexChange", function(event) {
            var item = _this.manager.getItemAt(event.previousIndex);
            _this.manager.setItemIndex(item, event.newIndex);
        });

        viewer.manager.addListener("removeItem", function(event) {
            var theirItem = event.item;
            var myItem = _this._getMatchingItem(theirItem);
            if (myItem) {
                _this.manager.removeItem(myItem);
            }
        });

        this.update(viewer.viewport);
    };

    xlv.extend( xlv.Navigator.prototype, xlv.EventDispatcher.prototype, xlv.Core.prototype, /** @lends XLviewer.Navigator.prototype */{

        /**
         * Used to notify the navigator when its size has changed.
         * Especially useful when navigator autoResize is set to false and the navigator is resizable.
         */
        updateSize: function () {
            if ( this.viewport ) {
                var containerSize = new xlv.Point(
                    (this.container.clientWidth === 0 ? 1 : this.container.clientWidth),
                    (this.container.clientHeight === 0 ? 1 : this.container.clientHeight)
                );

                if ( !containerSize.equals( this.oldContainerSize ) ) {
                    this.viewport.resize( containerSize, true );
                    this.viewport.doZoomReset(true);
                    this.oldContainerSize = containerSize;
                    this.drawer.clear();
                    this.manager.draw();
                }
            }
        },

        /**
         * Used to update the navigator minimap's viewport rectangle when a change in the viewer's viewport occurs.
         */
        update: function( viewport ) {

            var viewerSize,
                newWidth,
                newHeight,
                bounds,
                topleft,
                bottomright;

            viewerSize = xlv.getElementSize( this.viewer.element );
            if ( this._resizeWithViewer && viewerSize.x && viewerSize.y && !viewerSize.equals( this.oldViewerSize ) ) {
                this.oldViewerSize = viewerSize;

                if ( this.maintainSizeRatio || !this.elementArea) {
                    newWidth  = viewerSize.x * this.sizeRatio;
                    newHeight = viewerSize.y * this.sizeRatio;
                } else {
                    newWidth = Math.sqrt(this.elementArea * (viewerSize.x / viewerSize.y));
                    newHeight = this.elementArea / newWidth;
                }

                this.element.style.width  = Math.round( newWidth ) + 'px';
                this.element.style.height = Math.round( newHeight ) + 'px';

                if (!this.elementArea) {
                    this.elementArea = newWidth * newHeight;
                }

                this.updateSize();
            }

            if( viewport && this.viewport ) {
                bounds      = viewport.getBounds( true );
                topleft     = this.viewport.pixelFromPointNoRotate(bounds.getTopLeft(), false);
                bottomright = this.viewport.pixelFromPointNoRotate(bounds.getBottomRight(), false)
                    .minus( this.totalBorderWidths );

                //update style for navigator-box
                var style = this.focusRegion.style;
                style.display = this.manager.getItemCount() ? 'block' : 'none';

                style.top    = Math.round( topleft.y ) + 'px';
                style.left   = Math.round( topleft.x ) + 'px';

                var width = Math.abs( topleft.x - bottomright.x );
                var height = Math.abs( topleft.y - bottomright.y );
                // make sure width and height are non-negative so IE doesn't throw
                style.width  = Math.round( Math.max( width, 0 ) ) + 'px';
                style.height = Math.round( Math.max( height, 0 ) ) + 'px';
            }

        },

        // overrides Viewer.addTiledImage
        addTiledImage: function(options) {
            var _this = this;

            var original = options.originalTiledImage;
            delete options.original;

            var optionsClone = xlv.extend({}, options, {
                success: function(event) {
                    var myItem = event.item;
                    myItem._originalForNavigator = original;
                    _this._matchBounds(myItem, original, true);

                    original.addListener('boundsChange', function() {
                        _this._matchBounds(myItem, original);
                    });
                }
            });

            return xlv.Core.prototype.addTiledImage.apply(this, [optionsClone]);
        },

        // private
        _getMatchingItem: function(theirItem) {
            var count = this.manager.getItemCount();
            var item;
            for (var i = 0; i < count; i++) {
                item = this.manager.getItemAt(i);
                if (item._originalForNavigator === theirItem) {
                    return item;
                }
            }

            return null;
        },

        // private
        _matchBounds: function(myItem, theirItem, immediately) {
            var bounds = theirItem.getBounds();
            myItem.setPosition(bounds.getTopLeft(), immediately);
            myItem.setWidth(bounds.width, immediately);
        }
    });

    function onCanvasClick( event ) {
        if ( event.quick && this.viewer.viewport ) {
            this.viewer.viewport.panTo(this.viewport.pointFromPixel(event.position));
            this.viewer.viewport.applyConstraints();
        }
    }

    function onCanvasDrag( event ) {
        if ( this.viewer.viewport ) {
            if( this.blockHorizontalPanning ){
                event.delta.x = 0;
            }
            if( this.blockVerticalPanning ){
                event.delta.y = 0;
            }
            this.viewer.viewport.panBy(
                this.viewport.deltaPointsFromPixels(
                    event.delta
                )
            );
        }
    }

    function onCanvasRelease( event ) {
        if ( event.insideElementPressed && this.viewer.viewport ) {
            this.viewer.viewport.applyConstraints();
        }
    }

    function onCanvasScroll( event ) {
        /**
         * Dispatched when a scroll event occurs on the navigator element (mouse wheel, touch pinch, etc.).
         */
        this.viewer.dispatchEvent( 'navigatorScroll', {
            tracker: event.eventSource,
            position: event.position,
            scroll: event.scroll,
            shift: event.shift,
            originalEvent: event.originalEvent
        });

        //dont scroll the page up and down if the user is scrolling
        //in the navigator
        return false;
    }

    function _setTransformRotate (element, rotation) {
        element.style.webkitTransform = "rotate(" + rotation + "deg)";
        element.style.mozTransform = "rotate(" + rotation + "deg)";
        element.style.msTransform = "rotate(" + rotation + "deg)";
        element.style.oTransform = "rotate(" + rotation + "deg)";
        element.style.transform = "rotate(" + rotation + "deg)";
    }

}( XLviewer ));
(function( xlv ){

    /**
     * An enumeration of button states
     */
    xlv.CONST.BUTTON_STATE = {
        DISABLED:   0,
        NORMAL:  1,
        HOVER:  2,
        PRESSED:   3
    };
    xlv.CONST.BUTTON_ACTION = {
        CUSTOM:   0,
        CUSTOM_SELECTABLE:   1,
        ZOOM_IN:  2,
        ZOOM_OUT:  3,
        ZOOM_RESET:   4,
        FULLSCREEN:   5,
        ROTATE:   6,
        ROTATE_LEFT:   7,
        ROTATE_RIGHT:   8,
        PREV:   9,
        NEXT:   10,
        TOGGLE_3D:   11,
        TOGGLE_3D_AUTOROTATE:   12,
        FACEBOOK_SHARE : 13,
        TWITTER_SHARE : 14
    };

    xlv.Button = function( options ) {

        var self = this;

        xlv.EventDispatcher.call( this );

        xlv.extend( true, this, {
            buttonID: null,
            viewer : null,
            showLabel: false,
            action : xlv.CONST.BUTTON_ACTION.CUSTOM,
            tooltip:            null,
            tooltipSelected:            null,
            iconDisabled:            null,
            iconHover:           null,
            iconPressed:           null,
            icon:            null,
            iconSelectedDisabled:            null,
            iconSelectedHover:           null,
            iconSelectedPressed:           null,
            iconSelected:            null,
            clickMaxDuration: xlv.DEFAULT_SETTINGS.clickMaxDuration,
            clickAreaRadius: xlv.DEFAULT_SETTINGS.clickAreaRadius,
            disabledOpacity : 0.2,
            fadeDelay:          0,
            fadeLength:         2000,
            onPress:            null,
            onRelease:          null,
            onClick:            null,
            onEnter:            null,
            onExit:             null,
            onFocus:            null,
            onBlur:             null,
            callback : function () {}
        }, options );

        /**
         * The button element.
         */
        this.element        = options.element   || xlv.makeNeutralElement( "a" );
        this.className = options.className || "xlv-button";
        this.element.className = this.className;

        this.selectable = (
            this.action === xlv.CONST.BUTTON_ACTION.FULLSCREEN
            || this.action === xlv.CONST.BUTTON_ACTION.ROTATE
            || this.action === xlv.CONST.BUTTON_ACTION.TOGGLE_3D
            || this.action === xlv.CONST.BUTTON_ACTION.TOGGLE_3D_AUTOROTATE
            || this.action === xlv.CONST.BUTTON_ACTION.CUSTOM_SELECTABLE);
        this.selected = this.selected && this.selectable;

        //if the user has specified the element to bind the control to explicitly
        //then do not add the default control images
        if ( !options.element ) {
            this.element.style.position = "relative";
            xlv.setElementTouchActionNone( this.element );

            this.iconDisabledImg      = xlv.makeTransparentImage( this.iconDisabled );
            this.iconImg     = xlv.makeTransparentImage( this.icon );
            this.iconHoverImg     = xlv.makeTransparentImage( this.iconHover );
            this.iconPressedImg      = xlv.makeTransparentImage( this.iconPressed );

            xlv.setElementOpacity(this.iconDisabledImg, this.disabledOpacity);

            this.iconDisabledImg.alt  =
                this.iconImg.alt =
                    this.iconHoverImg.alt =
                        this.iconPressedImg.alt  =
                            this.tooltip;

            this.iconImg.style.position =
                this.iconHoverImg.style.position =
                    this.iconPressedImg.style.position  =
                        "absolute";

            this.iconImg.style.top =
                this.iconHoverImg.style.top =
                    this.iconPressedImg.style.top  =
                        "0px";

            this.iconImg.style.left =
                this.iconHoverImg.style.left =
                    this.iconPressedImg.style.left  =
                        "0px";

            this.iconHoverImg.style.visibility =
                this.iconPressedImg.style.visibility  =
                    this.iconDisabledImg.style.visibility  =
                        "hidden";

            if ( xlv.Browser.vendor == xlv.CONST.BROWSER.FIREFOX  && xlv.Browser.version < 3 ){
                this.iconImg.style.top =
                    this.iconDisabledImg.style.top =
                        this.iconHoverImg.style.top =
                            this.iconPressedImg.style.top  =
                                "";
            }

            this.element.appendChild( this.iconDisabledImg );
            this.element.appendChild( this.iconImg );
            this.element.appendChild( this.iconHoverImg );
            this.element.appendChild( this.iconPressedImg );


            if(this.selectable) {
                this.iconSelectedDisabledImg      = xlv.makeTransparentImage( this.iconSelectedDisabled );
                this.iconSelectedImg     = xlv.makeTransparentImage( this.iconSelected );
                this.iconSelectedHoverImg     = xlv.makeTransparentImage( this.iconSelectedHover );
                this.iconSelectedPressedImg      = xlv.makeTransparentImage( this.iconSelectedPressed );

                xlv.setElementOpacity(this.iconSelectedDisabledImg, this.disabledOpacity);

                this.iconSelectedDisabledImg.alt  =
                    this.iconSelectedImg.alt =
                        this.iconSelectedHoverImg.alt =
                            this.iconSelectedPressedImg.alt  =
                                this.tooltipSelected || this.tooltip;

                this.iconSelectedImg.style.position =
                    this.iconSelectedDisabledImg.style.position =
                        this.iconSelectedHoverImg.style.position =
                            this.iconSelectedPressedImg.style.position  =
                                "absolute";

                this.iconSelectedImg.style.top =
                    this.iconSelectedDisabledImg.style.top =
                        this.iconSelectedHoverImg.style.top =
                            this.iconSelectedPressedImg.style.top  =
                                "0px";

                this.iconSelectedImg.style.left =
                    this.iconSelectedDisabledImg.style.left =
                        this.iconSelectedHoverImg.style.left =
                            this.iconSelectedPressedImg.style.left  =
                                "0px";

                this.iconSelectedHoverImg.style.visibility =
                    this.iconSelectedPressedImg.style.visibility  =
                        this.iconSelectedImg.style.visibility  =
                            this.iconSelectedDisabledImg.style.visibility  =
                                "hidden";

                if ( xlv.Browser.vendor == xlv.CONST.BROWSER.FIREFOX  && xlv.Browser.version < 3 ){
                    this.iconSelectedImg.style.top =
                        this.iconSelectedHoverImg.style.top =
                            this.iconSelectedPressedImg.style.top  =
                                this.iconSelectedDisabledImg.style.top  =
                                    "";
                }

                this.element.appendChild( this.iconSelectedDisabledImg );
                this.element.appendChild( this.iconSelectedImg );
                this.element.appendChild( this.iconSelectedHoverImg );
                this.element.appendChild( this.iconSelectedPressedImg );
            }
            if(this.showLabel && this.tooltip) {
                this.label      = xlv.makeNeutralElement( "span" );
                this.label.innerText = this.tooltip;
                this.element.appendChild(this.label);
                this.label.className = "xlv-button-label";
                xlv.Utils.applyStyle(this.label, {
                    "position" : "absolute",
                    "bottom" : 0,
                    "left" : 0,
                    "width" : "100%"
                });
            }

        }


        if(this.action === xlv.CONST.BUTTON_ACTION.FACEBOOK_SHARE) {

            /*
            <a class="fb-xfbml-parse-ignore" target="_blank" href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fdevelopers.facebook.com%2Fdocs%2Fplugins%2F&amp;src=sdkpreparse">Condividi</a></div>
             */
            this.element.className += " fb-share-button fb-xfbml-parse-ignore";
            this.element.setAttribute('data-href', window.location.href);
            this.element.setAttribute('data-layout', 'icon_link');

            /*
            // FB META
            document.getElementsByTagName('head')[0].appendChild(buildFacebookMeta("og:url", window.location.href));
            document.getElementsByTagName('head')[0].appendChild(buildFacebookMeta("og:type", "website"));
            document.getElementsByTagName('head')[0].appendChild(buildFacebookMeta("og:title", document.title));
            document.getElementsByTagName('head')[0].appendChild(buildFacebookMeta("og:image", xlv.Net.thumbUrl(this.viewer.source, this.viewer.image, 150,150, 70)));
            */
            //FB SCRIPT
            var fbRoot = document.createElement('div');
            fbRoot.id = "fb-root";
            document.getElementsByTagName('body')[0].appendChild(fbRoot);
        }



        if(this.action === xlv.CONST.BUTTON_ACTION.TWITTER_SHARE) {

            /*
            <a class="fb-xfbml-parse-ignore" target="_blank" href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fdevelopers.facebook.com%2Fdocs%2Fplugins%2F&amp;src=sdkpreparse">Condividi</a></div>
             */
            //this.element.className += " twitter-share-button";
            this.element.setAttribute('href', "https://twitter.com/intent/tweet");
        }


        this.postScriptExecute = function () {
            if(this.action === xlv.CONST.BUTTON_ACTION.FACEBOOK_SHARE) {
                (function(d, s, id) {
                    var js, fjs = d.getElementsByTagName(s)[0];
                    if (d.getElementById(id)) return;
                    js = d.createElement(s); js.id = id;
                    js.src = "//connect.facebook.net/en_US/sdk.js#xfbml=1&&version=v2.9";
                    //js.src = "//connect.facebook.net/en_US/debug.js#xfbml=1&&version=v2.9";
                    fjs.parentNode.insertBefore(js, fjs);
                }(document, 'script', 'facebook-jssdk'));
            }
            if(this.action === xlv.CONST.BUTTON_ACTION.TWITTER_SHARE) {
                window.twttr = (function(d, s, id) {
                    var js, fjs = d.getElementsByTagName(s)[0],
                        t = window.twttr || {};
                    if (d.getElementById(id)) return t;
                    js = d.createElement(s);
                    js.id = id;
                    js.src = "https://platform.twitter.com/widgets.js";
                    fjs.parentNode.insertBefore(js, fjs);

                    t._e = [];
                    t.ready = function(f) {
                        t._e.push(f);
                    };

                    return t;
                }(document, "script", "twitter-wjs"));
            }
        };

        this.addListener( "press",     this.onPress );
        this.addListener( "release",   this.onRelease );
        this.addListener( "click",     this.onClick );
        this.addListener( "enter",     this.onEnter );
        this.addListener( "exit",      this.onExit );
        this.addListener( "focus",     this.onFocus );
        this.addListener( "blur",      this.onBlur );


        if(options.action === xlv.CONST.BUTTON_ACTION.FULLSCREEN) {
            this.viewer.addListener('fullScreen', onFullScreenChange);
        }
        function onFullScreenChange(e) {
            self.selected = e.fullScreen;
            self.setCurrentState(xlv.CONST.BUTTON_STATE.NORMAL);
            self.updateDisplayIcon();
            console.log(e);
        }

        /**
         * The button's current state.
         */
        this.currentState = xlv.CONST.BUTTON_STATE.NORMAL;

        this.element.style.display  = "inline-block";
        this.element.style.position = "relative";
        this.element.style.cursor = "pointer";
        this.element.title          = this.tooltip;

        this.setCurrentState = function(state) {
            if(self.currentState === xlv.CONST.BUTTON_STATE.DISABLED) {
                return;
            }
            this.currentState = state;
        };

        this.updateDisplayIcon = function() {
            // disabled
            var iconDisabledVisible = (self.currentState === xlv.CONST.BUTTON_STATE.DISABLED && !self.selected);
            var iconSelectedDisabledVisible = (self.currentState === xlv.CONST.BUTTON_STATE.DISABLED && self.selected);
            // normal
            var iconVisible = (self.currentState === xlv.CONST.BUTTON_STATE.NORMAL && !self.selected);
            var iconSelectedVisible = (self.currentState === xlv.CONST.BUTTON_STATE.NORMAL && self.selected);
            // hover
            var iconHoverVisible = (self.currentState === xlv.CONST.BUTTON_STATE.HOVER && !self.selected) ;
            var iconSelectedHoverVisible = (self.currentState === xlv.CONST.BUTTON_STATE.HOVER && self.selected);
            // pressed
            var iconPressedVisible = (self.currentState === xlv.CONST.BUTTON_STATE.PRESSED && !self.selected);
            var iconSelectedPressedVisible = (self.currentState === xlv.CONST.BUTTON_STATE.PRESSED && self.selected);


            xlv.setElementVisible(self.iconDisabledImg, iconDisabledVisible);
            xlv.setElementVisible(self.iconImg, iconVisible);
            xlv.setElementVisible(self.iconHoverImg, iconHoverVisible);
            xlv.setElementVisible(self.iconPressedImg, iconPressedVisible);

            if(self.selectable) {
                xlv.setElementVisible(self.iconSelectedDisabledImg, iconSelectedDisabledVisible);
                xlv.setElementVisible(self.iconSelectedImg, iconSelectedVisible);
                xlv.setElementVisible(self.iconSelectedHoverImg, iconSelectedHoverVisible);
                xlv.setElementVisible(self.iconSelectedPressedImg, iconSelectedPressedVisible);
            }

            if(!self.selected) {
                this.element.title          = this.tooltip;
                if(this.label)
                    this.label.innerText          = this.tooltip;
            } else if(this.tooltipSelected) {
                this.element.title          = this.tooltipSelected;
                if(this.label)
                    this.label.innerText          = this.tooltipSelected;
            }
        };

        this.fireAction = function() {
            switch (this.action) {
                case xlv.CONST.BUTTON_ACTION.ZOOM_IN:
                    self.viewer.zoomIn();
                    break;
                case xlv.CONST.BUTTON_ACTION.ZOOM_OUT:
                    self.viewer.zoomOut();
                    break;
                case xlv.CONST.BUTTON_ACTION.ZOOM_RESET:
                    self.viewer.zoomReset();
                    break;
                case xlv.CONST.BUTTON_ACTION.ROTATE:
                    self.viewer.toggleRotate();
                    break;
                case xlv.CONST.BUTTON_ACTION.ROTATE_LEFT:
                    self.viewer.rotateLeft();
                    break;
                case xlv.CONST.BUTTON_ACTION.ROTATE_RIGHT:
                    self.viewer.rotateRight();
                    break;
                case xlv.CONST.BUTTON_ACTION.FULLSCREEN:
                    toggleFullScreen(self.viewer);
                    break;
                case xlv.CONST.BUTTON_ACTION.PREV:
                    goPreviousImage(self.viewer);
                    break;
                case xlv.CONST.BUTTON_ACTION.NEXT:
                    goNextImage(self.viewer);
                    break;
                case xlv.CONST.BUTTON_ACTION.TOGGLE_3D:
                    toggle3d(self.viewer);
                    break;
                case xlv.CONST.BUTTON_ACTION.TOGGLE_3D_AUTOROTATE:
                    toggle3dAutorotate(self.viewer);
                    break;
                case xlv.CONST.BUTTON_ACTION.CUSTOM:
                case xlv.CONST.BUTTON_ACTION.CUSTOM_SELECTABLE:
                    break;
                case xlv.CONST.BUTTON_ACTION.FACEBOOK_SHARE:
                    window.open('https://www.facebook.com/sharer/sharer.php?u='+encodeURIComponent(window.location.href)+'&amp;src=sdkpreparse','_blank');
                    break;
            }
            if(self.callback) self.callback({target : self, selected: self.selected});

        };

        this.setSelected = function(value) {
            this.selected = value && this.selectable;
            this.updateDisplayIcon();
        };
        /**
         * Tracks mouse/touch/key events on the button.
         */
        this.tracker = new xlv.InteractionManager({

            element:            this.element,
            clickTimeThreshold: this.clickTimeThreshold,
            clickDistThreshold: this.clickDistThreshold,

            enterHandler: function( event ) {
                if ( event.insideElementPressed ) {
                    self.setCurrentState(xlv.CONST.BUTTON_STATE.PRESSED);
                    /**
                     * Raised when the cursor enters the Button element.
                     */
                    self.dispatchEvent( "enter", { originalEvent: event.originalEvent } );
                } else if ( !event.buttonDownAny ) {
                    self.setCurrentState(xlv.CONST.BUTTON_STATE.HOVER);
                }
                self.updateDisplayIcon();
            },

            focusHandler: function ( event ) {
                this.enterHandler( event );
                /**
                 * Raised when the Button element receives focus.
                 */
                self.dispatchEvent( "focus", { originalEvent: event.originalEvent } );
            },

            exitHandler: function( event ) {
                self.setCurrentState(xlv.CONST.BUTTON_STATE.NORMAL);
                if ( event.insideElementPressed ) {
                    /**
                     * Raised when the cursor leaves the Button element.
                     */
                    self.dispatchEvent( "exit", { originalEvent: event.originalEvent } );
                }
                self.updateDisplayIcon();
            },

            blurHandler: function ( event ) {
                this.exitHandler( event );
                /**
                 * Raised when the Button element loses focus.
                 */
                self.dispatchEvent( "blur", { originalEvent: event.originalEvent } );
            },

            pressHandler: function ( event ) {
                self.setCurrentState(xlv.CONST.BUTTON_STATE.PRESSED);
                /**
                 * Raised when a mouse button is pressed or touch occurs in the Button element.
                 */
                self.dispatchEvent( "press", { originalEvent: event.originalEvent } );
                self.updateDisplayIcon();
            },

            releaseHandler: function( event ) {
                if ( event.insideElementPressed && event.insideElementReleased ) {
                    self.setCurrentState(xlv.CONST.BUTTON_STATE.HOVER);
                    /**
                     * Raised when the mouse button is released or touch ends in the Button element.
                     */
                    self.dispatchEvent( "release", { originalEvent: event.originalEvent } );
                    if(self.selectable
                        && self.action != xlv.CONST.BUTTON_ACTION.FULLSCREEN
                        && self.action != xlv.CONST.BUTTON_ACTION.TOGGLE_3D_AUTOROTATE
                        && self.action != xlv.CONST.BUTTON_ACTION.TOGGLE_3D) {
                        self.selected = !self.selected;
                    }
                    self.fireAction();
                } else if ( event.insideElementPressed ) {
                    self.setCurrentState(xlv.CONST.BUTTON_STATE.NORMAL);
                } else {
                    self.setCurrentState(xlv.CONST.BUTTON_STATE.HOVER);
                }
                self.updateDisplayIcon();
            },

            clickHandler: function( event ) {
                if ( event.quick ) {

                    /**
                     * Raised when a mouse button is pressed and released or touch is initiated and ended in the Button element within the time and distance threshold.
                     */
                    self.dispatchEvent("click", { originalEvent: event.originalEvent });
                }
            },

            keyHandler: function( event ){
                //console.log( "%s : handling key %s!", self.tooltip, event.keyCode);
                if( 13 === event.keyCode ){
                    /***
                     * Raised when a mouse button is pressed and released or touch is initiated and ended in the Button element within the time and distance threshold.
                     */
                    self.dispatchEvent( "click", { originalEvent: event.originalEvent } );
                    /***
                     * Raised when the mouse button is released or touch ends in the Button element.
                     */
                    self.dispatchEvent( "release", { originalEvent: event.originalEvent } );
                    return false;
                }
                return true;
            }
        });


        this.updateDisplayIcon();
    };

    xlv.extend( xlv.Button.prototype, xlv.EventDispatcher.prototype, /** @lends Xlviewer.Button.prototype */{
        disable: function(){
            this.currentState = xlv.CONST.BUTTON_STATE.DISABLED;
            this.element.disabled = true;
            xlv.setElementOpacity( this.element, 0.2, true );
        },

        enable: function(){
            this.currentState = xlv.CONST.BUTTON_STATE.NORMAL;
            this.element.disabled = false;
            xlv.setElementOpacity( this.element, 1.0, true );
        }

    });


    function toggleFullScreen(viewer) {
        if ( viewer.isFullPage() && !xlv.isFullScreen() ) {
            // Is fullPage but not fullScreen
            viewer.setFullPage( false );

        } else {
            viewer.setFullScreen( !viewer.isFullPage() );
        }

        if ( viewer.viewport ) {
            viewer.viewport.applyConstraints();
        }


    }


    function goPreviousImage(viewer) {
        viewer.prev();
    }
    function goNextImage(viewer) {
        viewer.next();
    }

    function toggle3d(viewer) {
        if(!viewer.is3D || !viewer.staticPreview) {
            return;
        }
        viewer.staticPreview.stopAutorotate();
        viewer.staticPreview.toggle();
    }
    function toggle3dAutorotate(viewer) {
        if(!viewer.is3D || !viewer.staticPreview) {
            return;
        }
        viewer.staticPreview.toggleAutorotate();
    }


    function buildFacebookMeta(property, content) {
        var meta = document.createElement('meta');
        meta.property = property;
        meta.content = content;
        return meta;
    }


}( XLviewer ));
(function( xlv ){
    xlv.Toolbar = function( options ) {

        xlv.extend( true, this, {
            /**
             * An array containing the buttons themselves.
             */
            viewer : null,
            buttons:            [],
            clickMaxDuration: options.viewer.clickMaxDuration,
            clickAreaRadius: options.viewer.clickAreaRadius,
            label:          "",
            className :         "xlv-toolbar",
            style : {}
        }, options );

        var i;

        /**
         * The shared container for the buttons.
         */
        this.element = options.element || xlv.makeNeutralElement( "div" );

        this.element.className = this.className;
        this.element.style.display = "inline-block";
        this.element.style["z-index"] = 1001;

        this.setIconSelected = function (type, value) {
            for(var i = 0; i < this.buttons.length; i++) {
                var btn = this.buttons[i];
                if(btn.action === type) {
                    btn.selected = value;
                    btn.updateDisplayIcon();
                }
            }
        };

        xlv.Utils.applyStyle(this.element, this.style);

        for ( i = 0; i < this.buttons.length; i++ ) {
            var buttonOptions = this.buttons[ i ];
            buttonOptions.viewer = this.viewer;
            buttonOptions.toolbar = this;
            this.buttons[ i ] = new XLviewer.Button(buttonOptions);
            this.element.appendChild( this.buttons[ i ].element );
            this.buttons[ i ].postScriptExecute();
        }

        xlv.setElementTouchActionNone( this.element );

        /**
         * Tracks mouse/touch/key events accross the group of buttons.
         */
        this.tracker = new xlv.InteractionManager({
            element:            this.element,
            clickMaxDuration: this.clickMaxDuration,
            clickAreaRadius: this.clickAreaRadius
        });

        this.viewer.addControl(this.element, {anchor:options.anchor||XLviewer.ControlAnchor.BOTTOM_RIGHT});

        this.getButtonByID = function(id) {
            for(var i = 0; i < this.buttons.length; i++) {
                var btn = this.buttons[i];
                if(btn.buttonID === id) {
                    return btn;
                }
            }
            return null;
        };

        this.viewer.toolbar = this;

    };

}( XLviewer ));
export default XLviewer;
